import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Frontend statik kelimeleri
const resources = {
  tr: {
    translation: {
      "login_title": "İKPro Giriş",
      "email_label": "E-Posta Adresi",
      "password_label": "Şifre",
      "login_button": "Giriş Yap",
      "select_language": "Dil Seçin",
      "login_failed_generic": "Giriş başarısız. Lütfen bilgilerinizi kontrol edin.",
      "server_unreachable": "Sunucuya ulaşılamıyor. Lütfen bağlantınızı kontrol edin.",
      "condition_new": "Sıfır",
      "condition_working": "Sağlam / Çalışır Durumda",
      "error_fetching_data": "Veriler çekilemedi.",
      "assets_added_success": "Varlıklar başarıyla eklendi.",
      "error_adding_assets": "Varlıklar eklenemedi.",
      "prompt_return_note": "İade Notu / Kondisyon:",
      "default_return_note": "Sağlam İade Alındı",
      "status_updated": "Durum güncellendi.",
      "error_occurred": "Hata oluştu.",
      "select_personnel_first": "Personel seçiniz.",
      "assignment_successful": "Zimmetleme başarılı.",
      "assignment_error": "Zimmetleme hatası.",
      "preparing_pdf": "PDF hazırlanıyor...",
      "pdf_downloaded": "PDF indirildi.",
      "pdf_not_found": "PDF bulunamadı.",
      "status_in_stock": "DEPODA",
      "status_assigned": "ZİMMETLİ",
      "status_in_repair": "TAMİRDE",
      "status_archived": "ARŞİV",
      "filter_all": "TÜMÜ",
      "filter_in_stock": "DEPODA",
      "filter_assigned": "ZİMMETLİ",
      "filter_in_repair": "TAMİRDE",
      "btn_add_new_asset": "YENİ VARLIK EKLE",
      "stat_total_assets": "TOPLAM VARLIK",
      "stat_available": "DEPODA (MÜSAİT)",
      "stat_assigned": "ZİMMETLİ",
      "stat_in_repair": "TAMİRDE / ARIZALI",
      "loading": "YÜKLENİYOR...",
      "table_category_model": "KATEGORİ / MODEL ADI",
      "table_stock_status": "STOK DURUMU",
      "table_actions": "EYLEMLER",
      "lbl_total": "TOP",
      "lbl_stock": "DEPO",
      "table_serial_plate": "SERİ NO / PLAKA",
      "table_status": "DURUM",
      "table_current_assignee": "MEVCUT SORUMLU",
      "table_operations": "İŞLEMLER",
      "unknown": "BİLİNMİYOR",
      "btn_assign": "ZİMMETLE",
      "btn_send_repair": "Tamir",
      "btn_report": "TUTANAK",
      "btn_return": "İade Al",
      "btn_repair_done": "Tamir Bitti",
      "modal_bulk_entry_title": "TOPLU ENVANTER GİRİŞİ",
      "lbl_model_name": "MODEL / VARLIK ADI",
      "ph_model_name": "Örn: MACBOOK PRO M3",
      "lbl_category": "KATEGORİ",
      "cat_electronics": "Elektronik Cihazlar",
      "cat_vehicles": "Araç / Ulaşım",
      "cat_furniture": "Mobilya / Ofis",
      "cat_digital": "Lisans / Dijital",
      "cat_other": "Diğer",
      "lbl_serial_numbers": "SERİ NUMARALARI",
      "ph_serial_numbers": "Her satıra bir adet gelecek şekilde...",
      "lbl_total_detected": "Toplam: {count} Adet Tespit Edildi",
      "lbl_instant_assign": "ANINDA ZİMMETLE",
      "opt_keep_in_stock": "Depoda Tut",
      "lbl_notes": "AÇIKLAMA / NOTLAR",
      "btn_cancel": "İPTAL",
      "btn_save_assets": "VARLIKLARI SİSTEME İŞLE",
      "modal_assign_title": "PERSONEL ATAMASI",
      "lbl_select_personnel": "PERSONEL SEÇİNİZ",
      "opt_select": "Seçim Yapınız",
      "lbl_delivery_condition": "TESLİM KONDİSYONU",
      "ph_condition": "Örn: Çiziksiz / Sıfır",
      "btn_confirm_assign": "ONAYLA VE ZİMMETLE",
      "stage_new": "YENİ BAŞVURU",
      "stage_interview": "MÜLAKAT",
      "stage_reference": "REFERANS & TEST",
      "stage_offer": "TEKLİF SUNULDU",
      "stage_talent_pool": "YETENEK HAVUZU 🏊‍♂️",
      "stage_withdrawn": "ADAY VAZGEÇTİ 🛑",
      "stage_rejected": "REDDEDİLDİ (BİZ)",
      "stage_hired": "İŞE ALINDI 🎉",
      "error_fetch_data": "Veriler çekilemedi",
      "msg_job_published": "İlan başarıyla yayınlandı.",
      "msg_job_create_error": "İlan oluşturulamadı.",
      "msg_select_open_job": "Lütfen açık kadro seçin!",
      "msg_candidate_created": "Aday kaydı oluşturuldu.",
      "msg_candidate_create_error": "Aday eklenemedi!",
      "msg_pdf_only": "Sadece PDF formatında bir dosya yükleyin.",
      "msg_uploading_cv": "CV yükleniyor...",
      "msg_cv_uploaded": "CV başarıyla yüklendi.",
      "msg_cv_upload_error": "CV Yüklenemedi",
      "msg_upload_cv_first": "Önce adayın CV'sini yüklemelisiniz.",
      "msg_ai_analyzing": "Gemini AI özgeçmişi derinlemesine inceliyor...",
      "lbl_ai_evaluation": "AI Değerlendirmesi",
      "msg_ai_analysis_done": "Yapay zeka analizi tamamlandı!",
      "msg_ai_analysis_error": "Yapay zeka şu an meşgul veya bir hata oluştu.",
      "msg_confirm_withdraw": "{{name}} isimli adayın teklifi reddettiğini veya çekildiğini onaylıyor musunuz?",
      "mail_reject_subject": "{{job}} Pozisyonu Başvurunuz Hakkında",
      "mail_reject_body": "Sayın {{first_name}} {{last_name}},\n\nŞirketimize ve {{job}} pozisyonuna göstermiş olduğunuz ilgi için teşekkür ederiz.\n\nÖzgeçmişinizi ve mülakat sonuçlarınızı dikkatle inceledik. Ne yazık ki, bu aşamada sizinle sürece devam edemeyeceğimizi bildirmek isteriz.\n\nNitelikleriniz gerçekten etkileyiciydi. İleride profilinize uygun yeni bir fırsat doğması halinde sizinle tekrar iletişime geçmekten memnuniyet duyarız.\n\nKariyerinizde başarılar dileriz.\n\nSaygılarımızla,\nİnsan Kaynakları Departmanı",
      "msg_stage_update_error": "Aşama güncellenirken hata oluştu.",
      "msg_saving_notes": "Değerlendirme notları kaydediliyor...",
      "msg_saved_successfully": "Başarıyla kaydedildi.",
      "msg_save_error": "Değerlendirme notları kaydedilemedi!",
      "msg_sending_reject_mail": "Red maili gönderiliyor...",
      "msg_reject_mail_sent": "{{name}} isimli adaya bilgilendirme maili gönderildi ve reddedildi.",
      "msg_error_occurred": "Hata oluştu.",
      "msg_creating_employee_card": "Personel kartı oluşturuluyor...",
      "msg_hire_success": "{{name}} artık resmi bir personel.",
      "msg_hire_error": "Personel oluşturulamadı! Zorunlu alanları kontrol edin.",
      "msg_confirm_delete_candidate": "{{name}} isimli adayı sistemden tamamen silmek istediğinize emin misiniz?",
      "msg_candidate_deleted": "Aday silindi.",
      "msg_candidate_delete_error": "Aday silinirken hata oluştu.",
      "msg_generating_offer_pdf": "Teklif mektubu (PDF) üretiliyor...",
      "msg_offer_downloaded": "Mektup başarıyla indirildi.",
      "msg_offer_error": "Teklif mektubu oluşturulurken bir hata oluştu.",
      "opt_no_active_job": "Aktif İlan Yok",
      "btn_new_job": "YENİ İLAN AÇ",
      "btn_add_candidate": "ADAY EKLE",
      "msg_empty_board": "LÜTFEN BİR İLAN SEÇİN VEYA YENİ BİR AÇIK İLAN OLUŞTURUN",
      "msg_empty_board_sub": "Aday havuzunuzu yönetmek için yukarıdaki menüyü kullanın.",
      "tooltip_delete_candidate": "Adayı Sil",
      "tooltip_global_score": "Genel Uyum Skoru (İK + AI)",
      "lbl_drag_here": "BURAYA SÜRÜKLE",
      "lbl_click_to_offer": "Sözleşme oluşturmak için adayın üzerine tıklayın.",
      "modal_title_new_job": "YENİ İLAN AÇ",
      "lbl_select_position_from_org": "ORGANİZASYONDAN BOŞ KADRO SEÇ",
      "opt_manual_job": "MANUEL İLAN GİRECEĞİM",
      "msg_auto_fill_warning": "SEÇTİĞİNİZ KADRONUN ADI VE DEPARTMANI OTOMATİK DOLDURULACAKTIR.",
      "lbl_job_title": "İLAN / POZİSYON ADI",
      "lbl_department": "DEPARTMAN",
      "lbl_job_desc": "İLAN AÇIKLAMASI VE ARANAN NİTELİKLER",
      "btn_publish_job": "İLANI YAYINA AL",
      "modal_title_new_candidate": "YENİ ADAY EKLE",
      "lbl_first_name": "ADI",
      "lbl_last_name": "SOYADI",
      "lbl_email": "E-POSTA",
      "lbl_phone": "TELEFON NUMARASI",
      "ph_optional": "Opsiyonel",
      "btn_save_to_system": "SİSTEME KAYDET",
      "modal_title_hire": "İŞE ALIMI TAMAMLA",
      "lbl_creating_emp_card": "PERSONEL KARTI OLUŞTURULUYOR",
      "lbl_identity_no": "KİMLİK / PASAPORT NO",
      "ph_identity": "Kimlik Numarası",
      "lbl_position": "POZİSYON / ÜNVAN",
      "lbl_gross_salary": "BRÜT MAAŞ",
      "lbl_hire_date": "İŞE BAŞLAMA TARİHİ",
      "btn_save_official_employee": "RESMİ PERSONEL OLARAK KAYDET",
      "lbl_evaluation_center": "ADAY DEĞERLENDİRME MERKEZİ (SCORECARD)",
      "lbl_global_score": "GENEL UYUM SKORU",
      "lbl_contact_and_cv": "İLETİŞİM VE CV",
      "btn_view_cv": "CV'Yİ GÖRÜNTÜLE",
      "btn_analyzing": "İNCELENİYOR...",
      "btn_start_ai_analysis": "AI ANALİZİNİ BAŞLAT",
      "btn_upload_pdf": "PDF YÜKLE",
      "lbl_ai_analysis_title": "YAPAY ZEKA (AI) ANALİZİ",
      "lbl_match_score": "Uyum Skoru",
      "lbl_no_ai_note": "Yapay zeka notu bulunamadı.",
      "lbl_competency_eval": "YETKİNLİK BAZLI DEĞERLENDİRME (NİCEL)",
      "lbl_rating_comm": "İletişim ve İfade",
      "lbl_rating_tech": "Mesleki / Teknik",
      "lbl_rating_culture": "Kültürel Uyum",
      "lbl_rating_motivation": "Özgüven & Motivasyon",
      "lbl_interview_notes": "MÜLAKAT NOTLARI (NİTEL)",
      "lbl_pros": "Güçlü Yönler (Artılar)",
      "ph_pros": "Adayın mülakatta en çok parladığı konular...",
      "lbl_cons": "Soru İşaretleri (Eksiler)",
      "ph_cons": "Adayla ilgili endişeler veya yetersiz kaldığı konular...",
      "lbl_overall": "Genel İK Kararı / Özet",
      "ph_overall": "İşe alım yöneticisine bu adayı öneriyor musunuz? Genel özet...",
      "btn_generate_contract": "SÖZLEŞME ÜRET",
      "btn_save_eval_form": "DEĞERLENDİRME FORMUNU KAYDET",
      "modal_title_reject": "ADAYI REDDET VE BİLGİLENDİR",
      "lbl_edit_mail_template": "AŞAĞIDAKİ MAİL ŞABLONUNU DÜZENLEYEBİLİRSİNİZ",
      "lbl_to": "KİME:",
      "lbl_mail_subject": "MAİL KONUSU",
      "lbl_mail_body": "MAİL İÇERİĞİ",
      "btn_send_and_reject": "GÖNDER VE ADAYI REDDET",
      "modal_title_offer": "TEKLİF MEKTUBU OLUŞTUR",
      "lbl_preparing_pdf": "RESMİ PDF BELGESİ HAZIRLANIYOR",
      "lbl_offered_salary": "TEKLİF EDİLEN AYLIK MAAŞ",
      "ph_salary": "Örn: 45000",
      "lbl_planned_start_date": "PLANLANAN İŞE BAŞLAMA TARİHİ",
      "btn_download_pdf": "PDF İNDİR",
      "nav_dashboard": "KOKPİT",
      "nav_sub_dashboard": "Genel İstatistikler",
      "nav_employees": "PERSONEL YÖNETİMİ",
      "nav_sub_employees": "Kadro ve Çalışanlar",
      "nav_org_chart": "ORGANİZASYON ŞEMASI",
      "nav_sub_org_chart": "Hiyerarşik Yapı",
      "nav_ats": "ADAY TAKİP (ATS)",
      "nav_sub_ats": "İşe Alım Süreci",
      "nav_attendance": "ZAMAN & DEVAMLILIK",
      "nav_sub_attendance": "PDKS ve Mesai Takibi",
      "nav_locations": "KONUMLAR & ŞANTİYELER",
      "nav_sub_locations": "Güvenlik Çemberi Yönetimi",
      "nav_leaves": "İZİN YÖNETİMİ",
      "nav_sub_leaves": "Onay Merkezi",
      "nav_dossier": "E-ÖZLÜK ARŞİVİ",
      "nav_sub_dossier": "Dijital Belgeler",
      "nav_performance": "PERFORMANS & YETENEK",
      "nav_sub_performance": "OKR ve 360° Değerlendirme",
      "nav_training": "KURUMSAL AKADEMİ",
      "nav_sub_training": "Eğitim Yönetimi",
      "nav_expenses": "MASRAF YÖNETİMİ",
      "nav_sub_expenses": "Bütçe ve Fişler",
      "nav_assets": "ZİMMET & ENVANTER",
      "nav_sub_assets": "Stok Takibi",
      "nav_helpdesk": "DESTEK MASASI (IT/İK)",
      "nav_sub_helpdesk": "İç İletişim Talepleri",
      "nav_settings": "SİSTEM & ŞİRKET AYARLARI",
      "nav_sub_settings": "Kurumsal Kimlik Yönetimi",
      "nav_billing": "ABONELİK & FATURANDIRMA",
      "nav_sub_billing": "SaaS Paket Yönetimi",
      "menu_onboarding": "İŞE GİRİŞ & ÇIKIŞ",
      "lifecycle_header_title": "İŞE BAŞLATMA & İŞTEN AYRILIŞ",
      "lifecycle_header_subtitle": "İşe giriş, ayrılış ve belge süreçleri",
      "lifecycle_role_employee": "Personel",
      "lifecycle_role_manager": "Yönetici",
      "lifecycle_role_hr": "İK",
      "lifecycle_role_admin": "Admin",
      "lifecycle_role_superadmin": "Superadmin",
      "lifecycle_tab_onboarding": "İşe Başlatma",
      "lifecycle_tab_offboarding": "İşten Ayrılış",
      "lifecycle_search_onboarding": "Yeni başlayan personel ara",
      "lifecycle_search_offboarding": "Çıkış süreci personeli ara",
      "lifecycle_no_matching_personnel": "Bu görünüm için eşleşen personel bulunamadı.",
      "lifecycle_detail_loading": "Süreç detayı yükleniyor...",
      "lifecycle_select_personnel": "Personel Seçin",
      "lifecycle_select_personnel_hint": "Soldaki listeden bir personel seçtiğinizde işe başlatma / işten ayrılış adımları burada görünecek.",
      "lifecycle_onboarding_process": "İşe Başlatma Süreci",
      "lifecycle_offboarding_process": "İşten Ayrılış Süreci",
      "lifecycle_progress": "İlerleme",
      "lifecycle_account_active": "Hesap aktif",
      "lifecycle_account_closed_status": "Hesap kapalı",
      "lifecycle_document_count": "Evrak Sayısı",
      "lifecycle_open_workload": "Açık Yük",
      "lifecycle_active_device": "Aktif Cihaz",
      "lifecycle_leave_unit": "izin",
      "lifecycle_expense_unit": "masraf",
      "lifecycle_device_unit": "cihaz",
      "lifecycle_checklist": "Kontrol Listesi",
      "lifecycle_process_actions": "Süreç Aksiyonları",
      "lifecycle_close_account": "Hesabı Kapat",
      "lifecycle_open_account": "Hesabı Aç / Şifre Gönder",
      "lifecycle_open_release_form": "İşten Ayrılış Formunu Aç",
      "lifecycle_download_document": "Belgeyi İndir",
      "btn_store_to_dossier": "E-Özlüğe Kaydet",
      "lifecycle_process_note": "Süreç Notu",
      "lifecycle_offboarding_note": "Önce aktif zimmetleri ve açık iş yüklerini kontrol edin. Hesap kapanınca MFA ve mobil cihaz oturumları da pasifleştirilir.",
      "lifecycle_onboarding_note": "Hesap açılışında geçici şifre gönderilir. Üretilen sözleşmeyi e-özlüğe kaydedip işe başlatma evrak setine dahil edebilirsiniz.",
      "lifecycle_highlights": "Öne Çıkan Eksikler",
      "lifecycle_no_open_items": "Süreçte açık madde kalmadı",
      "lifecycle_offboarding_document": "İşten Ayrılış Belgesi",
      "lifecycle_release_form_title": "İşten Ayrılış / İbraname Formu",
      "lifecycle_release_form_desc": "Sistem alanları doldurur, hukuki serbest metin ve ödeme kalemlerini burada tamamlayıp PDF üretebilirsin.",
      "lifecycle_form_loading": "Form yükleniyor...",
      "lifecycle_template_label": "Belge Şablonu",
      "lifecycle_template_tr_release_title": "TR/KKTC İbraname",
      "lifecycle_template_tr_release_subtitle": "TR / KKTC uyumlu klasik çıkış ve ibra metni",
      "lifecycle_template_generic_clearance_title": "Genel Kapanış Mutabakatı",
      "lifecycle_template_generic_clearance_subtitle": "Ülke bağımsız genel kapanış ve mutabakat formu",
      "lifecycle_template_de_exit_title": "DE Austritt & Schlussabrechnung",
      "lifecycle_template_de_exit_subtitle": "Almanya odaklı çıkış mutabakatı ve kapanış özeti",
      "lifecycle_template_sgk_note": "Bu şablonda SGK/yerel sicil alanı kullanılır.",
      "lifecycle_template_generic_note": "Bu şablon genel kapanış formu olarak kullanılır.",
      "lifecycle_employer_name": "İşveren Unvanı",
      "lifecycle_employer_address": "İşveren Adresi",
      "lifecycle_employer_sgk": "SGK İşyeri Sicil No",
      "lifecycle_employer_tax": "Vergi Numarası",
      "lifecycle_employee_name": "Personel Adı",
      "lifecycle_employee_ssn": "SGK Sigorta Sicil No",
      "lifecycle_exit_reason_label": "İşten Ayrılış Nedeni",
      "lifecycle_hire_date": "İşe Başlama Tarihi",
      "lifecycle_exit_date": "İşten Ayrılış Tarihi",
      "lifecycle_exit_date_short": "Çıkış Tarihi",
      "lifecycle_release_date": "İbra Tarihi",
      "lifecycle_other_exit_reason_note": "Diğer Ayrılış Açıklaması",
      "lifecycle_other_exit_reason_placeholder": "Serbest metin ile açıklayın",
      "lifecycle_intro_text": "Giriş Metni",
      "lifecycle_settlement_text": "Hakediş Metni",
      "lifecycle_no_claim_text": "Hak Talebi Kalmadığına Dair Metin",
      "lifecycle_contact_note": "Adres ve Telefon / Serbest Not",
      "lifecycle_payment_table": "Ödeme Tablosu",
      "lifecycle_payment_table_hint": "İstersen boş bırak, istersen satırları hukuk/muhasebe onayına göre doldur.",
      "lifecycle_payment_col_name": "Ödemeler",
      "lifecycle_payment_col_gross": "Brüt",
      "lifecycle_payment_col_legal": "Yasal Kesinti",
      "lifecycle_payment_col_net": "Net",
      "lifecycle_payment_col_special": "Özel Kesinti",
      "lifecycle_payment_col_net_payment": "Net Ödeme",
      "lifecycle_exit_reason_select": "Neden seçin",
      "lifecycle_exit_reason_abandonment": "Terk",
      "lifecycle_exit_reason_resignation": "İstifa",
      "lifecycle_exit_reason_termination": "Çıkarılma / Fesih",
      "lifecycle_exit_reason_military": "Vatani Görev",
      "lifecycle_exit_reason_retirement": "Emeklilik",
      "lifecycle_exit_reason_death": "Vefat",
      "lifecycle_exit_reason_other": "Diğer",
      "lifecycle_overview_load_error": "Süreç verileri yüklenemedi.",
      "lifecycle_preparing_document": "Belge hazırlanıyor...",
      "lifecycle_document_downloaded": "Belge indirildi.",
      "lifecycle_document_download_error": "Belge indirilemedi.",
      "lifecycle_document_storing": "Belge e-özlüğe kaydediliyor...",
      "lifecycle_document_stored": "Belge üretildi ve e-özlüğe kaydedildi.",
      "lifecycle_document_store_error": "Belge kaydedilemedi.",
      "lifecycle_account_opening": "Kullanıcı hesabı açılıyor...",
      "lifecycle_account_opened_with_temp": "Hesap açıldı. Geçici şifre: {{password}}",
      "lifecycle_account_opened": "Hesap açıldı.",
      "lifecycle_account_open_error": "Hesap açılamadı.",
      "lifecycle_account_closing": "Hesap kapatılıyor...",
      "lifecycle_account_closed": "Hesap kapatıldı ve personel arşive alındı.",
      "lifecycle_account_close_error": "Hesap kapatılamadı.",
      "lifecycle_release_form_open_error": "İşten ayrılış formu açılamadı.",
      "lifecycle_template_load_error": "Şablon yüklenemedi.",
      "lifecycle_release_pdf_preparing": "İşten ayrılış PDF hazırlanıyor...",
      "lifecycle_release_pdf_downloaded": "İşten ayrılış belgesi indirildi.",
      "lifecycle_release_pdf_error": "İşten ayrılış belgesi indirilemedi.",
      "lifecycle_release_storing": "İşten ayrılış belgesi e-özlüğe kaydediliyor...",
      "lifecycle_release_stored": "İşten ayrılış belgesi üretildi ve e-özlüğe kaydedildi.",
      "lifecycle_release_store_error": "İşten ayrılış belgesi kaydedilemedi.",
      "lifecycle_not_planned": "Planlanmadı",
      "lifecycle_no_department": "Departman yok",
      "lifecycle_opening_progress": "Açılış İlerlemesi",
      "lifecycle_closure_progress": "Kapanış İlerlemesi",
      "lifecycle_detail_load_error": "Süreç detayı yüklenemedi.",
      "lifecycle_summary_total_process": "Toplam Süreç",
      "lifecycle_summary_total_process_hint": "İzlenen personel",
      "lifecycle_summary_closed_accounts": "Kapatılan Hesap",
      "lifecycle_summary_closed_accounts_hint": "Erişimi durdurulan",
      "lifecycle_summary_documents_ready": "Belgesi Hazır",
      "lifecycle_summary_offboarding_documents_hint": "Çıkış evrakı oluşan",
      "lifecycle_summary_attention_needed": "Takip Gereken",
      "lifecycle_summary_attention_needed_hint": "Açık adımı olan",
      "lifecycle_summary_total_employees": "Toplam Personel",
      "lifecycle_summary_total_employees_hint": "İşe başlatma görünümü",
      "lifecycle_summary_accounts_ready": "Hesap Hazır",
      "lifecycle_summary_accounts_ready_hint": "Giriş bilgisi tanımlı",
      "lifecycle_summary_onboarding_documents_hint": "Sözleşme ve evrakı hazır",
      "lifecycle_summary_attention_needed_onboarding_hint": "Eksik adımı olan",
      "helpdesk_stat_open": "Açık",
      "helpdesk_stat_open_hint": "Toplam aktif talep",
      "helpdesk_stat_pending": "Bekleyen",
      "helpdesk_stat_pending_hint": "İlk yanıt bekleyen",
      "helpdesk_stat_in_progress_hint": "Üzerinde çalışılan",
      "helpdesk_total_tickets": "TOPLAM TALEP",
      "nav_portal": "KOKPİT",
      "nav_sub_portal": "Kişisel Kokpit",
      "nav_my_leaves": "İZİNLERİM",
      "nav_sub_my_leaves": "Bireysel İzin Durumu",
      "nav_my_performance": "PERFORMANS DURUMUM",
      "nav_sub_my_performance": "Hedeflerim (OKR)",
      "nav_my_training": "EĞİTİM AKADEMİSİ",
      "nav_sub_my_training": "Gelişim Planım",
      "nav_my_expenses": "MASRAF BEYANLARIM",
      "nav_sub_my_expenses": "Harcama Girişleri",
      "nav_my_assets": "ÜZERİMDEKİ ZİMMETLER",
      "nav_sub_my_assets": "Şirket Ekipmanları",
      "nav_fallback": "KOKPİT",
      "nav_sub_fallback": "Kurumsal Yönetim",
      "error_fetch_weather": "Hava durumu çekilemedi",
      "lbl_city_weather": "ŞEHİR / HAVA",
      "ph_type_city": "Şehir yazın...",
      "tooltip_change_city": "Şehri değiştirmek için tıklayın",
      "lbl_today": "BUGÜN",
      "msg_payment_success": "🎉 Ödemeniz başarıyla alındı! Aboneliğiniz güncellendi.",
      "msg_payment_failed": "Ödeme sırasında bir hata oluştu. Lütfen tekrar deneyin.",
      "msg_redirecting_payment": "Güvenli ödeme sayfasına yönlendiriliyorsunuz...",
      "msg_no_payment_link": "Ödeme linki alınamadı.",
      "msg_payment_init_failed": "Ödeme sayfası başlatılamadı. Lütfen tekrar deneyin.",
      "lbl_current_subscription": "MEVCUT ABONELİĞİNİZ",
      "lbl_active": "Aktif",
      "lbl_renews_in_days": "{{days}} GÜN SONRA YENİLENECEK",
      "lbl_saved_card": "KAYITLI KART:",
      "btn_update_card": "KARTI GÜNCELLE",
      "lbl_iyzico_secure": "IYZICO İLE %100 GÜVENLİ",
      "plan_starter_title": "Başlangıç",
      "plan_starter_desc": "Küçük Ekipler İçin",
      "lbl_month": "ay",
      "feat_max_10_emp": "Maksimum 10 Personel",
      "feat_standard_payroll": "Standart Bordro (D1)",
      "feat_no_ats": "Aday Takip (ATS) Yok",
      "feat_no_helpdesk": "Destek Masası Yok",
      "btn_current_plan": "ŞU ANKİ PLANINIZ",
      "btn_downgrade": "PLANA DÜŞÜR",
      "badge_most_popular": "EN ÇOK TERCİH EDİLEN",
      "plan_pro_title": "Pro Plan",
      "plan_pro_desc": "Büyüyen Şirketler İçin",
      "feat_max_50_emp": "Maksimum 50 Personel",
      "feat_all_payroll": "Tüm Bordro Tipleri (D1, D3, E1)",
      "feat_ats_module": "Aday Takip (ATS) Modülü",
      "feat_helpdesk": "Personel Destek Masası",
      "plan_enterprise_title": "Enterprise",
      "plan_enterprise_desc": "Büyük Holdingler İçin",
      "feat_unlimited_emp": "Sınırsız Personel",
      "feat_advanced_api": "Gelişmiş API Erişimi",
      "feat_private_server": "Özel Sunucu Kurulumu",
      "feat_vip_support": "7/24 Özel VIP Destek",
      "btn_upgrade": "PLANA YÜKSELT",
      "err_invalid_qr": "GEÇERSİZ İŞLEM: LÜTFEN ŞANTİYEDEKİ GÜNCEL QR KODU OKUTARAK GİRİŞ YAPIN.",
      "msg_clock_in_success": "GİRİŞ BAŞARILI! İYİ MESAİLER.",
      "err_location_verify": "KONUM DOĞRULANAMADI.",
      "err_location_denied": "KONUM İZNİ REDDEDİLDİ VEYA ALINAMADI!",
      "err_location_timeout": "ZAMAN AŞIMI: LÜTFEN AÇIK ALANA ÇIKIP TEKRAR DENEYİN.",
      "lbl_verifying_gps": "GPS DOĞRULANIYOR...",
      "lbl_clocked_in": "GİRİŞ YAPILDI",
      "btn_clock_in": "GİRİŞ YAP (QR & GPS)",
      "err_fetch_attendance": "Puantaj verileri çekilemedi.",
      "err_only_excel": "Sadece Excel (.xlsx, .xls) dosyası yükleyebilirsiniz.",
      "err_select_excel": "Lütfen bir Excel dosyası seçin.",
      "msg_processing_excel": "Excel dosyası işleniyor...",
      "msg_excel_success": "Excel verileri başarıyla sisteme aktarıldı!",
      "msg_upload_failed": "Yükleme başarısız.",
      "action_reject": "reddetmek",
      "action_approve": "onaylamak",
      "msg_confirm_bulk": "Seçili {{count}} kaydı toplu olarak {{action}} istediğinize emin misiniz?",
      "msg_applying_bulk": "Toplu işlem uygulanıyor...",
      "msg_bulk_success": "Toplu işlem başarıyla tamamlandı.",
      "status_present": "MEVCUT",
      "status_absent": "DEVAMSIZ",
      "status_late": "GEÇ KALDI",
      "status_off": "İZİNLİ / TATİL",
      "badge_manager_pending": "MÜDÜR ONAYI BEK.",
      "badge_hr_pending": "İK ONAYI BEK.",
      "badge_payroll_ready": "BORDROYA HAZIR",
      "badge_rejected": "REDDEDİLDİ",
      "lbl_bulk_excel": "EXCEL İLE TOPLU AKTARIM",
      "lbl_excel_desc": "Yüz tanıma/Parmak izi cihazından alınan .xlsx dosyası.",
      "btn_select_file": "DOSYA SEÇİN",
      "btn_select_excel": "EXCEL DOSYASI SEÇ",
      "btn_processing": "İŞLENİYOR...",
      "btn_transfer": "AKTAR",
      "lbl_listed_records": "Ekranda Listelenen Kayıt",
      "lbl_records": "KAYIT",
      "lbl_record_selected": "KAYIT SEÇİLDİ",
      "btn_reject_selected": "REDDET",
      "btn_approve_selected": "ONAYLA",
      "opt_all_approvals": "TÜM ONAYLAR",
      "lbl_loading_data": "VERİLER YÜKLENİYOR...",
      "tbl_emp_dept": "PERSONEL & DEPARTMAN",
      "tbl_day_in_out": "GÜN & GİRİŞ-ÇIKIŞ",
      "tbl_total_ot": "TOPLAM / MESAİ",
      "tbl_daily_status": "GÜNLÜK DURUM",
      "tbl_approval_status": "ONAY DURUMU",
      "lbl_no_records": "HENÜZ KAYIT BULUNMUYOR.",
      "lbl_unknown": "BİLİNMİYOR",
      "lbl_weekday_ot": "H.İÇİ",
      "lbl_weekend_ot": "H.SONU",
      "lbl_no_ot": "MESAİ YOK",
      "lbl_records_selected_html": "KAYIT<br/>SEÇİLDİ",
      "lbl_assigned_count": "ATANAN",
      "lbl_selected_count": "SEÇİLEN",
      "badge_already_assigned": "ZATEN ATANDI",
      "btn_select_all_visible": "GÖRÜNENLERİ SEÇ",
      "btn_clear_visible": "GÖRÜNENLERİ TEMİZLE",
      "btn_manager_approve": "MÜDÜR ONAYI",
      "btn_hr_approve": "İK ONAYI (BORDRO)",
      "btn_reject_cancel": "REDDET (İPTAL)",
      "err_password_length": "Şifreniz en az 6 karakter olmalıdır.",
      "err_password_match": "Şifreler birbiriyle eşleşmiyor.",
      "msg_register_success": "Şirketiniz başarıyla kuruldu! Lütfen giriş yapın.",
      "err_generic_login": "Bir hata oluştu. Lütfen bilgilerinizi kontrol edin.",
      "lbl_login_title": "Sisteme Giriş Yapın",
      "lbl_register_title": "30 Günlük Ücretsiz Denemeyi Başlat",
      "ph_company_name": "Şirket / Kurum Adı",
      "ph_first_name": "Adınız",
      "ph_last_name": "Soyadınız",
      "ph_email": "E-Posta Adresi",
      "ph_password": "Şifreniz",
      "ph_confirm_password": "Şifrenizi Doğrulayın",
      "btn_login": "Sisteme Giriş Yap",
      "btn_register": "Hesabı Oluştur",
      "msg_no_account": "Henüz bir hesabınız yok mu?",
      "msg_has_account": "Zaten bir şirket hesabınız var mı?",
      "btn_start_trial": "Şimdi 30 Günlük Deneme Başlat",
      "btn_back_to_login": "Giriş Ekranına Dön",
      "lbl_other": "DİĞER",
      "lbl_unassigned": "KADRO ATANMAMIŞ",
      "err_fetch_data": "Veriler yüklenirken bir hata oluştu.",
      "msg_updating_company_info": "Kurumsal bilgiler güncelleniyor...",
      "msg_company_info_updated": "Kurumsal kimlik bilgileri başarıyla güncellendi!",
      "err_updating_info": "Güncelleme sırasında bir hata oluştu.",
      "err_file_size": "Dosya boyutu 2MB'den büyük olamaz.",
      "msg_uploading_logo": "Logo sunucuya yükleniyor...",
      "msg_logo_uploaded": "Logo başarıyla yüklendi ve sisteme işlendi!",
      "err_uploading_logo": "Logo yüklenirken bir hata oluştu.",
      "msg_saving_routing": "Rota ve operasyon ayarları kaydediliyor...",
      "msg_routing_saved": "Tüm sistem rotaları başarıyla kilitlendi!",
      "err_saving_routing": "Ayarlar kaydedilemedi. Lütfen backend bağlantısını kontrol edin.",
      "err_pwd_match": "Yeni şifreler birbiriyle eşleşmiyor!",
      "err_pwd_length": "Yeni şifreniz en az 6 karakter olmalıdır.",
      "msg_updating_pwd": "Şifreniz güncelleniyor...",
      "msg_pwd_updated": "Şifreniz başarıyla değiştirildi!",
      "err_updating_pwd": "Şifre güncellenemedi. Mevcut şifrenizi kontrol edin.",
      "lbl_loading_settings": "AYARLAR YÜKLENİYOR...",
      "tab_company": "KURUMSAL AYARLAR",
      "tab_security": "KİŞİSEL GÜVENLİK",
      "lbl_official_title": "RESMİ UNVAN",
      "lbl_company_name": "ŞİRKET ADI",
      "lbl_routing_settings": "SİSTEM ROTA AYARLARI",
      "desc_routing": "MODÜLLER İÇİN ANA SORUMLULARI BELİRLEYİN.",
      "lbl_routing_policy": "ONAY AKIŞ MANTIĞI",
      "desc_helpdesk_policy": "HELPDESK: COMPANY SETTINGS İÇİNDE ATANAN SORUMLUYA DÜŞER.",
      "desc_leave_policy": "İZİN: ÖNCE YÖNETİCİ, SONRA İK / ADMİN.",
      "desc_expense_policy": "MASRAF: ÖNCE YÖNETİCİ, SONRA ADMİN / FİNANS.",
      "desc_document_policy": "EVRAK: İK / ADMİN ONAYINA GİDER.",
      "lbl_helpdesk_it": "HELP DESK (IT)",
      "lbl_hr_responsible": "İZİN & EVRAK (İK)",
      "lbl_admin_responsible": "İDARİ TALEP & MASRAF",
      "lbl_payroll_officer": "BORDRO SORUMLUSU",
      "desc_payroll_officer": "HELPDESK BORDRO TALEPLERİ VE MASRAF AKIŞINDA FİNANS NOKTASI BU KİŞİDİR.",
      "btn_processing": "İŞLEM YAPILIYOR...",
      "btn_save_routing": "AYARLARI KİLİTLE VE KAYDET",
      "lbl_pdf_active": "PDF ANTET SİSTEMİ AKTİF",
      "lbl_no_logo": "LOGO TANIMLANMAMIŞ",
      "tab_company_info": "KURUMSAL",
      "tab_company_info_span": "BİLGİLER",
      "lbl_address": "ADRES",
      "lbl_phone": "SANTRAL",
      "lbl_email": "E-POSTA",
      "lbl_website": "WEB ADRESİ",
      "btn_update_info": "BİLGİLERİ GÜNCELLE",
      "lbl_logo_management": "LOGO YÖNETİMİ",
      "btn_select_new_file": "YENİ DOSYA SEÇ",
      "btn_start_upload": "YÜKLEMEYİ BAŞLAT",
      "lbl_no_logo_uploaded": "LOGO YOK",
      "lbl_current_view": "GÜNCEL GÖRÜNÜM",
      "tab_account": "HESAP",
      "tab_security_span": "GÜVENLİĞİ",
      "lbl_update_pwd": "ŞİFRENİZİ GÜNCELLEYİN",
      "desc_update_pwd": "Hesabınızın güvenliği için şifrenizi düzenli aralıklarla değiştirmeniz önerilir.",
      "lbl_old_pwd": "MEVCUT ŞİFRENİZ",
      "lbl_new_pwd": "YENİ ŞİFRE",
      "lbl_confirm_pwd": "YENİ ŞİFRE (TEKRAR)",
      "btn_change_pwd": "ŞİFREYİ GÜNCELLE",
      "opt_none_selected": "KİMSE SEÇİLMEDİ",
      "err_login_failed_check_info": "Giriş yapılamadı. Bilgilerinizi kontrol edin.",
      "lbl_system_subtitle": "Personel Yönetim Sistemi",
      "lbl_email_address": "E-Posta Adresi",
      "ph_email_example": "ornek@sirket.com",
      "lbl_password": "Şifre",
      "btn_login_system": "SİSTEME GİRİŞ YAP",
      "msg_no_account_yet": "Henüz hesabınız yok mu?",
      "btn_register_now": "Kayıt Olun",
      "notif_loading": "📢 Kokpit yükleniyor, lütfen bekleyin...",
      "err_fetch_ats": "ATS verisi çekilemedi:",
      "err_fetch_kudos": "Kudos akışı çekilemedi:",
      "notif_pending_leaves": "{{count}} adet yıllık izin talebi onayınızı bekliyor.",
      "notif_pending_expenses": "{{count}} adet masraf beyanı onayınızı bekliyor.",
      "notif_pending_documents": "{{count}} adet evrak onayınızı bekliyor.",
      "notif_dossier_missing_required_documents": "{{count}} adet zorunlu evrak eksiği gözden geçirilmeyi bekliyor.",
      "notif_dossier_expired_documents": "{{count}} adet evrakın süresi dolmuş görünüyor.",
      "notif_dossier_expiring_documents": "{{count}} adet evrak yakında sona erecek.",
      "notif_open_tickets": "IT/Destek departmanında {{count}} adet açık talep (ticket) var.",
      "notif_all_clear": "Şu anda beklemede olan onay işleminiz bulunmuyor. Harika bir gün!",
      "notif_last_announcement": "Son Duyuru: {{title}}",
      "notif_welcome": "Sisteme hoş geldiniz, iyi çalışmalar dileriz.",
      "err_server_unreachable": "Sunucuya bağlanılamadı. Lütfen daha sonra tekrar deneyin.",
      "lbl_dashboard_warning": "Kokpit Yükleme Uyarısı",
      "btn_view_all": "TÜMÜNÜ GÖR",
      "btn_new_job_posting": "YENİ İLAN AÇ",
      "btn_go_to_roster": "KADROYA GİT",
      "lbl_ats_summary": "İŞE ALIM (ATS) ÖZETİ",
      "lbl_active_jobs": "{{count}} AKTİF İLAN",
      "lbl_loading": "YÜKLENİYOR...",
      "msg_no_active_jobs_html": "ŞU AN AKTİF BİR İŞ İLANI<br/>BULUNMUYOR",
      "lbl_unnamed_job": "İSİMSİZ İLAN",
      "lbl_candidates_waiting": "{{count}} Aday Bekliyor",
      "lbl_daily_roster": "GÜNÜN KADRO DURUMU",
      "lbl_on_site": "ŞU AN SAHADA",
      "lbl_person": "Kişi",
      "lbl_on_leave": "İZİNLİ / RAPORLU",
      "lbl_kudos_title": "TEŞEKKÜR & TAKDİR (KUDOS)",
      "msg_no_kudos_html": "HENÜZ BİR TEŞEKKÜR YOK.<br/>İLK TAKDİRİ SEN GÖNDER!",
      "lbl_thanked_suffix": "'ya teşekkür etti.",
      "lbl_company_news": "ŞİRKET HABERLERİ & DUYURULAR",
      "msg_no_announcement_html": "GÜNCEL BİR DUYURU<br/>BULUNMUYOR",
      "doc_id": "KİMLİK / PASAPORT FOTOKOPİSİ",
      "doc_pre_permit": "ÖN İZİN EVRAKLARI (KKTC)",
      "doc_work_permit": "ÇALIŞMA İZNİ & SAĞLIK RAPORU",
      "doc_residency": "İKAMET / ADRES TEYİT BELGESİ",
      "doc_visa": "VİZE / OTURUM İZNİ",
      "doc_contract": "İŞ SÖZLEŞMESİ (HİZMET AKDİ)",
      "doc_nda": "GİZLİLİK / NDA",
      "doc_handbook_ack": "EL KİTABI ONAYI",
      "doc_background_check": "ARKA PLAN KONTROLÜ",
      "doc_ohs_training": "İSG EĞİTİM / SAĞLIK UYGUNLUK",
      "doc_bank_info": "BANKA / IBAN BİLGİSİ",
      "doc_tax_doc": "VERGİ / TIN BELGESİ",
      "doc_payroll": "MAAŞ BORDROSU",
      "doc_social_security_record": "SOSYAL GÜVENLİK KAYDI",
      "doc_performance_review": "PERFORMANS DEĞERLENDİRME",
      "doc_training_record": "EĞİTİM KAYDI",
      "doc_leave_record": "İZİN / DEVAMSIZLIK BELGESİ",
      "doc_disciplinary": "DİSİPLİN KAYDI",
      "doc_termination": "İŞTEN AYRILMA (FESİH / İBRANAME)",
      "doc_exit_interview": "ÇIKIŞ GÖRÜŞMESİ",
      "doc_onboarding_checklist": "ONBOARDING CHECKLIST",
      "doc_offboarding_checklist": "OFFBOARDING CHECKLIST",
      "doc_certificate": "SERTİFİKA & MESLEKİ EĞİTİM",
      "doc_other": "DİĞER EVRAKLAR",
      "lbl_employee": "Personel",
      "lbl_first_name": "Ad",
      "lbl_last_name": "Soyad",
      "err_fetch_files": "Dosyalarınız çekilemedi.",
      "err_fetch_emps": "Personeller çekilemedi.",
      "err_fetch_docs": "Evraklar çekilemedi.",
      "err_file_size": "Dosya boyutu 10MB'dan büyük olamaz.",
      "msg_uploading_doc": "Evrak arşive yükleniyor...",
      "msg_upload_pending": "Evrak başarıyla yüklendi ve yönetici onayına sunuldu.",
      "msg_upload_success": "Evrak başarıyla arşive eklendi.",
      "msg_document_status_updated": "Evrak durumu {{status}} olarak güncellendi.",
      "err_document_status_update": "Evrak durumu güncellenemedi.",
      "err_upload_failed": "Evrak yüklenirken hata oluştu.",
      "action_approved": "Onaylandı",
      "action_rejected": "Reddedildi",
      "msg_status_updated": "Evrak durumu {{status}} olarak güncellendi.",
      "err_status_update": "Durum güncellenemedi.",
      "err_delete_pending_only": "Sadece onay bekleyen (PENDING) evraklarınızı silebilirsiniz.",
      "msg_confirm_delete_doc": "Bu evrak kalıcı olarak silinecek. Emin misiniz?",
      "msg_delete_success": "Evrak başarıyla arşivden silindi.",
      "err_delete_failed": "Evrak silinemedi.",
      "lbl_archive_selection": "ARŞİV SEÇİMİ",
      "lbl_selected_employee": "SEÇİLİ PERSONEL",
      "msg_no_employee_selected": "Henüz personel seçilmedi",
      "btn_select_employee_archive": "PERSONEL SEÇ",
      "btn_change_employee_archive": "PERSONEL DEĞİŞTİR",
      "msg_select_emp_focus_html": "E-ÖZLÜK DOSYASINI GÖRMEK İÇİN<br/>ÖNCE BİR PERSONEL SEÇİNİZ.",
      "ph_search_emp": "İsim veya departman ara...",
      "msg_select_emp_html": "E-ÖZLÜK ARŞİVİNİ GÖRÜNTÜLEMEK İÇİN<br/>SOL TARAFTAN BİR PERSONEL SEÇİNİZ.",
      "lbl_my_dossier": "KİŞİSEL E-ÖZLÜK ARŞİVİM",
      "lbl_official_dossier": "RESMİ PERSONEL DOSYASI",
      "lbl_archive_size": "ARŞİV BOYUTU",
      "lbl_docs": "EVRAK",
      "lbl_upload_new_doc": "SİSTEME YENİ EVRAK YÜKLE",
      "lbl_doc_category": "EVRAK KATEGORİSİ",
      "lbl_doc_number": "BELGE NO",
      "lbl_doc_number_short": "NO",
      "lbl_doc_issued_by": "VEREN KURUM",
      "lbl_doc_issue_date": "DÜZENLENME TARİHİ",
      "lbl_doc_valid_until": "GEÇERLİLİK TARİHİ",
      "lbl_doc_mandatory": "ZORUNLU EVRAK",
      "lbl_dossier_compliance": "EVRAK UYUM ÖZETİ",
      "lbl_uploaded_documents": "YÜKLENMİŞ EVRAKLAR",
      "lbl_document_detail": "EVRAK DETAYI",
      "tab_uploaded_documents": "YÜKLENMİŞ EVRAKLAR",
      "tab_upload_document": "EVRAK YÜKLE",
      "tab_compliance": "UYUM ÖZETİ",
      "lbl_completion_score": "TAMAMLILIK SKORU",
      "lbl_expiring_soon": "YAKINDA SONA ERECEK",
      "lbl_expired_docs": "SÜRESİ DOLAN",
      "lbl_missing_required": "EKSİK ZORUNLU",
      "msg_missing_required_docs": "EKSİK ZORUNLU EVRAKLAR",
      "msg_all_required_docs_ready": "ZORUNLU EVRAKLAR TAMAM",
      "msg_dossier_compliant": "Bu arşivde tanımlı zorunlu evraklar şu an eksiksiz görünüyor.",
      "lbl_expired_required_docs": "SÜRESİ DOLAN ZORUNLU EVRAKLAR",
      "lbl_expiring_required_docs": "YAKINDA BİTECEK ZORUNLU EVRAKLAR",
      "msg_no_expired_required_docs": "Zorunlu belgelerde süresi dolmuş kayıt görünmüyor.",
      "msg_no_expiring_required_docs": "Yakında bitecek zorunlu evrak görünmüyor.",
      "lbl_country_role_rule_set": "ÜLKE / ROL KURAL SETİ",
      "dossier_profile_tr": "TR PROFİLİ",
      "dossier_profile_kktc": "KKTC PROFİLİ",
      "dossier_profile_eu": "AB PROFİLİ",
      "dossier_profile_mena": "MENA PROFİLİ",
      "dossier_profile_global": "GLOBAL PROFİL",
      "msg_select_doc_for_detail": "DETAYI GÖRMEK İÇİN BİR EVRAK SEÇİN",
      "badge_expiring_soon": "YAKINDA BİTİYOR",
      "badge_expired": "SÜRESİ DOLDU",
      "lbl_missing_required_dossier_docs": "EKSİK ZORUNLU EVRAKLAR",
      "msg_missing_required_dossier_docs_waiting": "zorunlu evrak eksiği takip bekliyor.",
      "lbl_expired_dossier_docs": "SÜRESİ DOLAN EVRAKLAR",
      "msg_expired_dossier_docs_waiting": "yenilenmesi gereken evrak bulunuyor.",
      "lbl_expiring_dossier_docs": "YAKINDA BİTECEK EVRAKLAR",
      "msg_expiring_dossier_docs_waiting": "yakında süresi dolacak evrak var.",
      "lbl_select_file_format": "DOSYA SEÇİN (PDF / RESİM)",
      "btn_choose_from_pc": "BİLGİSAYARDAN DOSYA SEÇİN",
      "btn_uploading": "YÜKLENİYOR...",
      "btn_upload_to_archive": "ARŞİVE YÜKLE",
      "lbl_max_file_size": "Maksimum Dosya Boyutu: 10MB",
      "msg_searching_docs": "Evraklar aranıyor...",
      "msg_no_docs_found": "Bu personelin dosyasında henüz evrak bulunmuyor.",
      "badge_pending_approval": "ONAY BEKLİYOR",
      "badge_approved_doc": "ONAYLI EVRAK",
      "badge_rejected_doc": "REDDEDİLDİ",
      "tooltip_view_doc": "Evrakı Görüntüle",
      "btn_approve": "ONAYLA",
      "btn_reject": "REDDET",
      "tooltip_delete_archive": "Arşivden Sil",
      "tooltip_download_doc": "Evrakı İndir",
      "err_fetch_assets": "Zimmet bilgileri çekilemedi.",
      "err_empty_issue": "Lütfen arıza detayını yazın.",
      "msg_sending_ticket": "Destek talebiniz IT departmanına iletiliyor...",
      "lbl_issue_report": "ARIZA BİLDİRİMİ",
      "lbl_serial_plate": "Seri No/Plaka",
      "lbl_category": "Kategori",
      "lbl_issue_details": "Sorun",
      "msg_ticket_created": "Arıza talebiniz başarıyla oluşturuldu!",
      "err_ticket_create_failed": "Talep oluşturulamadı. Lütfen yöneticinizle iletişime geçin.",
      "msg_confirm_acknowledge": "\"{{name}}\" isimli şirket varlığını fiziken, eksiksiz ve sağlam olarak teslim aldığınızı onaylıyor musunuz? (Bu işlem dijital imza yerine geçer)",
      "msg_acknowledging": "Teslim tutanağı onaylanıyor...",
      "msg_acknowledge_success": "Teslim alma işlemi başarıyla onaylandı!",
      "err_acknowledge_failed": "Onay işlemi başarısız oldu.",
      "lbl_my_active_assets": "AKTİF VARLIKLARIM",
      "msg_no_assets_html": "ÜZERİNİZDE ZİMMETLİ HERHANGİ BİR<br/>ŞİRKET VARLIĞI BULUNMUYOR.",
      "badge_in_repair": "TAMİRDE",
      "badge_active_device": "AKTİF CİHAZ",
      "lbl_no_serial_no": "SERİ NO BELİRTİLMEMİŞ",
      "lbl_allocation_date": "TAHSİS TARİHİ",
      "msg_please_acknowledge": "CİHAZI FİZİKEN TESLİM ALDIYSANIZ AŞAĞIDAN ONAYLAYINIZ.",
      "btn_acknowledge_asset": "CİHAZI TESLİM ALDIM (ONAYLA)",
      "btn_asset_in_repair": "CİHAZ ŞU AN SERVİSTE",
      "btn_report_issue": "ARIZA BİLDİR / DESTEK İSTE",
      "modal_title_issue_report": "ARIZA VE DESTEK BİLDİRİMİ",
      "msg_ticket_route_warning": "AÇACAĞINIZ BU DESTEK TALEBİ DOĞRUDAN IT (BİLGİ İŞLEM) DEPARTMANINA İLETİLECEKTİR.",
      "lbl_issue_desc": "SORUN NEDİR? DETAYLICA AÇIKLAYINIZ.",
      "ph_issue_example": "Örn: Cihazın ekranı kırıldı, bataryası şarj olmuyor, sisteme giriş yapamıyorum...",
      "btn_send_to_it": "TALEBİ IT'YE GÖNDER",
      "cat_food": "Yemek & Gıda",
      "cat_transport": "Yol & Ulaşım",
      "cat_accommodation": "Konaklama",
      "cat_education": "Eğitim & Kurs",
      "cat_office": "Ofis Malzemesi",
      "cat_customer": "Müşteri Ağırlama",
      "cat_other": "Diğer",
      "err_fetch_expenses": "Masraflar çekilemedi.",
      "err_missing_receipt": "Lütfen harcamanıza ait bir fiş veya fatura görseli yükleyin!",
      "lbl_no_desc": "Açıklama girilmedi.",
      "msg_uploading_expense": "Masraf beyanı sisteme yükleniyor...",
      "msg_expense_submitted": "Masrafınız fişiyle birlikte onaya gönderildi!",
      "err_submit_expense": "Masraf eklenirken bir hata oluştu.",
      "msg_confirm_cancel_expense": "Bu masraf beyanını iptal etmek istediğinize emin misiniz?",
      "msg_canceling_expense": "Masraf iptal ediliyor...",
      "msg_expense_canceled": "Masraf başarıyla iptal edildi.",
      "err_cancel_failed": "İptal işlemi başarısız.",
      "btn_new_receipt": "YENİ FİŞ / FATURA GİR",
      "lbl_pending_approval": "ONAY BEKLEYEN",
      "lbl_approved_total": "ONAYLANAN (TOPLAM)",
      "lbl_past_declarations": "GEÇMİŞ BEYANLARIM",
      "msg_no_expenses_html": "HENÜZ SİSTEME GİRDİĞİNİZ BİR<br/>MASRAF BULUNMUYOR.",
      "tooltip_cancel_expense": "Masrafı İptal Et (Sil)",
      "btn_view_receipt": "FİŞİ GÖRÜNTÜLE",
      "badge_approved": "ONAYLANDI",
      "badge_rejected": "REDDEDİLDİ",
      "badge_pending": "BEKLİYOR",
      "lbl_cancel_reason": "İptal:",
      "modal_title_new_expense": "YENİ FİŞ / FATURA GİRİŞİ",
      "lbl_approved_paid": "ONAYLANAN HARCAMALARINIZ ÖDENECEKTİR",
      "msg_expense_policy": "LÜTFEN SADECE İŞ İLE İLGİLİ ŞİRKET HARCAMALARINIZI GİRİNİZ. ONAYLANAN MASRAFLAR MUHASEBELEŞTİRİLECEKTİR.",
      "msg_limit_warning": "GİRDİĞİNİZ TUTAR LİMİT OLAN {{limit}} BİRİMİN ÜZERİNDEDİR. YÖNETİCİ ONAYI UZAYABİLİR.",
      "lbl_amount": "TUTAR",
      "lbl_amount_preview": "TUTAR ÖNİZLEME",
      "lbl_currency": "DÖVİZ",
      "lbl_category": "KATEGORİ",
      "lbl_receipt_date": "FİŞ TARİHİ",
      "lbl_short_desc": "KISA AÇIKLAMA / DETAY",
      "ph_expense_desc": "Örn: Ankara müşteri ziyareti yemek bedeli...",
      "lbl_receipt_image": "FİŞ / FATURA GÖRSELİ VEYA PDF",
      "btn_open_cam_gallery": "KAMERAYI AÇ VEYA GALERİDEN SEÇ",
      "btn_submit_for_approval": "MASRAFI ONAYA GÖNDER",
      "modal_title_receipt": "MASRAF FİŞİ",
      "lbl_receipt_pdf": "Fiş PDF",
      "lbl_receipt_img": "Masraf Fişi",
      "lbl_img_not_found": "Gorsel+Bulunamadi",
      "btn_close_window": "PENCEREYİ KAPAT",
      "err_fetch_leaves": "İzinler çekilemedi.",
      "err_date_order": "Bitiş tarihi başlangıç tarihinden önce olamaz!",
      "msg_creating_leave_req": "İzin talebiniz oluşturuluyor...",
      "msg_leave_req_success": "İzin talebiniz başarıyla yönetici onayına sunuldu!",
      "err_form_invalid": "Form verileri eksik veya hatalı!",
      "err_create_failed": "Talep oluşturulamadı.",
      "msg_confirm_cancel_leave": "Bu izin talebini iptal etmek istediğinize emin misiniz?",
      "msg_canceling_leave": "İzin talebi iptal ediliyor...",
      "msg_leave_canceled": "İzin talebi başarıyla iptal edildi.",
      "type_annual": "YILLIK İZİN (ÜCRETLİ)",
      "type_excuse": "MAZERET İZNİ",
      "type_sick": "HASTALIK İZNİ (RAPORLU)",
      "type_unpaid": "ÜCRETSİZ İZİN",
      "lbl_used_this_year": "BU YIL KULLANILAN (ONAYLI)",
      "lbl_days": "GÜN",
      "btn_request_new_leave": "YENİ İZİN TALEP ET",
      "lbl_my_leave_movements": "İZİN HAREKETLERİM",
      "msg_no_leaves_html": "HENÜZ HERHANGİ BİR İZİN TALEBİNİZ<br/>BULUNMUYOR.",
      "tooltip_cancel_leave": "İzni İptal Et (Sil)",
      "lbl_note": "Not:",
      "modal_title_new_leave": "İZİN TALEBİ OLUŞTUR",
      "lbl_request_will_be_reviewed": "TALEBİNİZ YÖNETİCİ ONAYINA SUNULACAKTIR",
      "msg_leave_policy": "Yıllık izin talepleri İnsan Kaynakları ve Yöneticiniz tarafından değerlendirilecektir.",
      "lbl_leave_type": "İZİN TÜRÜ",
      "lbl_start_date": "BAŞLANGIÇ",
      "lbl_end_date": "BİTİŞ",
      "lbl_reason": "AÇIKLAMA / SEBEP",
      "ph_leave_reason": "Kısa bir açıklama yazabilirsiniz...",
      "btn_submit_leave_req": "TALEBİ ONAYA GÖNDER",
      "lbl_default_report_title": "Personel Listesi ve İSG Raporu",
      "col_fullname": "Ad Soyad",
      "col_identity": "TC/Kimlik No",
      "col_department": "Departman",
      "col_position": "Kadro",
      "col_blood_type": "Kan Grubu",
      "col_phone": "Telefon",
      "col_email": "E-Posta",
      "col_hire_date": "İşe Giriş",
      "col_education": "Eğitim",
      "col_nationality": "Uyruk",
      "opt_male": "Erkek",
      "opt_female": "Kadın",
      "opt_unknown": "Bilinmiyor",
      "opt_university": "Üniversite",
      "err_fetch_data": "Veri çekme hatası oluştu.",
      "lbl_unassigned_dept": "ATANMAMIŞ KADROLAR",
      "msg_opening_dossier": "Özlük dosyası açılıyor...",
      "err_loading_emp_details": "Personel detayları yüklenirken bir hata oluştu.",
      "prompt_exit_date": "İşten çıkış tarihi (YYYY-MM-DD):",
      "msg_confirm_archive": "{{name}} isimli personeli arşivlemek istediğinize emin misiniz?",
      "msg_archiving_emp": "Personel arşivleniyor...",
      "msg_archive_success": "Personel başarıyla arşivlendi ve kadrosu boşaltıldı.",
      "err_archive_failed": "Üzerinde zimmet/masraf olabilir, arşivlenemedi.",
      "msg_confirm_reset_pwd": "{{name}} isimli personelin şifresini sıfırlamak istediğinize emin misiniz?",
      "msg_resetting_pwd": "Şifre sıfırlanıyor...",
      "msg_reset_success": "Şifre başarıyla sıfırlandı. (Mail gönderildi)",
      "err_reset_failed": "Şifre sıfırlanırken bir hata oluştu.",
      "msg_processing_record": "Özlük kaydı işleniyor...",
      "msg_update_success": "Kayıt başarıyla güncellendi.",
      "msg_create_success": "Personel başarıyla sisteme eklendi.",
      "err_save_failed": "Kaydedilemedi. Girdiğiniz verileri kontrol ediniz.",
      "msg_preparing_pdf": "PDF Belgesi hazırlanıyor...",
      "msg_download_success": "Belge indirildi.",
      "err_pdf_failed": "PDF oluşturulurken bir hata oluştu!",
      "err_select_column": "Lütfen en az 1 sütun seçiniz.",
      "msg_generating_report": "Özel raporunuz oluşturuluyor...",
      "msg_report_downloaded": "Rapor başarıyla indirildi.",
      "err_report_failed": "Rapor oluşturulurken bir hata oluştu.",
      "msg_processing": "İşlem yapılıyor...",
      "msg_profile_updated": "Profil başarıyla güncellendi.",
      "msg_request_rejected": "Talep reddedildi.",
      "err_action_failed": "İşlem gerçekleştirilemedi.",
      "lbl_key_phone": "TELEFON NUMARASI",
      "lbl_key_address": "İKAMETGAH ADRESİ",
      "lbl_first_name": "AD",
      "lbl_last_name": "SOYAD",
      "lbl_identity_no": "KİMLİK / PASAPORT NO",
      "lbl_gender": "CİNSİYET",
      "lbl_mother_name": "ANNE ADI",
      "lbl_father_name": "BABA ADI",
      "lbl_birth_place": "DOĞUM YERİ",
      "lbl_birth_date": "DOĞUM TARİHİ",
      "lbl_phone_no": "CEP TELEFONU",
      "lbl_address": "İKAMETGAH ADRESİ",
      "lbl_nationality": "UYRUK / VATANDAŞLIK",
      "ph_nationality": "Örn: TC, KKTC",
      "lbl_marital_married": "MEDENİ HALİ: EVLİ",
      "lbl_spouse_name": "EŞİNİN ADI SOYADI",
      "lbl_spouse_works": "EŞİ ÇALIŞIYOR MU? (Vergi İndirimi)",
      "lbl_children_count": "BAKMAKLA YÜKÜMLÜ OLDUĞU ÇOCUK SAYISI",
      "lbl_child_name": "{{idx}}. ÇOCUK ADI SOYADI",
      "lbl_company_branch": "BAĞLI ŞİRKET / ŞUBE",
      "opt_select": "Seçiniz",
      "lbl_hire_date": "İŞE GİRİŞ TARİHİ",
      "lbl_department": "ÇALIŞACAĞI DEPARTMAN",
      "opt_select_dept": "DEPARTMAN SEÇİNİZ",
      "lbl_position": "ATANACAĞI KADRO (POZİSYON)",
      "opt_no_position": "KADRO SEÇİLMEDİ",
      "lbl_select_dept_first": "Önce departman seçin",
      "lbl_system_role": "SİSTEM YETKİSİ (ROL)",
      "role_employee": "STANDART ÇALIŞAN (Sadece Kendi Bilgileri)",
      "role_manager": "YÖNETİCİ / MÜDÜR (Kendi Ekibi ve Onaylar)",
      "role_hr": "İNSAN KAYNAKLARI (Tüm Personel ve İşlemler)",
      "role_admin": "SİSTEM YÖNETİCİSİ (Tam Yetki)",
      "desc_role_access": "Seçilen role göre sol menü ve veri erişimi otomatik ayarlanır.",
      "lbl_education_level": "EĞİTİM SEVİYESİ",
      "edu_primary": "İlkokul",
      "edu_middle": "Ortaokul",
      "edu_high": "Lise",
      "edu_university": "Üniversite",
      "edu_master": "Yüksek Lisans",
      "lbl_gross_salary": "ANLAŞILAN MAAŞ (BRÜT)",
      "lbl_blood_type": "KAN GRUBU (İSG)",
      "opt_not_selected": "Seçilmedi",
      "lbl_ssn": "SOSYAL GÜVENLİK NO (SGK / SSN)",
      "lbl_tax_no": "VERGİ / EK FON NO (Opsiyonel)",
      "lbl_emergency_contact_name": "ACİL DURUM KİŞİSİ",
      "lbl_emergency_contact_relation": "YAKINLIK DERECESİ",
      "lbl_emergency_contact_phone": "ACİL DURUM TELEFONU",
      "lbl_bank_name": "BANKA ADI",
      "lbl_account_holder_name": "HESAP SAHİBİ",
      "lbl_iban": "IBAN",
      "lbl_tax_id_number": "VERGİ KİMLİK / TIN",
      "lbl_work_auth_type": "ÇALIŞMA YETKİ TÜRÜ",
      "lbl_work_auth_no": "ÇALIŞMA YETKİ NO",
      "lbl_work_auth_start": "YETKİ BAŞLANGICI",
      "lbl_work_auth_expiry": "YETKİ BİTİŞİ",
      "lbl_visa_type": "VİZE / OTURUM TÜRÜ",
      "lbl_visa_expiry": "VİZE BİTİŞ TARİHİ",
      "lbl_nda_signed_at": "NDA İMZA TARİHİ",
      "lbl_handbook_ack_signed_at": "EL KİTABI ONAY TARİHİ",
      "lbl_background_check_status": "ARKA PLAN KONTROL DURUMU",
      "lbl_background_check_completed_at": "ARKA PLAN KONTROL TARİHİ",
      "lbl_occupational_health_status": "İSG / SAĞLIK UYGUNLUK",
      "lbl_occupational_health_valid_until": "İSG / SAĞLIK GEÇERLİLİK",
      "opt_not_started": "Başlatılmadı",
      "opt_in_progress": "Devam Ediyor",
      "opt_completed_short": "Tamamlandı",
      "opt_exempt": "Muaf",
      "opt_fit": "Uygun",
      "opt_restricted": "Kısıtlı Uygun",
      "opt_expired": "Süresi Doldu",
      "tab_active_roster": "AKTİF KADRO",
      "tab_archive_roster": "ARŞİV (ÇIKANLAR)",
      "btn_approvals": "ONAYLAR",
      "btn_custom_report": "ÖZEL RAPOR OLUŞTUR",
      "btn_new_record": "YENİ KAYIT",
      "col_head_name": "AD SOYAD / KADRO",
      "col_head_company": "ŞİRKET / LOKASYON",
      "col_head_hire": "İŞE GİRİŞ",
      "col_head_exit": "İŞTEN ÇIKIŞ",
      "col_head_actions": "İŞLEMLER",
      "msg_no_records_tab": "Bu sekmede kayıt bulunmuyor.",
      "lbl_personnel_count": "PERSONEL",
      "lbl_unassigned_short": "KADRO ATANMAMIŞ",
      "tooltip_download_card": "Personel Bilgi Kartı (PDF) İndir",
      "tooltip_download_cert": "Resmi Çalışma Belgesi (PDF) İndir",
      "tooltip_reset_pwd": "Sisteme Giriş Şifresini Sıfırla",
      "tooltip_edit": "Düzenle",
      "tooltip_terminate": "İşten Çıkar (Arşivle)",
      "modal_title_approvals": "PROFİL GÜNCELLEME TALEPLERİ",
      "msg_no_pending_requests_html": "TÜM TALEPLER İNCELENDİ!<br/>ONAY BEKLEYEN İŞLEM YOK.",
      "badge_new_request": "YENİ TALEP",
      "btn_reject": "REDDET",
      "btn_approve": "ONAYLA",
      "modal_title_custom_report": "ÖZEL RAPOR OLUŞTUR",
      "lbl_report_title": "RAPOR BAŞLIĞI",
      "lbl_report_columns": "RAPORDA YER ALACAK BİLGİLER (SÜTUNLAR)",
      "btn_cancel": "İPTAL",
      "btn_download_pdf_report": "PDF RAPORU İNDİR",
      "modal_title_edit_emp": "ÖZLÜK DOSYASINI GÜNCELLE",
      "modal_title_new_emp": "YENİ PERSONEL ÖZLÜK KAYDI",
      "step_1": "1. KİMLİK",
      "step_2": "2. İLETİŞİM & AİLE",
      "step_3": "3. KURUMSAL",
      "step_4": "4. FİNANS & YASAL",
      "btn_back": "GERİ",
      "lbl_step": "ADIM {{step}} / 4",
      "btn_next": "İLERİ",
      "btn_update_record": "KAYDI GÜNCELLE",
      "btn_complete_record": "ÖZLÜK KAYDINI TAMAMLA",
      "err_session_expired": "Oturum süreniz dolmuş olabilir, lütfen tekrar giriş yapın.",
      "err_fetch_performance": "Performans verileri çekilemedi.",
      "msg_progress_saved": "İlerleme durumu kaydedildi.",
      "err_progress_update": "İlerleme güncellenemedi.",
      "lbl_loading_performance": "PERFORMANS VERİLERİ YÜKLENİYOR...",
      "lbl_ai_career_assistant": "YAPAY ZEKA (AI) KARİYER ASİSTANI",
      "msg_default_ai_summary": "Geçmiş değerlendirmelerine ve hedeflerine göre harika bir ivme yakaladın. Aynen böyle devam!",
      "lbl_active_goals": "AKTİF HEDEFLERİM (OKRS)",
      "msg_no_assigned_goals": "HENÜZ ATANMIŞ BİR HEDEFİN BULUNMUYOR.",
      "lbl_progress_status": "İLERLEME DURUMU",
      "lbl_drag_to_save": "Kaydetmek için çubuğu sürükleyip bırakın",
      "lbl_my_reviews": "DEĞERLENDİRMELERİM",
      "msg_no_past_reviews": "GEÇMİŞ DEĞERLENDİRMEN YOK.",
      "lbl_manager_note": "YÖNETİCİ NOTU",
      "mood_great": "HARİKA",
      "mood_good": "İYİ",
      "mood_normal": "NORMAL",
      "mood_bad": "KÖTÜ",
      "mood_awful": "BERBAT",
      "badge_team_star": "🌟 Takım Yıldızı",
      "badge_fast_solver": "🚀 Hızlı Çözücü",
      "badge_helpful": "🦸‍♂️ Süper Yardımsever",
      "badge_creative": "💡 İnovatif Fikir",
      "lbl_employee_fallback": "Çalışan",
      "err_fetch_portal": "Portal verisi alınamadı, lütfen sayfayı yenileyin.",
      "msg_creating_leave": "İzin talebiniz oluşturuluyor...",
      "msg_leave_success": "İzin talebiniz başarıyla yönetici onayına sunuldu!",
      "err_leave_failed": "Talep oluşturulamadı.",
      "msg_no_changes": "Bir değişiklik yapmadınız.",
      "msg_sending_update": "Güncelleme talebiniz iletiliyor...",
      "msg_update_success": "Değişiklik talebiniz onay için İK'ya gönderildi!",
      "err_update_failed": "Talep iletilemedi. Lütfen tekrar deneyin.",
      "err_pwd_match": "Yeni şifreler eşleşmiyor!",
      "err_pwd_length": "Şifre en az 6 karakter olmalıdır.",
      "msg_changing_pwd": "Şifreniz değiştiriliyor...",
      "msg_pwd_changed": "Şifreniz başarıyla değiştirildi!",
      "err_pwd_failed": "Şifre değiştirilemedi.",
      "msg_mood_success": "Ruh halin ekibe başarıyla iletildi!",
      "err_mood_failed": "Ruh hali kaydedilemedi.",
      "msg_sending_kudos": "Rozetiniz iletiliyor...",
      "msg_kudos_success": "Teşekkür rozetiniz başarıyla gönderildi!",
      "err_kudos_failed": "Rozet gönderilemedi.",
      "lbl_loading_portal": "PORTALINIZ YÜKLENİYOR...",
      "lbl_hello": "MERHABA, {{name}} 👋",
      "lbl_personnel": "PERSONEL",
      "lbl_general_dept": "GENEL DEPARTMAN",
      "btn_account_pwd": "HESABIM / ŞİFRE",
      "btn_req_new_leave": "YENİ İZİN TALEP ET",
      "lbl_used_this_year": "BU YIL KULLANILAN: {{days}} GÜN",
      "btn_declare_expense": "MASRAF BEYAN ET",
      "lbl_receipt_invoice": "FİŞ VE FATURA GİRİŞİ",
      "lbl_how_do_you_feel": "BUGÜN NASIL HİSSEDİYORSUN?",
      "lbl_share_mood": "Ruh halini paylaş, ekibine enerji gönder!",
      "lbl_upcoming_trainings": "YAKLAŞAN EĞİTİMLERİM",
      "lbl_no_trainings": "PLANLANMIŞ VEYA YAKLAŞAN EĞİTİMİNİZ BULUNMUYOR.",
      "lbl_participant": "KATILIMCI",
      "lbl_my_assets": "ÜZERİMDEKİ ZİMMETLER",
      "lbl_no_assets": "ÜZERİNİZDE AKTİF ZİMMET YOK.",
      "lbl_celebrations_this_month": "BU AY KUTLUYORUZ!",
      "lbl_no_celebrations": "BU AY KUTLANACAK BİR<br/>ETKİNLİK YOK.",
      "lbl_day": "GÜN",
      "lbl_birthday": "DOĞUM GÜNÜ",
      "lbl_anniversary": "{{years}}. YIL DÖNÜMÜ",
      "lbl_kudos_board": "TAKDİR PANOSU",
      "tooltip_send_badge": "Rozet Gönder",
      "lbl_no_kudos": "HENÜZ KİMSE ROZET GÖNDERMEDİ.<br/>İLK TEŞEKKÜR EDEN SEN OL!",
      "modal_title_kudos": "TEŞEKKÜR ROZETİ GÖNDER",
      "lbl_to_whom": "KİME GÖNDERİYORSUNUZ?",
      "opt_select_colleague": "-- Çalışma Arkadaşı Seçin --",
      "lbl_select_badge": "ROZET SEÇİMİ",
      "lbl_write_note": "GÜZEL BİR NOT YAZIN",
      "ph_kudos_note": "Yardımların için çok teşekkür ederim...",
      "btn_send_kudos": "ROZETİ VE MESAJI GÖNDER",
      "modal_title_leave": "İZİN TALEBİ OLUŞTUR",
      "lbl_manager_approval": "TALEBİNİZ YÖNETİCİ ONAYINA SUNULACAKTIR",
      "lbl_used_leave": "BU YIL KULLANILAN İZİN",
      "lbl_days": "GÜN",
      "lbl_leave_type": "İZİN TÜRÜ",
      "opt_annual": "YILLIK İZİN (ÜCRETLİ)",
      "opt_excuse": "MAZERET İZNİ",
      "opt_sick": "HASTALIK İZNİ (RAPORLU)",
      "opt_unpaid": "ÜCRETSİZ İZİN",
      "lbl_start": "BAŞLANGIÇ",
      "lbl_end": "BİTİŞ",
      "lbl_reason": "AÇIKLAMA / SEBEP",
      "ph_reason": "Kısa bir açıklama yazabilirsiniz...",
      "btn_cancel": "İPTAL",
      "btn_submit_approval": "TALEBİ ONAYA GÖNDER",
      "modal_title_settings": "HESAP AYARLARI",
      "tab_contact": "İLETİŞİM BİLGİLERİ",
      "tab_password": "ŞİFRE DEĞİŞTİR",
      "lbl_update_req": "GÜNCELLEME TALEBİ",
      "desc_update_req": "Burada yaptığınız değişiklikler \"Taslak\" olarak İnsan Kaynakları departmanına iletilir. Onaylandığında resmi dosyanıza işlenir.",
      "lbl_phone": "TELEFON NUMARASI",
      "ph_phone": "05XX XXX XX XX",
      "lbl_address": "İKAMETGAH ADRESİ",
      "ph_address": "Açık adresinizi giriniz...",
      "lbl_old_pwd": "MEVCUT ŞİFRENİZ",
      "ph_old_pwd": "Sisteme girerken kullandığınız şifre",
      "lbl_new_pwd": "YENİ ŞİFRENİZ",
      "ph_new_pwd": "En az 6 karakter",
      "lbl_confirm_pwd": "YENİ ŞİFRE (TEKRAR)",
      "ph_confirm_pwd": "Yeni şifrenizi doğrulayın",
      "btn_change_pwd": "ŞİFREMİ DEĞİŞTİR",
      "err_fetch_trainings": "Eğitim takviminiz çekilemedi.",
      "lbl_loading_trainings": "EĞİTİM TAKVİMİ YÜKLENİYOR...",
      "lbl_assigned_training": "SİZE ATANAN EĞİTİM:",
      "lbl_count": "ADET",
      "msg_no_upcoming_html": "YAKIN ZAMANDA KATILMANIZ GEREKEN<br/>BİR EĞİTİM BULUNMUYOR.",
      "badge_approaching": "YAKLAŞIYOR",
      "lbl_date": "TARİH",
      "lbl_time": "SAAT",
      "lbl_instructor": "EĞİTMEN",
      "lbl_location": "LOKASYON",
      "lbl_past_cancelled_trainings": "GEÇMİŞ & İPTAL EDİLEN EĞİTİMLER",
      "badge_cancelled_by_admin": "YÖNETİM TARAFINDAN İPTAL EDİLDİ",
      "lbl_unknown_field": "Bilinmeyen Alan",
      "err_format_invalid": "Hata ({{field}}): Eksik veya geçersiz format!",
      "err_no_user_id": "Kullanıcı kimliği bulunamadı.",
      "msg_confirm_approve": "Bu masraf beyanını ONAYLAMAK istediğinize emin misiniz?",
      "msg_processing": "İşlem gerçekleştiriliyor ve e-posta atılıyor...",
      "msg_confirm_delete_expense": "Bu masrafı tamamen SİLMEK istediğinize emin misiniz?",
      "msg_expense_deleted": "Masraf kaydı başarıyla silindi.",
      "tab_pending": "BEKLEYENLER",
      "tab_approved": "ONAYLANANLAR",
      "tab_rejected": "REDDEDİLENLER",
      "btn_new_expense": "YENİ MASRAF GİRİŞİ",
      "lbl_loading": "MASRAFLAR YÜKLENİYOR...",
      "msg_no_expenses_category_html": "BU KATEGORİDE MASRAF BEYANI BULUNMUYOR.",
      "col_personnel": "PERSONEL",
      "col_category_date": "KATEGORİ & TARİH",
      "col_amount": "TUTAR",
      "col_receipt": "FİŞ / FATURA",
      "col_description": "AÇIKLAMA / NOT",
      "col_actions": "İŞLEMLER",
      "badge_added_to_payroll": "BORDROYA EKLENDİ",
      "lbl_no_doc": "BELGE YOK",
      "lbl_action_completed": "İŞLEM TAMAMLANDI",
      "tooltip_delete_req": "Talebimi Sil",
      "lbl_no_action_needed": "İŞLEM GEREKMİYOR",
      "lbl_expense_date": "Masraf Tarihi",
      "lbl_desc_details": "Açıklama / Detay",
      "lbl_personnel_name": "PERSONEL:",
      "prompt_reject_reason": "Lütfen reddetme sebebini yazınız (Zorunlu Değil):",
      "prompt_reject_default": "Fiş görseli okunamıyor veya standart dışı.",
      "err_fetch_tickets": "Talepler çekilemedi.",
      "err_fetch_details": "Talep detayları çekilemedi.",
      "msg_creating_ticket": "Destek talebi oluşturuluyor...",
      "msg_ticket_created": "Talebiniz başarıyla oluşturuldu.",
      "err_create_ticket": "Talep oluşturulurken hata oluştu.",
      "msg_sending_msg": "Mesaj iletiliyor...",
      "lbl_file_attached": "Ekteki dosyayı inceleyebilirsiniz.",
      "msg_msg_sent": "Mesaj gönderildi!",
      "err_send_msg": "Mesaj gönderilemedi.",
      "msg_confirm_resolve": "Bu talebi ÇÖZÜLDÜ olarak işaretlemek istiyor musunuz? İşlem geri alınamaz ve sohbet kapatılır.",
      "msg_closing_ticket": "Talep kapatılıyor...",
      "msg_ticket_closed": "Talep başarıyla kapatıldı.",
      "err_update_status": "Durum güncellenemedi.",
      "status_open": "AÇIK",
      "status_in_progress": "İŞLEMDE",
      "status_resolved": "ÇÖZÜLDÜ",
      "cat_payroll": "BORDRO",
      "cat_it": "IT DESTEK",
      "cat_hr": "İK TALEBİ",
      "cat_admin": "İDARİ İŞLER / MALZEME",
      "btn_create_ticket": "YENİ TALEP OLUŞTUR",
      "lbl_tickets": "TALEPLER",
      "lbl_urgent": "ACİL",
      "msg_no_tickets_html": "SİSTEMDE KAYITLI BİR<br/>TALEP BULUNMUYOR.",
      "lbl_ticket_no": "TALEP NO:",
      "btn_close_ticket": "TALEBİ KAPAT",
      "msg_no_messages": "Henüz bir mesaj gönderilmemiş.",
      "btn_open_attachment": "EKTEKİ DOSYAYI AÇ",
      "lbl_click_to_view": "Görüntülemek için tıklayın",
      "ph_type_reply": "Bir cevap yazın...",
      "msg_ticket_closed_comment": "BU TALEP ÇÖZÜLDÜĞÜ İÇİN YORUMA KAPATILMIŞTIR.",
      "msg_select_ticket_html": "DETAYLARI VE MESAJLARI GÖRMEK İÇİN<br/>SOL TARAFTAN BİR TALEP SEÇİNİZ",
      "modal_title_new_ticket": "YENİ DESTEK TALEBİ",
      "lbl_subject_summary": "KONU ÖZETİ",
      "ph_subject": "Örn: 2024 Mart Bordromu Talep Ediyorum",
      "lbl_priority": "ÖNCELİK",
      "prio_low": "DÜŞÜK",
      "prio_normal": "NORMAL",
      "prio_urgent": "ACİL",
      "lbl_message_details": "MESAJINIZ / DETAY",
      "ph_ticket_message": "Talebinizi buraya yazın...",
      "btn_submit_ticket": "TALEBİ SİSTEME İLET",
      "err_fetch_requests": "İzin talepleri çekilirken bir hata oluştu.",
      "prompt_reject_reason": "Lütfen reddetme sebebini yazınız (Zorunludur):",
      "prompt_reject_default": "Operasyonel yoğunluk nedeniyle uygun değildir.",
      "err_reject_reason_required": "İzni reddetmek için bir sebep belirtmelisiniz.",
      "msg_confirm_approve": "Bu izin talebini ONAYLAMAK istediğinize emin misiniz?",
      "msg_processing": "İşlem gerçekleştiriliyor ve e-posta gönderiliyor...",
      "action_approved": "onaylandı",
      "action_rejected": "reddedildi",
      "msg_status_updated": "İzin talebi {{status}}.",
      "err_action_failed": "İşlem sırasında bir hata oluştu.",
      "err_missing_form_data": "Lütfen tarihleri ve mazereti eksiksiz doldurun.",
      "msg_creating_leave": "İzin talebiniz oluşturuluyor...",
      "msg_leave_req_success": "İzin talebiniz başarıyla oluşturuldu ve onaya gönderildi!",
      "err_leave_submit_failed": "Eksik bilgi girdiniz veya işlem başarısız oldu.",
      "err_fetch_summary": "Personel özeti çekilemedi.",
      "badge_pending": "ONAY BEKLİYOR",
      "badge_approved": "ONAYLANDI",
      "badge_rejected": "REDDEDİLDİ",
      "badge_unknown": "BİLİNMİYOR",
      "type_annual": "YILLIK İZİN (ÜCRETLİ)",
      "type_excuse": "MAZERET İZNİ",
      "type_sick": "HASTALIK İZNİ (RAPORLU)",
      "type_unpaid": "ÜCRETSİZ İZİN",
      "tab_pending_approvals": "ONAY BEKLEYENLER",
      "tab_approved_requests": "ONAYLANANLAR",
      "tab_rejected_requests": "REDDEDİLENLER",
      "btn_new_leave_req": "YENİ İZİN TALEBİ",
      "lbl_loading_requests": "TALEPLER YÜKLENİYOR...",
      "msg_no_requests_html": "BU KATEGORİDE HİÇBİR İZİN TALEBİ BULUNMUYOR.",
      "col_personnel": "PERSONEL",
      "col_status": "DURUM",
      "col_leave_type": "İZİN TÜRÜ",
      "col_date_range": "TARİH ARALIĞI",
      "col_days": "GÜN",
      "col_description": "AÇIKLAMA / NOT",
      "col_actions": "İŞLEMLER",
      "btn_leave_summary": "KALAN İZİN ÖZETİ",
      "lbl_cancel_note": "Not:",
      "lbl_action_completed": "İŞLEM TAMAMLANDI",
      "lbl_no_action_needed": "İŞLEM GEREKMİYOR",
      "lbl_pending_authorization": "YETKİ BEKLENİYOR",
      "btn_approve": "ONAYLA",
      "btn_reject": "REDDET",
      "modal_title_create_leave": "İZİN TALEBİ OLUŞTUR",
      "lbl_leave_type": "İzin Türü",
      "lbl_start": "Başlangıç",
      "lbl_end": "Bitiş",
      "lbl_calculated_days": "HESAPLANAN GÜN:",
      "lbl_days": "GÜN",
      "lbl_reason": "Mazeret / Açıklama",
      "ph_leave_reason": "İzin nedenini kısaca açıklayınız...",
      "btn_cancel": "İPTAL",
      "btn_submit_approval": "TALEBİ ONAYA GÖNDER",
      "modal_title_leave_summary": "İZİN HAKEDİŞ ÖZETİ",
      "lbl_total_used_this_year": "BU YIL KULLANILAN TOPLAM",
      "lbl_usage_breakdown": "KULLANIM KIRILIMI",
      "msg_no_approved_leaves": "Henüz onaylanmış bir izin kaydı bulunmuyor.",
      "btn_close_window": "PENCEREYİ KAPAT",
      "err_fetch_locations": "Konumlar çekilemedi.",
      "err_geo_not_supported": "Tarayıcınız konum servisini (GPS) desteklemiyor.",
      "msg_geo_success": "Konumunuz başarıyla alındı.",
      "err_geo_failed": "Konum alınamadı. Lütfen tarayıcı izinlerinizi kontrol edin.",
      "msg_saving_location": "Şantiye kaydediliyor...",
      "msg_location_updated": "Şantiye başarıyla güncellendi.",
      "msg_location_added": "Yeni şantiye başarıyla eklendi.",
      "msg_confirm_delete_location": "\"{{name}}\" şantiyesini silmek (arşive kaldırmak) istediğinize emin misiniz? Bu işlem, bu konuma ait QR kodunu iptal edecektir.",
      "msg_archiving_location": "Şantiye arşive alınıyor...",
      "msg_location_deleted": "Şantiye başarıyla silindi.",
      "err_delete_location": "Konum silinirken bir hata oluştu.",
      "msg_confirm_rotate_qr": "DİKKAT: \"{{name}}\" şantiyesinin mevcut QR kodunu iptal edip yepyeni bir güvenlik şifresi oluşturmak istediğinize emin misiniz? (Mevcut posterler çalışmayacaktır!)",
      "msg_resetting_qr": "QR Kodu sıfırlanıyor...",
      "msg_qr_rotated": "Güvenlik şifresi yenilendi. Yeni posteri indirmeyi unutmayın!",
      "err_rotate_qr": "QR kod yenilenirken bir hata oluştu.",
      "msg_preparing_poster": "PDF Poster hazırlanıyor...",
      "msg_poster_downloaded": "PDF İndirildi.",
      "err_poster_failed": "Poster oluşturulurken bir hata oluştu.",
      "lbl_anti_fraud_system": "ANTI-FRAUD (SAHTEKARLIK ÖNLEME) SİSTEMİ",
      "desc_anti_fraud_html": "Eklediğiniz her şantiye/ofis için sistem <span class='bg-rose-200 text-rose-900 px-2 py-0.5 rounded-md font-black'>Güvenlik Token'lı</span> A4 QR Poster üretir. Personel uzak mesafeden (veya WhatsApp'tan fotoğraf çekerek) okutmaya çalışırsa, sistem GPS doğrulaması yapıp girişi reddeder.",
      "btn_add_location": "ŞANTİYE / OFİS EKLE",
      "lbl_loading_locations": "KONUMLAR YÜKLENİYOR...",
      "msg_no_locations_html": "SİSTEME KAYITLI HİÇBİR ŞANTİYE/KONUM BULUNMUYOR.",
      "tooltip_reset_qr": "QR Şifresini Sıfırla (Anti-Fraud)",
      "tooltip_delete": "Sil (Arşive Al)",
      "lbl_no_address": "Adres Belirtilmemiş",
      "lbl_latitude": "ENLEM (LAT)",
      "lbl_longitude": "BOYLAM (LNG)",
      "lbl_security_radius": "GÜVENLİK ÇEMBERİ",
      "lbl_meters": "METRE",
      "btn_download_poster": "A4 QR POSTERİ İNDİR",
      "modal_title_edit_loc": "ŞANTİYE / OFİS DÜZENLE",
      "modal_title_new_loc": "YENİ ŞANTİYE / OFİS EKLE",
      "lbl_location_name": "KONUM ADI (Örn: Merkez Ofis)",
      "lbl_full_address": "AÇIK ADRES",
      "ph_optional": "İsteğe bağlı...",
      "lbl_gps_coordinates": "GPS KOORDİNATLARI",
      "btn_finding_location": "BULUNUYOR...",
      "btn_get_my_location": "MEVCUT KONUMUMU AL",
      "lbl_security_radius_input": "GÜVENLİK ÇEMBERİ (YARIÇAP - METRE)",
      "desc_radius_warning": "Personel bu çemberin dışına çıkarsa QR kod çalışmaz ve yoklama veremez.",
      "btn_update_location": "ŞANTİYEYİ GÜNCELLE",
      "btn_save_location": "ŞANTİYEYİ SİSTEME KAYDET",
      "login_failed_generic": "Giriş başarısız. Lütfen bilgilerinizi kontrol edin.",
      "server_unreachable": "Sunucuya ulaşılamıyor. Lütfen bağlantınızı kontrol edin.",
      "login_title": "İKPro Giriş",
      "email_label": "E-posta:",
      "password_label": "Şifre:",
      "login_button": "Giriş Yap",
      "lbl_user": "Kullanıcı",
      "role_superadmin": "SİSTEM YÖNETİCİSİ",
      "role_admin": "İNSAN KAYNAKLARI (MÜDÜR)",
      "role_hr": "İNSAN KAYNAKLARI (UZMAN)",
      "role_manager": "DEPARTMAN YÖNETİCİSİ",
      "role_employee_short": "PERSONEL",
      "lbl_notifications": "BİLDİRİMLER",
      "lbl_new": "YENİ",
      "msg_no_new_notifs": "YENİ BİLDİRİM YOK",
      "lbl_leave_requests": "İZİN TALEPLERİ",
      "lbl_items": "adet",
      "msg_leave_waiting": "izin talebi onayınızı bekliyor.",
      "lbl_expense_requests": "MASRAF TALEPLERİ",
      "msg_expense_waiting": "masraf onayınızı bekliyor.",
      "lbl_open_tickets": "AÇIK TALEPLER",
      "msg_ticket_waiting": "açık destek talebi var.",
      "btn_view_all_dashboard": "TÜMÜNÜ GÖR (KOKPİTE GİT)",
      "lbl_logged_in": "OTURUM AÇIK",
      "btn_secure_logout": "GÜVENLİ ÇIKIŞ YAP",
      "tooltip_drag_to_move": "Sürüklemek için tutun",
      "tooltip_edit_position": "KADRO BİLGİLERİNİ DÜZENLE",
      "tooltip_delete_position": "KADROYU SİL",
      "lbl_vacant_position": "BOŞ KADRO",
      "lbl_filled_positions": "DOLU KADROLAR",
      "lbl_employee_count": "PERSONEL SAYISI",
      "err_fetch_org_data": "Şema verileri çekilemedi.",
      "msg_confirm_delete_pos": "Bu kadroyu silmek istediğinize emin misiniz? Alt kadrolar ve personeller etkilenebilir.",
      "msg_deleting_pos": "Kadro siliniyor...",
      "msg_delete_success": "Kadro başarıyla silindi.",
      "err_delete_pos_failed": "Kadro içinde personel olabilir, silinemedi.",
      "msg_creating_dept": "Departman oluşturuluyor...",
      "msg_dept_added": "Yeni departman sisteme eklendi.",
      "err_add_dept": "Departman eklenemedi.",
      "err_hierarchy_loop": "HİYERARŞİ HATASI: Bir üst kadroyu, kendi altındaki bir kadroya bağlayamazsınız!",
      "msg_confirm_move_pos": "Bu kadroyu yeni yöneticisine bağlamak istediğinize emin misiniz?",
      "msg_updating_org": "Organizasyon güncelleniyor...",
      "msg_move_success": "Kadro başarıyla taşındı.",
      "err_move_failed": "Kadro taşınırken bir hata oluştu.",
      "err_select_dept": "Lütfen bir departman seçin!",
      "err_self_parent": "Bir kadroyu kendine bağlayamazsınız!",
      "msg_saving_pos": "Kadro kaydediliyor...",
      "msg_update_pos_success": "Kadro güncellendi.",
      "msg_create_pos_success": "Yeni kadro oluşturuldu.",
      "lbl_drag_drop_info": "KADROLARI SÜRÜKLEYİP BAĞLAYABİLİRSİNİZ",
      "btn_create_dept": "DEPARTMAN AÇ",
      "btn_create_position": "YENİ KADRO AÇ",
      "lbl_loading_chart": "ŞEMA OLUŞTURULUYOR...",
      "msg_empty_org_chart_html": "SİSTEMDE HENÜZ BİR KADRO YOK.<br/>ÖNCE DEPARTMAN AÇIN, ARDINDAN İLK POZİSYONU OLUŞTURUN.",
      "modal_title_new_dept": "YENİ DEPARTMAN AÇ",
      "lbl_department_name": "DEPARTMAN ADI",
      "ph_department_name": "Örn: BİLGİ TEKNOLOJİLERİ",
      "btn_save_dept": "DEPARTMANI KAYDET",
      "modal_title_edit_pos": "KADROYU GÜNCELLE",
      "modal_title_new_pos": "YENİ KADRO TANIMLA",
      "lbl_position_name": "KADRO / POZİSYON ADI",
      "ph_position_name": "Örn: SAHA MÜHENDİSİ",
      "lbl_belongs_to_dept": "AİT OLDUĞU DEPARTMAN",
      "lbl_parent_position": "ÜST KADRO (KİME BAĞLI?)",
      "opt_top_management": "EN TEPE YÖNETİM (BAĞLI DEĞİL)",
      "desc_parent_pos_info": "Bu kadrodaki çalışanların izinleri, seçtiğiniz üst kadrodaki kişiye düşer.",
      "btn_save_changes": "DEĞİŞİKLİKLERİ KAYDET",
      "btn_save_to_system": "SİSTEME KAYDET",
      "err_select_personnel": "Lütfen önce bir personel seçin!",
      "msg_ai_success": "AI 9-Box analizi tamamlandı.",
      "err_ai_failed": "Yapay Zeka analizi şu an oluşturulamadı.",
      "msg_goal_updated": "Hedef güncellendi.",
      "msg_goal_added": "Yeni hedef atandı.",
      "err_goal_saved": "Hedef kaydedilemedi!",
      "confirm_delete_goal": "Bu hedefi silmek istediğinize emin misiniz?",
      "msg_goal_deleted": "Hedef silindi.",
      "err_goal_deleted": "Hedef silinemedi!",
      "msg_progress_saved": "İlerleme kaydedildi.",
      "err_progress_update": "İlerleme güncellenemedi!",
      "msg_review_updated": "Değerlendirme güncellendi.",
      "msg_review_saved": "Değerlendirme kaydedildi.",
      "err_review_failed": "Değerlendirme hatası!",
      "confirm_delete_review": "Bu değerlendirmeyi silmek istediğinize emin misiniz?",
      "msg_review_deleted": "Değerlendirme silindi.",
      "err_review_deleted": "Değerlendirme silinemedi.",
      "tab_okr": "HEDEFLER (OKR)",
      "tab_360": "360° DEĞERLENDİRME",
      "tab_ai": "AI TALENT ANALİZİ",
      "opt_select_personnel": "PERSONEL SEÇİN",
      "lbl_eval_center": "DEĞERLENDİRME MERKEZİ",
      "msg_select_personnel": "LÜTFEN İŞLEM YAPMAK İÇİN BİR PERSONEL SEÇİNİZ.",
      "lbl_strategic_goals": "STRATEJİK HEDEFLER",
      "btn_add_goal": "YENİ HEDEF EKLE",
      "msg_no_goals": "HENÜZ ATANMIŞ BİR HEDEFİN BULUNMUYOR.",
      "lbl_progress": "MEVCUT İLERLEME",
      "msg_ai_analyzing": "AI VERİ ANALİZİ YAPILIYOR...",
      "lbl_9box_matrix": "9-BOX POTANSİYEL/PERFORMANS MATRİSİ",
      "lbl_ai_summary": "AI YÖNETİCİ ÖZETİ",
      "lbl_dev_suggestion": "Gelişim Önerisi",
      "val_fast_promo": "Hızlı Terfi / Liderlik Eğitimi",
      "lbl_risk_analysis": "Risk Analizi",
      "val_low_risk": "Düşük (Bağlılık Yüksek)",
      "msg_press_to_analyze": "Analiz başlatmak için butona basınız.",
      "btn_run_analysis": "ANALİZİ ÇALIŞTIR",
      "box_STAR": "STAR",
      "box_HIGH_POTENTIAL": "YÜKSEK POTANSİYEL",
      "box_ENIGMA": "KAPALI KUTU",
      "box_HIGH_PERFORMER": "YÜKSEK PERFORMANS",
      "box_CORE_EMPLOYEE": "KİLİT ÇALIŞAN",
      "box_DILEMMA": "İKİLEM",
      "box_SOLID_PERFORMER": "GÜVENİLİR PERFORMANS",
      "box_EFFECTIVE_EMPLOYEE": "ETKİLİ ÇALIŞAN",
      "box_UNDER_PERFORMER": "DÜŞÜK PERFORMANS",
      "lbl_feedback_pool": "GERİ BİLDİRİM HAVUZU",
      "btn_score": "PUANLAMA YAP",
      "msg_no_reviews": "GEÇMİŞ DEĞERLENDİRMEN YOK.",
      "lbl_peer_note": "İş Arkadaşı Notu",
      "modal_review_title": "PERFORMANS PUANLAMASI",
      "lbl_review_period": "Değerlendirme Dönemi",
      "opt_q1": "2026 Q1 (1. Çeyrek)",
      "opt_q2": "2026 Q2 (2. Çeyrek)",
      "opt_q3": "2026 Q3 (3. Çeyrek)",
      "opt_q4": "2026 Q4 (4. Çeyrek)",
      "opt_custom_period": "Özel Dönem Yaz...",
      "ph_custom_period": "Örn: 2026 Yıl Sonu Değerlendirmesi",
      "lbl_rating": "Genel Puan (1-5)",
      "lbl_manager_comments": "Yönetici Görüşü / Yorumlar",
      "ph_manager_comments": "Personelin güçlü yönleri ve gelişim alanları hakkında notlarınızı buraya yazın...",
      "btn_cancel": "İPTAL",
      "btn_save_score": "PUANLAMAYI KAYDET",
      "modal_goal_title": "HEDEF PARAMETRELERİ",
      "lbl_goal_title": "Hedef Başlığı",
      "lbl_goal_desc": "Detaylar",
      "lbl_due_date": "Bitiş Tarihi",
      "opt_end_q1": "2026-Q1 Sonu",
      "opt_end_q2": "2026-Q2 Sonu",
      "opt_end_q3": "2026-Q3 Sonu",
      "opt_end_q4": "2026-Q4 Sonu",
      "opt_custom_date": "Özel Tarih...",
      "btn_save": "KAYDET",
      "err_unauthorized_access": "Bu sayfaya erişim yetkiniz yok!",
      "err_fill_all_fields": "Lütfen tüm alanları doldurun.",
      "err_pwd_length": "Şifreniz en az 6 karakter olmalıdır.",
      "msg_creating_account": "Hesabınız ve şirketiniz oluşturuluyor...",
      "msg_registration_success": "Kayıt başarılı! 30 günlük denemeniz başladı.",
      "err_registration_failed": "Kayıt sırasında bir hata oluştu.",
      "lbl_welcome_title_html": "KTC HR'A<br/>HOŞ GELDİNİZ",
      "lbl_welcome_desc": "Şirketinizin tüm İK, performans, zimmet ve operasyonel süreçlerini tek bir çatı altından yönetmeye başlamak üzeresiniz.",
      "lbl_feature_1": "30 Gün Ücretsiz Deneme",
      "lbl_feature_2": "Sınırsız Personel Ekleme",
      "lbl_feature_3": "Dilediğiniz Zaman İptal",
      "lbl_step_company": "Şirket",
      "lbl_step_payment": "Ödeme",
      "lbl_corporate_info": "Kurumsal Bilgiler",
      "lbl_company_org_name": "Şirket / Organizasyon Adı",
      "ph_company_name": "Örn: Koçak Teknoloji A.Ş.",
      "lbl_manager_name": "Yönetici Adı Soyadı",
      "ph_manager_name": "Ad Soyad",
      "lbl_business_email": "İş E-Posta Adresi",
      "ph_business_email": "admin@sirket.com",
      "lbl_account_password": "Hesap Şifresi",
      "ph_password": "En az 6 karakter",
      "btn_proceed_payment": "ÖDEME ADIMINA GEÇ",
      "msg_already_have_account": "Zaten hesabınız var mı?",
      "btn_login_link": "Giriş Yapın",
      "lbl_payment_method": "Ödeme Yöntemi",
      "lbl_ssl_secure": "256-BIT SSL GÜVENLİ",
      "lbl_card_holder_display": "KART SAHİBİ",
      "lbl_full_name_display": "AD SOYAD",
      "lbl_expiry_display": "SKT",
      "lbl_mm_yy_display": "AA/YY",
      "lbl_card_name": "Kart Üzerindeki İsim",
      "ph_card_name": "Kart Sahibinin Adı",
      "lbl_card_number": "Kart Numarası",
      "lbl_expiry_date": "Son Kullanma",
      "ph_expiry_date": "AA/YY",
      "lbl_security_code": "Güvenlik Kodu",
      "ph_security_code": "CVC",
      "msg_no_charge_warning": "* 30 günlük ücretsiz deneme süreniz boyunca kredi kartınızdan <strong class='text-indigo-600'>herhangi bir ücret çekilmeyecektir.</strong>",
      "btn_back": "GERİ",
      "btn_complete_and_start": "KAYDI TAMAMLA VE BAŞLA",
      "lbl_loading": "YÜKLENİYOR...",
      "role_superadmin": "SİSTEM YÖNETİCİSİ",
      "role_admin": "İNSAN KAYNAKLARI (MÜDÜR)",
      "role_hr": "İNSAN KAYNAKLARI (UZMAN)",
      "role_manager": "DEPARTMAN YÖNETİCİSİ",
      "role_employee_short": "PERSONEL",
      "menu_dashboard": "KOKPİT",
      "menu_employees": "PERSONEL YÖNETİMİ",
      "menu_org_chart": "ORGANİZASYON ŞEMASI",
      "menu_ats": "ADAY TAKİP (ATS)",
      "menu_attendance": "ZAMAN & DEVAMLILIK",
      "menu_operations_time": "OPERASYON / ZAMAN DEVAMLILIK",
      "menu_locations": "KONUMLAR & ŞANTİYELER",
      "menu_leaves": "İZİN YÖNETİMİ",
      "menu_dossier": "E-ÖZLÜK ARŞİVİ",
      "menu_performance": "PERFORMANS (OKR)",
      "menu_training": "EĞİTİM (LMS)",
      "menu_expenses": "MASRAF & HARCAMA",
      "menu_assets": "ZİMMET & ENVANTER",
      "menu_helpdesk": "DESTEK MASASI",
      "menu_portal": "KOKPİT",
      "menu_my_team": "EKİBİM (PERSONEL)",
      "menu_settings": "ŞİRKET AYARLARI (YENİ)",
      "operations_time_kicker": "Operasyon / Zaman Devamlılık",
      "operations_time_title": "Puantaj ve bordro operasyonları",
      "operations_time_desc": "Resmi tatil takvimini, pay-code ve katsayı onaylarını, puantaj dönemlerini ve muhasebe export profilini tek operasyon ekranından yönetin.",
      "schedule_management_kicker": "Vardiya planlama",
      "schedule_management_title": "Vardiya planları ve atamalar",
      "schedule_management_desc": "Vardiya şablonlarını oluşturun, departmanlara atayın ve personel istisnalarını yönetin.",
      "schedule_management_open": "Vardiya planlamayı aç",
      "operations_time_tab_puantaj": "Puantaj",
      "operations_time_tab_schedules": "Vardiya Planlama",
      "operations_time_tab_leave": "İzin Ayarları",
      "operations_time_tab_departments": "Departman Atamaları",
      "operations_time_tab_overrides": "Personel İstisnası",
      "operations_time_tab_reports": "Bordro Raporu",
      "operations_time_tab_settings": "Puantaj Ayarları",
      "operations_time_tabs": "Zaman devamlılık sekmeleri",
      "pay_code_title": "Ücret kodu ve katsayı onayı",
      "pay_code_desc": "Onaylanmamış katsayılar muhasebe çıktısına alınmaz.",
      "pay_code_seed": "Varsayılanları oluştur",
      "pay_code_add": "Öner",
      "pay_code_category": "Kategori",
      "pay_code_code": "Kod",
      "pay_code_name": "Açıklama",
      "pay_code_accounting_code": "Muhasebe kodu",
      "pay_code_coefficient": "Katsayı",
      "pay_code_unit": "Birim",
      "pay_code_status_approved": "Onaylandı",
      "pay_code_status_proposed": "Onay bekliyor",
      "pay_code_status_rejected": "Reddedildi",
      "pay_code_reviewer": "Onay sorumlusu",
      "pay_code_reviewer_missing": "Bordro onay sorumlusu atanmadı; admin yedek akışı kullanılır.",
      "pay_code_waiting_reviewer": "Bordro sorumlusu onayı bekleniyor",
      "pay_code_category_work": "Çalışma",
      "pay_code_category_overtime": "Fazla mesai",
      "pay_code_category_holiday": "Resmi tatil",
      "pay_code_category_leave": "İzin",
      "pay_code_category_absence": "Devamsızlık",
      "payroll_export_title": "Muhasebe çıktı profili",
      "payroll_export_desc": "Onaylı profil olmadan muhasebe formatı kullanılamaz.",
      "payroll_export_provider": "Sağlayıcı",
      "payroll_export_format": "Format",
      "payroll_export_delimiter": "Ayraç",
      "payroll_export_date_format": "Tarih formatı",
      "payroll_export_propose": "Öner",
      "payroll_export_approve": "Onayla",
      "payroll_export_status_approved": "Onaylandı",
      "payroll_export_status_proposed": "Onay bekliyor",
      "timesheet_title": "Puantaj dönem hesaplama ve çıktı",
      "timesheet_desc": "Hesapla, onaya gönder, kilitle ve muhasebe çıktısını al.",
      "timesheet_start": "Başlangıç",
      "timesheet_end": "Bitiş",
      "timesheet_create": "Oluştur",
      "timesheet_calculate": "Hesapla",
      "timesheet_send_approval": "Onaya gönder",
      "timesheet_approve": "Onayla",
      "timesheet_lock": "Kilitle",
      "timesheet_export": "Çıktı al",
      "timesheet_status": "Durum",
      "timesheet_status_draft": "Taslak",
      "timesheet_status_calculated": "Hesaplandı",
      "timesheet_status_pending": "Onay bekliyor",
      "timesheet_status_approved": "Onaylandı",
      "timesheet_status_locked": "Kilitli",
      "timesheet_status_exported": "Çıktı alındı",
      "timesheet_calculated": "Puantaj hesaplandı.",
      "timesheet_sent_approval": "Onaya gönderildi.",
      "timesheet_approved": "Puantaj onaylandı.",
      "timesheet_locked": "Puantaj kilitlendi.",
      "refresh": "Yenile",
      "holiday_source_system": "Sistem",
      "holiday_source_company": "Şirket",
      "menu_logout": "GÜVENLİ ÇIKIŞ",
      "menu_audit_logs": "SİSTEM LOGLARI",
      "audit_logs_title": "SİSTEM LOG KAYITLARI",
      "audit_logs_subtitle": "SÜPERADMİN MERKEZİ DENETİM EKRANI",
      "audit_logs_records": "KAYIT",
      "audit_filter_company": "TÜM ŞİRKETLER",
      "audit_filter_action": "TÜM İŞLEMLER",
      "audit_filter_resource": "TÜM MODÜLLER",
      "audit_filter_employee": "TÜM KİŞİLER",
      "audit_filter_department": "TÜM DEPARTMANLAR",
      "audit_apply_filters": "FİLTRELE",
      "audit_reset_filters": "SIFIRLA",
      "audit_col_datetime": "TARİH / SAAT",
      "audit_col_company": "ŞİRKET",
      "audit_col_person": "KİŞİ",
      "audit_col_department": "DEPARTMAN",
      "audit_col_detail": "İŞLEM DETAYI",
      "audit_col_action": "İŞLEM",
      "audit_col_module": "MODÜL",
      "audit_col_status": "SONUÇ",
      "audit_col_path": "ENDPOINT",
      "audit_loading": "LOG KAYITLARI YÜKLENİYOR...",
      "audit_empty": "SEÇİLEN FİLTRELERDE KAYIT BULUNAMADI",
      "err_fetch_audit_filters": "Log filtreleri alınamadı.",
      "err_fetch_audit_logs": "Log kayıtları alınamadı.",
      "audit_detail_view_logs": "Sistem loglarını görüntüledi",
      "audit_detail_clock_in": "QR ve konum ile işe giriş yaptı",
      "audit_detail_clock_out": "QR ve konum ile çıkış yaptı",
      "audit_detail_bulk_attendance": "Toplu puantaj verisi yükledi",
      "audit_detail_schedule_create": "Mesai planı oluşturdu",
      "audit_detail_schedule_update": "Mesai planını güncelledi",
      "audit_detail_schedule_delete": "Mesai planını sildi",
      "audit_detail_schedule_assign_departments": "Departmanlara mesai planı atadı",
      "audit_detail_schedule_assign_employees": "Personele özel mesai planı atadı",
      "audit_detail_schedule_clear_employees": "Personel mesai istisnasını kaldırdı",
      "audit_detail_document_upload": "Evrak yükledi",
      "audit_detail_document_status": "Evrak durumunu güncelledi",
      "audit_detail_expense_create": "Masraf talebi oluşturdu",
      "audit_detail_expense_status": "Masraf durumunu güncelledi",
      "audit_detail_leave_create": "İzin talebi oluşturdu",
      "audit_detail_leave_status": "İzin durumunu güncelledi",
      "audit_detail_helpdesk_create": "Destek talebi oluşturdu",
      "audit_detail_helpdesk_message": "Destek talebine mesaj gönderdi",
      "audit_detail_helpdesk_status": "Destek talebinin durumunu güncelledi",
      "audit_detail_location_create": "Lokasyon ekledi",
      "audit_detail_location_update": "Lokasyonu güncelledi",
      "audit_detail_location_rotate_qr": "Lokasyon QR kodunu yeniledi",
      "audit_detail_location_poster": "QR posterini indirdi",
      "audit_detail_asset_assign": "Zimmet atadı",
      "audit_detail_asset_return": "Zimmeti iade aldı",
      "audit_detail_offer_letter": "Teklif mektubu oluşturdu",
      "audit_detail_failed_suffix": "ancak işlem hata ile sonuçlandı",
      "demo_goal_description": "Bu personel için örnek OKR hedefi",
      "demo_manager_review": "Örnek yönetici değerlendirmesi: hedef takibi ve ekip içi iletişim olumlu.",
      "demo_peer_review": "Örnek ekip arkadaşı geri bildirimi: destekleyici ve sorumluluk sahibi.",
      "err_fetch_data": "Veriler çekilirken bir hata oluştu.",
      "draft_cancel_msg": "Değerli Çalışma Arkadaşlarımız,\n\n{{date}} tarihinde gerçekleştirilmesi planlanan \"{{title}}\" konulu eğitimimiz iptal edilmiştir.\n\nBilginize sunar, iyi çalışmalar dileriz.",
      "msg_training_scheduled": "Yeni eğitim başarıyla planlandı.",
      "err_schedule_training": "Eğitim planlanamadı!",
      "err_select_min_one_emp": "Lütfen en az 1 personel seçin.",
      "msg_assigning_sending": "Personel atanıyor ve mail gönderiliyor...",
      "msg_assigned_invited": "Personeller atandı ve davetiyeler gönderildi!",
      "err_assign_failed": "Atama işlemi başarısız oldu.",
      "msg_canceling_sending": "İptal ediliyor ve mailler gönderiliyor...",
      "msg_training_canceled": "Eğitim iptal edildi ve katılımcılara bildirildi.",
      "err_cancel_failed": "İptal işlemi başarısız.",
      "msg_confirm_delete_training": "Bu eğitimi sistemden tamamen silmek istediğinize emin misiniz?",
      "msg_training_deleted": "Eğitim sistemden silindi.",
      "err_delete_training": "Eğitim silinemedi.",
      "msg_attendance_updated": "Yoklama durumu güncellendi.",
      "err_attendance_update": "Yoklama güncellenemedi!",
      "err_no_data_download": "İndirilecek veri bulunamadı.",
      "csv_headers": "Eğitim Adı,Tarih,Eğitmen,Personel Ad Soyad,Departman,Katılım Durumu\n",
      "msg_excel_downloaded": "Excel dosyası indirildi.",
      "btn_schedule_training": "YENİ EĞİTİM PLANLA",
      "msg_no_trainings_scheduled": "HENÜZ PLANLANMIŞ BİR EĞİTİM BULUNMUYOR.",
      "badge_cancelled": "İPTAL EDİLDİ",
      "badge_completed": "TAMAMLANDI",
      "badge_approaching": "YAKLAŞIYOR",
      "tooltip_delete": "Sil",
      "lbl_no_description": "Açıklama bulunmuyor.",
      "lbl_instructor": "EĞİTMEN",
      "lbl_date": "TARİH",
      "lbl_time": "SAAT",
      "lbl_participants": "KATILIMCI",
      "lbl_persons": "KİŞİ",
      "btn_assign_personnel": "PERSONEL ATA",
      "err_no_participants_assigned": "Bu eğitime kimse atanmamış.",
      "btn_take_attendance": "YOKLAMA YAP",
      "btn_cancel": "İPTAL ET",
      "modal_title_schedule_training": "YENİ EĞİTİM PLANLA",
      "lbl_training_title": "EĞİTİM ADI / KONUSU",
      "ph_training_title": "Örn: İleri Düzey Excel Eğitimi",
      "lbl_training_desc": "AÇIKLAMA",
      "ph_training_desc": "Eğitim içeriği hakkında kısa bilgi...",
      "ph_instructor": "Örn: Ahmet Yılmaz",
      "lbl_location": "KONUM / LİNK",
      "ph_location": "Toplantı Odası 1 veya Zoom Linki",
      "btn_save_publish_training": "EĞİTİMİ KAYDET VE YAYINLA",
      "modal_title_assign_personnel": "EĞİTİME PERSONEL ATA",
      "msg_invitation_will_be_sent": "SEÇİLEN PERSONELLERE DAVET MAİLİ GÖNDERİLECEKTİR.",
      "btn_assign_and_invite": "{{count}} PERSONELİ ATA VE DAVET ET",
      "modal_title_attendance_report": "EĞİTİM YOKLAMASI VE RAPORU",
      "lbl_registered_personnel_list": "KAYITLI PERSONEL LİSTESİ",
      "btn_download_excel": "EXCEL İNDİR",
      "msg_no_one_assigned": "BU EĞİTİME KİMSE ATANMAMIŞ.",
      "btn_attended": "KATILDI",
      "btn_not_attended": "KATILMADI",
      "modal_title_cancel_training": "EĞİTİMİ İPTAL ET",
      "lbl_cancellation_draft": "İPTAL BİLDİRİM TASLAĞI",
      "msg_cancellation_warning": "AŞAĞIDAKİ İPTAL MESAJI, BU EĞİTİME KAYITLI TÜM PERSONELLERE E-POSTA OLARAK GÖNDERİLECEKTİR. METNİ DÜZENLEYEBİLİRSİNİZ.",
      "lbl_cancel_email_content": "İPTAL E-POSTA İÇERİĞİ",
      "btn_cancel_and_notify": "İPTAL ET VE HERKESE BİLDİR",
      "title_leave_management": "İzin Yönetimi",
      "desc_leave_management_wip": "İzin talepleri ve onay süreci burada görüntülenecek.",
      "badge_under_construction": "Yapım Aşamasında",
      "mfa_title": "Güvenlik Doğrulaması",
      "mfa_subtitle": "E-posta adresinize gönderilen 6 haneli kodu giriniz.",
      "otp_code_label": "DOĞRULAMA KODU",
      "forgot_password": "Şifremi Unuttum",
      "lbl_system_subtitle": "Güvenli personel yönetim sistemine hoş geldiniz.",
      "btn_back_to_login": "Giriş Ekranına Dön",
      "invalid_mfa_code": "Geçersiz veya süresi dolmuş doğrulama kodu!",
      "password_too_short": "Şifre çok kısa (En az 8 karakter olmalıdır).",
      "password_too_weak": "Şifre çok zayıf (Büyük harf, küçük harf ve rakam içermelidir).",
      "password_no_special_char": "Şifre en az bir özel karakter içermelidir (@$!%*?&).",
      "email_already_in_use": "Bu e-posta adresi zaten kullanımda.",
      "default_department_name": "Yönetim Kurulu",
      "default_position_title": "Kurucu / Yönetici",
      "registration_successful": "Kayıt işlemi başarıyla tamamlandı.",
      "registration_error": "Kayıt sırasında beklenmeyen bir hata oluştu.",
      "invalid_credentials": "E-posta adresi veya şifre hatalı.",
      "account_suspended": "Hesabınız askıya alınmıştır. Lütfen yönetici ile iletişime geçin.",
      "mfa_code_sent": "Güvenlik kodu e-posta adresinize gönderildi.",
      "mfa_code_expired": "Güvenlik kodunun süresi dolmuş. Lütfen tekrar giriş yapın.",
      "reset_email_sent_if_exists": "Eğer sistemde böyle bir hesap varsa, şifre sıfırlama bağlantısı gönderilmiştir.",
      "btn_verify_code": "KODU DOĞRULA",
      "btn_back": "GERİ DÖN",
      "lbl_new_password": "Yeni Şifreniz",
      "btn_send_code": "Sıfırlama Kodu Gönder",
      "btn_reset_password": "Şifreyi Güncelle",
      "lbl_remembered_password": "Şifrenizi hatırladınız mı?",
      "msg_password_reset_success": "Şifreniz başarıyla güncellendi! Giriş yapabilirsiniz.",
      "err_password_match": "Şifreler birbiriyle eşleşmiyor.",
      "msg_password_updated": "Şifreniz başarıyla güncellendi.",
      "idle_warning_title": "Hâlâ burada mısınız?",
      "idle_warning_desc": "Güvenliğiniz için, işlem yapılmadığı takdirde oturumunuz birazdan sona erecek.",
      "btn_stay_logged_in": "Buradayım, oturumu açık tut",
      "btn_logout_now": "Şimdi çıkış yap",
      "idle_warning_title": "Hâlâ burada mısınız?",
      "idle_warning_desc": "Güvenliğiniz için, işlem yapılmadığı takdirde oturumunuz birazdan sona erecek.",
      "btn_stay_logged_in": "Buradayım, oturumu açık tut",
      "btn_logout_now": "Şimdi çıkış yap",
      "btn_clock_in": "İŞE BAŞLA",
      "btn_clock_out": "PAYDOS ET",
      "msg_getting_location": "Konumunuz algılanıyor...",
      "err_gps_not_supported": "Tarayıcınız GPS desteklemiyor!",
      "err_location_denied": "Lütfen tarayıcıdan konum izni verin!",
      "msg_clock_in_success": "Mesai başlatıldı!",
      "msg_clock_out_success": "Paydos edildi!",
      "err_geofence_failed": "Konum doğrulanamadı!",
      "msg_exporting": "Dışa aktarılıyor...",
      "msg_export_success": "Dosya başarıyla indirildi!",
      "err_export_failed": "Dışa aktarım başarısız oldu.",
      "btn_export_excel": "EXCEL",
      "btn_export_csv": "CSV",
      "btn_export_pdf": "PDF",
      "btn_send_email": "E-POSTA",
      "lbl_email_modal_title": "RAPORU GÖNDER",
      "ph_enter_email": "ALICI E-POSTA",
      "lbl_format": "FORMAT SEÇİMİ",
      "btn_cancel": "İPTAL",
      "btn_send": "GÖNDER",
      "err_empty_email": "Lütfen e-posta adresi girin.",
      "msg_sending_email": "E-posta gönderiliyor...",
      "msg_email_queued": "E-posta başarıyla sıraya alındı!",
      "err_email_failed": "E-posta gönderimi başarısız.",
      "file_attendance": "Puantaj",
      "sheet_attendance": "Puantaj_Raporu",
      "msg_employee_attendance_wip": "Personel Puantaj Ekranı Yapım Aşamasında...",
      "err_fetch_my_attendance": "Geçmiş kayıtlar alınamadı.",
      "err_no_geolocation": "Tarayıcınız konum özelliğini desteklemiyor.",
      "err_location_denied": "Konum erişimi reddedildi veya alınamadı. Lütfen tarayıcı ayarlarından konum izni verin.",
      "msg_getting_location": "Konumunuz alınıyor, lütfen bekleyin...",
      "msg_verifying_location": "Konum doğrulanıyor...",
      "msg_validating_qr_location": "QR ve konum doğrulanıyor...",
      "msg_success": "İşlem başarılı!",
      "msg_attendance_completed": "Puantaj işlemi başarıyla tamamlandı.",
      "msg_requesting_camera": "Kamera izni bekleniyor...",
      "msg_scan_qr_prompt": "QR kodu kameraya gösterin. Kamera ve konum izni zorunludur.",
      "msg_qr_detected": "QR kod algılandı. Konum doğrulanıyor...",
      "err_action_failed": "İşlem başarısız oldu.",
      "err_camera_not_supported": "Bu tarayıcı kamera erişimini desteklemiyor. Lütfen farklı bir cihaz veya tarayıcı kullanın.",
      "err_camera_qr_not_supported": "Bu tarayıcı kamera ile QR okumayı desteklemiyor. Lütfen güncel Chrome veya Edge kullanın.",
      "err_camera_denied": "Kamera izni verilmeden puantaj işlemi yapılamaz.",
      "err_camera_denied_persisted": "Kamera izni verilmeden puantaj işlemi yapılamaz. Tarayıcı izinlerini açıp tekrar deneyin.",
      "err_qr_scan_failed": "QR kod okunamadı. Lütfen tekrar deneyin.",
      "btn_clock_in_large": "İŞE BAŞLA",
      "btn_clock_out_large": "PAYDOS ET",
      "lbl_gps_required": "GPS ZORUNLU",
      "lbl_camera_gps_required": "KAMERA + GPS ZORUNLU",
      "attendance_qr_modal_title_in": "QR İLE İŞE BAŞLA",
      "attendance_qr_modal_title_out": "QR İLE PAYDOS",
      "attendance_qr_modal_subtitle": "Kamera ve konum izni zorunludur",
      "attendance_qr_security_title": "Güvenli puantaj",
      "attendance_qr_security_desc": "Sisteme devam kaydı düşmek için QR okutma ve anlık konum doğrulaması birlikte kullanılır.",
      "attendance_qr_steps_title": "Adımlar",
      "attendance_qr_step_1": "Kamerayı lokasyondaki güncel QR koduna doğrultun.",
      "attendance_qr_step_2": "Tarayıcı sizden konum izni isterse mutlaka onaylayın.",
      "attendance_qr_step_3": "QR ve konum birlikte doğrulanmadan giriş veya çıkış yapılmaz.",
      "attendance_qr_status_error": "HATA",
      "attendance_qr_status_success": "BAŞARILI",
      "attendance_qr_status_active": "AKTİF TARAMA",
      "btn_retry_qr_scan": "TEKRAR DENE",
      "btn_cancel_scan": "VAZGEÇ",
      "lbl_my_recent_records": "SON HAREKETLERİM (30 GÜN)",
      "nav_dashboard": "COCKPIT",
        "nav_sub_dashboard": "Genel İstatistikler",
        "nav_employees": "PERSONEL YÖNETİMİ",
        "nav_sub_employees": "Kadro ve Çalışanlar",
        "nav_org_chart": "ORGANİZASYON ŞEMASI",
        "nav_sub_org_chart": "Hiyerarşik Yapı",
        "nav_ats": "ADAY TAKİP (ATS)",
        "nav_sub_ats": "İşe Alım Süreci",
        "nav_attendance": "ZAMAN & DEVAMLILIK",
        "nav_sub_attendance": "PDKS ve Mesai Takibi",
        "nav_locations": "KONUMLAR & ŞANTİYELER",
        "nav_sub_locations": "Güvenlik Çemberi Yönetimi",
        "nav_leaves": "İZİN YÖNETİMİ",
        "nav_sub_leaves": "Onay Merkezi",
        "nav_dossier": "E-ÖZLÜK ARŞİVİ",
        "nav_sub_dossier": "Dijital Belgeler",
        "nav_performance": "PERFORMANS & YETENEK",
        "nav_sub_performance": "OKR ve 360° Değerlendirme",
        "nav_training": "KURUMSAL AKADEMİ",
        "nav_sub_training": "Eğitim Yönetimi",
        "nav_expenses": "MASRAF YÖNETİMİ",
        "nav_sub_expenses": "Bütçe ve Fişler",
        "nav_assets": "ZİMMET & ENVANTER",
        "nav_sub_assets": "Stok Takibi",
        "nav_helpdesk": "DESTEK MASASI (IT/İK)",
        "nav_sub_helpdesk": "İç İletişim Talepleri",
        "nav_settings": "SİSTEM & ŞİRKET AYARLARI",
        "nav_sub_settings": "Kurumsal Kimlik Yönetimi",
        "nav_billing": "ABONELİK & FATURANDIRMA",
        "nav_sub_billing": "SaaS Paket Yönetimi",
        "nav_portal": "COCKPIT",
        "nav_sub_portal": "Kişisel Kokpit",
        "nav_my_leaves": "İZİNLERİM",
        "nav_sub_my_leaves": "Bireysel İzin Durumu",
        "nav_my_performance": "PERFORMANS DURUMUM",
        "nav_sub_my_performance": "Hedeflerim (OKR)",
        "nav_my_training": "EĞİTİM AKADEMİSİ",
        "nav_sub_my_training": "Gelişim Planım",
        "nav_my_expenses": "MASRAF BEYANLARIM",
        "nav_sub_my_expenses": "Harcama Girişleri",
        "nav_my_assets": "ÜZERİMDEKİ ZİMMETLER",
        "nav_sub_my_assets": "Şirket Ekipmanları",
        "nav_fallback": "KOKPİT",
        "nav_sub_fallback": "Kurumsal Yönetim",
        "lbl_city_weather": "ŞEHİR / HAVA",
        "ph_type_city": "Şehir...",
        "lbl_today": "BUGÜN",
      "btn_add_schedule": "MESAİ PLANI EKLE",
      "btn_assign_special_schedule": "ÖZEL PLAN ATA",
      "btn_collapse_department": "Departmanı Daralt",
      "btn_coming_soon": "YAKINDA",
      "btn_create_schedule": "PLANI OLUŞTUR",
      "btn_expand_department": "Departmanı Genişlet",
      "btn_reset_to_department_default": "DEPARTMAN VARSAYILANINA DÖNDÜR",
      "btn_save_department_schedules": "DEPARTMAN ATAMALARINI KAYDET",
      "btn_saving": "KAYDEDİLİYOR...",
      "btn_update_schedule": "PLANI GÜNCELLE",
      "col_active_people": "AKTİF KİŞİ",
      "col_check_in": "GİRİŞ",
      "col_check_out": "ÇIKIŞ",
      "col_date": "TARİH",
      "col_default_schedule": "VARSAYILAN PLAN",
      "col_my_schedule": "PLANIM",
      "col_schedule_hours": "SAATLER",
      "col_schedule_name": "PLAN ADI",
      "col_schedule_rules": "KURALLAR",
      "col_schedule_type": "PLAN TİPİ",
      "col_schedule_usage": "KULLANIM",
      "col_total_hours": "TOPLAM SAAT",
      "default_repair_done_note": "Tamir tamamlandı ve depoya alındı.",
      "default_repair_note": "Arıza nedeniyle tamire gönderildi.",
      "desc_assign_after_stock": "İsterseniz varlığı önce depoya alın, sonra personel atamasını ayrıca yapın.",
      "desc_department_schedule_defaults": "Her departman için varsayılan mesai planını belirleyin.",
      "desc_employee_schedule_override": "Sadece istisna personeller için özel mesai planı atayın.",
      "desc_work_schedules": "Şirketiniz için sabit veya esnek mesai planları oluşturun.",
      "err_department_schedules_save": "Departman mesai atamaları kaydedilemedi.",
      "err_employee_schedule_assign": "Personel mesai planı atanamadı.",
      "err_employee_schedule_clear": "Personel özel mesai planı temizlenemedi.",
      "err_fetch_department_schedules": "Departman mesai atamaları çekilemedi.",
      "err_fetch_employee_overrides": "Personel istisnaları çekilemedi.",
      "err_fetch_schedules": "Mesai planları çekilemedi.",
      "err_invalid_date": "Geçerli bir tarih girin.",
      "err_schedule_delete": "Mesai planı silinemedi.",
      "err_schedule_save": "Mesai planı kaydedilemedi.",
      "err_select_department_schedule": "Her departman için bir plan seçin.",
      "err_select_employees": "Önce personel seçin.",
      "err_select_schedule_for_people": "Personeller için bir mesai planı seçin.",
      "info_assign_after_create": "Varlık kaydı oluşturulduktan sonra atama yapabilirsiniz.",
      "info_status_route_not_ready": "Bu durum akışı henüz backend tarafında aktif değil.",
      "lbl_active_overrides": "AKTİF İSTİSNALAR",
      "lbl_break_minutes": "MOLA (DK)",
      "lbl_bulk_department_logic": "Departman varsayılanı çoğu çalışan için otomatik uygulanır.",
      "lbl_core_end": "ÇEKİRDEK BİTİŞ",
      "lbl_core_start": "ÇEKİRDEK BAŞLANGIÇ",
      "lbl_crosses_midnight": "GECEYE SARKIYOR",
      "lbl_crosses_midnight_toggle": "Vardiya gece yarısını aşıyor",
      "lbl_department_defaults": "DEPARTMAN VARSAYILANLARI",
      "lbl_department_filter": "DEPARTMAN FİLTRESİ",
      "lbl_departments_short": "Dept.",
      "lbl_early_leave_after": "ERKEN ÇIKIŞ EŞİĞİ",
      "lbl_early_out": "ERKEN ÇIKIŞ",
      "lbl_effective_from": "GEÇERLİLİK BAŞLANGICI",
      "lbl_employee_override_logic": "İstisna personeller için personel bazlı özel plan atayın.",
      "lbl_employee_overrides": "PERSONEL İSTİSNALARI",
      "lbl_end_time": "BİTİŞ SAATİ",
      "lbl_grace_in": "GİRİŞ TOLERANSI",
      "lbl_grace_in_minutes": "GİRİŞ TOLERANSI (DK)",
      "lbl_grace_out": "ÇIKIŞ TOLERANSI",
      "lbl_grace_out_minutes": "ÇIKIŞ TOLERANSI (DK)",
      "lbl_late": "GEÇ",
      "lbl_late_after": "GEÇ KALMA EŞİĞİ",
      "lbl_loading_department_schedules": "Departman mesai atamaları yükleniyor...",
      "lbl_loading_people": "Personeller yükleniyor...",
      "lbl_loading_schedules": "Mesai planları yükleniyor...",
      "lbl_no_schedule_type": "Plan tipi yok",
      "lbl_no_target_schedule": "Plan seçilmedi",
      "lbl_ot_after": "FAZLA MESAİ EŞİĞİ",
      "lbl_overtime": "FAZLA MESAİ",
      "lbl_overtime_after": "FAZLA MESAİ BAŞLANGICI",
      "lbl_people": "Kişi",
      "lbl_people_short": "Kişi",
      "lbl_position_count": "Pozisyon",
      "lbl_remaining_leave": "KALAN İZİN",
      "lbl_same_day": "AYNI GÜN",
      "lbl_schedule_logic": "MESAİ MANTIĞI",
      "desc_core_hours": "ESNEK ÇALIŞMADA PERSONELİN MUTLAKA OFİSTE OLMASI BEKLENEN ÇEKİRDEK SAAT ARALIĞINI BELİRLEYİN.",
      "lbl_schedule_name": "PLAN ADI",
      "lbl_schedule_type": "PLAN TİPİ",
      "lbl_selected_people": "SEÇİLİ KİŞİ",
      "lbl_start_time": "BAŞLANGIÇ SAATİ",
      "lbl_stat_late_days": "GEÇ GÜN",
      "lbl_stat_present_days": "MEVCUT GÜN",
      "lbl_stat_total_hours": "TOPLAM SAAT",
      "lbl_target_schedule": "HEDEF PLAN",
      "lbl_total_plans": "TOPLAM PLAN",
      "lbl_unknown_department": "Bilinmeyen Departman",
      "lbl_unscheduled": "Plansız",
      "modal_title_edit_schedule": "MESAİ PLANINI DÜZENLE",
      "modal_title_new_schedule": "YENİ MESAİ PLANI",
      "msg_assigning_employee_schedule": "Personel mesai planı atanıyor...",
      "msg_billing_not_enabled": "Faturalandırma modülü şu anda aktif değil.",
      "msg_billing_passive_banner": "Abonelik ekranı hazır, ancak ödeme altyapısı bu ortamda pasif durumda.",
      "msg_clearing_employee_schedule": "Personel özel planı temizleniyor...",
      "msg_confirm_clear_employee_schedule": "Seçili personelleri departman varsayılanına döndürmek istediğinize emin misiniz?",
      "msg_confirm_delete_schedule": "Bu mesai planını silmek istediğinize emin misiniz?",
      "msg_creating_schedule": "Mesai planı oluşturuluyor...",
      "msg_deleting_schedule": "Mesai planı siliniyor...",
      "msg_department_schedules_saved": "Departman mesai atamaları kaydedildi.",
      "msg_employee_schedule_assigned": "Personel mesai planı atandı.",
      "msg_employee_schedule_cleared": "Personel özel mesai planı temizlendi.",
      "msg_expense_approved": "Masraf onaylandı.",
      "msg_expense_rejected": "Masraf reddedildi.",
      "msg_hire_pick_org_slot": "İşe alım için departman ve pozisyon seçin.",
      "msg_no_departments": "Departman bulunamadı.",
      "msg_no_employee_overrides": "Aktif personel istisnası bulunmuyor.",
      "msg_no_filtered_employees": "Filtreye uygun personel bulunamadı.",
      "msg_no_schedules": "Henüz mesai planı tanımlanmadı.",
      "msg_saving_department_schedules": "Departman mesai atamaları kaydediliyor...",
      "msg_schedule_created": "Mesai planı oluşturuldu.",
      "msg_schedule_deleted": "Mesai planı silindi.",
      "msg_schedule_updated": "Mesai planı güncellendi.",
      "msg_updating_schedule": "Mesai planı güncelleniyor...",
      "opt_all_departments": "Tüm Departmanlar",
      "opt_fixed": "Sabit",
      "opt_flex": "Esnek",
      "opt_select_position": "Pozisyon Seçin",
      "opt_select_schedule": "Mesai Planı Seçin",
      "ph_override_reason": "İstisna nedeni (opsiyonel)",
      "ph_search_employee": "Ad, e-posta veya telefon ile ara...",
      "prompt_repair_done_note": "Tamirden dönüş notu:",
      "prompt_repair_note": "Tamire gönderme notu:",
      "status_early_out": "ERKEN ÇIKIŞ",
      "status_late_early": "GEÇ + ERKEN",
      "tab_attendance_records": "PUANTAJ",
      "tab_department_assignments": "DEPARTMAN ATAMALARI",
      "tab_employee_overrides": "PERSONEL İSTİSNASI",
      "tab_work_schedules": "MESAİ PLANLARI",
      "tbl_schedule_plan": "Plan",
      "title_department_schedule_defaults": "DEPARTMAN MESAİ PLANLARI",
      "title_employee_schedule_override": "PERSONEL MESAİ İSTİSNALARI",
      "title_work_schedules": "MESAİ PLANLARI",
      "btn_schedule_pdf_report": "PDF RAPORU",
      "btn_participant_report_pdf": "KATILIMCI RAPORU PDF",
      "lbl_created_by": "AÇAN",
      "type_maternity": "DOĞUM İZNİ",
      "unknown_employee": "Bilinmeyen Personel",
      "unknown_user": "Bilinmeyen Kullanıcı",
      "violation_early_out": "Erken Çıkış",
      "violation_late_early": "Geç Giriş + Erken Çıkış",
      "violation_late_in": "Geç Giriş",
      "violation_missing_in": "Eksik Giriş",
      "violation_missing_out": "Eksik Çıkış",
      "violation_none": "İhlal Yok",
    }
  },
  en: {
    translation: {
      "login_title": "HRPro Login",
      "email_label": "Email Address",
      "password_label": "Password",
      "login_button": "Sign In",
      "select_language": "Select Language",
      "login_failed_generic": "Login failed. Please check your credentials.",
      "server_unreachable": "Server unreachable. Please check your connection.",
      "condition_new": "Brand New",
      "condition_working": "Working / Good Condition",
      "error_fetching_data": "Failed to fetch data.",
      "assets_added_success": "Assets added successfully.",
      "error_adding_assets": "Failed to add assets.",
      "prompt_return_note": "Return Note / Condition:",
      "default_return_note": "Returned in good condition",
      "status_updated": "Status updated.",
      "error_occurred": "An error occurred.",
      "select_personnel_first": "Please select personnel.",
      "assignment_successful": "Assignment successful.",
      "assignment_error": "Assignment error.",
      "preparing_pdf": "Preparing PDF...",
      "pdf_downloaded": "PDF downloaded.",
      "pdf_not_found": "PDF not found.",
      "status_in_stock": "IN STOCK",
      "status_assigned": "ASSIGNED",
      "status_in_repair": "IN REPAIR",
      "status_archived": "ARCHIVED",
      "filter_all": "ALL",
      "filter_in_stock": "IN STOCK",
      "filter_assigned": "ASSIGNED",
      "filter_in_repair": "IN REPAIR",
      "btn_add_new_asset": "ADD NEW ASSET",
      "stat_total_assets": "TOTAL ASSETS",
      "stat_available": "IN STOCK (AVAILABLE)",
      "stat_assigned": "ASSIGNED",
      "stat_in_repair": "IN REPAIR / FAULTY",
      "loading": "LOADING...",
      "table_category_model": "CATEGORY / MODEL NAME",
      "table_stock_status": "STOCK STATUS",
      "table_actions": "ACTIONS",
      "lbl_total": "TOT",
      "lbl_stock": "STOCK",
      "table_serial_plate": "SERIAL NO / PLATE",
      "table_status": "STATUS",
      "table_current_assignee": "CURRENT ASSIGNEE",
      "table_operations": "OPERATIONS",
      "unknown": "UNKNOWN",
      "btn_assign": "ASSIGN",
      "btn_send_repair": "Repair",
      "btn_report": "REPORT",
      "btn_return": "Return",
      "btn_repair_done": "Repair Done",
      "modal_bulk_entry_title": "BULK INVENTORY ENTRY",
      "lbl_model_name": "MODEL / ASSET NAME",
      "ph_model_name": "E.g., MACBOOK PRO M3",
      "lbl_category": "CATEGORY",
      "cat_electronics": "Electronics",
      "cat_vehicles": "Vehicles / Transport",
      "cat_furniture": "Furniture / Office",
      "cat_digital": "Licenses / Digital",
      "cat_other": "Other",
      "lbl_serial_numbers": "SERIAL NUMBERS",
      "ph_serial_numbers": "One item per line...",
      "lbl_total_detected": "Total: {count} Detected",
      "lbl_instant_assign": "INSTANT ASSIGNMENT",
      "opt_keep_in_stock": "Keep in Stock",
      "lbl_notes": "DESCRIPTION / NOTES",
      "btn_cancel": "CANCEL",
      "btn_save_assets": "PROCESS ASSETS TO SYSTEM",
      "modal_assign_title": "PERSONNEL ASSIGNMENT",
      "lbl_select_personnel": "SELECT PERSONNEL",
      "opt_select": "Select",
      "lbl_delivery_condition": "DELIVERY CONDITION",
      "ph_condition": "E.g., No scratches / Brand new",
      "btn_confirm_assign": "CONFIRM AND ASSIGN",
      "stage_new": "NEW APPLICANT",
      "stage_interview": "INTERVIEW",
      "stage_reference": "REFERENCE & TEST",
      "stage_offer": "OFFER SENT",
      "stage_talent_pool": "TALENT POOL 🏊‍♂️",
      "stage_withdrawn": "WITHDRAWN 🛑",
      "stage_rejected": "REJECTED",
      "stage_hired": "HIRED 🎉",
      "error_fetch_data": "Failed to fetch data",
      "msg_job_published": "Job published successfully.",
      "msg_job_create_error": "Failed to create job.",
      "msg_select_open_job": "Please select an open position!",
      "msg_candidate_created": "Candidate record created.",
      "msg_candidate_create_error": "Failed to add candidate!",
      "msg_pdf_only": "Please upload a PDF file only.",
      "msg_uploading_cv": "Uploading CV...",
      "msg_cv_uploaded": "CV uploaded successfully.",
      "msg_cv_upload_error": "Failed to upload CV",
      "msg_upload_cv_first": "You must upload the candidate's CV first.",
      "msg_ai_analyzing": "Gemini AI is analyzing the resume...",
      "lbl_ai_evaluation": "AI Evaluation",
      "msg_ai_analysis_done": "AI analysis completed!",
      "msg_ai_analysis_error": "AI is currently busy or an error occurred.",
      "msg_confirm_withdraw": "Are you sure candidate {{name}} has withdrawn or rejected the offer?",
      "mail_reject_subject": "Regarding Your Application for {{job}}",
      "mail_reject_body": "Dear {{first_name}} {{last_name}},\n\nThank you for your interest in our company and the {{job}} position.\n\nWe have carefully reviewed your resume and interview results. Unfortunately, we will not be moving forward with your application at this time.\n\nYour qualifications are impressive, and we would be happy to contact you should a suitable opportunity arise in the future.\n\nWe wish you the best in your career.\n\nSincerely,\nHuman Resources Department",
      "msg_stage_update_error": "Error updating stage.",
      "msg_saving_notes": "Saving evaluation notes...",
      "msg_saved_successfully": "Saved successfully.",
      "msg_save_error": "Failed to save evaluation notes!",
      "msg_sending_reject_mail": "Sending rejection email...",
      "msg_reject_mail_sent": "Rejection email sent to {{name}}.",
      "msg_error_occurred": "An error occurred.",
      "msg_creating_employee_card": "Creating employee record...",
      "msg_hire_success": "{{name}} is now an official employee.",
      "msg_hire_error": "Failed to create employee! Check required fields.",
      "msg_confirm_delete_candidate": "Are you sure you want to permanently delete candidate {{name}}?",
      "msg_candidate_deleted": "Candidate deleted.",
      "msg_candidate_delete_error": "Error deleting candidate.",
      "msg_generating_offer_pdf": "Generating offer letter (PDF)...",
      "msg_offer_downloaded": "Letter downloaded successfully.",
      "msg_offer_error": "Error generating offer letter.",
      "opt_no_active_job": "No Active Jobs",
      "btn_new_job": "NEW JOB POSTING",
      "btn_add_candidate": "ADD CANDIDATE",
      "msg_empty_board": "PLEASE SELECT A JOB OR CREATE A NEW ONE",
      "msg_empty_board_sub": "Use the menu above to manage your candidate pool.",
      "tooltip_delete_candidate": "Delete Candidate",
      "tooltip_global_score": "Global Fit Score (HR + AI)",
      "lbl_drag_here": "DRAG HERE",
      "lbl_click_to_offer": "Click on candidate to generate contract.",
      "modal_title_new_job": "NEW JOB POSTING",
      "lbl_select_position_from_org": "SELECT VACANT POSITION FROM ORG",
      "opt_manual_job": "I WILL ENTER MANUALLY",
      "msg_auto_fill_warning": "POSITION NAME AND DEPARTMENT WILL BE AUTO-FILLED.",
      "lbl_job_title": "JOB / POSITION TITLE",
      "lbl_department": "DEPARTMENT",
      "lbl_job_desc": "JOB DESCRIPTION & REQUIREMENTS",
      "btn_publish_job": "PUBLISH JOB",
      "modal_title_new_candidate": "ADD NEW CANDIDATE",
      "lbl_first_name": "FIRST NAME",
      "lbl_last_name": "LAST NAME",
      "lbl_email": "EMAIL",
      "lbl_phone": "PHONE NUMBER",
      "ph_optional": "Optional",
      "btn_save_to_system": "SAVE TO SYSTEM",
      "modal_title_hire": "COMPLETE HIRING",
      "lbl_creating_emp_card": "CREATING EMPLOYEE CARD",
      "lbl_identity_no": "ID / PASSPORT NO",
      "ph_identity": "ID Number",
      "lbl_position": "POSITION / TITLE",
      "lbl_gross_salary": "GROSS SALARY",
      "lbl_hire_date": "START DATE",
      "btn_save_official_employee": "SAVE AS OFFICIAL EMPLOYEE",
      "lbl_evaluation_center": "CANDIDATE EVALUATION CENTER (SCORECARD)",
      "lbl_global_score": "GLOBAL FIT SCORE",
      "lbl_contact_and_cv": "CONTACT & CV",
      "btn_view_cv": "VIEW CV",
      "btn_analyzing": "ANALYZING...",
      "btn_start_ai_analysis": "START AI ANALYSIS",
      "btn_upload_pdf": "UPLOAD PDF",
      "lbl_ai_analysis_title": "ARTIFICIAL INTELLIGENCE (AI) ANALYSIS",
      "lbl_match_score": "Match Score",
      "lbl_no_ai_note": "No AI note found.",
      "lbl_competency_eval": "COMPETENCY EVALUATION (QUANTITATIVE)",
      "lbl_rating_comm": "Communication & Expression",
      "lbl_rating_tech": "Professional / Technical",
      "lbl_rating_culture": "Cultural Fit",
      "lbl_rating_motivation": "Confidence & Motivation",
      "lbl_interview_notes": "INTERVIEW NOTES (QUALITATIVE)",
      "lbl_pros": "Strengths (Pros)",
      "ph_pros": "Where the candidate shined most...",
      "lbl_cons": "Concerns (Cons)",
      "ph_cons": "Concerns or areas of improvement...",
      "lbl_overall": "Overall HR Decision / Summary",
      "ph_overall": "Do you recommend this candidate to the hiring manager?",
      "btn_generate_contract": "GENERATE CONTRACT",
      "btn_save_eval_form": "SAVE EVALUATION FORM",
      "modal_title_reject": "REJECT CANDIDATE & NOTIFY",
      "lbl_edit_mail_template": "YOU CAN EDIT THE EMAIL TEMPLATE BELOW",
      "lbl_to": "TO:",
      "lbl_mail_subject": "EMAIL SUBJECT",
      "lbl_mail_body": "EMAIL BODY",
      "btn_send_and_reject": "SEND AND REJECT CANDIDATE",
      "modal_title_offer": "GENERATE OFFER LETTER",
      "lbl_preparing_pdf": "PREPARING OFFICIAL PDF DOCUMENT",
      "lbl_offered_salary": "OFFERED MONTHLY SALARY",
      "ph_salary": "E.g.: 45000",
      "lbl_planned_start_date": "PLANNED START DATE",
      "btn_download_pdf": "DOWNLOAD PDF",
      "nav_dashboard": "COCKPIT",
      "nav_sub_dashboard": "General Statistics",
      "nav_employees": "EMPLOYEE MANAGEMENT",
      "nav_sub_employees": "Staff and Roster",
      "nav_org_chart": "ORGANIZATION CHART",
      "nav_sub_org_chart": "Hierarchical Structure",
      "nav_ats": "APPLICANT TRACKING (ATS)",
      "nav_sub_ats": "Recruitment Process",
      "nav_attendance": "TIME & ATTENDANCE",
      "nav_sub_attendance": "Time Tracking & Shifts",
      "nav_locations": "LOCATIONS & SITES",
      "nav_sub_locations": "Geofencing Management",
      "nav_leaves": "LEAVE MANAGEMENT",
      "nav_sub_leaves": "Approval Center",
      "nav_dossier": "E-DOSSIER ARCHIVE",
      "nav_sub_dossier": "Digital Documents",
      "nav_performance": "PERFORMANCE & TALENT",
      "nav_sub_performance": "OKR & 360° Evaluation",
      "nav_training": "CORPORATE ACADEMY",
      "nav_sub_training": "Training Management",
      "nav_expenses": "EXPENSE MANAGEMENT",
      "nav_sub_expenses": "Budgets & Receipts",
      "nav_assets": "ASSETS & INVENTORY",
      "nav_sub_assets": "Stock Tracking",
      "nav_helpdesk": "HELPDESK (IT/HR)",
      "nav_sub_helpdesk": "Internal Requests",
      "nav_settings": "SYSTEM & COMPANY SETTINGS",
      "nav_sub_settings": "Corporate Identity",
      "nav_billing": "SUBSCRIPTION & BILLING",
      "nav_sub_billing": "SaaS Plan Management",
      "menu_onboarding": "ONBOARDING & OFFBOARDING",
      "lifecycle_header_title": "ONBOARDING & OFFBOARDING",
      "lifecycle_header_subtitle": "Hiring, exit, and lifecycle document flows",
      "lifecycle_role_employee": "Employee",
      "lifecycle_role_manager": "Manager",
      "lifecycle_role_hr": "HR",
      "lifecycle_role_admin": "Admin",
      "lifecycle_role_superadmin": "Superadmin",
      "lifecycle_tab_onboarding": "Onboarding",
      "lifecycle_tab_offboarding": "Offboarding",
      "lifecycle_search_onboarding": "Search new starter",
      "lifecycle_search_offboarding": "Search offboarding employee",
      "lifecycle_no_matching_personnel": "No matching employee was found for this view.",
      "lifecycle_detail_loading": "Loading process details...",
      "lifecycle_select_personnel": "Select Employee",
      "lifecycle_select_personnel_hint": "When you select an employee from the list, onboarding / offboarding steps will appear here.",
      "lifecycle_onboarding_process": "Onboarding Process",
      "lifecycle_offboarding_process": "Offboarding Process",
      "lifecycle_progress": "Progress",
      "lifecycle_account_active": "Account active",
      "lifecycle_account_closed_status": "Account closed",
      "lifecycle_document_count": "Document Count",
      "lifecycle_open_workload": "Open Workload",
      "lifecycle_active_device": "Active Device",
      "lifecycle_leave_unit": "leave",
      "lifecycle_expense_unit": "expense",
      "lifecycle_device_unit": "device",
      "lifecycle_checklist": "Checklist",
      "lifecycle_process_actions": "Process Actions",
      "lifecycle_close_account": "Close Account",
      "lifecycle_open_account": "Open Account / Send Password",
      "lifecycle_open_release_form": "Open Release Form",
      "lifecycle_download_document": "Download Document",
      "btn_store_to_dossier": "Save to E-Dossier",
      "lifecycle_process_note": "Process Note",
      "lifecycle_offboarding_note": "Check active assets and open workload first. When the account is closed, MFA and mobile device sessions are also disabled.",
      "lifecycle_onboarding_note": "A temporary password is sent when the account is opened. You can store the generated contract in the e-dossier and include it in the onboarding document set.",
      "lifecycle_highlights": "Key Gaps",
      "lifecycle_no_open_items": "No open items remain in the process",
      "lifecycle_offboarding_document": "Offboarding Document",
      "lifecycle_release_form_title": "Termination / Release Form",
      "lifecycle_release_form_desc": "The system fills core fields. Complete legal free text and settlement items here, then generate the PDF.",
      "lifecycle_form_loading": "Loading form...",
      "lifecycle_template_label": "Document Template",
      "lifecycle_template_tr_release_title": "TR/KKTC Release Form",
      "lifecycle_template_tr_release_subtitle": "Classic release and settlement text aligned for TR / TRNC",
      "lifecycle_template_generic_clearance_title": "Final Settlement & Clearance",
      "lifecycle_template_generic_clearance_subtitle": "Country-agnostic general settlement and clearance form",
      "lifecycle_template_de_exit_title": "DE Exit & Final Settlement",
      "lifecycle_template_de_exit_subtitle": "Germany-focused exit settlement and closeout summary",
      "lifecycle_template_sgk_note": "This template uses local registration identifiers.",
      "lifecycle_template_generic_note": "This template is used as a generic clearance form.",
      "lifecycle_employer_name": "Employer Name",
      "lifecycle_employer_address": "Employer Address",
      "lifecycle_employer_sgk": "Workplace Registration No",
      "lifecycle_employer_tax": "Tax Number",
      "lifecycle_employee_name": "Employee Name",
      "lifecycle_employee_ssn": "Social Security No",
      "lifecycle_exit_reason_label": "Exit Reason",
      "lifecycle_hire_date": "Hire Date",
      "lifecycle_exit_date": "Termination Date",
      "lifecycle_exit_date_short": "Exit Date",
      "lifecycle_release_date": "Release Date",
      "lifecycle_other_exit_reason_note": "Other Exit Explanation",
      "lifecycle_other_exit_reason_placeholder": "Describe with free text",
      "lifecycle_intro_text": "Intro Text",
      "lifecycle_settlement_text": "Settlement Text",
      "lifecycle_no_claim_text": "No Remaining Claim Text",
      "lifecycle_contact_note": "Address and Phone / Free Note",
      "lifecycle_payment_table": "Payment Table",
      "lifecycle_payment_table_hint": "Leave it blank if needed, or complete the rows based on legal/accounting review.",
      "lifecycle_payment_col_name": "Payments",
      "lifecycle_payment_col_gross": "Gross",
      "lifecycle_payment_col_legal": "Legal Deduction",
      "lifecycle_payment_col_net": "Net",
      "lifecycle_payment_col_special": "Special Deduction",
      "lifecycle_payment_col_net_payment": "Net Payment",
      "lifecycle_exit_reason_select": "Select reason",
      "lifecycle_exit_reason_abandonment": "Abandonment",
      "lifecycle_exit_reason_resignation": "Resignation",
      "lifecycle_exit_reason_termination": "Termination / Dismissal",
      "lifecycle_exit_reason_military": "Military Service",
      "lifecycle_exit_reason_retirement": "Retirement",
      "lifecycle_exit_reason_death": "Death",
      "lifecycle_exit_reason_other": "Other",
      "lifecycle_overview_load_error": "Process data could not be loaded.",
      "lifecycle_preparing_document": "Preparing document...",
      "lifecycle_document_downloaded": "Document downloaded.",
      "lifecycle_document_download_error": "Document could not be downloaded.",
      "lifecycle_document_storing": "Saving document to e-dossier...",
      "lifecycle_document_stored": "Document generated and saved to e-dossier.",
      "lifecycle_document_store_error": "Document could not be saved.",
      "lifecycle_account_opening": "Opening user account...",
      "lifecycle_account_opened_with_temp": "Account opened. Temporary password: {{password}}",
      "lifecycle_account_opened": "Account opened.",
      "lifecycle_account_open_error": "Account could not be opened.",
      "lifecycle_account_closing": "Closing account...",
      "lifecycle_account_closed": "Account closed and employee archived.",
      "lifecycle_account_close_error": "Account could not be closed.",
      "lifecycle_release_form_open_error": "Release form could not be opened.",
      "lifecycle_template_load_error": "Template could not be loaded.",
      "lifecycle_release_pdf_preparing": "Preparing release PDF...",
      "lifecycle_release_pdf_downloaded": "Release document downloaded.",
      "lifecycle_release_pdf_error": "Release document could not be downloaded.",
      "lifecycle_release_storing": "Saving release document to e-dossier...",
      "lifecycle_release_stored": "Release document generated and saved to e-dossier.",
      "lifecycle_release_store_error": "Release document could not be saved.",
      "lifecycle_not_planned": "Not planned",
      "lifecycle_no_department": "No department",
      "lifecycle_opening_progress": "Opening Progress",
      "lifecycle_closure_progress": "Closing Progress",
      "lifecycle_detail_load_error": "Process details could not be loaded.",
      "lifecycle_summary_total_process": "Total Processes",
      "lifecycle_summary_total_process_hint": "Employees tracked",
      "lifecycle_summary_closed_accounts": "Closed Accounts",
      "lifecycle_summary_closed_accounts_hint": "Access disabled",
      "lifecycle_summary_documents_ready": "Documents Ready",
      "lifecycle_summary_offboarding_documents_hint": "Exit documents prepared",
      "lifecycle_summary_attention_needed": "Needs Attention",
      "lifecycle_summary_attention_needed_hint": "Has open steps",
      "lifecycle_summary_total_employees": "Total Employees",
      "lifecycle_summary_total_employees_hint": "Onboarding view",
      "lifecycle_summary_accounts_ready": "Accounts Ready",
      "lifecycle_summary_accounts_ready_hint": "Login prepared",
      "lifecycle_summary_onboarding_documents_hint": "Contract and documents ready",
      "lifecycle_summary_attention_needed_onboarding_hint": "Has missing steps",
      "helpdesk_stat_open": "Open",
      "helpdesk_stat_open_hint": "Total active tickets",
      "helpdesk_stat_pending": "Pending",
      "helpdesk_stat_pending_hint": "Waiting for first response",
      "helpdesk_stat_in_progress_hint": "Currently being handled",
      "helpdesk_total_tickets": "TOTAL TICKETS",
      "nav_portal": "COCKPIT",
      "nav_sub_portal": "Personal Dashboard",
      "nav_my_leaves": "MY LEAVES",
      "nav_sub_my_leaves": "Personal Leave Status",
      "nav_my_performance": "MY PERFORMANCE",
      "nav_sub_my_performance": "My Goals (OKR)",
      "nav_my_training": "TRAINING ACADEMY",
      "nav_sub_my_training": "Development Plan",
      "nav_my_expenses": "MY EXPENSES",
      "nav_sub_my_expenses": "Expense Entries",
      "nav_my_assets": "MY ASSIGNED ASSETS",
      "nav_sub_my_assets": "Company Equipment",
      "nav_fallback": "COCKPIT",
      "nav_sub_fallback": "Corporate Management",
      "error_fetch_weather": "Failed to fetch weather",
      "lbl_city_weather": "CITY / WEATHER",
      "ph_type_city": "Type a city...",
      "tooltip_change_city": "Click to change city",
      "lbl_today": "TODAY",
      "msg_payment_success": "🎉 Payment successful! Your subscription is updated.",
      "msg_payment_failed": "An error occurred during payment. Please try again.",
      "msg_redirecting_payment": "Redirecting to secure payment page...",
      "msg_no_payment_link": "Could not retrieve payment link.",
      "msg_payment_init_failed": "Payment initialization failed. Please try again.",
      "lbl_current_subscription": "YOUR CURRENT SUBSCRIPTION",
      "lbl_active": "Active",
      "lbl_renews_in_days": "RENEWS IN {{days}} DAYS",
      "lbl_saved_card": "SAVED CARD:",
      "btn_update_card": "UPDATE CARD",
      "lbl_iyzico_secure": "100% SECURE VIA IYZICO",
      "plan_starter_title": "Starter",
      "plan_starter_desc": "For Small Teams",
      "lbl_month": "month",
      "feat_max_10_emp": "Up to 10 Employees",
      "feat_standard_payroll": "Standard Payroll (D1)",
      "feat_no_ats": "No Applicant Tracking (ATS)",
      "feat_no_helpdesk": "No Helpdesk",
      "btn_current_plan": "CURRENT PLAN",
      "btn_downgrade": "DOWNGRADE",
      "badge_most_popular": "MOST POPULAR",
      "plan_pro_title": "Pro Plan",
      "plan_pro_desc": "For Growing Companies",
      "feat_max_50_emp": "Up to 50 Employees",
      "feat_all_payroll": "All Payroll Types (D1, D3, E1)",
      "feat_ats_module": "Applicant Tracking (ATS)",
      "feat_helpdesk": "Employee Helpdesk",
      "plan_enterprise_title": "Enterprise",
      "plan_enterprise_desc": "For Large Corporations",
      "feat_unlimited_emp": "Unlimited Employees",
      "feat_advanced_api": "Advanced API Access",
      "feat_private_server": "Private Server Installation",
      "feat_vip_support": "24/7 VIP Support",
      "btn_upgrade": "UPGRADE PLAN",
      "err_invalid_qr": "INVALID ACTION: PLEASE SCAN THE CURRENT QR CODE AT THE SITE TO CLOCK IN.",
      "msg_clock_in_success": "CLOCK IN SUCCESSFUL! HAVE A GREAT SHIFT.",
      "err_location_verify": "LOCATION COULD NOT BE VERIFIED.",
      "err_location_denied": "LOCATION PERMISSION DENIED OR UNAVAILABLE!",
      "err_location_timeout": "TIMEOUT: PLEASE GO OUTSIDE AND TRY AGAIN.",
      "lbl_verifying_gps": "VERIFYING GPS...",
      "lbl_clocked_in": "CLOCKED IN",
      "btn_clock_in": "CLOCK IN (QR & GPS)",
      "err_fetch_attendance": "Failed to fetch attendance data.",
      "err_only_excel": "You can only upload Excel (.xlsx, .xls) files.",
      "err_select_excel": "Please select an Excel file.",
      "msg_processing_excel": "Processing Excel file...",
      "msg_excel_success": "Excel data successfully imported into the system!",
      "msg_upload_failed": "Upload failed.",
      "action_reject": "reject",
      "action_approve": "approve",
      "msg_confirm_bulk": "Are you sure you want to bulk {{action}} the selected {{count}} records?",
      "msg_applying_bulk": "Applying bulk action...",
      "msg_bulk_success": "Bulk action completed successfully.",
      "status_present": "PRESENT",
      "status_absent": "ABSENT",
      "status_late": "LATE",
      "status_off": "DAY OFF / HOLIDAY",
      "badge_manager_pending": "PENDING MANAGER",
      "badge_hr_pending": "PENDING HR",
      "badge_payroll_ready": "READY FOR PAYROLL",
      "badge_rejected": "REJECTED",
      "lbl_bulk_excel": "BULK UPLOAD VIA EXCEL",
      "lbl_excel_desc": ".xlsx file from Face ID / Fingerprint device.",
      "btn_select_file": "SELECT FILE",
      "btn_select_excel": "SELECT EXCEL FILE",
      "btn_processing": "PROCESSING...",
      "btn_transfer": "UPLOAD",
      "lbl_listed_records": "Records Listed on Screen",
      "lbl_records": "RECORDS",
      "lbl_record_selected": "RECORDS SELECTED",
      "btn_reject_selected": "REJECT",
      "btn_approve_selected": "APPROVE",
      "opt_all_approvals": "ALL APPROVALS",
      "lbl_loading_data": "LOADING DATA...",
      "tbl_emp_dept": "EMPLOYEE & DEPARTMENT",
      "tbl_day_in_out": "DAY & CLOCK IN-OUT",
      "tbl_total_ot": "TOTAL / OVERTIME",
      "tbl_daily_status": "DAILY STATUS",
      "tbl_approval_status": "APPROVAL STATUS",
      "lbl_no_records": "NO RECORDS FOUND YET.",
      "lbl_unknown": "UNKNOWN",
      "lbl_weekday_ot": "WKDAY",
      "lbl_weekend_ot": "WKEND",
      "lbl_no_ot": "NO OVERTIME",
      "lbl_records_selected_html": "RECORDS<br/>SELECTED",
      "lbl_assigned_count": "ASSIGNED",
      "lbl_selected_count": "SELECTED",
      "badge_already_assigned": "ALREADY ASSIGNED",
      "btn_select_all_visible": "SELECT VISIBLE",
      "btn_clear_visible": "CLEAR VISIBLE",
      "btn_manager_approve": "MANAGER APPROVE",
      "btn_hr_approve": "HR APPROVE (PAYROLL)",
      "btn_reject_cancel": "REJECT (CANCEL)",
      "err_password_length": "Your password must be at least 6 characters.",
      "err_password_match": "Passwords do not match.",
      "msg_register_success": "Company registered successfully! Please log in.",
      "err_generic_login": "An error occurred. Please check your credentials.",
      "lbl_login_title": "Log in to System",
      "lbl_register_title": "Start Your 30-Day Free Trial",
      "ph_company_name": "Company / Organization Name",
      "ph_first_name": "First Name",
      "ph_last_name": "Last Name",
      "ph_email": "Email Address",
      "ph_password": "Password",
      "ph_confirm_password": "Confirm Password",
      "btn_login": "Sign In",
      "btn_register": "Create Account",
      "msg_no_account": "Don't have an account yet?",
      "msg_has_account": "Already have a company account?",
      "btn_start_trial": "Start 30-Day Trial Now",
      "btn_back_to_login": "Back to Login",
      "lbl_other": "OTHER",
      "lbl_unassigned": "UNASSIGNED",
      "err_fetch_data": "An error occurred while loading data.",
      "msg_updating_company_info": "Updating corporate information...",
      "msg_company_info_updated": "Corporate identity information successfully updated!",
      "err_updating_info": "An error occurred during the update.",
      "err_file_size": "File size cannot exceed 2MB.",
      "msg_uploading_logo": "Uploading logo to the server...",
      "msg_logo_uploaded": "Logo successfully uploaded and applied to the system!",
      "err_uploading_logo": "An error occurred while uploading the logo.",
      "msg_saving_routing": "Saving routing and operation settings...",
      "msg_routing_saved": "All system routes have been successfully locked!",
      "err_saving_routing": "Could not save settings. Please check backend connection.",
      "err_pwd_match": "New passwords do not match!",
      "err_pwd_length": "Your new password must be at least 6 characters.",
      "msg_updating_pwd": "Updating your password...",
      "msg_pwd_updated": "Your password has been successfully changed!",
      "err_updating_pwd": "Could not update password. Please check your current password.",
      "lbl_loading_settings": "LOADING SETTINGS...",
      "tab_company": "CORPORATE SETTINGS",
      "tab_security": "PERSONAL SECURITY",
      "lbl_official_title": "OFFICIAL TITLE",
      "lbl_company_name": "COMPANY NAME",
      "lbl_routing_settings": "SYSTEM ROUTING SETTINGS",
      "desc_routing": "DEFINE MAIN RESPONSIBLES FOR MODULES.",
      "lbl_routing_policy": "APPROVAL FLOW LOGIC",
      "desc_helpdesk_policy": "HELPDESK: REQUESTS FALL TO THE RESPONSIBLE PERSON ASSIGNED IN COMPANY SETTINGS.",
      "desc_leave_policy": "LEAVE: MANAGER FIRST, THEN HR / ADMIN.",
      "desc_expense_policy": "EXPENSE: MANAGER FIRST, THEN ADMIN / FINANCE.",
      "desc_document_policy": "DOCUMENTS: GO TO HR / ADMIN APPROVAL.",
      "lbl_helpdesk_it": "HELP DESK (IT)",
      "lbl_hr_responsible": "LEAVE & DOCUMENTS (HR)",
      "lbl_admin_responsible": "ADMIN REQUESTS & EXPENSES",
      "lbl_payroll_officer": "PAYROLL OFFICER",
      "desc_payroll_officer": "THIS PERSON HANDLES HELPDESK PAYROLL REQUESTS AND ACTS AS THE FINANCE POINT IN EXPENSE FLOWS.",
      "btn_processing": "PROCESSING...",
      "btn_save_routing": "LOCK AND SAVE SETTINGS",
      "lbl_pdf_active": "PDF LETTERHEAD SYSTEM ACTIVE",
      "lbl_no_logo": "NO LOGO DEFINED",
      "tab_company_info": "CORPORATE",
      "tab_company_info_span": "INFO",
      "lbl_address": "ADDRESS",
      "lbl_phone": "PHONE",
      "lbl_email": "EMAIL",
      "lbl_website": "WEBSITE",
      "btn_update_info": "UPDATE INFORMATION",
      "lbl_logo_management": "LOGO MANAGEMENT",
      "btn_select_new_file": "SELECT NEW FILE",
      "btn_start_upload": "START UPLOAD",
      "lbl_no_logo_uploaded": "NO LOGO",
      "lbl_current_view": "CURRENT VIEW",
      "tab_account": "ACCOUNT",
      "tab_security_span": "SECURITY",
      "lbl_update_pwd": "UPDATE YOUR PASSWORD",
      "desc_update_pwd": "For the security of your account, it is recommended to change your password regularly.",
      "lbl_old_pwd": "CURRENT PASSWORD",
      "lbl_new_pwd": "NEW PASSWORD",
      "lbl_confirm_pwd": "NEW PASSWORD (CONFIRM)",
      "btn_change_pwd": "UPDATE PASSWORD",
      "opt_none_selected": "NONE SELECTED",
      "err_login_failed_check_info": "Login failed. Please check your credentials.",
      "lbl_system_subtitle": "Personnel Management System",
      "lbl_email_address": "Email Address",
      "ph_email_example": "example@company.com",
      "lbl_password": "Password",
      "btn_login_system": "LOGIN TO SYSTEM",
      "msg_no_account_yet": "Don't have an account yet?",
      "btn_register_now": "Register Now",
      "notif_loading": "📢 Dashboard loading, please wait...",
      "err_fetch_ats": "Failed to fetch ATS data:",
      "err_fetch_kudos": "Failed to fetch Kudos feed:",
      "notif_pending_leaves": "{{count}} annual leave requests pending your approval.",
      "notif_pending_expenses": "{{count}} expense claims pending your approval.",
      "notif_pending_documents": "{{count}} documents are pending your approval.",
      "notif_dossier_missing_required_documents": "{{count}} missing required dossier items need review.",
      "notif_dossier_expired_documents": "{{count}} documents appear to be expired.",
      "notif_dossier_expiring_documents": "{{count}} documents are approaching expiry.",
      "notif_open_tickets": "There are {{count}} open tickets in the IT/Support department.",
      "notif_all_clear": "You have no pending approvals. Have a great day!",
      "notif_last_announcement": "Latest Announcement: {{title}}",
      "notif_welcome": "Welcome to the system, we wish you a productive day.",
      "err_server_unreachable": "Could not connect to the server. Please try again later.",
      "lbl_dashboard_warning": "Dashboard Loading Warning",
      "btn_view_all": "VIEW ALL",
      "btn_new_job_posting": "NEW JOB POSTING",
      "btn_go_to_roster": "GO TO ROSTER",
      "lbl_ats_summary": "RECRUITMENT (ATS) SUMMARY",
      "lbl_active_jobs": "{{count}} ACTIVE JOBS",
      "lbl_loading": "LOADING...",
      "msg_no_active_jobs_html": "NO ACTIVE JOB POSTINGS<br/>AT THE MOMENT",
      "lbl_unnamed_job": "UNNAMED JOB",
      "lbl_candidates_waiting": "{{count}} Candidates Waiting",
      "lbl_daily_roster": "DAILY HEADCOUNT STATUS",
      "lbl_on_site": "CURRENTLY ON SITE",
      "lbl_person": "People",
      "lbl_on_leave": "ON LEAVE / SICK",
      "lbl_kudos_title": "APPRECIATION & RECOGNITION (KUDOS)",
      "msg_no_kudos_html": "NO KUDOS YET.<br/>BE THE FIRST TO SEND ONE!",
      "lbl_thanked_suffix": "was thanked by",
      "lbl_company_news": "COMPANY NEWS & ANNOUNCEMENTS",
      "msg_no_announcement_html": "NO CURRENT<br/>ANNOUNCEMENTS",
      "doc_id": "ID / PASSPORT COPY",
      "doc_pre_permit": "PRE-PERMIT DOCUMENTS",
      "doc_work_permit": "WORK PERMIT & HEALTH REPORT",
      "doc_residency": "RESIDENCY / ADDRESS CONFIRMATION",
      "doc_visa": "VISA / RESIDENCY PERMIT",
      "doc_contract": "EMPLOYMENT CONTRACT",
      "doc_nda": "NDA / CONFIDENTIALITY",
      "doc_handbook_ack": "HANDBOOK ACKNOWLEDGEMENT",
      "doc_background_check": "BACKGROUND CHECK",
      "doc_ohs_training": "OHS TRAINING / MEDICAL FITNESS",
      "doc_bank_info": "BANK / IBAN DETAILS",
      "doc_tax_doc": "TAX / TIN DOCUMENT",
      "doc_payroll": "PAYSLIP / PAYROLL",
      "doc_social_security_record": "SOCIAL SECURITY RECORD",
      "doc_performance_review": "PERFORMANCE REVIEW",
      "doc_training_record": "TRAINING RECORD",
      "doc_leave_record": "LEAVE / ABSENCE RECORD",
      "doc_disciplinary": "DISCIPLINARY RECORD",
      "doc_termination": "TERMINATION (RELEASE FORM)",
      "doc_exit_interview": "EXIT INTERVIEW",
      "doc_onboarding_checklist": "ONBOARDING CHECKLIST",
      "doc_offboarding_checklist": "OFFBOARDING CHECKLIST",
      "doc_certificate": "CERTIFICATE & VOCATIONAL TRAINING",
      "doc_other": "OTHER DOCUMENTS",
      "lbl_employee": "Employee",
      "lbl_first_name": "First Name",
      "lbl_last_name": "Last Name",
      "err_fetch_files": "Could not fetch your files.",
      "err_fetch_emps": "Could not fetch employees.",
      "err_fetch_docs": "Could not fetch documents.",
      "err_file_size": "File size cannot exceed 10MB.",
      "msg_uploading_doc": "Uploading document to archive...",
      "msg_upload_pending": "Document successfully uploaded and submitted for manager approval.",
      "msg_upload_success": "Document successfully added to archive.",
      "msg_document_status_updated": "Document status updated to {{status}}.",
      "err_document_status_update": "Document status could not be updated.",
      "err_upload_failed": "An error occurred while uploading the document.",
      "action_approved": "Approved",
      "action_rejected": "Rejected",
      "msg_status_updated": "Document status updated to {{status}}.",
      "err_status_update": "Status could not be updated.",
      "err_delete_pending_only": "You can only delete your pending (PENDING) documents.",
      "msg_confirm_delete_doc": "This document will be permanently deleted. Are you sure?",
      "msg_delete_success": "Document successfully deleted from archive.",
      "err_delete_failed": "Document could not be deleted.",
      "lbl_archive_selection": "ARCHIVE SELECTION",
      "lbl_selected_employee": "SELECTED EMPLOYEE",
      "msg_no_employee_selected": "No employee selected yet",
      "btn_select_employee_archive": "SELECT EMPLOYEE",
      "btn_change_employee_archive": "CHANGE EMPLOYEE",
      "msg_select_emp_focus_html": "SELECT AN EMPLOYEE FIRST<br/>TO VIEW THE E-DOSSIER.",
      "ph_search_emp": "Search name or department...",
      "msg_select_emp_html": "SELECT AN EMPLOYEE FROM THE LEFT<br/>TO VIEW E-DOSSIER ARCHIVE.",
      "lbl_my_dossier": "MY PERSONAL E-DOSSIER",
      "lbl_official_dossier": "OFFICIAL EMPLOYEE DOSSIER",
      "lbl_archive_size": "ARCHIVE SIZE",
      "lbl_docs": "DOCUMENTS",
      "lbl_upload_new_doc": "UPLOAD NEW DOCUMENT TO SYSTEM",
      "lbl_doc_category": "DOCUMENT CATEGORY",
      "lbl_doc_number": "DOCUMENT NO",
      "lbl_doc_number_short": "NO",
      "lbl_doc_issued_by": "ISSUED BY",
      "lbl_doc_issue_date": "ISSUE DATE",
      "lbl_doc_valid_until": "VALID UNTIL",
      "lbl_doc_mandatory": "MANDATORY DOCUMENT",
      "lbl_dossier_compliance": "DOSSIER COMPLIANCE",
      "lbl_uploaded_documents": "UPLOADED DOCUMENTS",
      "lbl_document_detail": "DOCUMENT DETAIL",
      "tab_uploaded_documents": "UPLOADED DOCUMENTS",
      "tab_upload_document": "UPLOAD DOCUMENT",
      "tab_compliance": "COMPLIANCE",
      "lbl_completion_score": "COMPLETION SCORE",
      "lbl_expiring_soon": "EXPIRING SOON",
      "lbl_expired_docs": "EXPIRED",
      "lbl_missing_required": "MISSING REQUIRED",
      "msg_missing_required_docs": "MISSING REQUIRED DOCUMENTS",
      "msg_all_required_docs_ready": "REQUIRED DOCUMENTS COMPLETE",
      "msg_dossier_compliant": "All required documents currently appear complete in this dossier.",
      "lbl_expired_required_docs": "EXPIRED REQUIRED DOCUMENTS",
      "lbl_expiring_required_docs": "EXPIRING REQUIRED DOCUMENTS",
      "msg_no_expired_required_docs": "No expired required document appears in this dossier.",
      "msg_no_expiring_required_docs": "No required document is approaching expiry.",
      "lbl_country_role_rule_set": "COUNTRY / ROLE RULE SET",
      "dossier_profile_tr": "TR PROFILE",
      "dossier_profile_kktc": "TRNC PROFILE",
      "dossier_profile_eu": "EU PROFILE",
      "dossier_profile_mena": "MENA PROFILE",
      "dossier_profile_global": "GLOBAL PROFILE",
      "msg_select_doc_for_detail": "SELECT A DOCUMENT TO SEE THE DETAIL",
      "badge_expiring_soon": "EXPIRING SOON",
      "badge_expired": "EXPIRED",
      "lbl_missing_required_dossier_docs": "MISSING REQUIRED DOCUMENTS",
      "msg_missing_required_dossier_docs_waiting": "required dossier items need follow-up.",
      "lbl_expired_dossier_docs": "EXPIRED DOCUMENTS",
      "msg_expired_dossier_docs_waiting": "documents need renewal.",
      "lbl_expiring_dossier_docs": "DOCUMENTS EXPIRING SOON",
      "msg_expiring_dossier_docs_waiting": "documents are approaching expiry.",
      "lbl_select_file_format": "SELECT FILE (PDF / IMAGE)",
      "btn_choose_from_pc": "CHOOSE FILE FROM COMPUTER",
      "btn_uploading": "UPLOADING...",
      "btn_upload_to_archive": "UPLOAD TO ARCHIVE",
      "lbl_max_file_size": "Maximum File Size: 10MB",
      "msg_searching_docs": "Searching documents...",
      "msg_no_docs_found": "No documents found in this employee's file yet.",
      "badge_pending_approval": "PENDING APPROVAL",
      "badge_approved_doc": "APPROVED DOCUMENT",
      "badge_rejected_doc": "REJECTED",
      "tooltip_view_doc": "View Document",
      "btn_approve": "APPROVE",
      "btn_reject": "REJECT",
      "tooltip_delete_archive": "Delete from Archive",
      "tooltip_download_doc": "Download Document",
      "err_fetch_assets": "Could not fetch assigned assets.",
      "err_empty_issue": "Please describe the issue in detail.",
      "msg_sending_ticket": "Sending your support request to the IT department...",
      "lbl_issue_report": "ISSUE REPORT",
      "lbl_serial_plate": "Serial No/Plate",
      "lbl_category": "Category",
      "lbl_issue_details": "Issue",
      "msg_ticket_created": "Issue request created successfully!",
      "err_ticket_create_failed": "Could not create request. Please contact your manager.",
      "msg_confirm_acknowledge": "Do you confirm that you have physically received the company asset named \"{{name}}\" in complete and working condition? (This process serves as a digital signature)",
      "msg_acknowledging": "Acknowledging handover...",
      "msg_acknowledge_success": "Asset acknowledgment successful!",
      "err_acknowledge_failed": "Acknowledgment failed.",
      "lbl_my_active_assets": "MY ACTIVE ASSETS",
      "msg_no_assets_html": "YOU DO NOT HAVE ANY<br/>COMPANY ASSETS ASSIGNED TO YOU.",
      "badge_in_repair": "IN REPAIR",
      "badge_active_device": "ACTIVE DEVICE",
      "lbl_no_serial_no": "SERIAL NO NOT SPECIFIED",
      "lbl_allocation_date": "ALLOCATION DATE",
      "msg_please_acknowledge": "IF YOU HAVE PHYSICALLY RECEIVED THE DEVICE, PLEASE ACKNOWLEDGE BELOW.",
      "btn_acknowledge_asset": "I HAVE RECEIVED THE DEVICE (ACKNOWLEDGE)",
      "btn_asset_in_repair": "DEVICE IS CURRENTLY IN SERVICE",
      "btn_report_issue": "REPORT ISSUE / REQUEST SUPPORT",
      "modal_title_issue_report": "ISSUE AND SUPPORT REPORT",
      "msg_ticket_route_warning": "THIS SUPPORT REQUEST WILL BE SENT DIRECTLY TO THE IT DEPARTMENT.",
      "lbl_issue_desc": "WHAT IS THE ISSUE? PLEASE EXPLAIN IN DETAIL.",
      "ph_issue_example": "E.g.: The screen is broken, the battery is not charging, I cannot log into the system...",
      "btn_send_to_it": "SEND REQUEST TO IT",
      "cat_food": "Food & Dining",
      "cat_transport": "Travel & Transport",
      "cat_accommodation": "Accommodation",
      "cat_education": "Education & Course",
      "cat_office": "Office Supplies",
      "cat_customer": "Client Entertainment",
      "cat_other": "Other",
      "err_fetch_expenses": "Could not fetch expenses.",
      "err_missing_receipt": "Please upload a receipt or invoice image for your expense!",
      "lbl_no_desc": "No description provided.",
      "msg_uploading_expense": "Uploading expense declaration to system...",
      "msg_expense_submitted": "Your expense and receipt have been submitted for approval!",
      "err_submit_expense": "An error occurred while adding the expense.",
      "msg_confirm_cancel_expense": "Are you sure you want to cancel this expense declaration?",
      "msg_canceling_expense": "Canceling expense...",
      "msg_expense_canceled": "Expense canceled successfully.",
      "err_cancel_failed": "Cancellation failed.",
      "btn_new_receipt": "NEW RECEIPT / INVOICE",
      "lbl_pending_approval": "PENDING APPROVAL",
      "lbl_approved_total": "APPROVED (TOTAL)",
      "lbl_past_declarations": "MY PAST DECLARATIONS",
      "msg_no_expenses_html": "YOU HAVE NOT ENTERED<br/>ANY EXPENSES YET.",
      "tooltip_cancel_expense": "Cancel Expense (Delete)",
      "btn_view_receipt": "VIEW RECEIPT",
      "badge_approved": "APPROVED",
      "badge_rejected": "REJECTED",
      "badge_pending": "PENDING",
      "lbl_cancel_reason": "Cancel Reason:",
      "modal_title_new_expense": "ENTER NEW RECEIPT / INVOICE",
      "lbl_approved_paid": "APPROVED EXPENSES WILL BE PAID",
      "msg_expense_policy": "PLEASE ENTER ONLY WORK-RELATED EXPENSES. APPROVED EXPENSES WILL BE REIMBURSED.",
      "msg_limit_warning": "THE AMOUNT ENTERED IS OVER THE LIMIT OF {{limit}}. MANAGER APPROVAL MAY TAKE LONGER.",
      "lbl_amount": "AMOUNT",
      "lbl_amount_preview": "AMOUNT PREVIEW",
      "lbl_currency": "CURRENCY",
      "lbl_category": "CATEGORY",
      "lbl_receipt_date": "RECEIPT DATE",
      "lbl_short_desc": "SHORT DESCRIPTION / DETAILS",
      "ph_expense_desc": "E.g., Dinner expense for client visit in London...",
      "lbl_receipt_image": "RECEIPT / INVOICE IMAGE OR PDF",
      "btn_open_cam_gallery": "OPEN CAMERA OR CHOOSE FROM GALLERY",
      "btn_submit_for_approval": "SUBMIT EXPENSE FOR APPROVAL",
      "modal_title_receipt": "EXPENSE RECEIPT",
      "lbl_receipt_pdf": "Receipt PDF",
      "lbl_receipt_img": "Expense Receipt",
      "lbl_img_not_found": "Image+Not+Found",
      "btn_close_window": "CLOSE WINDOW",
      "err_fetch_leaves": "Could not fetch leaves.",
      "err_date_order": "End date cannot be earlier than start date!",
      "msg_creating_leave_req": "Creating your leave request...",
      "msg_leave_req_success": "Your leave request has been successfully submitted for manager approval!",
      "err_form_invalid": "Form data is incomplete or invalid!",
      "err_create_failed": "Could not create request.",
      "msg_confirm_cancel_leave": "Are you sure you want to cancel this leave request?",
      "msg_canceling_leave": "Canceling leave request...",
      "msg_leave_canceled": "Leave request canceled successfully.",
      "type_annual": "ANNUAL LEAVE (PAID)",
      "type_excuse": "EXCUSE LEAVE",
      "type_sick": "SICK LEAVE (MEDICAL REPORT)",
      "type_unpaid": "UNPAID LEAVE",
      "lbl_used_this_year": "USED THIS YEAR (APPROVED)",
      "lbl_days": "DAYS",
      "btn_request_new_leave": "REQUEST NEW LEAVE",
      "lbl_my_leave_movements": "MY LEAVE HISTORY",
      "msg_no_leaves_html": "YOU DO NOT HAVE ANY<br/>LEAVE REQUESTS YET.",
      "tooltip_cancel_leave": "Cancel Leave (Delete)",
      "lbl_note": "Note:",
      "modal_title_new_leave": "CREATE LEAVE REQUEST",
      "lbl_request_will_be_reviewed": "YOUR REQUEST WILL BE SUBMITTED FOR MANAGER APPROVAL",
      "msg_leave_policy": "Annual leave requests will be evaluated by Human Resources and your Manager.",
      "lbl_leave_type": "LEAVE TYPE",
      "lbl_start_date": "START DATE",
      "lbl_end_date": "END DATE",
      "lbl_reason": "REASON / DESCRIPTION",
      "ph_leave_reason": "You can write a short description...",
      "btn_submit_leave_req": "SUBMIT REQUEST FOR APPROVAL",
      "lbl_default_report_title": "Employee List & OHS Report",
      "col_fullname": "Full Name",
      "col_identity": "ID / Passport No",
      "col_department": "Department",
      "col_position": "Position",
      "col_blood_type": "Blood Type",
      "col_phone": "Phone",
      "col_email": "Email",
      "col_hire_date": "Hire Date",
      "col_education": "Education",
      "col_nationality": "Nationality",
      "opt_male": "Male",
      "opt_female": "Female",
      "opt_unknown": "Unknown",
      "opt_university": "University",
      "err_fetch_data": "An error occurred while fetching data.",
      "lbl_unassigned_dept": "UNASSIGNED ROLES",
      "msg_opening_dossier": "Opening employee dossier...",
      "err_loading_emp_details": "An error occurred while loading employee details.",
      "prompt_exit_date": "Termination Date (YYYY-MM-DD):",
      "msg_confirm_archive": "Are you sure you want to archive the employee named {{name}}?",
      "msg_archiving_emp": "Archiving employee...",
      "msg_archive_success": "Employee successfully archived and role vacated.",
      "err_archive_failed": "Employee might have pending assets/expenses, archiving failed.",
      "msg_confirm_reset_pwd": "Are you sure you want to reset the password for {{name}}?",
      "msg_resetting_pwd": "Resetting password...",
      "msg_reset_success": "Password successfully reset. (Email sent)",
      "err_reset_failed": "An error occurred while resetting password.",
      "msg_processing_record": "Processing personnel record...",
      "msg_update_success": "Record successfully updated.",
      "msg_create_success": "Employee successfully added to the system.",
      "err_save_failed": "Could not save. Please check the entered data.",
      "msg_preparing_pdf": "Preparing PDF Document...",
      "msg_download_success": "Document downloaded.",
      "err_pdf_failed": "An error occurred while generating PDF!",
      "err_select_column": "Please select at least 1 column.",
      "msg_generating_report": "Generating your custom report...",
      "msg_report_downloaded": "Report downloaded successfully.",
      "err_report_failed": "An error occurred while generating the report.",
      "msg_processing": "Processing...",
      "msg_profile_updated": "Profile successfully updated.",
      "msg_request_rejected": "Request rejected.",
      "err_action_failed": "Could not perform the action.",
      "lbl_key_phone": "PHONE NUMBER",
      "lbl_key_address": "RESIDENTIAL ADDRESS",
      "lbl_first_name": "FIRST NAME",
      "lbl_last_name": "LAST NAME",
      "lbl_identity_no": "ID / PASSPORT NO",
      "lbl_gender": "GENDER",
      "lbl_mother_name": "MOTHER'S NAME",
      "lbl_father_name": "FATHER'S NAME",
      "lbl_birth_place": "BIRTH PLACE",
      "lbl_birth_date": "BIRTH DATE",
      "lbl_phone_no": "MOBILE PHONE",
      "lbl_address": "RESIDENTIAL ADDRESS",
      "lbl_nationality": "NATIONALITY / CITIZENSHIP",
      "ph_nationality": "E.g.: US, UK",
      "lbl_marital_married": "MARITAL STATUS: MARRIED",
      "lbl_spouse_name": "SPOUSE FULL NAME",
      "lbl_spouse_works": "DOES SPOUSE WORK? (Tax Deduction)",
      "lbl_children_count": "NUMBER OF DEPENDENT CHILDREN",
      "lbl_child_name": "CHILD {{idx}} FULL NAME",
      "lbl_company_branch": "COMPANY / BRANCH",
      "opt_select": "Select",
      "lbl_hire_date": "HIRE DATE",
      "lbl_department": "DEPARTMENT",
      "opt_select_dept": "SELECT DEPARTMENT",
      "lbl_position": "POSITION / TITLE",
      "opt_no_position": "NO POSITION SELECTED",
      "lbl_select_dept_first": "Select a department first",
      "lbl_system_role": "SYSTEM ROLE (ACCESS)",
      "role_employee": "STANDARD EMPLOYEE (Own Info Only)",
      "role_manager": "MANAGER (Own Team and Approvals)",
      "role_hr": "HUMAN RESOURCES (All Employees)",
      "role_admin": "SYSTEM ADMIN (Full Access)",
      "desc_role_access": "Left menu and data access are adjusted automatically based on role.",
      "lbl_education_level": "EDUCATION LEVEL",
      "edu_primary": "Primary School",
      "edu_middle": "Middle School",
      "edu_high": "High School",
      "edu_university": "University",
      "edu_master": "Master's Degree",
      "lbl_gross_salary": "AGREED SALARY (GROSS)",
      "lbl_blood_type": "BLOOD TYPE",
      "opt_not_selected": "Not Selected",
      "lbl_ssn": "SOCIAL SECURITY NO (SSN)",
      "lbl_tax_no": "TAX / FUND NO (Optional)",
      "lbl_emergency_contact_name": "EMERGENCY CONTACT",
      "lbl_emergency_contact_relation": "RELATIONSHIP",
      "lbl_emergency_contact_phone": "EMERGENCY PHONE",
      "lbl_bank_name": "BANK NAME",
      "lbl_account_holder_name": "ACCOUNT HOLDER",
      "lbl_iban": "IBAN",
      "lbl_tax_id_number": "TAX ID / TIN",
      "lbl_work_auth_type": "WORK AUTHORIZATION TYPE",
      "lbl_work_auth_no": "WORK AUTHORIZATION NO",
      "lbl_work_auth_start": "AUTHORIZATION START",
      "lbl_work_auth_expiry": "AUTHORIZATION EXPIRY",
      "lbl_visa_type": "VISA / RESIDENCY TYPE",
      "lbl_visa_expiry": "VISA EXPIRY DATE",
      "lbl_nda_signed_at": "NDA SIGN DATE",
      "lbl_handbook_ack_signed_at": "HANDBOOK ACK DATE",
      "lbl_background_check_status": "BACKGROUND CHECK STATUS",
      "lbl_background_check_completed_at": "BACKGROUND CHECK DATE",
      "lbl_occupational_health_status": "OHS / MEDICAL FITNESS",
      "lbl_occupational_health_valid_until": "OHS / MEDICAL VALID UNTIL",
      "opt_not_started": "Not Started",
      "opt_in_progress": "In Progress",
      "opt_completed_short": "Completed",
      "opt_exempt": "Exempt",
      "opt_fit": "Fit",
      "opt_restricted": "Restricted",
      "opt_expired": "Expired",
      "tab_active_roster": "ACTIVE ROSTER",
      "tab_archive_roster": "ARCHIVE (TERMINATED)",
      "btn_approvals": "APPROVALS",
      "btn_custom_report": "CREATE CUSTOM REPORT",
      "btn_new_record": "NEW RECORD",
      "col_head_name": "FULL NAME / POSITION",
      "col_head_company": "COMPANY / LOCATION",
      "col_head_hire": "HIRE DATE",
      "col_head_exit": "TERMINATION DATE",
      "col_head_actions": "ACTIONS",
      "msg_no_records_tab": "No records in this tab.",
      "lbl_personnel_count": "PERSONNEL",
      "lbl_unassigned_short": "UNASSIGNED",
      "tooltip_download_card": "Download Info Card (PDF)",
      "tooltip_download_cert": "Download Work Certificate (PDF)",
      "tooltip_reset_pwd": "Reset Login Password",
      "tooltip_edit": "Edit",
      "tooltip_terminate": "Terminate (Archive)",
      "modal_title_approvals": "PROFILE UPDATE REQUESTS",
      "msg_no_pending_requests_html": "ALL REQUESTS REVIEWED!<br/>NO PENDING ACTIONS.",
      "badge_new_request": "NEW REQUEST",
      "btn_reject": "REJECT",
      "btn_approve": "APPROVE",
      "modal_title_custom_report": "CREATE CUSTOM REPORT",
      "lbl_report_title": "REPORT TITLE",
      "lbl_report_columns": "INFORMATION TO INCLUDE (COLUMNS)",
      "btn_cancel": "CANCEL",
      "btn_download_pdf_report": "DOWNLOAD PDF REPORT",
      "modal_title_edit_emp": "UPDATE EMPLOYEE DOSSIER",
      "modal_title_new_emp": "NEW EMPLOYEE REGISTRATION",
      "step_1": "1. IDENTITY",
      "step_2": "2. CONTACT & FAMILY",
      "step_3": "3. CORPORATE",
      "step_4": "4. FINANCE & LEGAL",
      "btn_back": "BACK",
      "lbl_step": "STEP {{step}} / 4",
      "btn_next": "NEXT",
      "btn_update_record": "UPDATE RECORD",
      "btn_complete_record": "COMPLETE REGISTRATION",
      "err_session_expired": "Your session may have expired, please log in again.",
      "err_fetch_performance": "Could not fetch performance data.",
      "msg_progress_saved": "Progress saved successfully.",
      "err_progress_update": "Could not update progress.",
      "lbl_loading_performance": "LOADING PERFORMANCE DATA...",
      "lbl_ai_career_assistant": "ARTIFICIAL INTELLIGENCE (AI) CAREER ASSISTANT",
      "msg_default_ai_summary": "Based on your past reviews and goals, you've caught a great momentum. Keep it up!",
      "lbl_active_goals": "MY ACTIVE GOALS (OKRS)",
      "msg_no_assigned_goals": "YOU HAVE NO ASSIGNED GOALS YET.",
      "lbl_progress_status": "PROGRESS STATUS",
      "lbl_drag_to_save": "Drag and drop the slider to save",
      "lbl_my_reviews": "MY REVIEWS",
      "msg_no_past_reviews": "NO PAST REVIEWS YET.",
      "lbl_manager_note": "MANAGER'S NOTE",
      "mood_great": "GREAT",
      "mood_good": "GOOD",
      "mood_normal": "NORMAL",
      "mood_bad": "BAD",
      "mood_awful": "AWFUL",
      "badge_team_star": "🌟 Team Star",
      "badge_fast_solver": "🚀 Fast Solver",
      "badge_helpful": "🦸‍♂️ Super Helpful",
      "badge_creative": "💡 Innovative Idea",
      "lbl_employee_fallback": "Employee",
      "err_fetch_portal": "Could not load portal data, please refresh the page.",
      "msg_creating_leave": "Creating your leave request...",
      "msg_leave_success": "Your leave request has been successfully submitted to your manager!",
      "err_leave_failed": "Could not create request.",
      "msg_no_changes": "You did not make any changes.",
      "msg_sending_update": "Sending your update request...",
      "msg_update_success": "Your change request has been sent to HR for approval!",
      "err_update_failed": "Could not send request. Please try again.",
      "err_pwd_match": "New passwords do not match!",
      "err_pwd_length": "Password must be at least 6 characters.",
      "msg_changing_pwd": "Changing your password...",
      "msg_pwd_changed": "Your password has been changed successfully!",
      "err_pwd_failed": "Could not change password.",
      "msg_mood_success": "Your mood has been shared with the team successfully!",
      "err_mood_failed": "Could not save your mood.",
      "msg_sending_kudos": "Sending your badge...",
      "msg_kudos_success": "Your Kudos badge has been sent successfully!",
      "err_kudos_failed": "Could not send badge.",
      "lbl_loading_portal": "LOADING YOUR PORTAL...",
      "lbl_hello": "HELLO, {{name}} 👋",
      "lbl_personnel": "PERSONNEL",
      "lbl_general_dept": "GENERAL DEPARTMENT",
      "btn_account_pwd": "ACCOUNT / PASSWORD",
      "btn_req_new_leave": "REQUEST NEW LEAVE",
      "lbl_used_this_year": "USED THIS YEAR: {{days}} DAYS",
      "btn_declare_expense": "DECLARE EXPENSE",
      "lbl_receipt_invoice": "RECEIPT & INVOICE ENTRY",
      "lbl_how_do_you_feel": "HOW DO YOU FEEL TODAY?",
      "lbl_share_mood": "Share your mood, send energy to your team!",
      "lbl_upcoming_trainings": "MY UPCOMING TRAININGS",
      "lbl_no_trainings": "YOU HAVE NO SCHEDULED OR UPCOMING TRAININGS.",
      "lbl_participant": "PARTICIPANT",
      "lbl_my_assets": "MY ASSIGNED ASSETS",
      "lbl_no_assets": "NO ACTIVE ASSETS ASSIGNED TO YOU.",
      "lbl_celebrations_this_month": "CELEBRATING THIS MONTH!",
      "lbl_no_celebrations": "NO EVENTS TO CELEBRATE<br/>THIS MONTH.",
      "lbl_day": "DAY",
      "lbl_birthday": "BIRTHDAY",
      "lbl_anniversary": "{{years}} YEAR ANNIVERSARY",
      "lbl_kudos_board": "KUDOS BOARD",
      "tooltip_send_badge": "Send a Badge",
      "lbl_no_kudos": "NO ONE HAS SENT A BADGE YET.<br/>BE THE FIRST TO SAY THANKS!",
      "modal_title_kudos": "SEND KUDOS BADGE",
      "lbl_to_whom": "TO WHOM ARE YOU SENDING?",
      "opt_select_colleague": "-- Select a Colleague --",
      "lbl_select_badge": "SELECT BADGE",
      "lbl_write_note": "WRITE A NICE NOTE",
      "ph_kudos_note": "Thank you so much for your help...",
      "btn_send_kudos": "SEND BADGE AND MESSAGE",
      "modal_title_leave": "CREATE LEAVE REQUEST",
      "lbl_manager_approval": "YOUR REQUEST WILL BE SUBMITTED FOR MANAGER APPROVAL",
      "lbl_used_leave": "LEAVE USED THIS YEAR",
      "lbl_days": "DAYS",
      "lbl_leave_type": "LEAVE TYPE",
      "opt_annual": "ANNUAL LEAVE (PAID)",
      "opt_excuse": "EXCUSE LEAVE",
      "opt_sick": "SICK LEAVE (MEDICAL REPORT)",
      "opt_unpaid": "UNPAID LEAVE",
      "lbl_start": "START",
      "lbl_end": "END",
      "lbl_reason": "REASON / DESCRIPTION",
      "ph_reason": "You can write a short description...",
      "btn_cancel": "CANCEL",
      "btn_submit_approval": "SUBMIT FOR APPROVAL",
      "modal_title_settings": "ACCOUNT SETTINGS",
      "tab_contact": "CONTACT INFO",
      "tab_password": "CHANGE PASSWORD",
      "lbl_update_req": "UPDATE REQUEST",
      "desc_update_req": "Changes made here are sent to HR as a \"Draft\". They will be applied to your official file once approved.",
      "lbl_phone": "PHONE NUMBER",
      "ph_phone": "e.g. +1 555 123 4567",
      "lbl_address": "RESIDENTIAL ADDRESS",
      "ph_address": "Enter your full address...",
      "lbl_old_pwd": "CURRENT PASSWORD",
      "ph_old_pwd": "The password you use to log in",
      "lbl_new_pwd": "NEW PASSWORD",
      "ph_new_pwd": "At least 6 characters",
      "lbl_confirm_pwd": "NEW PASSWORD (CONFIRM)",
      "ph_confirm_pwd": "Verify your new password",
      "btn_change_pwd": "CHANGE MY PASSWORD",
      "err_fetch_trainings": "Could not fetch your training calendar.",
      "lbl_loading_trainings": "LOADING TRAINING CALENDAR...",
      "lbl_assigned_training": "ASSIGNED TRAININGS:",
      "lbl_count": "ITEMS",
      "msg_no_upcoming_html": "YOU DO NOT HAVE ANY UPCOMING<br/>TRAININGS SCHEDULED.",
      "badge_approaching": "UPCOMING",
      "lbl_date": "DATE",
      "lbl_time": "TIME",
      "lbl_instructor": "INSTRUCTOR",
      "lbl_location": "LOCATION",
      "lbl_past_cancelled_trainings": "PAST & CANCELLED TRAININGS",
      "badge_cancelled_by_admin": "CANCELLED BY MANAGEMENT",
      "lbl_unknown_field": "Unknown Field",
      "err_format_invalid": "Error ({{field}}): Missing or invalid format!",
      "err_no_user_id": "User ID not found.",
      "msg_confirm_approve": "Are you sure you want to APPROVE this expense declaration?",
      "msg_processing": "Processing and sending email...",
      "msg_confirm_delete_expense": "Are you sure you want to completely DELETE this expense?",
      "msg_expense_deleted": "Expense record successfully deleted.",
      "tab_pending": "PENDING",
      "tab_approved": "APPROVED",
      "tab_rejected": "REJECTED",
      "btn_new_expense": "NEW EXPENSE ENTRY",
      "lbl_loading": "LOADING EXPENSES...",
      "msg_no_expenses_category_html": "NO EXPENSE DECLARATIONS IN THIS CATEGORY.",
      "col_personnel": "PERSONNEL",
      "col_category_date": "CATEGORY & DATE",
      "col_amount": "AMOUNT",
      "col_receipt": "RECEIPT / INVOICE",
      "col_description": "DESCRIPTION / NOTE",
      "col_actions": "ACTIONS",
      "badge_added_to_payroll": "ADDED TO PAYROLL",
      "lbl_no_doc": "NO DOCUMENT",
      "lbl_action_completed": "ACTION COMPLETED",
      "tooltip_delete_req": "Delete My Request",
      "lbl_no_action_needed": "NO ACTION NEEDED",
      "lbl_expense_date": "Expense Date",
      "lbl_desc_details": "Description / Details",
      "lbl_personnel_name": "PERSONNEL:",
      "prompt_reject_reason": "Please enter the reason for rejection (Optional):",
      "prompt_reject_default": "Receipt image is unreadable or non-standard.",
      "err_fetch_tickets": "Could not fetch tickets.",
      "err_fetch_details": "Could not fetch ticket details.",
      "msg_creating_ticket": "Creating support ticket...",
      "msg_ticket_created": "Your ticket has been successfully created.",
      "err_create_ticket": "An error occurred while creating the ticket.",
      "msg_sending_msg": "Sending message...",
      "lbl_file_attached": "Please review the attached file.",
      "msg_msg_sent": "Message sent!",
      "err_send_msg": "Message could not be sent.",
      "msg_confirm_resolve": "Do you want to mark this ticket as RESOLVED? This action cannot be undone and the chat will be closed.",
      "msg_closing_ticket": "Closing ticket...",
      "msg_ticket_closed": "Ticket successfully closed.",
      "err_update_status": "Could not update status.",
      "status_open": "OPEN",
      "status_in_progress": "IN PROGRESS",
      "status_resolved": "RESOLVED",
      "cat_payroll": "PAYROLL",
      "cat_it": "IT SUPPORT",
      "cat_hr": "HR REQUEST",
      "cat_admin": "ADMIN / MATERIAL",
      "btn_create_ticket": "CREATE NEW TICKET",
      "lbl_tickets": "TICKETS",
      "lbl_urgent": "URGENT",
      "msg_no_tickets_html": "THERE ARE NO REGISTERED<br/>TICKETS IN THE SYSTEM.",
      "lbl_ticket_no": "TICKET NO:",
      "btn_close_ticket": "CLOSE TICKET",
      "msg_no_messages": "No messages sent yet.",
      "btn_open_attachment": "OPEN ATTACHED FILE",
      "lbl_click_to_view": "Click to view",
      "ph_type_reply": "Type a reply...",
      "msg_ticket_closed_comment": "THIS TICKET IS CLOSED FOR COMMENTS BECAUSE IT HAS BEEN RESOLVED.",
      "msg_select_ticket_html": "SELECT A TICKET FROM THE LEFT<br/>TO VIEW DETAILS AND MESSAGES",
      "modal_title_new_ticket": "NEW SUPPORT TICKET",
      "lbl_subject_summary": "SUBJECT SUMMARY",
      "ph_subject": "E.g., Requesting my March 2024 Payslip",
      "lbl_priority": "PRIORITY",
      "prio_low": "LOW",
      "prio_normal": "NORMAL",
      "prio_urgent": "URGENT",
      "lbl_message_details": "YOUR MESSAGE / DETAILS",
      "ph_ticket_message": "Type your request here...",
      "btn_submit_ticket": "SUBMIT TICKET TO SYSTEM",
      "err_fetch_requests": "An error occurred while fetching leave requests.",
      "prompt_reject_reason": "Please state the reason for rejection (Required):",
      "prompt_reject_default": "Not suitable due to operational workload.",
      "err_reject_reason_required": "You must provide a reason to reject the leave.",
      "msg_confirm_approve": "Are you sure you want to APPROVE this leave request?",
      "msg_processing": "Processing and sending email...",
      "action_approved": "approved",
      "action_rejected": "rejected",
      "msg_status_updated": "Leave request has been {{status}}.",
      "err_action_failed": "An error occurred during the process.",
      "err_missing_form_data": "Please fill in the dates and reason completely.",
      "msg_creating_leave": "Creating your leave request...",
      "msg_leave_req_success": "Your leave request has been successfully created and submitted for approval!",
      "err_leave_submit_failed": "Missing information entered or the process failed.",
      "err_fetch_summary": "Could not fetch personnel summary.",
      "badge_pending": "PENDING APPROVAL",
      "badge_approved": "APPROVED",
      "badge_rejected": "REJECTED",
      "badge_unknown": "UNKNOWN",
      "type_annual": "ANNUAL LEAVE (PAID)",
      "type_excuse": "EXCUSE LEAVE",
      "type_sick": "SICK LEAVE (REPORT)",
      "type_unpaid": "UNPAID LEAVE",
      "tab_pending_approvals": "PENDING APPROVALS",
      "tab_approved_requests": "APPROVED",
      "tab_rejected_requests": "REJECTED",
      "btn_new_leave_req": "NEW LEAVE REQUEST",
      "lbl_loading_requests": "LOADING REQUESTS...",
      "msg_no_requests_html": "NO LEAVE REQUESTS FOUND IN THIS CATEGORY.",
      "col_personnel": "PERSONNEL",
      "col_status": "STATUS",
      "col_leave_type": "LEAVE TYPE",
      "col_date_range": "DATE RANGE",
      "col_days": "DAYS",
      "col_description": "DESCRIPTION / NOTE",
      "col_actions": "ACTIONS",
      "btn_leave_summary": "REMAINING LEAVE SUMMARY",
      "lbl_cancel_note": "Note:",
      "lbl_action_completed": "ACTION COMPLETED",
      "lbl_no_action_needed": "NO ACTION NEEDED",
      "lbl_pending_authorization": "PENDING AUTHORIZATION",
      "btn_approve": "APPROVE",
      "btn_reject": "REJECT",
      "modal_title_create_leave": "CREATE LEAVE REQUEST",
      "lbl_leave_type": "Leave Type",
      "lbl_start": "Start",
      "lbl_end": "End",
      "lbl_calculated_days": "CALCULATED DAYS:",
      "lbl_days": "DAYS",
      "lbl_reason": "Reason / Description",
      "ph_leave_reason": "Briefly explain the reason for leave...",
      "btn_cancel": "CANCEL",
      "btn_submit_approval": "SUBMIT FOR APPROVAL",
      "modal_title_leave_summary": "LEAVE ENTITLEMENT SUMMARY",
      "lbl_total_used_this_year": "TOTAL USED THIS YEAR",
      "lbl_usage_breakdown": "USAGE BREAKDOWN",
      "msg_no_approved_leaves": "No approved leave records found yet.",
      "btn_close_window": "CLOSE WINDOW",
      "err_fetch_locations": "Could not fetch locations.",
      "err_geo_not_supported": "Your browser does not support geolocation (GPS).",
      "msg_geo_success": "Location successfully acquired.",
      "err_geo_failed": "Could not get location. Please check browser permissions.",
      "msg_saving_location": "Saving location...",
      "msg_location_updated": "Location successfully updated.",
      "msg_location_added": "New location successfully added.",
      "msg_confirm_delete_location": "Are you sure you want to delete (archive) the location \"{{name}}\"? This action will invalidate its QR code.",
      "msg_archiving_location": "Archiving location...",
      "msg_location_deleted": "Location successfully deleted.",
      "err_delete_location": "An error occurred while deleting the location.",
      "msg_confirm_rotate_qr": "WARNING: Are you sure you want to invalidate the current QR code for \"{{name}}\" and generate a brand new security token? (Existing posters will no longer work!)",
      "msg_resetting_qr": "Resetting QR Code...",
      "msg_qr_rotated": "Security token regenerated. Do not forget to download the new poster!",
      "err_rotate_qr": "An error occurred while regenerating the QR code.",
      "msg_preparing_poster": "Preparing PDF Poster...",
      "msg_poster_downloaded": "PDF Downloaded.",
      "err_poster_failed": "An error occurred while generating the poster.",
      "lbl_anti_fraud_system": "ANTI-FRAUD (GEOFENCING) SYSTEM",
      "desc_anti_fraud_html": "For every site/office you add, the system generates an A4 QR Poster with a <span class='bg-rose-200 text-rose-900 px-2 py-0.5 rounded-md font-black'>Security Token</span>. If personnel try to scan it from far away (or via WhatsApp photos), the system checks GPS and denies entry.",
      "btn_add_location": "ADD SITE / OFFICE",
      "lbl_loading_locations": "LOADING LOCATIONS...",
      "msg_no_locations_html": "NO SITES/LOCATIONS REGISTERED IN THE SYSTEM.",
      "tooltip_reset_qr": "Reset QR Token (Anti-Fraud)",
      "tooltip_delete": "Delete (Archive)",
      "lbl_no_address": "No Address Specified",
      "lbl_latitude": "LATITUDE",
      "lbl_longitude": "LONGITUDE",
      "lbl_security_radius": "SECURITY RADIUS",
      "lbl_meters": "METERS",
      "btn_download_poster": "DOWNLOAD A4 QR POSTER",
      "modal_title_edit_loc": "EDIT SITE / OFFICE",
      "modal_title_new_loc": "ADD NEW SITE / OFFICE",
      "lbl_location_name": "LOCATION NAME (e.g., Head Office)",
      "lbl_full_address": "FULL ADDRESS",
      "ph_optional": "Optional...",
      "lbl_gps_coordinates": "GPS COORDINATES",
      "btn_finding_location": "LOCATING...",
      "btn_get_my_location": "GET MY CURRENT LOCATION",
      "lbl_security_radius_input": "SECURITY RADIUS (IN METERS)",
      "desc_radius_warning": "If personnel step outside this radius, the QR code will not work and they cannot clock in.",
      "btn_update_location": "UPDATE LOCATION",
      "btn_save_location": "SAVE LOCATION TO SYSTEM",
      "login_failed_generic": "Login failed. Please check your credentials.",
      "server_unreachable": "Server unreachable. Please check your connection.",
      "login_title": "IKPro Login",
      "email_label": "Email:",
      "password_label": "Password:",
      "login_button": "Sign In",
      "lbl_user": "User",
      "role_superadmin": "SYSTEM ADMINISTRATOR",
      "role_admin": "HUMAN RESOURCES (MANAGER)",
      "role_hr": "HUMAN RESOURCES (SPECIALIST)",
      "role_manager": "DEPARTMENT MANAGER",
      "role_employee_short": "PERSONNEL",
      "lbl_notifications": "NOTIFICATIONS",
      "lbl_new": "NEW",
      "msg_no_new_notifs": "NO NEW NOTIFICATIONS",
      "lbl_leave_requests": "LEAVE REQUESTS",
      "lbl_items": "items",
      "msg_leave_waiting": "leave request(s) pending your approval.",
      "lbl_expense_requests": "EXPENSE REQUESTS",
      "msg_expense_waiting": "expense(s) pending your approval.",
      "lbl_open_tickets": "OPEN TICKETS",
      "msg_ticket_waiting": "open support ticket(s).",
      "btn_view_all_dashboard": "VIEW ALL (GO TO DASHBOARD)",
      "lbl_logged_in": "SIGNED IN",
      "btn_secure_logout": "SECURE LOGOUT",
      "tooltip_drag_to_move": "Drag to move",
      "tooltip_edit_position": "EDIT POSITION",
      "tooltip_delete_position": "DELETE POSITION",
      "lbl_vacant_position": "VACANT POSITION",
      "lbl_filled_positions": "FILLED POSITIONS",
      "lbl_employee_count": "EMPLOYEE COUNT",
      "err_fetch_org_data": "Could not fetch chart data.",
      "msg_confirm_delete_pos": "Are you sure you want to delete this position? Subordinates and personnel may be affected.",
      "msg_deleting_pos": "Deleting position...",
      "msg_delete_success": "Position successfully deleted.",
      "err_delete_pos_failed": "Position could not be deleted (it may contain personnel).",
      "msg_creating_dept": "Creating department...",
      "msg_dept_added": "New department added to the system.",
      "err_add_dept": "Could not add department.",
      "err_hierarchy_loop": "HIERARCHY ERROR: You cannot link a superior position to a position under it!",
      "msg_confirm_move_pos": "Are you sure you want to link this position to a new manager?",
      "msg_updating_org": "Updating organization...",
      "msg_move_success": "Position successfully moved.",
      "err_move_failed": "An error occurred while moving the position.",
      "err_select_dept": "Please select a department!",
      "err_self_parent": "You cannot link a position to itself!",
      "msg_saving_pos": "Saving position...",
      "msg_update_pos_success": "Position updated.",
      "msg_create_pos_success": "New position created.",
      "lbl_drag_drop_info": "YOU CAN DRAG AND DROP POSITIONS TO LINK THEM",
      "btn_create_dept": "ADD DEPARTMENT",
      "btn_create_position": "ADD POSITION",
      "lbl_loading_chart": "GENERATING CHART...",
      "msg_empty_org_chart_html": "NO POSITIONS IN THE SYSTEM YET.<br/>CREATE A DEPARTMENT FIRST, THEN ADD THE FIRST POSITION.",
      "modal_title_new_dept": "ADD NEW DEPARTMENT",
      "lbl_department_name": "DEPARTMENT NAME",
      "ph_department_name": "E.g.: INFORMATION TECHNOLOGY",
      "btn_save_dept": "SAVE DEPARTMENT",
      "modal_title_edit_pos": "UPDATE POSITION",
      "modal_title_new_pos": "DEFINE NEW POSITION",
      "lbl_position_name": "POSITION / TITLE NAME",
      "ph_position_name": "E.g.: FIELD ENGINEER",
      "lbl_belongs_to_dept": "BELONGS TO DEPARTMENT",
      "lbl_parent_position": "PARENT POSITION (REPORTS TO)",
      "opt_top_management": "TOP MANAGEMENT (NO PARENT)",
      "desc_parent_pos_info": "Leave requests from personnel in this position will go to the selected parent position.",
      "btn_save_changes": "SAVE CHANGES",
      "btn_save_to_system": "SAVE TO SYSTEM",
      "err_select_personnel": "Please select an employee first!",
      "msg_ai_success": "AI 9-Box analysis completed.",
      "err_ai_failed": "Could not generate AI analysis at the moment.",
      "msg_goal_updated": "Goal updated.",
      "msg_goal_added": "New goal assigned.",
      "err_goal_saved": "Goal could not be saved!",
      "confirm_delete_goal": "Are you sure you want to delete this goal?",
      "msg_goal_deleted": "Goal deleted.",
      "err_goal_deleted": "Goal could not be deleted!",
      "msg_progress_saved": "Progress saved.",
      "err_progress_update": "Progress could not be updated!",
      "msg_review_updated": "Review updated.",
      "msg_review_saved": "Review saved.",
      "err_review_failed": "Review error!",
      "confirm_delete_review": "Are you sure you want to delete this review?",
      "msg_review_deleted": "Review deleted.",
      "err_review_deleted": "Review could not be deleted.",
      "tab_okr": "GOALS (OKR)",
      "tab_360": "360° REVIEW",
      "tab_ai": "AI TALENT ANALYSIS",
      "opt_select_personnel": "SELECT PERSONNEL",
      "lbl_eval_center": "EVALUATION CENTER",
      "msg_select_personnel": "PLEASE SELECT A PERSONNEL TO PROCEED.",
      "lbl_strategic_goals": "STRATEGIC GOALS",
      "btn_add_goal": "ADD NEW GOAL",
      "msg_no_goals": "YOU HAVE NO ASSIGNED GOALS YET.",
      "lbl_progress": "CURRENT PROGRESS",
      "msg_ai_analyzing": "AI DATA ANALYSIS IN PROGRESS...",
      "lbl_9box_matrix": "9-BOX POTENTIAL/PERFORMANCE MATRIX",
      "lbl_ai_summary": "AI EXECUTIVE SUMMARY",
      "lbl_dev_suggestion": "Development Suggestion",
      "val_fast_promo": "Fast Promotion / Leadership Training",
      "lbl_risk_analysis": "Risk Analysis",
      "val_low_risk": "Low (High Engagement)",
      "msg_press_to_analyze": "Press the button to start the analysis.",
      "btn_run_analysis": "RUN ANALYSIS",
      "box_STAR": "STAR",
      "box_HIGH_POTENTIAL": "HIGH POTENTIAL",
      "box_ENIGMA": "ENIGMA",
      "box_HIGH_PERFORMER": "HIGH PERFORMER",
      "box_CORE_EMPLOYEE": "CORE EMPLOYEE",
      "box_DILEMMA": "DILEMMA",
      "box_SOLID_PERFORMER": "SOLID PERFORMER",
      "box_EFFECTIVE_EMPLOYEE": "EFFECTIVE EMPLOYEE",
      "box_UNDER_PERFORMER": "UNDER PERFORMER",
      "lbl_feedback_pool": "FEEDBACK POOL",
      "btn_score": "ADD SCORE",
      "msg_no_reviews": "YOU HAVE NO PAST REVIEWS.",
      "lbl_peer_note": "Peer Note",
      "modal_review_title": "PERFORMANCE SCORING",
      "lbl_review_period": "Review Period",
      "opt_q1": "2026 Q1",
      "opt_q2": "2026 Q2",
      "opt_q3": "2026 Q3",
      "opt_q4": "2026 Q4",
      "opt_custom_period": "Custom Period...",
      "ph_custom_period": "E.g., 2026 Year-End Review",
      "lbl_rating": "Overall Rating (1-5)",
      "lbl_manager_comments": "Manager Comments / Feedback",
      "ph_manager_comments": "Write your notes on the employee's strengths and areas for development here...",
      "btn_cancel": "CANCEL",
      "btn_save_score": "SAVE SCORE",
      "modal_goal_title": "GOAL PARAMETERS",
      "lbl_goal_title": "Goal Title",
      "lbl_goal_desc": "Details",
      "lbl_due_date": "Due Date",
      "opt_end_q1": "End of 2026-Q1",
      "opt_end_q2": "End of 2026-Q2",
      "opt_end_q3": "End of 2026-Q3",
      "opt_end_q4": "End of 2026-Q4",
      "opt_custom_date": "Custom Date...",
      "btn_save": "SAVE",
      "err_unauthorized_access": "You do not have permission to access this page!",
      "err_fill_all_fields": "Please fill in all fields.",
      "err_pwd_length": "Your password must be at least 6 characters.",
      "msg_creating_account": "Creating your account and company profile...",
      "msg_registration_success": "Registration successful! Your 30-day trial has started.",
      "err_registration_failed": "An error occurred during registration.",
      "lbl_welcome_title_html": "WELCOME TO<br/>KTC HR",
      "lbl_welcome_desc": "You are about to start managing all your HR, performance, assets, and operational processes under one roof.",
      "lbl_feature_1": "30-Day Free Trial",
      "lbl_feature_2": "Unlimited Employees",
      "lbl_feature_3": "Cancel Anytime",
      "lbl_step_company": "Company",
      "lbl_step_payment": "Payment",
      "lbl_corporate_info": "Corporate Information",
      "lbl_company_org_name": "Company / Organization Name",
      "ph_company_name": "E.g.: Tech Solutions Inc.",
      "lbl_manager_name": "Manager Full Name",
      "ph_manager_name": "Full Name",
      "lbl_business_email": "Business Email Address",
      "ph_business_email": "admin@company.com",
      "lbl_account_password": "Account Password",
      "ph_password": "At least 6 characters",
      "btn_proceed_payment": "PROCEED TO PAYMENT",
      "msg_already_have_account": "Already have an account?",
      "btn_login_link": "Sign In",
      "lbl_payment_method": "Payment Method",
      "lbl_ssl_secure": "256-BIT SSL SECURE",
      "lbl_card_holder_display": "CARD HOLDER",
      "lbl_full_name_display": "FULL NAME",
      "lbl_expiry_display": "EXP",
      "lbl_mm_yy_display": "MM/YY",
      "lbl_card_name": "Name on Card",
      "ph_card_name": "Cardholder's Name",
      "lbl_card_number": "Card Number",
      "lbl_expiry_date": "Expiration Date",
      "ph_expiry_date": "MM/YY",
      "lbl_security_code": "Security Code",
      "ph_security_code": "CVC",
      "msg_no_charge_warning": "* Your credit card <strong class='text-indigo-600'>will not be charged</strong> during your 30-day free trial.",
      "btn_back": "BACK",
      "btn_complete_and_start": "COMPLETE REGISTRATION & START",
      "lbl_loading": "LOADING...",
      "role_superadmin": "SYSTEM ADMINISTRATOR",
      "role_admin": "HUMAN RESOURCES (MANAGER)",
      "role_hr": "HUMAN RESOURCES (SPECIALIST)",
      "role_manager": "DEPARTMENT MANAGER",
      "role_employee_short": "PERSONNEL",
      "menu_dashboard": "COCKPIT",
      "menu_employees": "EMPLOYEE MANAGEMENT",
      "menu_org_chart": "ORGANIZATION CHART",
      "menu_ats": "APPLICANT TRACKING (ATS)",
      "menu_attendance": "TIME & ATTENDANCE",
      "menu_operations_time": "OPERATIONS / TIME ATTENDANCE",
      "menu_locations": "LOCATIONS & SITES",
      "menu_leaves": "LEAVE MANAGEMENT",
      "menu_dossier": "E-DOSSIER ARCHIVE",
      "menu_performance": "PERFORMANCE (OKR)",
      "menu_training": "TRAINING (LMS)",
      "menu_expenses": "EXPENSE MANAGEMENT",
      "menu_assets": "ASSETS & INVENTORY",
      "menu_helpdesk": "HELPDESK",
      "menu_portal": "COCKPIT",
      "menu_my_team": "MY TEAM (STAFF)",
      "menu_settings": "COMPANY SETTINGS (NEW)",
      "operations_time_kicker": "Operations / Time Attendance",
      "operations_time_title": "Timesheet and payroll operations",
      "operations_time_desc": "Manage holiday calendars, pay-code approvals, timesheet periods and payroll export profiles from one screen.",
      "schedule_management_kicker": "Shift planning",
      "schedule_management_title": "Shift plans and assignments",
      "schedule_management_desc": "Create shift templates, assign them to departments and manage employee overrides.",
      "schedule_management_open": "Open shift planning",
      "operations_time_tab_puantaj": "Timesheet",
      "operations_time_tab_schedules": "Shift Planning",
      "operations_time_tab_leave": "Leave Settings",
      "operations_time_tab_departments": "Department Assignments",
      "operations_time_tab_overrides": "Employee Overrides",
      "operations_time_tab_reports": "Payroll Report",
      "operations_time_tab_settings": "Timesheet Settings",
      "operations_time_tabs": "Time attendance tabs",
      "pay_code_title": "Pay-code and coefficient approval",
      "pay_code_desc": "Unapproved coefficients are excluded from payroll exports.",
      "pay_code_seed": "Create defaults",
      "pay_code_add": "Propose",
      "pay_code_category": "Category",
      "pay_code_code": "Code",
      "pay_code_name": "Description",
      "pay_code_accounting_code": "Accounting code",
      "pay_code_coefficient": "Coefficient",
      "pay_code_unit": "Unit",
      "pay_code_status_approved": "Approved",
      "pay_code_status_proposed": "Pending approval",
      "pay_code_status_rejected": "Rejected",
      "pay_code_category_work": "Work",
      "pay_code_category_overtime": "Overtime",
      "pay_code_category_holiday": "Public holiday",
      "pay_code_category_leave": "Leave",
      "pay_code_category_absence": "Absence",
      "payroll_export_title": "Payroll export profile",
      "payroll_export_desc": "A payroll format cannot be used without an approved profile.",
      "payroll_export_provider": "Provider",
      "payroll_export_format": "Format",
      "payroll_export_delimiter": "Delimiter",
      "payroll_export_date_format": "Date format",
      "payroll_export_propose": "Propose",
      "payroll_export_approve": "Approve",
      "payroll_export_status_approved": "Approved",
      "payroll_export_status_proposed": "Pending approval",
      "timesheet_title": "Timesheet calculation and export",
      "timesheet_desc": "Calculate, submit for approval, lock and export payroll data.",
      "timesheet_start": "Start",
      "timesheet_end": "End",
      "timesheet_create": "Create",
      "timesheet_calculate": "Calculate",
      "timesheet_send_approval": "Submit for approval",
      "timesheet_approve": "Approve",
      "timesheet_lock": "Lock",
      "timesheet_export": "Export",
      "timesheet_status": "Status",
      "timesheet_status_draft": "Draft",
      "timesheet_status_calculated": "Calculated",
      "timesheet_status_pending": "Pending approval",
      "timesheet_status_approved": "Approved",
      "timesheet_status_locked": "Locked",
      "timesheet_status_exported": "Exported",
      "timesheet_calculated": "Timesheet calculated.",
      "timesheet_sent_approval": "Submitted for approval.",
      "timesheet_approved": "Timesheet approved.",
      "timesheet_locked": "Timesheet locked.",
      "refresh": "Refresh",
      "holiday_source_system": "System",
      "holiday_source_company": "Company",
      "menu_logout": "SECURE LOGOUT",
      "menu_audit_logs": "SYSTEM LOGS",
      "audit_logs_title": "SYSTEM LOG RECORDS",
      "audit_logs_subtitle": "SUPERADMIN CENTRAL AUDIT SCREEN",
      "audit_logs_records": "RECORDS",
      "audit_filter_company": "ALL COMPANIES",
      "audit_filter_action": "ALL ACTIONS",
      "audit_filter_resource": "ALL MODULES",
      "audit_filter_employee": "ALL PEOPLE",
      "audit_filter_department": "ALL DEPARTMENTS",
      "audit_apply_filters": "FILTER",
      "audit_reset_filters": "RESET",
      "audit_col_datetime": "DATE / TIME",
      "audit_col_company": "COMPANY",
      "audit_col_person": "PERSON",
      "audit_col_department": "DEPARTMENT",
      "audit_col_detail": "DETAIL",
      "audit_col_action": "ACTION",
      "audit_col_module": "MODULE",
      "audit_col_status": "STATUS",
      "audit_col_path": "ENDPOINT",
      "audit_loading": "LOADING LOG RECORDS...",
      "audit_empty": "NO RECORDS FOUND FOR THE SELECTED FILTERS",
      "err_fetch_audit_filters": "Audit filters could not be loaded.",
      "err_fetch_audit_logs": "Audit log records could not be loaded.",
      "audit_detail_view_logs": "Viewed system logs",
      "audit_detail_clock_in": "Clocked in with QR and location",
      "audit_detail_clock_out": "Clocked out with QR and location",
      "audit_detail_bulk_attendance": "Uploaded bulk attendance data",
      "audit_detail_schedule_create": "Created a work schedule",
      "audit_detail_schedule_update": "Updated a work schedule",
      "audit_detail_schedule_delete": "Deleted a work schedule",
      "audit_detail_schedule_assign_departments": "Assigned work schedules to departments",
      "audit_detail_schedule_assign_employees": "Assigned custom work schedules to employees",
      "audit_detail_schedule_clear_employees": "Cleared employee schedule overrides",
      "audit_detail_document_upload": "Uploaded a document",
      "audit_detail_document_status": "Updated document status",
      "audit_detail_expense_create": "Created an expense request",
      "audit_detail_expense_status": "Updated expense status",
      "audit_detail_leave_create": "Created a leave request",
      "audit_detail_leave_status": "Updated leave status",
      "audit_detail_helpdesk_create": "Created a helpdesk ticket",
      "audit_detail_helpdesk_message": "Sent a helpdesk message",
      "audit_detail_helpdesk_status": "Updated helpdesk ticket status",
      "audit_detail_location_create": "Created a location",
      "audit_detail_location_update": "Updated a location",
      "audit_detail_location_rotate_qr": "Rotated the location QR code",
      "audit_detail_location_poster": "Downloaded the QR poster",
      "audit_detail_asset_assign": "Assigned an asset",
      "audit_detail_asset_return": "Returned an asset",
      "audit_detail_offer_letter": "Generated an offer letter",
      "audit_detail_failed_suffix": "but the request failed",
      "demo_goal_description": "Sample OKR goal for this employee",
      "demo_manager_review": "Sample manager review: goal tracking and team communication are positive.",
      "demo_peer_review": "Sample peer feedback: supportive and accountable.",
      "err_fetch_data": "An error occurred while fetching data.",
      "draft_cancel_msg": "Dear Colleagues,\n\nOur training titled \"{{title}}\" scheduled for {{date}} has been canceled.\n\nThank you for your understanding.",
      "msg_training_scheduled": "New training scheduled successfully.",
      "err_schedule_training": "Could not schedule training!",
      "err_select_min_one_emp": "Please select at least 1 employee.",
      "msg_assigning_sending": "Assigning personnel and sending emails...",
      "msg_assigned_invited": "Personnel assigned and invitations sent!",
      "err_assign_failed": "Assignment process failed.",
      "msg_canceling_sending": "Canceling and sending emails...",
      "msg_training_canceled": "Training canceled and participants notified.",
      "err_cancel_failed": "Cancellation process failed.",
      "msg_confirm_delete_training": "Are you sure you want to completely delete this training from the system?",
      "msg_training_deleted": "Training deleted from the system.",
      "err_delete_training": "Could not delete training.",
      "msg_attendance_updated": "Attendance status updated.",
      "err_attendance_update": "Could not update attendance!",
      "err_no_data_download": "No data found to download.",
      "csv_headers": "Training Name,Date,Instructor,Employee Name,Department,Attendance Status\n",
      "msg_excel_downloaded": "Excel file downloaded.",
      "btn_schedule_training": "SCHEDULE NEW TRAINING",
      "msg_no_trainings_scheduled": "NO TRAININGS SCHEDULED YET.",
      "badge_cancelled": "CANCELLED",
      "badge_completed": "COMPLETED",
      "badge_approaching": "UPCOMING",
      "tooltip_delete": "Delete",
      "lbl_no_description": "No description available.",
      "lbl_instructor": "INSTRUCTOR",
      "lbl_date": "DATE",
      "lbl_time": "TIME",
      "lbl_participants": "PARTICIPANTS",
      "lbl_persons": "PEOPLE",
      "btn_assign_personnel": "ASSIGN PERSONNEL",
      "err_no_participants_assigned": "No one is assigned to this training.",
      "btn_take_attendance": "TAKE ATTENDANCE",
      "btn_cancel": "CANCEL",
      "modal_title_schedule_training": "SCHEDULE NEW TRAINING",
      "lbl_training_title": "TRAINING TITLE / SUBJECT",
      "ph_training_title": "E.g., Advanced Excel Training",
      "lbl_training_desc": "DESCRIPTION",
      "ph_training_desc": "Brief info about the training content...",
      "ph_instructor": "E.g., John Doe",
      "lbl_location": "LOCATION / LINK",
      "ph_location": "Meeting Room 1 or Zoom Link",
      "btn_save_publish_training": "SAVE AND PUBLISH TRAINING",
      "modal_title_assign_personnel": "ASSIGN PERSONNEL TO TRAINING",
      "msg_invitation_will_be_sent": "INVITATION EMAIL WILL BE SENT TO SELECTED PERSONNEL.",
      "btn_assign_and_invite": "ASSIGN AND INVITE {{count}} PERSONNEL",
      "modal_title_attendance_report": "TRAINING ATTENDANCE AND REPORT",
      "lbl_registered_personnel_list": "REGISTERED PERSONNEL LIST",
      "btn_download_excel": "DOWNLOAD EXCEL",
      "msg_no_one_assigned": "NO ONE IS ASSIGNED TO THIS TRAINING.",
      "btn_attended": "ATTENDED",
      "btn_not_attended": "NOT ATTENDED",
      "modal_title_cancel_training": "CANCEL TRAINING",
      "lbl_cancellation_draft": "CANCELLATION NOTIFICATION DRAFT",
      "msg_cancellation_warning": "THE FOLLOWING CANCELLATION MESSAGE WILL BE EMAILED TO ALL PERSONNEL REGISTERED FOR THIS TRAINING. YOU CAN EDIT THE TEXT.",
      "lbl_cancel_email_content": "CANCELLATION EMAIL CONTENT",
      "btn_cancel_and_notify": "CANCEL AND NOTIFY EVERYONE",
      "title_leave_management": "Leave Management",
      "desc_leave_management_wip": "Leave requests and approval process will be displayed here.",
      "badge_under_construction": "Under Construction",
      "mfa_title": "Security Verification",
      "mfa_subtitle": "Please enter the 6-digit code sent to your email address.",
      "otp_code_label": "VERIFICATION CODE",
      "forgot_password": "Forgot Password",
      "lbl_system_subtitle": "Welcome to the secure personnel management system.",
      "btn_back_to_login": "Back to Login",
      "invalid_mfa_code": "Invalid or expired verification code!",
      "password_too_short": "Password is too short (Must be at least 8 characters).",
      "password_too_weak": "Password is too weak (Must contain uppercase, lowercase, and numbers).",
      "password_no_special_char": "Password must contain at least one special character (@$!%*?&).",
      "email_already_in_use": "This email address is already in use.",
      "default_department_name": "Board of Directors",
      "default_position_title": "Founder / Manager",
      "registration_successful": "Registration completed successfully.",
      "registration_error": "An unexpected error occurred during registration.",
      "invalid_credentials": "Invalid email or password.",
      "account_suspended": "Your account has been suspended. Please contact the administrator.",
      "mfa_code_sent": "Security code has been sent to your email address.",
      "mfa_code_expired": "Security code has expired. Please log in again.",
      "reset_email_sent_if_exists": "If an account exists, a password reset link has been sent.",
      "btn_verify_code": "VERIFY CODE",
      "btn_back": "GO BACK",
      "lbl_new_password": "Your New Password",
      "btn_send_code": "Send Reset Code",
      "btn_reset_password": "Update Password",
      "lbl_remembered_password": "Remembered your password?",
      "msg_password_reset_success": "Your password has been successfully updated! You can now log in.",
      "err_password_match": "Passwords do not match.",
      "msg_password_updated": "Your password has been successfully updated.",
      "idle_warning_title": "Are you still there?",
      "idle_warning_desc": "For your security, your session is about to expire due to inactivity.",
      "btn_stay_logged_in": "I'm Here, Stay Logged In",
      "btn_logout_now": "Log Out Now",
      "idle_warning_title": "Are you still there?",
      "idle_warning_desc": "For your security, your session is about to expire due to inactivity.",
      "btn_stay_logged_in": "I'm Here, Stay Logged In",
      "btn_logout_now": "Log Out Now",
      "btn_clock_in": "CLOCK IN",
      "btn_clock_out": "CLOCK OUT",
      "msg_getting_location": "Getting your location...",
      "err_gps_not_supported": "Your browser does not support GPS!",
      "err_location_denied": "Please allow location access!",
      "msg_clock_in_success": "Clocked in successfully!",
      "msg_clock_out_success": "Clocked out successfully!",
      "err_geofence_failed": "Location verification failed!",
      "msg_exporting": "Exporting...",
      "msg_export_success": "File downloaded successfully!",
      "err_export_failed": "Export failed.",
      "btn_export_excel": "EXCEL",
      "btn_export_csv": "CSV",
      "btn_export_pdf": "PDF",
      "btn_send_email": "EMAIL",
      "lbl_email_modal_title": "SEND REPORT",
      "ph_enter_email": "RECIPIENT EMAIL",
      "lbl_format": "SELECT FORMAT",
      "btn_cancel": "CANCEL",
      "btn_send": "SEND",
      "err_empty_email": "Please enter an email address.",
      "msg_sending_email": "Sending email...",
      "msg_email_queued": "Email successfully queued!",
      "err_email_failed": "Failed to send email.",
      "file_attendance": "Attendance",
      "sheet_attendance": "Attendance_Report",
      "msg_employee_attendance_wip": "Employee Attendance Screen is Under Construction...",
      "err_fetch_my_attendance": "Failed to fetch past records.",
      "err_no_geolocation": "Your browser does not support geolocation.",
      "err_location_denied": "Location access denied or unavailable. Please enable location permissions in your browser.",
      "msg_getting_location": "Getting your location, please wait...",
      "msg_verifying_location": "Verifying location...",
      "msg_validating_qr_location": "Validating QR and location...",
      "msg_success": "Operation successful!",
      "msg_attendance_completed": "Attendance action completed successfully.",
      "msg_requesting_camera": "Waiting for camera permission...",
      "msg_scan_qr_prompt": "Show the QR code to the camera. Camera and location permissions are required.",
      "msg_qr_detected": "QR code detected. Validating location...",
      "err_action_failed": "Operation failed.",
      "err_camera_not_supported": "This browser does not support camera access. Please use another browser or device.",
      "err_camera_qr_not_supported": "This browser does not support camera QR scanning. Please use a current Chrome or Edge browser.",
      "err_camera_denied": "Attendance cannot continue without camera permission.",
      "err_camera_denied_persisted": "Attendance cannot continue without camera permission. Please enable camera access in your browser settings and try again.",
      "err_qr_scan_failed": "QR code could not be read. Please try again.",
      "btn_clock_in_large": "CLOCK IN",
      "btn_clock_out_large": "CLOCK OUT",
      "lbl_gps_required": "GPS REQUIRED",
      "lbl_camera_gps_required": "CAMERA + GPS REQUIRED",
      "attendance_qr_modal_title_in": "CLOCK IN WITH QR",
      "attendance_qr_modal_title_out": "CLOCK OUT WITH QR",
      "attendance_qr_modal_subtitle": "Camera and location permissions are required",
      "attendance_qr_security_title": "Secure attendance",
      "attendance_qr_security_desc": "QR scan and live location verification are used together before an attendance record is created.",
      "attendance_qr_steps_title": "Steps",
      "attendance_qr_step_1": "Point the camera at the current QR code at your location.",
      "attendance_qr_step_2": "Approve location permission if your browser asks for it.",
      "attendance_qr_step_3": "Clock-in or clock-out will not proceed until QR and location are both verified.",
      "attendance_qr_status_error": "ERROR",
      "attendance_qr_status_success": "SUCCESS",
      "attendance_qr_status_active": "SCANNING",
      "btn_retry_qr_scan": "TRY AGAIN",
      "btn_cancel_scan": "CANCEL",
      "lbl_my_recent_records": "MY RECENT RECORDS (30 DAYS)",
      "nav_dashboard": "COCKPIT",
        "nav_sub_dashboard": "General Statistics",
        "nav_employees": "EMPLOYEE MANAGEMENT",
        "nav_sub_employees": "Staff and Personnel",
        "nav_org_chart": "ORGANIZATION CHART",
        "nav_sub_org_chart": "Hierarchical Structure",
        "nav_ats": "APPLICANT TRACKING (ATS)",
        "nav_sub_ats": "Recruitment Process",
        "nav_attendance": "TIME & ATTENDANCE",
        "nav_sub_attendance": "Shift & Time Tracking",
        "nav_locations": "LOCATIONS & SITES",
        "nav_sub_locations": "Geofence Management",
        "nav_leaves": "LEAVE MANAGEMENT",
        "nav_sub_leaves": "Approval Center",
        "nav_dossier": "E-DOSSIER",
        "nav_sub_dossier": "Digital Records",
        "nav_performance": "PERFORMANCE & TALENT",
        "nav_sub_performance": "OKR & 360° Review",
        "nav_training": "CORPORATE ACADEMY",
        "nav_sub_training": "Learning Management",
        "nav_expenses": "EXPENSE MANAGEMENT",
        "nav_sub_expenses": "Budgets & Receipts",
        "nav_assets": "ASSET MANAGEMENT",
        "nav_sub_assets": "Inventory Tracking",
        "nav_helpdesk": "HELPDESK (IT/HR)",
        "nav_sub_helpdesk": "Internal Requests",
        "nav_settings": "SYSTEM & COMPANY SETTINGS",
        "nav_sub_settings": "Corporate Identity Management",
        "nav_billing": "SUBSCRIPTION & BILLING",
        "nav_sub_billing": "SaaS Package Management",
        "nav_portal": "COCKPIT",
        "nav_sub_portal": "Personal Dashboard",
        "nav_my_leaves": "MY LEAVES",
        "nav_sub_my_leaves": "Personal Leave Status",
        "nav_my_performance": "MY PERFORMANCE",
        "nav_sub_my_performance": "My Goals (OKR)",
        "nav_my_training": "MY TRAINING ACADEMY",
        "nav_sub_my_training": "My Development Plan",
        "nav_my_expenses": "MY EXPENSES",
        "nav_sub_my_expenses": "Expense Claims",
        "nav_my_assets": "MY ASSETS",
        "nav_sub_my_assets": "Company Equipment",
        "nav_fallback": "COCKPIT",
        "nav_sub_fallback": "Corporate Management",
        "lbl_city_weather": "CITY / WEATHER",
        "ph_type_city": "City...",
        "lbl_today": "TODAY",
      "btn_add_schedule": "ADD SCHEDULE",
      "btn_assign_special_schedule": "ASSIGN SPECIAL SCHEDULE",
      "btn_collapse_department": "Collapse Department",
      "btn_coming_soon": "COMING SOON",
      "btn_create_schedule": "CREATE SCHEDULE",
      "btn_expand_department": "Expand Department",
      "btn_reset_to_department_default": "RESET TO DEPARTMENT DEFAULT",
      "btn_save_department_schedules": "SAVE DEPARTMENT ASSIGNMENTS",
      "btn_saving": "SAVING...",
      "btn_update_schedule": "UPDATE SCHEDULE",
      "col_active_people": "ACTIVE PEOPLE",
      "col_check_in": "CHECK-IN",
      "col_check_out": "CHECK-OUT",
      "col_date": "DATE",
      "col_default_schedule": "DEFAULT SCHEDULE",
      "col_my_schedule": "MY SCHEDULE",
      "col_schedule_hours": "HOURS",
      "col_schedule_name": "SCHEDULE NAME",
      "col_schedule_rules": "RULES",
      "col_schedule_type": "TYPE",
      "col_schedule_usage": "USAGE",
      "col_total_hours": "TOTAL HOURS",
      "default_repair_done_note": "Repair completed and asset returned to stock.",
      "default_repair_note": "Sent to repair due to malfunction.",
      "desc_assign_after_stock": "You can keep the asset in stock first and assign it later.",
      "desc_department_schedule_defaults": "Set the default work schedule for each department.",
      "desc_employee_schedule_override": "Assign a special schedule only for exception employees.",
      "desc_work_schedules": "Create fixed or flexible work schedules for your company.",
      "err_department_schedules_save": "Department schedule assignments could not be saved.",
      "err_employee_schedule_assign": "Employee schedule could not be assigned.",
      "err_employee_schedule_clear": "Employee schedule override could not be cleared.",
      "err_fetch_department_schedules": "Department schedule assignments could not be fetched.",
      "err_fetch_employee_overrides": "Employee overrides could not be fetched.",
      "err_fetch_schedules": "Work schedules could not be fetched.",
      "err_invalid_date": "Enter a valid date.",
      "err_schedule_delete": "Work schedule could not be deleted.",
      "err_schedule_save": "Work schedule could not be saved.",
      "err_select_department_schedule": "Select a schedule for each department.",
      "err_select_employees": "Select employees first.",
      "err_select_schedule_for_people": "Select a work schedule for the selected employees.",
      "info_assign_after_create": "You can assign the asset after creating the record.",
      "info_status_route_not_ready": "This status flow is not active on the backend yet.",
      "lbl_active_overrides": "ACTIVE OVERRIDES",
      "lbl_break_minutes": "BREAK (MIN)",
      "lbl_bulk_department_logic": "Department default applies automatically to most employees.",
      "lbl_core_end": "CORE END",
      "lbl_core_start": "CORE START",
      "lbl_crosses_midnight": "CROSSES MIDNIGHT",
      "lbl_crosses_midnight_toggle": "Shift crosses midnight",
      "lbl_department_defaults": "DEPARTMENT DEFAULTS",
      "lbl_department_filter": "DEPARTMENT FILTER",
      "lbl_departments_short": "Dept.",
      "lbl_early_leave_after": "EARLY LEAVE THRESHOLD",
      "lbl_early_out": "EARLY OUT",
      "lbl_effective_from": "EFFECTIVE FROM",
      "lbl_employee_override_logic": "Assign a person-based custom schedule for exception employees.",
      "lbl_employee_overrides": "EMPLOYEE OVERRIDES",
      "lbl_end_time": "END TIME",
      "lbl_grace_in": "CHECK-IN GRACE",
      "lbl_grace_in_minutes": "CHECK-IN GRACE (MIN)",
      "lbl_grace_out": "CHECK-OUT GRACE",
      "lbl_grace_out_minutes": "CHECK-OUT GRACE (MIN)",
      "lbl_late": "LATE",
      "lbl_late_after": "LATE THRESHOLD",
      "lbl_loading_department_schedules": "Loading department schedule assignments...",
      "lbl_loading_people": "Loading employees...",
      "lbl_loading_schedules": "Loading work schedules...",
      "lbl_no_schedule_type": "No schedule type",
      "lbl_no_target_schedule": "No schedule selected",
      "lbl_ot_after": "OVERTIME THRESHOLD",
      "lbl_overtime": "OVERTIME",
      "lbl_overtime_after": "OVERTIME START",
      "lbl_people": "People",
      "lbl_people_short": "Ppl",
      "lbl_position_count": "Positions",
      "lbl_remaining_leave": "REMAINING LEAVE",
      "lbl_same_day": "SAME DAY",
      "lbl_schedule_logic": "SCHEDULE LOGIC",
      "desc_core_hours": "Define the core-hours range in which employees are expected to be physically present in the office for flexible schedules.",
      "lbl_schedule_name": "SCHEDULE NAME",
      "lbl_schedule_type": "SCHEDULE TYPE",
      "lbl_selected_people": "SELECTED PEOPLE",
      "lbl_start_time": "START TIME",
      "lbl_stat_late_days": "LATE DAYS",
      "lbl_stat_present_days": "PRESENT DAYS",
      "lbl_stat_total_hours": "TOTAL HOURS",
      "lbl_target_schedule": "TARGET SCHEDULE",
      "lbl_total_plans": "TOTAL PLANS",
      "lbl_unknown_department": "Unknown Department",
      "lbl_unscheduled": "Unscheduled",
      "modal_title_edit_schedule": "EDIT WORK SCHEDULE",
      "modal_title_new_schedule": "NEW WORK SCHEDULE",
      "msg_assigning_employee_schedule": "Assigning employee schedule...",
      "msg_billing_not_enabled": "Billing module is not enabled right now.",
      "msg_billing_passive_banner": "The subscription screen is ready, but payment infrastructure is passive in this environment.",
      "msg_clearing_employee_schedule": "Clearing employee schedule override...",
      "msg_confirm_clear_employee_schedule": "Are you sure you want to reset selected employees to the department default?",
      "msg_confirm_delete_schedule": "Are you sure you want to delete this work schedule?",
      "msg_creating_schedule": "Creating work schedule...",
      "msg_deleting_schedule": "Deleting work schedule...",
      "msg_department_schedules_saved": "Department schedule assignments saved.",
      "msg_employee_schedule_assigned": "Employee schedule assigned.",
      "msg_employee_schedule_cleared": "Employee schedule override cleared.",
      "msg_expense_approved": "Expense approved.",
      "msg_expense_rejected": "Expense rejected.",
      "msg_hire_pick_org_slot": "Select a department and position for hiring.",
      "msg_no_departments": "No departments found.",
      "msg_no_employee_overrides": "No active employee overrides.",
      "msg_no_filtered_employees": "No employees matched the filter.",
      "msg_no_schedules": "No work schedules have been defined yet.",
      "msg_saving_department_schedules": "Saving department schedule assignments...",
      "msg_schedule_created": "Work schedule created.",
      "msg_schedule_deleted": "Work schedule deleted.",
      "msg_schedule_updated": "Work schedule updated.",
      "msg_updating_schedule": "Updating work schedule...",
      "opt_all_departments": "All Departments",
      "opt_fixed": "Fixed",
      "opt_flex": "Flexible",
      "opt_select_position": "Select Position",
      "opt_select_schedule": "Select Work Schedule",
      "ph_override_reason": "Override reason (optional)",
      "ph_search_employee": "Search by name, email or phone...",
      "prompt_repair_done_note": "Repair completion note:",
      "prompt_repair_note": "Repair note:",
      "status_early_out": "EARLY OUT",
      "status_late_early": "LATE + EARLY",
      "tab_attendance_records": "ATTENDANCE",
      "tab_department_assignments": "DEPARTMENT ASSIGNMENTS",
      "tab_employee_overrides": "EMPLOYEE OVERRIDES",
      "tab_work_schedules": "WORK SCHEDULES",
      "tbl_schedule_plan": "Plan",
      "title_department_schedule_defaults": "DEPARTMENT WORK SCHEDULES",
      "title_employee_schedule_override": "EMPLOYEE SCHEDULE OVERRIDES",
      "title_work_schedules": "WORK SCHEDULES",
      "btn_schedule_pdf_report": "PDF REPORT",
      "btn_participant_report_pdf": "PARTICIPANT REPORT PDF",
      "lbl_created_by": "CREATED BY",
      "type_maternity": "MATERNITY LEAVE",
      "unknown_employee": "Unknown Employee",
      "unknown_user": "Unknown User",
      "violation_early_out": "Early Out",
      "violation_late_early": "Late In + Early Out",
      "violation_late_in": "Late In",
      "violation_missing_in": "Missing Check-In",
      "violation_missing_out": "Missing Check-Out",
      "violation_none": "No Violation",
    }
  },
  de: {
    translation: {
      "login_title": "HRPro Anmeldung",
      "email_label": "E-Mail Adresse",
      "password_label": "Passwort",
      "login_button": "Anmelden",
      "select_language": "Sprache wählen",
      "login_failed_generic": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.",
      "server_unreachable": "Server nicht erreichbar. Bitte überprüfen Sie Ihre Verbindung.",
      "condition_new": "Brandneu",
      "condition_working": "Funktionstüchtig / Guter Zustand",
      "error_fetching_data": "Datenabruf fehlgeschlagen.",
      "assets_added_success": "Anlagen erfolgreich hinzugefügt.",
      "error_adding_assets": "Hinzufügen der Anlagen fehlgeschlagen.",
      "prompt_return_note": "Rückgabenotiz / Zustand:",
      "default_return_note": "In gutem Zustand zurückgegeben",
      "status_updated": "Status aktualisiert.",
      "error_occurred": "Ein Fehler ist aufgetreten.",
      "select_personnel_first": "Bitte Personal auswählen.",
      "assignment_successful": "Zuweisung erfolgreich.",
      "assignment_error": "Zuweisungsfehler.",
      "preparing_pdf": "PDF wird vorbereitet...",
      "pdf_downloaded": "PDF heruntergeladen.",
      "pdf_not_found": "PDF nicht gefunden.",
      "status_in_stock": "AUF LAGER",
      "status_assigned": "ZUGEWIESEN",
      "status_in_repair": "IN REPARATUR",
      "status_archived": "ARCHIVIERT",
      "filter_all": "ALLE",
      "filter_in_stock": "AUF LAGER",
      "filter_assigned": "ZUGEWIESEN",
      "filter_in_repair": "IN REPARATUR",
      "btn_add_new_asset": "NEUE ANLAGE HINZUFÜGEN",
      "stat_total_assets": "GESAMTE ANLAGEN",
      "stat_available": "AUF LAGER (VERFÜGBAR)",
      "stat_assigned": "ZUGEWIESEN",
      "stat_in_repair": "IN REPARATUR / DEFEKT",
      "loading": "LÄDT...",
      "table_category_model": "KATEGORIE / MODELLNAME",
      "table_stock_status": "BESTANDSSTATUS",
      "table_actions": "AKTIONEN",
      "lbl_total": "GES",
      "lbl_stock": "LAGER",
      "table_serial_plate": "SERIENNR / KENNZEICHEN",
      "table_status": "STATUS",
      "table_current_assignee": "AKTUELLE ZUWEISUNG",
      "table_operations": "OPERATIONEN",
      "unknown": "UNBEKANNT",
      "btn_assign": "ZUWEISEN",
      "btn_send_repair": "Reparatur",
      "btn_report": "BERICHT",
      "btn_return": "Rückgabe",
      "btn_repair_done": "Reparatur Fertig",
      "modal_bulk_entry_title": "MASSEN-INVENTAREINGABE",
      "lbl_model_name": "MODELL / ANLAGENNAME",
      "ph_model_name": "Z.B. MACBOOK PRO M3",
      "lbl_category": "KATEGORIE",
      "cat_electronics": "Elektronik",
      "cat_vehicles": "Fahrzeuge / Transport",
      "cat_furniture": "Möbel / Büro",
      "cat_digital": "Lizenzen / Digital",
      "cat_other": "Sonstiges",
      "lbl_serial_numbers": "SERIENNUMMERN",
      "ph_serial_numbers": "Ein Artikel pro Zeile...",
      "lbl_total_detected": "Gesamt: {count} Erfasst",
      "lbl_instant_assign": "SOFORT ZUWEISEN",
      "opt_keep_in_stock": "Auf Lager behalten",
      "lbl_notes": "BESCHREIBUNG / NOTIZEN",
      "btn_cancel": "ABBRECHEN",
      "btn_save_assets": "ANLAGEN INS SYSTEM ÜBERNEHMEN",
      "modal_assign_title": "PERSONALZUWEISUNG",
      "lbl_select_personnel": "PERSONAL AUSWÄHLEN",
      "opt_select": "Bitte wählen",
      "lbl_delivery_condition": "ÜBERGABEZUSTAND",
      "ph_condition": "Z.B. Kratzerfrei / Neu",
      "btn_confirm_assign": "BESTÄTIGEN UND ZUWEISEN",
      "stage_new": "NEUE BEWERBUNG",
      "stage_interview": "INTERVIEW",
      "stage_reference": "REFERENZ & TEST",
      "stage_offer": "ANGEBOT GESENDET",
      "stage_talent_pool": "TALENTPOOL 🏊‍♂️",
      "stage_withdrawn": "ZURÜCKGEZOGEN 🛑",
      "stage_rejected": "ABGELEHNT",
      "stage_hired": "EINGESTELLT 🎉",
      "error_fetch_data": "Datenabruf fehlgeschlagen",
      "msg_job_published": "Stellenangebot erfolgreich veröffentlicht.",
      "msg_job_create_error": "Stellenangebot konnte nicht erstellt werden.",
      "msg_select_open_job": "Bitte wählen Sie eine offene Position!",
      "msg_candidate_created": "Bewerberdatensatz erstellt.",
      "msg_candidate_create_error": "Bewerber konnte nicht hinzugefügt werden!",
      "msg_pdf_only": "Bitte nur PDF-Dateien hochladen.",
      "msg_uploading_cv": "CV wird hochgeladen...",
      "msg_cv_uploaded": "CV erfolgreich hochgeladen.",
      "msg_cv_upload_error": "CV konnte nicht hochgeladen werden",
      "msg_upload_cv_first": "Sie müssen zuerst den CV des Bewerbers hochladen.",
      "msg_ai_analyzing": "Gemini AI analysiert den Lebenslauf...",
      "lbl_ai_evaluation": "KI-Bewertung",
      "msg_ai_analysis_done": "KI-Analyse abgeschlossen!",
      "msg_ai_analysis_error": "KI ist derzeit beschäftigt oder ein Fehler ist aufgetreten.",
      "msg_confirm_withdraw": "Sind Sie sicher, dass Bewerber {{name}} das Angebot abgelehnt oder zurückgezogen hat?",
      "mail_reject_subject": "Bezüglich Ihrer Bewerbung für {{job}}",
      "mail_reject_body": "Sehr geehrte(r) {{first_name}} {{last_name}},\n\nvielen Dank für Ihr Interesse an unserem Unternehmen und der Position als {{job}}.\n\nWir haben Ihren Lebenslauf und die Interviewergebnisse sorgfältig geprüft. Leider müssen wir Ihnen mitteilen, dass wir Ihre Bewerbung im weiteren Auswahlverfahren nicht berücksichtigen können.\n\nIhre Qualifikationen sind beeindruckend, und wir würden uns freuen, Sie bei zukünftigen passenden Vakanzen erneut zu kontaktieren.\n\nWir wünschen Ihnen für Ihren weiteren Karriereweg alles Gute.\n\nMit freundlichen Grüßen,\nPersonalabteilung",
      "msg_stage_update_error": "Fehler beim Aktualisieren der Phase.",
      "msg_saving_notes": "Bewertungsnotizen werden gespeichert...",
      "msg_saved_successfully": "Erfolgreich gespeichert.",
      "msg_save_error": "Bewertungsnotizen konnten nicht gespeichert werden!",
      "msg_sending_reject_mail": "Absage-E-Mail wird gesendet...",
      "msg_reject_mail_sent": "Absage-E-Mail an {{name}} gesendet.",
      "msg_error_occurred": "Ein Fehler ist aufgetreten.",
      "msg_creating_employee_card": "Mitarbeiterkarte wird erstellt...",
      "msg_hire_success": "{{name}} ist nun offizieller Mitarbeiter.",
      "msg_hire_error": "Mitarbeiter konnte nicht erstellt werden! Pflichtfelder prüfen.",
      "msg_confirm_delete_candidate": "Sind Sie sicher, dass Sie den Bewerber {{name}} dauerhaft löschen möchten?",
      "msg_candidate_deleted": "Bewerber gelöscht.",
      "msg_candidate_delete_error": "Fehler beim Löschen des Bewerbers.",
      "msg_generating_offer_pdf": "Angebotsbrief (PDF) wird erstellt...",
      "msg_offer_downloaded": "Brief erfolgreich heruntergeladen.",
      "msg_offer_error": "Fehler beim Erstellen des Angebotsbriefs.",
      "opt_no_active_job": "Keine aktiven Stellen",
      "btn_new_job": "NEUE STELLE AUSSCHREIBEN",
      "btn_add_candidate": "BEWERBER HINZUFÜGEN",
      "msg_empty_board": "BITTE WÄHLEN SIE EINE STELLE ODER ERSTELLEN SIE EINE NEUE",
      "msg_empty_board_sub": "Nutzen Sie das obige Menü zur Verwaltung des Bewerberpools.",
      "tooltip_delete_candidate": "Bewerber löschen",
      "tooltip_global_score": "Gesamtbewertung (HR + KI)",
      "lbl_drag_here": "HIERHER ZIEHEN",
      "lbl_click_to_offer": "Klicken Sie auf den Bewerber, um einen Vertrag zu erstellen.",
      "modal_title_new_job": "NEUE STELLE AUSSCHREIBEN",
      "lbl_select_position_from_org": "FREIE POSITION AUS ORGANISATION WÄHLEN",
      "opt_manual_job": "MANUELL EINGEBEN",
      "msg_auto_fill_warning": "POSITIONSNAME UND ABTEILUNG WERDEN AUTOMATISCH AUSGEFÜLLT.",
      "lbl_job_title": "STELLEN- / POSITIONSBEZEICHNUNG",
      "lbl_department": "ABTEILUNG",
      "lbl_job_desc": "STELLENBESCHREIBUNG & ANFORDERUNGEN",
      "btn_publish_job": "STELLE VERÖFFENTLICHEN",
      "modal_title_new_candidate": "NEUEN BEWERBER HINZUFÜGEN",
      "lbl_first_name": "VORNAME",
      "lbl_last_name": "NACHNAME",
      "lbl_email": "E-MAIL",
      "lbl_phone": "TELEFONNUMMER",
      "ph_optional": "Optional",
      "btn_save_to_system": "IM SYSTEM SPEICHERN",
      "modal_title_hire": "EINSTELLUNG ABSCHLIESSEN",
      "lbl_creating_emp_card": "MITARBEITERKARTE WIRD ERSTELLT",
      "lbl_identity_no": "ID / REISEPASS NR",
      "ph_identity": "ID-Nummer",
      "lbl_position": "POSITION / TITEL",
      "lbl_gross_salary": "BRUTTOGEHALT",
      "lbl_hire_date": "STARTDATUM",
      "btn_save_official_employee": "ALS OFFIZIELLEN MITARBEITER SPEICHERN",
      "lbl_evaluation_center": "BEWERBER-BEWERTUNGSZENTRUM (SCORECARD)",
      "lbl_global_score": "GESAMTBEWERTUNG",
      "lbl_contact_and_cv": "KONTAKT & CV",
      "btn_view_cv": "CV ANZEIGEN",
      "btn_analyzing": "WIRD ANALYSIERT...",
      "btn_start_ai_analysis": "KI-ANALYSE STARTEN",
      "btn_upload_pdf": "PDF HOCHLADEN",
      "lbl_ai_analysis_title": "KÜNSTLICHE INTELLIGENZ (KI) ANALYSE",
      "lbl_match_score": "Übereinstimmung",
      "lbl_no_ai_note": "Keine KI-Notiz gefunden.",
      "lbl_competency_eval": "KOMPETENZBEWERTUNG (QUANTITATIV)",
      "lbl_rating_comm": "Kommunikation & Ausdruck",
      "lbl_rating_tech": "Fachlich / Technisch",
      "lbl_rating_culture": "Kulturelle Passung",
      "lbl_rating_motivation": "Selbstvertrauen & Motivation",
      "lbl_interview_notes": "INTERVIEW-NOTIZEN (QUALITATIV)",
      "lbl_pros": "Stärken (Pros)",
      "ph_pros": "Wobei der Bewerber besonders glänzte...",
      "lbl_cons": "Bedenken (Cons)",
      "ph_cons": "Bedenken oder Verbesserungsbereiche...",
      "lbl_overall": "Gesamte HR-Entscheidung / Zusammenfassung",
      "ph_overall": "Empfehlen Sie diesen Bewerber dem Fachbereich?",
      "btn_generate_contract": "VERTRAG ERSTELLEN",
      "btn_save_eval_form": "BEWERTUNGSFORMULAR SPEICHERN",
      "modal_title_reject": "BEWERBER ABLEHNEN & BENACHRICHTIGEN",
      "lbl_edit_mail_template": "SIE KÖNNEN DIE E-MAIL-VORLAGE UNTEN BEARBEITEN",
      "lbl_to": "AN:",
      "lbl_mail_subject": "E-MAIL-BETREFF",
      "lbl_mail_body": "E-MAIL-INHALT",
      "btn_send_and_reject": "SENDEN UND BEWERBER ABLEHNEN",
      "modal_title_offer": "ANGEBOTSBRIEF ERSTELLEN",
      "lbl_preparing_pdf": "OFFIZIELLES PDF-DOKUMENT WIRD VORBEREITET",
      "lbl_offered_salary": "ANGEBOTENES MONATSGEHALT",
      "ph_salary": "Z.B.: 45000",
      "lbl_planned_start_date": "GEPLANTES STARTDATUM",
      "btn_download_pdf": "PDF HERUNTERLADEN",
      "nav_dashboard": "KOKPİT",
      "nav_sub_dashboard": "Allgemeine Statistiken",
      "nav_employees": "PERSONALVERWALTUNG",
      "nav_sub_employees": "Mitarbeiter & Teams",
      "nav_org_chart": "ORGANIGRAMM",
      "nav_sub_org_chart": "Hierarchische Struktur",
      "nav_ats": "BEWERBERMANAGEMENT (ATS)",
      "nav_sub_ats": "Rekrutierungsprozess",
      "nav_attendance": "ZEITERFASSUNG",
      "nav_sub_attendance": "Anwesenheit & Schichten",
      "nav_locations": "STANDORTE & BEREICHE",
      "nav_sub_locations": "Geofencing-Verwaltung",
      "nav_leaves": "URLAUBSVERWALTUNG",
      "nav_sub_leaves": "Genehmigungscenter",
      "nav_dossier": "E-AKTE ARCHIV",
      "nav_sub_dossier": "Digitale Dokumente",
      "nav_performance": "LEISTUNG & TALENT",
      "nav_sub_performance": "OKR & 360° Feedback",
      "nav_training": "UNTERNEHMENSAKADEMIE",
      "nav_sub_training": "Schulungsverwaltung",
      "nav_expenses": "SPESENVERWALTUNG",
      "nav_sub_expenses": "Budget & Belege",
      "nav_assets": "INVENTAR & GERÄTE",
      "nav_sub_assets": "Bestandsverfolgung",
      "nav_helpdesk": "HELPDESK (IT/HR)",
      "nav_sub_helpdesk": "Interne Anfragen",
      "nav_settings": "SYSTEM- & FIRMENEINSTELLUNGEN",
      "nav_sub_settings": "Corporate Identity",
      "nav_billing": "ABONNEMENT & ABRECHNUNG",
      "nav_sub_billing": "SaaS Paketverwaltung",
      "menu_onboarding": "EINTRITT & AUSTRITT",
      "lifecycle_header_title": "EINTRITT & AUSTRITT",
      "lifecycle_header_subtitle": "Eintritts-, Austritts- und Dokumentprozesse",
      "lifecycle_role_employee": "Mitarbeiter",
      "lifecycle_role_manager": "Manager",
      "lifecycle_role_hr": "HR",
      "lifecycle_role_admin": "Admin",
      "lifecycle_role_superadmin": "Superadmin",
      "lifecycle_tab_onboarding": "Eintritt",
      "lifecycle_tab_offboarding": "Austritt",
      "lifecycle_search_onboarding": "Neue Mitarbeitende suchen",
      "lifecycle_search_offboarding": "Austrittsprozess suchen",
      "lifecycle_no_matching_personnel": "Für diese Ansicht wurde kein passender Mitarbeiter gefunden.",
      "lifecycle_detail_loading": "Prozessdetails werden geladen...",
      "lifecycle_select_personnel": "Mitarbeiter auswählen",
      "lifecycle_select_personnel_hint": "Wenn Sie links einen Mitarbeiter auswählen, erscheinen hier die Eintritts- / Austrittsschritte.",
      "lifecycle_onboarding_process": "Eintrittsprozess",
      "lifecycle_offboarding_process": "Austrittsprozess",
      "lifecycle_progress": "Fortschritt",
      "lifecycle_account_active": "Konto aktiv",
      "lifecycle_account_closed_status": "Konto geschlossen",
      "lifecycle_document_count": "Dokumentenanzahl",
      "lifecycle_open_workload": "Offene Last",
      "lifecycle_active_device": "Aktives Gerät",
      "lifecycle_leave_unit": "urlaub",
      "lifecycle_expense_unit": "spese",
      "lifecycle_device_unit": "gerät",
      "lifecycle_checklist": "Checkliste",
      "lifecycle_process_actions": "Prozessaktionen",
      "lifecycle_close_account": "Konto schließen",
      "lifecycle_open_account": "Konto öffnen / Passwort senden",
      "lifecycle_open_release_form": "Austrittsformular öffnen",
      "lifecycle_download_document": "Dokument herunterladen",
      "btn_store_to_dossier": "In E-Akte speichern",
      "lifecycle_process_note": "Prozesshinweis",
      "lifecycle_offboarding_note": "Prüfen Sie zuerst aktive Geräte und offene Lasten. Beim Schließen des Kontos werden auch MFA und mobile Sitzungen deaktiviert.",
      "lifecycle_onboarding_note": "Beim Öffnen des Kontos wird ein temporäres Passwort gesendet. Sie können den erzeugten Vertrag in der E-Akte speichern und dem Eintrittsdokumentensatz hinzufügen.",
      "lifecycle_highlights": "Offene Punkte",
      "lifecycle_no_open_items": "Im Prozess sind keine offenen Punkte mehr vorhanden",
      "lifecycle_offboarding_document": "Austrittsdokument",
      "lifecycle_release_form_title": "Austritts- / Freigabeformular",
      "lifecycle_release_form_desc": "Das System füllt die Kerndaten. Juristische Freitexte und Abrechnungspositionen können hier ergänzt und danach als PDF erzeugt werden.",
      "lifecycle_form_loading": "Formular wird geladen...",
      "lifecycle_template_label": "Dokumentvorlage",
      "lifecycle_template_tr_release_title": "TR/KKTC-Freigabeformular",
      "lifecycle_template_tr_release_subtitle": "Klassischer Freigabe- und Abrechnungstext für TR / TRNZ",
      "lifecycle_template_generic_clearance_title": "Allgemeine Schlussabrechnung",
      "lifecycle_template_generic_clearance_subtitle": "Länderunabhängiges allgemeines Abschluss- und Freigabeformular",
      "lifecycle_template_de_exit_title": "DE Austritt & Schlussabrechnung",
      "lifecycle_template_de_exit_subtitle": "Deutschlandfokussierte Austritts- und Abschlussübersicht",
      "lifecycle_template_sgk_note": "Diese Vorlage verwendet lokale Registrierungsfelder.",
      "lifecycle_template_generic_note": "Diese Vorlage wird als allgemeines Abschlussformular verwendet.",
      "lifecycle_employer_name": "Arbeitgeber",
      "lifecycle_employer_address": "Arbeitgeberadresse",
      "lifecycle_employer_sgk": "Betriebsregistrierungsnummer",
      "lifecycle_employer_tax": "Steuernummer",
      "lifecycle_employee_name": "Mitarbeitername",
      "lifecycle_employee_ssn": "Sozialversicherungsnummer",
      "lifecycle_exit_reason_label": "Austrittsgrund",
      "lifecycle_hire_date": "Eintrittsdatum",
      "lifecycle_exit_date": "Austrittsdatum",
      "lifecycle_exit_date_short": "Austrittsdatum",
      "lifecycle_release_date": "Freigabedatum",
      "lifecycle_other_exit_reason_note": "Sonstige Austrittserklärung",
      "lifecycle_other_exit_reason_placeholder": "Freitext eingeben",
      "lifecycle_intro_text": "Einleitungstext",
      "lifecycle_settlement_text": "Abrechnungstext",
      "lifecycle_no_claim_text": "Text ohne Restansprüche",
      "lifecycle_contact_note": "Adresse und Telefon / Freier Hinweis",
      "lifecycle_payment_table": "Zahlungstabelle",
      "lifecycle_payment_table_hint": "Lassen Sie die Felder bei Bedarf leer oder füllen Sie sie nach juristischer bzw. buchhalterischer Prüfung aus.",
      "lifecycle_payment_col_name": "Zahlungen",
      "lifecycle_payment_col_gross": "Brutto",
      "lifecycle_payment_col_legal": "Gesetzlicher Abzug",
      "lifecycle_payment_col_net": "Netto",
      "lifecycle_payment_col_special": "Sonderabzug",
      "lifecycle_payment_col_net_payment": "Nettozahlung",
      "lifecycle_exit_reason_select": "Grund auswählen",
      "lifecycle_exit_reason_abandonment": "Arbeitsverweigerung",
      "lifecycle_exit_reason_resignation": "Eigenkündigung",
      "lifecycle_exit_reason_termination": "Kündigung / Entlassung",
      "lifecycle_exit_reason_military": "Militärdienst",
      "lifecycle_exit_reason_retirement": "Ruhestand",
      "lifecycle_exit_reason_death": "Todesfall",
      "lifecycle_exit_reason_other": "Andere",
      "lifecycle_overview_load_error": "Prozessdaten konnten nicht geladen werden.",
      "lifecycle_preparing_document": "Dokument wird vorbereitet...",
      "lifecycle_document_downloaded": "Dokument heruntergeladen.",
      "lifecycle_document_download_error": "Dokument konnte nicht heruntergeladen werden.",
      "lifecycle_document_storing": "Dokument wird in der E-Akte gespeichert...",
      "lifecycle_document_stored": "Dokument wurde erzeugt und in der E-Akte gespeichert.",
      "lifecycle_document_store_error": "Dokument konnte nicht gespeichert werden.",
      "lifecycle_account_opening": "Benutzerkonto wird geöffnet...",
      "lifecycle_account_opened_with_temp": "Konto geöffnet. Temporäres Passwort: {{password}}",
      "lifecycle_account_opened": "Konto geöffnet.",
      "lifecycle_account_open_error": "Konto konnte nicht geöffnet werden.",
      "lifecycle_account_closing": "Konto wird geschlossen...",
      "lifecycle_account_closed": "Konto geschlossen und Mitarbeiter archiviert.",
      "lifecycle_account_close_error": "Konto konnte nicht geschlossen werden.",
      "lifecycle_release_form_open_error": "Austrittsformular konnte nicht geöffnet werden.",
      "lifecycle_template_load_error": "Vorlage konnte nicht geladen werden.",
      "lifecycle_release_pdf_preparing": "Austritts-PDF wird vorbereitet...",
      "lifecycle_release_pdf_downloaded": "Austrittsdokument heruntergeladen.",
      "lifecycle_release_pdf_error": "Austrittsdokument konnte nicht heruntergeladen werden.",
      "lifecycle_release_storing": "Austrittsdokument wird in der E-Akte gespeichert...",
      "lifecycle_release_stored": "Austrittsdokument wurde erzeugt und in der E-Akte gespeichert.",
      "lifecycle_release_store_error": "Austrittsdokument konnte nicht gespeichert werden.",
      "lifecycle_not_planned": "Nicht geplant",
      "lifecycle_no_department": "Keine Abteilung",
      "lifecycle_opening_progress": "Eintrittsfortschritt",
      "lifecycle_closure_progress": "Austrittsfortschritt",
      "lifecycle_detail_load_error": "Prozessdetails konnten nicht geladen werden.",
      "lifecycle_summary_total_process": "Gesamtprozesse",
      "lifecycle_summary_total_process_hint": "Beobachtete Mitarbeiter",
      "lifecycle_summary_closed_accounts": "Geschlossene Konten",
      "lifecycle_summary_closed_accounts_hint": "Zugriff deaktiviert",
      "lifecycle_summary_documents_ready": "Dokumente bereit",
      "lifecycle_summary_offboarding_documents_hint": "Austrittsdokumente erstellt",
      "lifecycle_summary_attention_needed": "Benötigt Aufmerksamkeit",
      "lifecycle_summary_attention_needed_hint": "Mit offenen Schritten",
      "lifecycle_summary_total_employees": "Mitarbeiter gesamt",
      "lifecycle_summary_total_employees_hint": "Eintrittsansicht",
      "lifecycle_summary_accounts_ready": "Konten bereit",
      "lifecycle_summary_accounts_ready_hint": "Zugang vorbereitet",
      "lifecycle_summary_onboarding_documents_hint": "Vertrag und Unterlagen bereit",
      "lifecycle_summary_attention_needed_onboarding_hint": "Mit fehlenden Schritten",
      "helpdesk_stat_open": "Offen",
      "helpdesk_stat_open_hint": "Aktive Tickets gesamt",
      "helpdesk_stat_pending": "Wartend",
      "helpdesk_stat_pending_hint": "Warten auf erste Rückmeldung",
      "helpdesk_stat_in_progress_hint": "Derzeit in Bearbeitung",
      "helpdesk_total_tickets": "TICKETS GESAMT",
      "nav_portal": "KOKPİT",
      "nav_sub_portal": "Persönliches Dashboard",
      "nav_my_leaves": "MEINE URLAUBE",
      "nav_sub_my_leaves": "Persönlicher Status",
      "nav_my_performance": "MEINE LEISTUNG",
      "nav_sub_my_performance": "Meine Ziele (OKR)",
      "nav_my_training": "TRAININGSAKADEMIE",
      "nav_sub_my_training": "Entwicklungsplan",
      "nav_my_expenses": "MEINE AUSGABEN",
      "nav_sub_my_expenses": "Speseneinträge",
      "nav_my_assets": "MEINE GERÄTE",
      "nav_sub_my_assets": "Firmenausstattung",
      "nav_fallback": "COCKPIT",
      "nav_sub_fallback": "Unternehmensführung",
      "error_fetch_weather": "Wetterdaten konnten nicht abgerufen werden",
      "lbl_city_weather": "STADT / WETTER",
      "ph_type_city": "Stadt eingeben...",
      "tooltip_change_city": "Klicken, um Stadt zu ändern",
      "lbl_today": "HEUTE",
      "msg_payment_success": "🎉 Zahlung erfolgreich! Ihr Abonnement wurde aktualisiert.",
      "msg_payment_failed": "Während der Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "msg_redirecting_payment": "Weiterleitung zur sicheren Zahlungsseite...",
      "msg_no_payment_link": "Zahlungslink konnte nicht abgerufen werden.",
      "msg_payment_init_failed": "Zahlungsinitialisierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "lbl_current_subscription": "IHR AKTUELLES ABONNEMENT",
      "lbl_active": "Aktiv",
      "lbl_renews_in_days": "ERNEUERT SICH IN {{days}} TAGEN",
      "lbl_saved_card": "GESPEICHERTE KARTE:",
      "btn_update_card": "KARTE AKTUALISIEREN",
      "lbl_iyzico_secure": "100% SICHER DURCH IYZICO",
      "plan_starter_title": "Starter",
      "plan_starter_desc": "Für kleine Teams",
      "lbl_month": "Monat",
      "feat_max_10_emp": "Bis zu 10 Mitarbeiter",
      "feat_standard_payroll": "Standard-Gehaltsabrechnung (D1)",
      "feat_no_ats": "Kein Bewerbermanagement (ATS)",
      "feat_no_helpdesk": "Kein Helpdesk",
      "btn_current_plan": "AKTUELLE PLAN",
      "btn_downgrade": "HERABSTUFEN",
      "badge_most_popular": "AM BELIEBTESTEN",
      "plan_pro_title": "Pro Plan",
      "plan_pro_desc": "Für wachsende Unternehmen",
      "feat_max_50_emp": "Bis zu 50 Mitarbeiter",
      "feat_all_payroll": "Alle Abrechnungsarten (D1, D3, E1)",
      "feat_ats_module": "Bewerbermanagement (ATS)",
      "feat_helpdesk": "Mitarbeiter Helpdesk",
      "plan_enterprise_title": "Enterprise",
      "plan_enterprise_desc": "Für Großkonzerne",
      "feat_unlimited_emp": "Unbegrenzte Mitarbeiter",
      "feat_advanced_api": "Erweiterter API-Zugang",
      "feat_private_server": "Private Server-Installation",
      "feat_vip_support": "24/7 VIP-Support",
      "btn_upgrade": "PLAN UPGRADEN",
      "err_invalid_qr": "UNGÜLTIGE AKTION: BITTE SCANNEN SIE DEN AKTUELLEN QR-CODE VOR ORT.",
      "msg_clock_in_success": "ERFOLGREICH EINGELOGGT! GUTE SCHICHT.",
      "err_location_verify": "STANDORT KONNTE NICHT VERIFIZIERT WERDEN.",
      "err_location_denied": "STANDORTFREIGABE VERWEIGERT ODER NICHT VERFÜGBAR!",
      "err_location_timeout": "ZEITÜBERSCHREITUNG: BITTE GEHEN SIE NACH DRAUSSEN UND VERSUCHEN SIE ES ERNEUT.",
      "lbl_verifying_gps": "GPS WIRD VERIFIZIERT...",
      "lbl_clocked_in": "EINGELOGGT",
      "btn_clock_in": "EINLOGGEN (QR & GPS)",
      "err_fetch_attendance": "Zeiterfassungsdaten konnten nicht abgerufen werden.",
      "err_only_excel": "Sie können nur Excel-Dateien (.xlsx, .xls) hochladen.",
      "err_select_excel": "Bitte wählen Sie eine Excel-Datei aus.",
      "msg_processing_excel": "Excel-Datei wird verarbeitet...",
      "msg_excel_success": "Excel-Daten erfolgreich ins System importiert!",
      "msg_upload_failed": "Hochladen fehlgeschlagen.",
      "action_reject": "ablehnen",
      "action_approve": "genehmigen",
      "msg_confirm_bulk": "Sind Sie sicher, dass Sie die ausgewählten {{count}} Datensätze massenhaft {{action}} möchten?",
      "msg_applying_bulk": "Massenaktion wird angewendet...",
      "msg_bulk_success": "Massenaktion erfolgreich abgeschlossen.",
      "status_present": "ANWESEND",
      "status_absent": "ABWESEND",
      "status_late": "VERSPÄTET",
      "status_off": "FREI / URLAUB",
      "badge_manager_pending": "WARTET AUF MANAGER",
      "badge_hr_pending": "WARTET AUF HR",
      "badge_payroll_ready": "BEREIT FÜR LOHNABRECHNUNG",
      "badge_rejected": "ABGELEHNT",
      "lbl_bulk_excel": "MASSEN-UPLOAD PER EXCEL",
      "lbl_excel_desc": ".xlsx-Datei vom Face-ID/Fingerabdruck-Gerät.",
      "btn_select_file": "DATEI WÄHLEN",
      "btn_select_excel": "EXCEL-DATEI WÄHLEN",
      "btn_processing": "WIRD VERARBEITET...",
      "btn_transfer": "HOCHLADEN",
      "lbl_listed_records": "Auf dem Bildschirm gelistete Datensätze",
      "lbl_records": "DATENSÄTZE",
      "lbl_record_selected": "DATENSÄTZE AUSGEWÄHLT",
      "btn_reject_selected": "ABLEHNEN",
      "btn_approve_selected": "GENEHMIGEN",
      "opt_all_approvals": "ALLE FREIGABEN",
      "lbl_loading_data": "DATEN WERDEN GELADEN...",
      "tbl_emp_dept": "MITARBEITER & ABTEILUNG",
      "tbl_day_in_out": "TAG & KOMMT-GEHT",
      "tbl_total_ot": "GESAMT / ÜBERSTUNDEN",
      "tbl_daily_status": "TAGESSTATUS",
      "tbl_approval_status": "GENEHMIGUNGSSTATUS",
      "lbl_no_records": "NOCH KEINE DATENSÄTZE VORHANDEN.",
      "lbl_unknown": "UNBEKANNT",
      "lbl_weekday_ot": "WT",
      "lbl_weekend_ot": "WE",
      "lbl_no_ot": "KEINE ÜBERSTUNDEN",
      "lbl_records_selected_html": "DATENSÄTZE<br/>GEWÄHLT",
      "lbl_assigned_count": "ZUGEWIESEN",
      "lbl_selected_count": "AUSGEWÄHLT",
      "badge_already_assigned": "BEREITS ZUGEWIESEN",
      "btn_select_all_visible": "SICHTBARE AUSWÄHLEN",
      "btn_clear_visible": "SICHTBARE LEEREN",
      "btn_manager_approve": "MANAGER-FREIGABE",
      "btn_hr_approve": "HR-FREIGABE (LOHN)",
      "btn_reject_cancel": "ABLEHNEN (STORNIEREN)",
      "err_password_length": "Ihr Passwort muss mindestens 6 Zeichen lang sein.",
      "err_password_match": "Die Passwörter stimmen nicht überein.",
      "msg_register_success": "Unternehmen erfolgreich registriert! Bitte melden Sie sich an.",
      "err_generic_login": "Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Daten.",
      "lbl_login_title": "Im System Anmelden",
      "lbl_register_title": "Starten Sie Ihre 30-Tage Testversion",
      "ph_company_name": "Firmen- / Organisationsname",
      "ph_first_name": "Vorname",
      "ph_last_name": "Nachname",
      "ph_email": "E-Mail Adresse",
      "ph_password": "Passwort",
      "ph_confirm_password": "Passwort Bestätigen",
      "btn_login": "Anmelden",
      "btn_register": "Konto Erstellen",
      "msg_no_account": "Noch kein Konto?",
      "msg_has_account": "Haben Sie bereits ein Firmenkonto?",
      "btn_start_trial": "Jetzt 30-Tage Test Starten",
      "btn_back_to_login": "Zurück zum Login",
      "lbl_other": "ANDERE",
      "lbl_unassigned": "NICHT ZUGEWIESEN",
      "err_fetch_data": "Fehler beim Laden der Daten aufgetreten.",
      "msg_updating_company_info": "Unternehmensinformationen werden aktualisiert...",
      "msg_company_info_updated": "Corporate-Identity-Informationen erfolgreich aktualisiert!",
      "err_updating_info": "Während der Aktualisierung ist ein Fehler aufgetreten.",
      "err_file_size": "Die Dateigröße darf 2 MB nicht überschreiten.",
      "msg_uploading_logo": "Logo wird auf den Server hochgeladen...",
      "msg_logo_uploaded": "Logo erfolgreich hochgeladen und ins System übernommen!",
      "err_uploading_logo": "Fehler beim Hochladen des Logos aufgetreten.",
      "msg_saving_routing": "Routing- und Betriebseinstellungen werden gespeichert...",
      "msg_routing_saved": "Alle Systemrouten wurden erfolgreich gesperrt!",
      "err_saving_routing": "Einstellungen konnten nicht gespeichert werden. Bitte Backend-Verbindung prüfen.",
      "err_pwd_match": "Die neuen Passwörter stimmen nicht überein!",
      "err_pwd_length": "Ihr neues Passwort muss mindestens 6 Zeichen lang sein.",
      "msg_updating_pwd": "Ihr Passwort wird aktualisiert...",
      "msg_pwd_updated": "Ihr Passwort wurde erfolgreich geändert!",
      "err_updating_pwd": "Passwort konnte nicht aktualisiert werden. Bitte prüfen Sie Ihr aktuelles Passwort.",
      "lbl_loading_settings": "EINSTELLUNGEN WERDEN GELADEN...",
      "tab_company": "UNTERNEHMENSEINSTELLUNGEN",
      "tab_security": "PERSÖNLICHE SICHERHEIT",
      "lbl_official_title": "OFFIZIELLER TITEL",
      "lbl_company_name": "FIRMENNAME",
      "lbl_routing_settings": "SYSTEM-ROUTING-EINSTELLUNGEN",
      "desc_routing": "HAUPTVERANTWORTLICHE FÜR MODULE FESTLEGEN.",
      "lbl_routing_policy": "LOGIK DES FREIGABEFLUSSES",
      "desc_helpdesk_policy": "HELPDESK: ANFRAGEN GEHEN AN DIE IN DEN UNTERNEHMENSEINSTELLUNGEN ZUGEWIESENE PERSON.",
      "desc_leave_policy": "URLAUB: ZUERST VORGESETZTE, DANN HR / ADMIN.",
      "desc_expense_policy": "SPESEN: ZUERST VORGESETZTE, DANN ADMIN / FINANZ.",
      "desc_document_policy": "DOKUMENTE: GEHEN ZUR HR- / ADMIN-FREIGABE.",
      "lbl_helpdesk_it": "HELP DESK (IT)",
      "lbl_hr_responsible": "URLAUB & DOKUMENTE (HR)",
      "lbl_admin_responsible": "ADMIN-ANFRAGEN & SPESEN",
      "lbl_payroll_officer": "LOHNBUCHHALTER",
      "desc_payroll_officer": "DIESE PERSON BEARBEITET HELPDESK-LOHNANFRAGEN UND DIENT ALS FINANZPUNKT IM SPESENFLUSS.",
      "btn_processing": "WIRD BEARBEITET...",
      "btn_save_routing": "EINSTELLUNGEN SPERREN UND SPEICHERN",
      "lbl_pdf_active": "PDF-BRIEFBOGEN-SYSTEM AKTIV",
      "lbl_no_logo": "KEIN LOGO DEFINIERT",
      "tab_company_info": "UNTERNEHMENS",
      "tab_company_info_span": "INFO",
      "lbl_address": "ADRESSE",
      "lbl_phone": "TELEFON",
      "lbl_email": "E-MAIL",
      "lbl_website": "WEBSITE",
      "btn_update_info": "INFORMATIONEN AKTUALISIEREN",
      "lbl_logo_management": "LOGO-VERWALTUNG",
      "btn_select_new_file": "NEUE DATEI AUSWÄHLEN",
      "btn_start_upload": "HOCHLADEN STARTEN",
      "lbl_no_logo_uploaded": "KEIN LOGO",
      "lbl_current_view": "AKTUELLE ANSICHT",
      "tab_account": "KONTO",
      "tab_security_span": "SICHERHEIT",
      "lbl_update_pwd": "PASSWORT AKTUALISIEREN",
      "desc_update_pwd": "Zur Sicherheit Ihres Kontos wird empfohlen, Ihr Passwort regelmäßig zu ändern.",
      "lbl_old_pwd": "AKTUELLES PASSWORT",
      "lbl_new_pwd": "NEUES PASSWORT",
      "lbl_confirm_pwd": "NEUES PASSWORT (BESTÄTIGEN)",
      "btn_change_pwd": "PASSWORT AKTUALISIEREN",
      "opt_none_selected": "NIEMAND AUSGEWÄHLT",
      "err_login_failed_check_info": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.",
      "lbl_system_subtitle": "Personalverwaltungssystem",
      "lbl_email_address": "E-Mail Adresse",
      "ph_email_example": "beispiel@firma.com",
      "lbl_password": "Passwort",
      "btn_login_system": "IM SYSTEM ANMELDEN",
      "msg_no_account_yet": "Noch kein Konto?",
      "btn_register_now": "Jetzt registrieren",
      "notif_loading": "📢 Dashboard lädt, bitte warten...",
      "err_fetch_ats": "ATS-Daten konnten nicht abgerufen werden:",
      "err_fetch_kudos": "Kudos-Feed konnte nicht abgerufen werden:",
      "notif_pending_leaves": "{{count}} Urlaubsanträge warten auf Ihre Genehmigung.",
      "notif_pending_expenses": "{{count}} Spesenabrechnungen warten auf Ihre Genehmigung.",
      "notif_pending_documents": "{{count}} Dokumente warten auf Ihre Genehmigung.",
      "notif_dossier_missing_required_documents": "{{count}} fehlende Pflichtdokumente warten auf Prüfung.",
      "notif_dossier_expired_documents": "{{count}} Dokumente scheinen abgelaufen zu sein.",
      "notif_dossier_expiring_documents": "{{count}} Dokumente laufen bald ab.",
      "notif_open_tickets": "Es gibt {{count}} offene Tickets in der IT/Support-Abteilung.",
      "notif_all_clear": "Sie haben derzeit keine ausstehenden Genehmigungen. Haben Sie einen tollen Tag!",
      "notif_last_announcement": "Letzte Ankündigung: {{title}}",
      "notif_welcome": "Willkommen im System, wir wünschen Ihnen einen produktiven Tag.",
      "err_server_unreachable": "Keine Verbindung zum Server möglich. Bitte versuchen Sie es später erneut.",
      "lbl_dashboard_warning": "Warnung beim Laden des Dashboards",
      "btn_view_all": "ALLE ANSEHEN",
      "btn_new_job_posting": "NEUES STELLENANGEBOT",
      "btn_go_to_roster": "ZUM DIENSTPLAN",
      "lbl_ats_summary": "REKRUTIERUNGS- (ATS) ZUSAMMENFASSUNG",
      "lbl_active_jobs": "{{count}} AKTIVE STELLEN",
      "lbl_loading": "WIRD GELADEN...",
      "msg_no_active_jobs_html": "MOMENTAN KEINE<br/>AKTIVEN STELLENANGEBOTE",
      "lbl_unnamed_job": "UNBENANNTER JOB",
      "lbl_candidates_waiting": "{{count}} Kandidaten warten",
      "lbl_daily_roster": "TÄGLICHER PERSONALSTATUS",
      "lbl_on_site": "DERZEIT VOR ORT",
      "lbl_person": "Personen",
      "lbl_on_leave": "IM URLAUB / KRANK",
      "lbl_kudos_title": "WERTCHÄTZUNG & ANERKENNUNG (KUDOS)",
      "msg_no_kudos_html": "NOCH KEINE KUDOS.<br/>SEIEN SIE DER ERSTE, DER EINES SENDET!",
      "lbl_thanked_suffix": "wurde gedankt von",
      "lbl_company_news": "UNTERNEHMENSNACHRICHTEN & ANKÜNDIGUNGEN",
      "msg_no_announcement_html": "KEINE AKTUELLEN<br/>ANKÜNDIGUNGEN",
      "doc_id": "AUSWEIS / REISEPASS KOPIE",
      "doc_pre_permit": "VORGENEHMIGUNGSDOKUMENTE",
      "doc_work_permit": "ARBEITSERLAUBNIS & GESUNDHEITSBERICHT",
      "doc_residency": "AUFENTHALTS- / ADRESSNACHWEIS",
      "doc_visa": "VISUM / AUFENTHALTSERLAUBNIS",
      "doc_contract": "ARBEITSVERTRAG",
      "doc_nda": "VERTRAULICHKEIT / NDA",
      "doc_handbook_ack": "HANDBUCHBESTÄTIGUNG",
      "doc_background_check": "HINTERGRUNDPRÜFUNG",
      "doc_ohs_training": "ARBEITSSCHUTZ / GESUNDHEITSEIGNUNG",
      "doc_bank_info": "BANK / IBAN-ANGABEN",
      "doc_tax_doc": "STEUER / TIN-DOKUMENT",
      "doc_payroll": "LOHNABRECHNUNG",
      "doc_social_security_record": "SOZIALVERSICHERUNGSNACHWEIS",
      "doc_performance_review": "LEISTUNGSBEURTEILUNG",
      "doc_training_record": "SCHULUNGSNACHWEIS",
      "doc_leave_record": "URLAUBS- / ABWESENHEITSNACHWEIS",
      "doc_disciplinary": "DISZIPLINARAKTE",
      "doc_termination": "KÜNDIGUNG (FREIGABEFORMULAR)",
      "doc_exit_interview": "AUSTRITTSGESPRÄCH",
      "doc_onboarding_checklist": "ONBOARDING-CHECKLISTE",
      "doc_offboarding_checklist": "OFFBOARDING-CHECKLISTE",
      "doc_certificate": "ZERTIFIKAT & BERUFSAUSBILDUNG",
      "doc_other": "SONSTIGE DOKUMENTE",
      "lbl_employee": "Mitarbeiter",
      "lbl_first_name": "Vorname",
      "lbl_last_name": "Nachname",
      "err_fetch_files": "Ihre Dateien konnten nicht abgerufen werden.",
      "err_fetch_emps": "Mitarbeiter konnten nicht abgerufen werden.",
      "err_fetch_docs": "Dokumente konnten nicht abgerufen werden.",
      "err_file_size": "Die Dateigröße darf 10 MB nicht überschreiten.",
      "msg_uploading_doc": "Dokument wird ins Archiv hochgeladen...",
      "msg_upload_pending": "Dokument erfolgreich hochgeladen und zur Genehmigung eingereicht.",
      "msg_upload_success": "Dokument erfolgreich ins Archiv aufgenommen.",
      "msg_document_status_updated": "Dokumentenstatus wurde auf {{status}} aktualisiert.",
      "err_document_status_update": "Dokumentenstatus konnte nicht aktualisiert werden.",
      "err_upload_failed": "Beim Hochladen des Dokuments ist ein Fehler aufgetreten.",
      "action_approved": "Genehmigt",
      "action_rejected": "Abgelehnt",
      "msg_status_updated": "Dokumentenstatus auf {{status}} aktualisiert.",
      "err_status_update": "Status konnte nicht aktualisiert werden.",
      "err_delete_pending_only": "Sie können nur Ihre ausstehenden (PENDING) Dokumente löschen.",
      "msg_confirm_delete_doc": "Dieses Dokument wird dauerhaft gelöscht. Sind Sie sicher?",
      "msg_delete_success": "Dokument erfolgreich aus dem Archiv gelöscht.",
      "err_delete_failed": "Dokument konnte nicht gelöscht werden.",
      "lbl_archive_selection": "ARCHIVAUSWAHL",
      "lbl_selected_employee": "AUSGEWÄHLTER MITARBEITER",
      "msg_no_employee_selected": "Noch kein Mitarbeiter ausgewählt",
      "btn_select_employee_archive": "MITARBEITER WÄHLEN",
      "btn_change_employee_archive": "MITARBEITER WECHSELN",
      "msg_select_emp_focus_html": "WÄHLEN SIE ZUERST EINEN MITARBEITER AUS,<br/>UM DIE E-AKTE ZU SEHEN.",
      "ph_search_emp": "Name oder Abteilung suchen...",
      "msg_select_emp_html": "WÄHLEN SIE EINEN MITARBEITER LINKS AUS,<br/>UM DAS E-AKTEN-ARCHIV ANZUSEHEN.",
      "lbl_my_dossier": "MEINE PERSÖNLICHE E-AKTE",
      "lbl_official_dossier": "OFFIZIELLE MITARBEITERAKTE",
      "lbl_archive_size": "ARCHIVGRÖSSE",
      "lbl_docs": "DOKUMENTE",
      "lbl_upload_new_doc": "NEUES DOKUMENT INS SYSTEM HOCHLADEN",
      "lbl_doc_category": "DOKUMENTENKATEGORIE",
      "lbl_doc_number": "DOKUMENTNR",
      "lbl_doc_number_short": "NR",
      "lbl_doc_issued_by": "AUSGESTELLT VON",
      "lbl_doc_issue_date": "AUSSTELLUNGSDATUM",
      "lbl_doc_valid_until": "GÜLTIG BIS",
      "lbl_doc_mandatory": "PFLICHTDOKUMENT",
      "lbl_dossier_compliance": "DOSSIER-COMPLIANCE",
      "lbl_uploaded_documents": "HOCHGELADENE DOKUMENTE",
      "lbl_document_detail": "DOKUMENTDETAIL",
      "tab_uploaded_documents": "HOCHGELADENE DOKUMENTE",
      "tab_upload_document": "DOKUMENT HOCHLADEN",
      "tab_compliance": "COMPLIANCE",
      "lbl_completion_score": "VOLLSTÄNDIGKEIT",
      "lbl_expiring_soon": "LÄUFT BALD AB",
      "lbl_expired_docs": "ABGELAUFEN",
      "lbl_missing_required": "FEHLENDE PFLICHT",
      "msg_missing_required_docs": "FEHLENDE PFLICHTDOKUMENTE",
      "msg_all_required_docs_ready": "PFLICHTDOKUMENTE VOLLSTÄNDIG",
      "msg_dossier_compliant": "Die definierten Pflichtdokumente sind in diesem Dossier aktuell vollständig.",
      "lbl_expired_required_docs": "ABGELAUFENE PFLICHTDOKUMENTE",
      "lbl_expiring_required_docs": "BALD ABLAUFENDE PFLICHTDOKUMENTE",
      "msg_no_expired_required_docs": "Es gibt aktuell keine abgelaufenen Pflichtdokumente.",
      "msg_no_expiring_required_docs": "Es gibt aktuell keine bald ablaufenden Pflichtdokumente.",
      "lbl_country_role_rule_set": "LAND / ROLLEN-REGELSET",
      "dossier_profile_tr": "TR-PROFIL",
      "dossier_profile_kktc": "TRNZ-PROFIL",
      "dossier_profile_eu": "EU-PROFIL",
      "dossier_profile_mena": "MENA-PROFIL",
      "dossier_profile_global": "GLOBALES PROFIL",
      "msg_select_doc_for_detail": "WÄHLEN SIE EIN DOKUMENT, UM DIE DETAILS ZU SEHEN",
      "badge_expiring_soon": "LÄUFT BALD AB",
      "badge_expired": "ABGELAUFEN",
      "lbl_missing_required_dossier_docs": "FEHLENDE PFLICHTDOKUMENTE",
      "msg_missing_required_dossier_docs_waiting": "Pflichtdokumente benötigen Nachverfolgung.",
      "lbl_expired_dossier_docs": "ABGELAUFENE DOKUMENTE",
      "msg_expired_dossier_docs_waiting": "Dokumente müssen erneuert werden.",
      "lbl_expiring_dossier_docs": "BALD ABLAUFENDE DOKUMENTE",
      "msg_expiring_dossier_docs_waiting": "Dokumente laufen bald ab.",
      "lbl_select_file_format": "DATEI WÄHLEN (PDF / BILD)",
      "btn_choose_from_pc": "DATEI VOM COMPUTER WÄHLEN",
      "btn_uploading": "WIRD HOCHGELADEN...",
      "btn_upload_to_archive": "INS ARCHIV HOCHLADEN",
      "lbl_max_file_size": "Maximale Dateigröße: 10MB",
      "msg_searching_docs": "Dokumente werden gesucht...",
      "msg_no_docs_found": "Noch keine Dokumente in der Akte dieses Mitarbeiters.",
      "badge_pending_approval": "AUSSTEHENDE GENEHMIGUNG",
      "badge_approved_doc": "GENEHMIGTES DOKUMENT",
      "badge_rejected_doc": "ABGELEHNT",
      "tooltip_view_doc": "Dokument ansehen",
      "btn_approve": "GENEHMIGEN",
      "btn_reject": "ABLEHNEN",
      "tooltip_delete_archive": "Aus dem Archiv löschen",
      "tooltip_download_doc": "Dokument herunterladen",
      "err_fetch_assets": "Zugewiesene Anlagen konnten nicht abgerufen werden.",
      "err_empty_issue": "Bitte beschreiben Sie das Problem im Detail.",
      "msg_sending_ticket": "Ihre Supportanfrage wird an die IT-Abteilung gesendet...",
      "lbl_issue_report": "MÄNGELBERICHT",
      "lbl_serial_plate": "Seriennr./Kennzeichen",
      "lbl_category": "Kategorie",
      "lbl_issue_details": "Problem",
      "msg_ticket_created": "Fehleranfrage erfolgreich erstellt!",
      "err_ticket_create_failed": "Anfrage konnte nicht erstellt werden. Bitte wenden Sie sich an Ihren Manager.",
      "msg_confirm_acknowledge": "Bestätigen Sie, dass Sie das Firmeninventar namens \"{{name}}\" physisch, vollständig und in funktionstüchtigem Zustand erhalten haben? (Dieser Vorgang gilt als digitale Unterschrift)",
      "msg_acknowledging": "Übergabe wird bestätigt...",
      "msg_acknowledge_success": "Bestätigung des Inventars erfolgreich!",
      "err_acknowledge_failed": "Bestätigung fehlgeschlagen.",
      "lbl_my_active_assets": "MEINE AKTIVEN ANLAGEN",
      "msg_no_assets_html": "IHNEN SIND DERZEIT KEINE<br/>FIRMENANLAGEN ZUGEWIESEN.",
      "badge_in_repair": "IN REPARATUR",
      "badge_active_device": "AKTIVES GERÄT",
      "lbl_no_serial_no": "SERIENNUMMER NICHT ANGEGEBEN",
      "lbl_allocation_date": "ZUTEILUNGSDATUM",
      "msg_please_acknowledge": "WENN SIE DAS GERÄT PHYSISCH ERHALTEN HABEN, BESTÄTIGEN SIE BITTE UNTEN.",
      "btn_acknowledge_asset": "ICH HABE DAS GERÄT ERHALTEN (BESTÄTIGEN)",
      "btn_asset_in_repair": "GERÄT BEFINDET SICH DERZEIT IM SERVICE",
      "btn_report_issue": "PROBLEM MELDEN / SUPPORT ANFORDERN",
      "modal_title_issue_report": "MÄNGEL- UND SUPPORTBERICHT",
      "msg_ticket_route_warning": "DIESE SUPPORTANFRAGE WIRD DIREKT AN DIE IT-ABTEILUNG GESENDET.",
      "lbl_issue_desc": "WAS IST DAS PROBLEM? BITTE ERKLÄREN SIE ES IM DETAIL.",
      "ph_issue_example": "Z.B.: Der Bildschirm ist kaputt, der Akku lädt nicht, ich kann mich nicht im System anmelden...",
      "btn_send_to_it": "ANFRAGE AN IT SENDEN",
      "cat_food": "Essen & Trinken",
      "cat_transport": "Reisen & Transport",
      "cat_accommodation": "Unterkunft",
      "cat_education": "Bildung & Kurs",
      "cat_office": "Büromaterial",
      "cat_customer": "Kundenbewirtung",
      "cat_other": "Sonstiges",
      "err_fetch_expenses": "Ausgaben konnten nicht abgerufen werden.",
      "err_missing_receipt": "Bitte laden Sie ein Bild des Belegs oder der Rechnung für Ihre Ausgabe hoch!",
      "lbl_no_desc": "Keine Beschreibung angegeben.",
      "msg_uploading_expense": "Ausgabenerklärung wird ins System hochgeladen...",
      "msg_expense_submitted": "Ihre Ausgabe und Ihr Beleg wurden zur Genehmigung eingereicht!",
      "err_submit_expense": "Beim Hinzufügen der Ausgabe ist ein Fehler aufgetreten.",
      "msg_confirm_cancel_expense": "Sind Sie sicher, dass Sie diese Ausgabenerklärung stornieren möchten?",
      "msg_canceling_expense": "Ausgabe wird storniert...",
      "msg_expense_canceled": "Ausgabe erfolgreich storniert.",
      "err_cancel_failed": "Stornierung fehlgeschlagen.",
      "btn_new_receipt": "NEUER BELEG / RECHNUNG",
      "lbl_pending_approval": "AUSSTEHENDE GENEHMIGUNG",
      "lbl_approved_total": "GENEHMIGT (GESAMT)",
      "lbl_past_declarations": "MEINE VERGANGENEN ERKLÄRUNGEN",
      "msg_no_expenses_html": "SIE HABEN NOCH KEINE<br/>AUSGABEN EINGEGEBEN.",
      "tooltip_cancel_expense": "Ausgabe stornieren (Löschen)",
      "btn_view_receipt": "BELEG ANSEHEN",
      "badge_approved": "GENEHMIGT",
      "badge_rejected": "ABGELEHNT",
      "badge_pending": "AUSSTEHEND",
      "lbl_cancel_reason": "Stornierungsgrund:",
      "modal_title_new_expense": "NEUEN BELEG / RECHNUNG EINGEBEN",
      "lbl_approved_paid": "GENEHMIGTE AUSGABEN WERDEN AUSGEZAHLT",
      "msg_expense_policy": "BITTE GEBEN SIE NUR ARBEITSBEZOGENE AUSGABEN EIN. GENEHMIGTE AUSGABEN WERDEN ERSTATTET.",
      "msg_limit_warning": "DER EINGEGEBENE BETRAG ÜBERSCHREITET DAS LIMIT VON {{limit}}. MANAGER-GENEHMIGUNG KANN LÄNGER DAUERN.",
      "lbl_amount": "BETRAG",
      "lbl_amount_preview": "BETRAGSVORSCHAU",
      "lbl_currency": "WÄHRUNG",
      "lbl_category": "KATEGORIE",
      "lbl_receipt_date": "BELEGDATUM",
      "lbl_short_desc": "KURZE BESCHREIBUNG / DETAILS",
      "ph_expense_desc": "Z.B., Abendessen für Kundenbesuch in Berlin...",
      "lbl_receipt_image": "BELEG / RECHNUNGSBILD ODER PDF",
      "btn_open_cam_gallery": "KAMERA ÖFFNEN ODER AUS GALERIE WÄHLEN",
      "btn_submit_for_approval": "AUSGABE ZUR GENEHMIGUNG EINREICHEN",
      "modal_title_receipt": "AUSGABENBELEG",
      "lbl_receipt_pdf": "Beleg PDF",
      "lbl_receipt_img": "Ausgabenbeleg",
      "lbl_img_not_found": "Bild+Nicht+Gefunden",
      "btn_close_window": "FENSTER SCHLIESSEN",
      "err_fetch_leaves": "Urlaube konnten nicht abgerufen werden.",
      "err_date_order": "Das Enddatum darf nicht vor dem Startdatum liegen!",
      "msg_creating_leave_req": "Ihr Urlaubsantrag wird erstellt...",
      "msg_leave_req_success": "Ihr Urlaubsantrag wurde erfolgreich zur Genehmigung durch den Manager eingereicht!",
      "err_form_invalid": "Formulardaten sind unvollständig oder ungültig!",
      "err_create_failed": "Antrag konnte nicht erstellt werden.",
      "msg_confirm_cancel_leave": "Sind Sie sicher, dass Sie diesen Urlaubsantrag stornieren möchten?",
      "msg_canceling_leave": "Urlaubsantrag wird storniert...",
      "msg_leave_canceled": "Urlaubsantrag erfolgreich storniert.",
      "type_annual": "JAHRESURLAUB (BEZAHLT)",
      "type_excuse": "SONDERURLAUB",
      "type_sick": "KRANKHEITSURLAUB (MIT ATTEST)",
      "type_unpaid": "UNBEZAHLTER URLAUB",
      "lbl_used_this_year": "DIESES JAHR GENUTZT (GENEHMIGT)",
      "lbl_days": "TAGE",
      "btn_request_new_leave": "NEUEN URLAUB BEANTRAGEN",
      "lbl_my_leave_movements": "MEINE URLAUBSHISTORIE",
      "msg_no_leaves_html": "SIE HABEN NOCH KEINE<br/>URLAUBSANTRÄGE.",
      "tooltip_cancel_leave": "Urlaub stornieren (Löschen)",
      "lbl_note": "Notiz:",
      "modal_title_new_leave": "URLAUBSANTRAG ERSTELLEN",
      "lbl_request_will_be_reviewed": "IHR ANTRAG WIRD ZUR GENEHMIGUNG DURCH DEN MANAGER EINGEREICHT",
      "msg_leave_policy": "Jahresurlaubsanträge werden von der Personalabteilung und Ihrem Manager geprüft.",
      "lbl_leave_type": "URLAUBSART",
      "lbl_start_date": "STARTDATUM",
      "lbl_end_date": "ENDDATUM",
      "lbl_reason": "GRUND / BESCHREIBUNG",
      "ph_leave_reason": "Sie können eine kurze Beschreibung eingeben...",
      "btn_submit_leave_req": "ANTRAG ZUR GENEHMIGUNG EINREICHEN",
      "lbl_default_report_title": "Mitarbeiterliste & Arbeitsschutzbericht",
      "col_fullname": "Vollständiger Name",
      "col_identity": "ID / Passnummer",
      "col_department": "Abteilung",
      "col_position": "Position",
      "col_blood_type": "Blutgruppe",
      "col_phone": "Telefon",
      "col_email": "E-Mail",
      "col_hire_date": "Einstellungsdatum",
      "col_education": "Bildung",
      "col_nationality": "Nationalität",
      "opt_male": "Männlich",
      "opt_female": "Weiblich",
      "opt_unknown": "Unbekannt",
      "opt_university": "Universität",
      "err_fetch_data": "Fehler beim Abrufen der Daten.",
      "lbl_unassigned_dept": "NICHT ZUGEWIESENE ROLLEN",
      "msg_opening_dossier": "Mitarbeiterakte wird geöffnet...",
      "err_loading_emp_details": "Fehler beim Laden der Mitarbeiterdetails.",
      "prompt_exit_date": "Kündigungsdatum (JJJJ-MM-TT):",
      "msg_confirm_archive": "Sind Sie sicher, dass Sie den Mitarbeiter {{name}} archivieren möchten?",
      "msg_archiving_emp": "Mitarbeiter wird archiviert...",
      "msg_archive_success": "Mitarbeiter erfolgreich archiviert und Stelle freigegeben.",
      "err_archive_failed": "Mitarbeiter hat noch offene Anlagen/Spesen, Archivierung fehlgeschlagen.",
      "msg_confirm_reset_pwd": "Möchten Sie das Passwort für {{name}} wirklich zurücksetzen?",
      "msg_resetting_pwd": "Passwort wird zurückgesetzt...",
      "msg_reset_success": "Passwort erfolgreich zurückgesetzt. (E-Mail gesendet)",
      "err_reset_failed": "Fehler beim Zurücksetzen des Passworts.",
      "msg_processing_record": "Personalakte wird verarbeitet...",
      "msg_update_success": "Eintrag erfolgreich aktualisiert.",
      "msg_create_success": "Mitarbeiter erfolgreich zum System hinzugefügt.",
      "err_save_failed": "Konnte nicht gespeichert werden. Bitte prüfen Sie die eingegebenen Daten.",
      "msg_preparing_pdf": "PDF-Dokument wird vorbereitet...",
      "msg_download_success": "Dokument heruntergeladen.",
      "err_pdf_failed": "Fehler beim Generieren der PDF!",
      "err_select_column": "Bitte wählen Sie mindestens 1 Spalte aus.",
      "msg_generating_report": "Ihr benutzerdefinierter Bericht wird erstellt...",
      "msg_report_downloaded": "Bericht erfolgreich heruntergeladen.",
      "err_report_failed": "Fehler beim Generieren des Berichts.",
      "msg_processing": "Wird verarbeitet...",
      "msg_profile_updated": "Profil erfolgreich aktualisiert.",
      "msg_request_rejected": "Anfrage abgelehnt.",
      "err_action_failed": "Aktion konnte nicht durchgeführt werden.",
      "lbl_key_phone": "TELEFONNUMMER",
      "lbl_key_address": "WOHNADRESSE",
      "lbl_first_name": "VORNAME",
      "lbl_last_name": "NACHNAME",
      "lbl_identity_no": "ID / PASSNUMMER",
      "lbl_gender": "GESCHLECHT",
      "lbl_mother_name": "NAME DER MUTTER",
      "lbl_father_name": "NAME DES VATERS",
      "lbl_birth_place": "GEBURTSORT",
      "lbl_birth_date": "GEBURTSDATUM",
      "lbl_phone_no": "MOBILTELEFON",
      "lbl_address": "WOHNADRESSE",
      "lbl_nationality": "NATIONALITÄT / STAATSBÜRGERSCHAFT",
      "ph_nationality": "Z.B.: DE, AT",
      "lbl_marital_married": "FAMILIENSTAND: VERHEIRATET",
      "lbl_spouse_name": "NAME DES EHEPARTNERS",
      "lbl_spouse_works": "ARBEITET DER EHEPARTNER? (Steuerermäßigung)",
      "lbl_children_count": "ANZAHL DER UNTERHALTSBERECHTIGTEN KINDER",
      "lbl_child_name": "KIND {{idx}} VOLLSTÄNDIGER NAME",
      "lbl_company_branch": "UNTERNEHMEN / NIEDERLASSUNG",
      "opt_select": "Auswählen",
      "lbl_hire_date": "EINSTELLUNGSDATUM",
      "lbl_department": "ABTEILUNG",
      "opt_select_dept": "ABTEILUNG AUSWÄHLEN",
      "lbl_position": "POSITION / TITEL",
      "opt_no_position": "KEINE POSITION AUSGEWÄHLT",
      "lbl_select_dept_first": "Zuerst eine Abteilung wählen",
      "lbl_system_role": "SYSTEMROLLE (ZUGRIFF)",
      "role_employee": "STANDARDMITARBEITER (Nur eigene Infos)",
      "role_manager": "MANAGER (Eigenes Team und Genehmigungen)",
      "role_hr": "PERSONALABTEILUNG (Alle Mitarbeiter)",
      "role_admin": "SYSTEM-ADMIN (Vollzugriff)",
      "desc_role_access": "Linkes Menü und Datenzugriff werden basierend auf der Rolle angepasst.",
      "lbl_education_level": "BILDUNGSSTAND",
      "edu_primary": "Grundschule",
      "edu_middle": "Mittelschule",
      "edu_high": "Abitur",
      "edu_university": "Universität",
      "edu_master": "Masterabschluss",
      "lbl_gross_salary": "VEREINBARTES GEHALT (BRUTTO)",
      "lbl_blood_type": "BLUTGRUPPE",
      "opt_not_selected": "Nicht Ausgewählt",
      "lbl_ssn": "SOZIALVERSICHERUNGSNR (SV-NR)",
      "lbl_tax_no": "STEUER / FONDS-NR (Optional)",
      "lbl_emergency_contact_name": "NOTFALLKONTAKT",
      "lbl_emergency_contact_relation": "VERWANDSCHAFT",
      "lbl_emergency_contact_phone": "NOTFALLTELEFON",
      "lbl_bank_name": "BANKNAME",
      "lbl_account_holder_name": "KONTOINHABER",
      "lbl_iban": "IBAN",
      "lbl_tax_id_number": "STEUER-ID / TIN",
      "lbl_work_auth_type": "ARBEITSBERECHTIGUNGSTYP",
      "lbl_work_auth_no": "ARBEITSBERECHTIGUNGSNR",
      "lbl_work_auth_start": "BEGINN DER BERECHTIGUNG",
      "lbl_work_auth_expiry": "ENDE DER BERECHTIGUNG",
      "lbl_visa_type": "VISUM / AUFENTHALTSTYP",
      "lbl_visa_expiry": "VISUMABLAUF",
      "lbl_nda_signed_at": "NDA-UNTERZEICHNUNG",
      "lbl_handbook_ack_signed_at": "HANDBUCHBESTÄTIGUNG",
      "lbl_background_check_status": "STATUS HINTERGRUNDPRÜFUNG",
      "lbl_background_check_completed_at": "DATUM HINTERGRUNDPRÜFUNG",
      "lbl_occupational_health_status": "ARBEITSMEDIZIN / EIGNUNG",
      "lbl_occupational_health_valid_until": "ARBEITSMEDIZIN GÜLTIG BIS",
      "opt_not_started": "Nicht begonnen",
      "opt_in_progress": "In Bearbeitung",
      "opt_completed_short": "Abgeschlossen",
      "opt_exempt": "Ausgenommen",
      "opt_fit": "Geeignet",
      "opt_restricted": "Eingeschränkt geeignet",
      "opt_expired": "Abgelaufen",
      "tab_active_roster": "AKTIVER DIENSTPLAN",
      "tab_archive_roster": "ARCHIV (GEKÜNDIGT)",
      "btn_approvals": "GENEHMIGUNGEN",
      "btn_custom_report": "BENUTZERDEFINIERTEN BERICHT ERSTELLEN",
      "btn_new_record": "NEUER EINTRAG",
      "col_head_name": "NAME / POSITION",
      "col_head_company": "UNTERNEHMEN / STANDORT",
      "col_head_hire": "EINSTELLUNGSDATUM",
      "col_head_exit": "KÜNDIGUNGSDATUM",
      "col_head_actions": "AKTIONEN",
      "msg_no_records_tab": "Keine Einträge in diesem Tab.",
      "lbl_personnel_count": "PERSONAL",
      "lbl_unassigned_short": "NICHT ZUGEWIESEN",
      "tooltip_download_card": "Infokarte (PDF) herunterladen",
      "tooltip_download_cert": "Arbeitsbescheinigung (PDF) herunterladen",
      "tooltip_reset_pwd": "Login-Passwort zurücksetzen",
      "tooltip_edit": "Bearbeiten",
      "tooltip_terminate": "Kündigen (Archivieren)",
      "modal_title_approvals": "PROFIL-AKTUALISIERUNGSANFRAGEN",
      "msg_no_pending_requests_html": "ALLE ANFRAGEN GEPRÜFT!<br/>KEINE AUSSTEHENDEN AKTIONEN.",
      "badge_new_request": "NEUE ANFRAGE",
      "btn_reject": "ABLEHNEN",
      "btn_approve": "GENEHMIGEN",
      "modal_title_custom_report": "BENUTZERDEFINIERTEN BERICHT ERSTELLEN",
      "lbl_report_title": "BERICHTSTITEL",
      "lbl_report_columns": "EINZUSCHLIESSENDE INFORMATIONEN (SPALTEN)",
      "btn_cancel": "ABBRECHEN",
      "btn_download_pdf_report": "PDF-BERICHT HERUNTERLADEN",
      "modal_title_edit_emp": "MITARBEITERAKTE AKTUALISIEREN",
      "modal_title_new_emp": "NEUE MITARBEITERREGISTRIERUNG",
      "step_1": "1. IDENTITÄT",
      "step_2": "2. KONTAKT & FAMILIE",
      "step_3": "3. UNTERNEHMEN",
      "step_4": "4. FINANZEN & RECHT",
      "btn_back": "ZURÜCK",
      "lbl_step": "SCHRITT {{step}} / 4",
      "btn_next": "WEITER",
      "btn_update_record": "EINTRAG AKTUALISIEREN",
      "btn_complete_record": "REGISTRIERUNG ABSCHLIESSEN",
      "err_session_expired": "Ihre Sitzung ist möglicherweise abgelaufen. Bitte melden Sie sich erneut an.",
      "err_fetch_performance": "Leistungsdaten konnten nicht abgerufen werden.",
      "msg_progress_saved": "Fortschritt erfolgreich gespeichert.",
      "err_progress_update": "Fortschritt konnte nicht aktualisiert werden.",
      "lbl_loading_performance": "LEISTUNGSDATEN WERDEN GELADEN...",
      "lbl_ai_career_assistant": "KÜNSTLICHE INTELLIGENZ (KI) KARRIEREASSISTENT",
      "msg_default_ai_summary": "Basierend auf Ihren vergangenen Bewertungen und Zielen haben Sie ein großartiges Momentum erreicht. Weiter so!",
      "lbl_active_goals": "MEINE AKTIVEN ZIELE (OKRS)",
      "msg_no_assigned_goals": "IHNEN WURDEN NOCH KEINE ZIELE ZUGEWIESEN.",
      "lbl_progress_status": "FORTSCHRITTSSTATUS",
      "lbl_drag_to_save": "Zum Speichern den Schieberegler ziehen und loslassen",
      "lbl_my_reviews": "MEINE BEWERTUNGEN",
      "msg_no_past_reviews": "NOCH KEINE VERGANGENEN BEWERTUNGEN.",
      "lbl_manager_note": "NOTIZ DES MANAGERS",
      "mood_great": "GROSSARTIG",
      "mood_good": "GUT",
      "mood_normal": "NORMAL",
      "mood_bad": "SCHLECHT",
      "mood_awful": "SCHRECKLICH",
      "badge_team_star": "🌟 Team-Stern",
      "badge_fast_solver": "🚀 Schneller Löser",
      "badge_helpful": "🦸‍♂️ Super Hilfsbereit",
      "badge_creative": "💡 Innovative Idee",
      "lbl_employee_fallback": "Mitarbeiter",
      "err_fetch_portal": "Portaldaten konnten nicht geladen werden, bitte aktualisieren Sie die Seite.",
      "msg_creating_leave": "Ihr Urlaubsantrag wird erstellt...",
      "msg_leave_success": "Ihr Urlaubsantrag wurde erfolgreich zur Genehmigung eingereicht!",
      "err_leave_failed": "Antrag konnte nicht erstellt werden.",
      "msg_no_changes": "Sie haben keine Änderungen vorgenommen.",
      "msg_sending_update": "Ihre Änderungsanfrage wird gesendet...",
      "msg_update_success": "Ihre Änderungsanfrage wurde zur Genehmigung an HR gesendet!",
      "err_update_failed": "Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
      "err_pwd_match": "Die neuen Passwörter stimmen nicht überein!",
      "err_pwd_length": "Das Passwort muss mindestens 6 Zeichen lang sein.",
      "msg_changing_pwd": "Ihr Passwort wird geändert...",
      "msg_pwd_changed": "Ihr Passwort wurde erfolgreich geändert!",
      "err_pwd_failed": "Passwort konnte nicht geändert werden.",
      "msg_mood_success": "Ihre Stimmung wurde dem Team erfolgreich mitgeteilt!",
      "err_mood_failed": "Stimmung konnte nicht gespeichert werden.",
      "msg_sending_kudos": "Ihr Abzeichen wird gesendet...",
      "msg_kudos_success": "Ihr Kudos-Abzeichen wurde erfolgreich gesendet!",
      "err_kudos_failed": "Abzeichen konnte nicht gesendet werden.",
      "lbl_loading_portal": "IHR PORTAL WIRD GELADEN...",
      "lbl_hello": "HALLO, {{name}} 👋",
      "lbl_personnel": "PERSONAL",
      "lbl_general_dept": "ALLGEMEINE ABTEILUNG",
      "btn_account_pwd": "KONTO / PASSWORT",
      "btn_req_new_leave": "NEUEN URLAUB BEANTRAGEN",
      "lbl_used_this_year": "DIESES JAHR GENUTZT: {{days}} TAGE",
      "btn_declare_expense": "AUSGABEN MELDEN",
      "lbl_receipt_invoice": "BELEG- & RECHNUNGSEINGABE",
      "lbl_how_do_you_feel": "WIE FÜHLEN SIE SICH HEUTE?",
      "lbl_share_mood": "Teilen Sie Ihre Stimmung und senden Sie Energie an Ihr Team!",
      "lbl_upcoming_trainings": "MEINE ANSTEHENDEN SCHULUNGEN",
      "lbl_no_trainings": "SIE HABEN KEINE GEPLANTEN SCHULUNGEN.",
      "lbl_participant": "TEILNEHMER",
      "lbl_my_assets": "MEINE ZUGEWIESENEN ANLAGEN",
      "lbl_no_assets": "IHNEN SIND KEINE ANLAGEN ZUGEWIESEN.",
      "lbl_celebrations_this_month": "WIR FEIERN DIESEN MONAT!",
      "lbl_no_celebrations": "KEINE EREIGNISSE ZU FEIERN<br/>DIESEN MONAT.",
      "lbl_day": "TAG",
      "lbl_birthday": "GEBURTSTAG",
      "lbl_anniversary": "{{years}}. JAHRESTAG",
      "lbl_kudos_board": "KUDOS BOARD",
      "tooltip_send_badge": "Ein Abzeichen senden",
      "lbl_no_kudos": "NOCH NIEMAND HAT EIN ABZEICHEN GESENDET.<br/>SEIEN SIE DER ERSTE!",
      "modal_title_kudos": "KUDOS ABZEICHEN SENDEN",
      "lbl_to_whom": "AN WEN SENDEN SIE ES?",
      "opt_select_colleague": "-- Wählen Sie einen Kollegen --",
      "lbl_select_badge": "ABZEICHEN WÄHLEN",
      "lbl_write_note": "SCHREIBEN SIE EINE NETTE NOTIZ",
      "ph_kudos_note": "Vielen Dank für deine Hilfe...",
      "btn_send_kudos": "ABZEICHEN UND NACHRICHT SENDEN",
      "modal_title_leave": "URLAUBSANTRAG ERSTELLEN",
      "lbl_manager_approval": "IHR ANTRAG WIRD DEM MANAGER VORGELEGT",
      "lbl_used_leave": "IN DIESEM JAHR GENUTZTER URLAUB",
      "lbl_days": "TAGE",
      "lbl_leave_type": "URLAUBSART",
      "opt_annual": "JAHRESURLAUB (BEZAHLT)",
      "opt_excuse": "SONDERURLAUB",
      "opt_sick": "KRANKHEITSURLAUB (ATTEST)",
      "opt_unpaid": "UNBEZAHLTER URLAUB",
      "lbl_start": "START",
      "lbl_end": "ENDE",
      "lbl_reason": "GRUND / BESCHREIBUNG",
      "ph_reason": "Sie können eine kurze Beschreibung schreiben...",
      "btn_cancel": "ABBRECHEN",
      "btn_submit_approval": "ZUR GENEHMIGUNG EINREICHEN",
      "modal_title_settings": "KONTOEINSTELLUNGEN",
      "tab_contact": "KONTAKTINFO",
      "tab_password": "PASSWORT ÄNDERN",
      "lbl_update_req": "ÄNDERUNGSANFRAGE",
      "desc_update_req": "Hier vorgenommene Änderungen werden als \"Entwurf\" an HR gesendet. Nach Genehmigung werden sie übernommen.",
      "lbl_phone": "TELEFONNUMMER",
      "ph_phone": "z.B. 0151 1234567",
      "lbl_address": "WOHNADRESSE",
      "ph_address": "Geben Sie Ihre vollständige Adresse ein...",
      "lbl_old_pwd": "AKTUELLES PASSWORT",
      "ph_old_pwd": "Ihr Login-Passwort",
      "lbl_new_pwd": "NEUES PASSWORT",
      "ph_new_pwd": "Mindestens 6 Zeichen",
      "lbl_confirm_pwd": "NEUES PASSWORT (BESTÄTIGEN)",
      "ph_confirm_pwd": "Bestätigen Sie Ihr neues Passwort",
      "btn_change_pwd": "MEIN PASSWORT ÄNDERN",
      "err_fetch_trainings": "Schulungskalender konnte nicht abgerufen werden.",
      "lbl_loading_trainings": "SCHULUNGSKALENDER WIRD GELADEN...",
      "lbl_assigned_training": "IHNEN ZUGEWIESENE SCHULUNGEN:",
      "lbl_count": "STÜCK",
      "msg_no_upcoming_html": "IN NÄCHSTER ZEIT STEHEN KEINE<br/>SCHULUNGEN FÜR SIE AN.",
      "badge_approaching": "BEVORSTEHEND",
      "lbl_date": "DATUM",
      "lbl_time": "UHRZEIT",
      "lbl_instructor": "TRAINER",
      "lbl_location": "ORT",
      "lbl_past_cancelled_trainings": "VERGANGENE & ABGESAGTE SCHULUNGEN",
      "badge_cancelled_by_admin": "VOM MANAGEMENT ABGESAGT",
      "lbl_unknown_field": "Unbekanntes Feld",
      "err_format_invalid": "Fehler ({{field}}): Fehlendes oder ungültiges Format!",
      "err_no_user_id": "Benutzer-ID nicht gefunden.",
      "msg_confirm_approve": "Sind Sie sicher, dass Sie diese Ausgabenerklärung GENEHMIGEN möchten?",
      "msg_processing": "Wird verarbeitet und E-Mail gesendet...",
      "msg_confirm_delete_expense": "Sind Sie sicher, dass Sie diese Ausgabe komplett LÖSCHEN möchten?",
      "msg_expense_deleted": "Ausgabendatensatz erfolgreich gelöscht.",
      "tab_pending": "AUSSTEHEND",
      "tab_approved": "GENEHMIGT",
      "tab_rejected": "ABGELEHNT",
      "btn_new_expense": "NEUE AUSGABEN EINGEBEN",
      "lbl_loading": "AUSGABEN WERDEN GELADEN...",
      "msg_no_expenses_category_html": "KEINE AUSGABENERKLÄRUNGEN IN DIESER KATEGORIE.",
      "col_personnel": "PERSONAL",
      "col_category_date": "KATEGORIE & DATUM",
      "col_amount": "BETRAG",
      "col_receipt": "BELEG / RECHNUNG",
      "col_description": "BESCHREIBUNG / NOTIZ",
      "col_actions": "AKTIONEN",
      "badge_added_to_payroll": "ZUR LOHNABRECHNUNG HINZUGEFÜGT",
      "lbl_no_doc": "KEIN DOKUMENT",
      "lbl_action_completed": "AKTION ABGESCHLOSSEN",
      "tooltip_delete_req": "Meine Anfrage löschen",
      "lbl_no_action_needed": "KEINE AKTION ERFORDERLICH",
      "lbl_expense_date": "Ausgabendatum",
      "lbl_desc_details": "Beschreibung / Details",
      "lbl_personnel_name": "PERSONAL:",
      "prompt_reject_reason": "Bitte geben Sie den Grund für die Ablehnung ein (Optional):",
      "prompt_reject_default": "Belegbild ist unleserlich oder entspricht nicht dem Standard.",
      "err_fetch_tickets": "Tickets konnten nicht abgerufen werden.",
      "err_fetch_details": "Ticketdetails konnten nicht abgerufen werden.",
      "msg_creating_ticket": "Support-Ticket wird erstellt...",
      "msg_ticket_created": "Ihr Ticket wurde erfolgreich erstellt.",
      "err_create_ticket": "Beim Erstellen des Tickets ist ein Fehler aufgetreten.",
      "msg_sending_msg": "Nachricht wird gesendet...",
      "lbl_file_attached": "Bitte überprüfen Sie die angehängte Datei.",
      "msg_msg_sent": "Nachricht gesendet!",
      "err_send_msg": "Nachricht konnte nicht gesendet werden.",
      "msg_confirm_resolve": "Möchten Sie dieses Ticket als GELÖST markieren? Diese Aktion kann nicht rückgängig gemacht werden und der Chat wird geschlossen.",
      "msg_closing_ticket": "Ticket wird geschlossen...",
      "msg_ticket_closed": "Ticket erfolgreich geschlossen.",
      "err_update_status": "Status konnte nicht aktualisiert werden.",
      "status_open": "OFFEN",
      "status_in_progress": "IN BEARBEITUNG",
      "status_resolved": "GELÖST",
      "cat_payroll": "LOHNABRECHNUNG",
      "cat_it": "IT-SUPPORT",
      "cat_hr": "HR-ANFRAGE",
      "cat_admin": "VERWALTUNG / MATERIAL",
      "btn_create_ticket": "NEUES TICKET ERSTELLEN",
      "lbl_tickets": "TICKETS",
      "lbl_urgent": "DRINGEND",
      "msg_no_tickets_html": "ES GIBT KEINE REGISTRIERTEN<br/>TICKETS IM SYSTEM.",
      "lbl_ticket_no": "TICKET NR:",
      "btn_close_ticket": "TICKET SCHLIESSEN",
      "msg_no_messages": "Bisher keine Nachrichten gesendet.",
      "btn_open_attachment": "ANGEHÄNGTE DATEI ÖFFNEN",
      "lbl_click_to_view": "Klicken, um anzuzeigen",
      "ph_type_reply": "Schreiben Sie eine Antwort...",
      "msg_ticket_closed_comment": "DIESES TICKET IST FÜR KOMMENTARE GESCHLOSSEN, DA ES GELÖST WURDE.",
      "msg_select_ticket_html": "WÄHLEN SIE LINKS EIN TICKET AUS,<br/>UM DETAILS UND NACHRICHTEN ZU SEHEN",
      "modal_title_new_ticket": "NEUES SUPPORT-TICKET",
      "lbl_subject_summary": "ZUSAMMENFASSUNG",
      "ph_subject": "Z.B. Anfrage meiner Gehaltsabrechnung für März 2024",
      "lbl_priority": "PRIORITÄT",
      "prio_low": "NIEDRIG",
      "prio_normal": "NORMAL",
      "prio_urgent": "DRINGEND",
      "lbl_message_details": "IHRE NACHRICHT / DETAILS",
      "ph_ticket_message": "Geben Sie hier Ihre Anfrage ein...",
      "btn_submit_ticket": "TICKET AN SYSTEM SENDEN",
      "err_fetch_requests": "Beim Abrufen der Urlaubsanträge ist ein Fehler aufgetreten.",
      "prompt_reject_reason": "Bitte geben Sie den Grund für die Ablehnung an (Erforderlich):",
      "prompt_reject_default": "Aufgrund der betrieblichen Auslastung nicht möglich.",
      "err_reject_reason_required": "Sie müssen einen Grund angeben, um den Urlaub abzulehnen.",
      "msg_confirm_approve": "Sind Sie sicher, dass Sie diesen Urlaubsantrag GENEHMIGEN möchten?",
      "msg_processing": "Wird verarbeitet und E-Mail gesendet...",
      "action_approved": "genehmigt",
      "action_rejected": "abgelehnt",
      "msg_status_updated": "Urlaubsantrag wurde {{status}}.",
      "err_action_failed": "Während des Vorgangs ist ein Fehler aufgetreten.",
      "err_missing_form_data": "Bitte füllen Sie die Daten und den Grund vollständig aus.",
      "msg_creating_leave": "Ihr Urlaubsantrag wird erstellt...",
      "msg_leave_req_success": "Ihr Urlaubsantrag wurde erfolgreich erstellt und zur Genehmigung eingereicht!",
      "err_leave_submit_failed": "Fehlende Informationen eingegeben oder Vorgang fehlgeschlagen.",
      "err_fetch_summary": "Personalübersicht konnte nicht abgerufen werden.",
      "badge_pending": "AUSSTEHENDE GENEHMIGUNG",
      "badge_approved": "GENEHMIGT",
      "badge_rejected": "ABGELEHNT",
      "badge_unknown": "UNBEKANNT",
      "type_annual": "JAHRESURLAUB (BEZAHLT)",
      "type_excuse": "SONDERURLAUB",
      "type_sick": "KRANKHEITSURLAUB (ATTEST)",
      "type_unpaid": "UNBEZAHLTER URLAUB",
      "tab_pending_approvals": "AUSSTEHENDE GENEHMIGUNGEN",
      "tab_approved_requests": "GENEHMIGT",
      "tab_rejected_requests": "ABGELEHNT",
      "btn_new_leave_req": "NEUER URLAUBSANTRAG",
      "lbl_loading_requests": "ANTRÄGE WERDEN GELADEN...",
      "msg_no_requests_html": "IN DIESER KATEGORIE WURDEN KEINE URLAUBSANTRÄGE GEFUNDEN.",
      "col_personnel": "PERSONAL",
      "col_status": "STATUS",
      "col_leave_type": "URLAUBSART",
      "col_date_range": "DATUMSBEREICH",
      "col_days": "TAGE",
      "col_description": "BESCHREIBUNG / NOTIZ",
      "col_actions": "AKTIONEN",
      "btn_leave_summary": "URLAUBSÜBERSICHT",
      "lbl_cancel_note": "Notiz:",
      "lbl_action_completed": "AKTION ABGESCHLOSSEN",
      "lbl_no_action_needed": "KEINE AKTION ERFORDERLICH",
      "lbl_pending_authorization": "WARTET AUF BERECHTIGUNG",
      "btn_approve": "GENEHMIGEN",
      "btn_reject": "ABLEHNEN",
      "modal_title_create_leave": "URLAUBSANTRAG ERSTELLEN",
      "lbl_leave_type": "Urlaubsart",
      "lbl_start": "Start",
      "lbl_end": "Ende",
      "lbl_calculated_days": "BERECHNETE TAGE:",
      "lbl_days": "TAGE",
      "lbl_reason": "Grund / Beschreibung",
      "ph_leave_reason": "Erklären Sie kurz den Grund für den Urlaub...",
      "btn_cancel": "ABBRECHEN",
      "btn_submit_approval": "ZUR GENEHMIGUNG EINREICHEN",
      "modal_title_leave_summary": "ZUSAMMENFASSUNG URLAUBSANSPRUCH",
      "lbl_total_used_this_year": "DIESES JAHR INSGESAMT GENUTZT",
      "lbl_usage_breakdown": "NUTZUNGSAUFTEILUNG",
      "msg_no_approved_leaves": "Noch keine genehmigten Urlaubseinträge gefunden.",
      "btn_close_window": "FENSTER SCHLIESSEN",
      "err_fetch_locations": "Standorte konnten nicht abgerufen werden.",
      "err_geo_not_supported": "Ihr Browser unterstützt keine Standortdienste (GPS).",
      "msg_geo_success": "Standort erfolgreich ermittelt.",
      "err_geo_failed": "Standort konnte nicht ermittelt werden. Bitte Browser-Berechtigungen prüfen.",
      "msg_saving_location": "Standort wird gespeichert...",
      "msg_location_updated": "Standort erfolgreich aktualisiert.",
      "msg_location_added": "Neuer Standort erfolgreich hinzugefügt.",
      "msg_confirm_delete_location": "Sind Sie sicher, dass Sie den Standort \"{{name}}\" löschen (archivieren) möchten? Dadurch wird sein QR-Code ungültig.",
      "msg_archiving_location": "Standort wird archiviert...",
      "msg_location_deleted": "Standort erfolgreich gelöscht.",
      "err_delete_location": "Beim Löschen des Standorts ist ein Fehler aufgetreten.",
      "msg_confirm_rotate_qr": "WARNUNG: Sind Sie sicher, dass Sie den aktuellen QR-Code für \"{{name}}\" ungültig machen und einen neuen Sicherheitstoken generieren möchten? (Bisherige Poster funktionieren nicht mehr!)",
      "msg_resetting_qr": "QR-Code wird zurückgesetzt...",
      "msg_qr_rotated": "Sicherheitstoken erneuert. Vergessen Sie nicht, das neue Poster herunterzuladen!",
      "err_rotate_qr": "Fehler beim Erneuern des QR-Codes.",
      "msg_preparing_poster": "PDF-Poster wird vorbereitet...",
      "msg_poster_downloaded": "PDF heruntergeladen.",
      "err_poster_failed": "Fehler beim Erstellen des Posters.",
      "lbl_anti_fraud_system": "ANTI-BETRUGS-SYSTEM (GEOFENCING)",
      "desc_anti_fraud_html": "Für jeden hinzugefügten Standort generiert das System ein A4-QR-Poster mit einem <span class='bg-rose-200 text-rose-900 px-2 py-0.5 rounded-md font-black'>Sicherheitstoken</span>. Wenn Personal versucht, ihn aus der Ferne zu scannen, prüft das System das GPS und verweigert den Zutritt.",
      "btn_add_location": "STANDORT HINZUFÜGEN",
      "lbl_loading_locations": "STANDORTE WERDEN GELADEN...",
      "msg_no_locations_html": "KEINE STANDORTE IM SYSTEM REGISTRIERT.",
      "tooltip_reset_qr": "QR-Token zurücksetzen (Anti-Betrug)",
      "tooltip_delete": "Löschen (Archivieren)",
      "lbl_no_address": "Keine Adresse angegeben",
      "lbl_latitude": "BREITENGRAD (LAT)",
      "lbl_longitude": "LÄNGENGRAD (LNG)",
      "lbl_security_radius": "SICHERHEITSRADIUS",
      "lbl_meters": "METER",
      "btn_download_poster": "A4 QR-POSTER HERUNTERLADEN",
      "modal_title_edit_loc": "STANDORT BEARBEITEN",
      "modal_title_new_loc": "NEUEN STANDORT HINZUFÜGEN",
      "lbl_location_name": "STANDORTNAME (z.B. Hauptbüro)",
      "lbl_full_address": "VOLLSTÄNDIGE ADRESSE",
      "ph_optional": "Optional...",
      "lbl_gps_coordinates": "GPS-KOORDINATEN",
      "btn_finding_location": "WIRD GEFUNDEN...",
      "btn_get_my_location": "MEINEN AKTUELLEN STANDORT ABRUFEN",
      "lbl_security_radius_input": "SICHERHEITSRADIUS (IN METERN)",
      "desc_radius_warning": "Wenn Personal diesen Radius verlässt, funktioniert der QR-Code nicht und sie können sich nicht einstempeln.",
      "btn_update_location": "STANDORT AKTUALISIEREN",
      "btn_save_location": "STANDORT IM SYSTEM SPEICHERN",
      "login_failed_generic": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.",
      "server_unreachable": "Server nicht erreichbar. Bitte überprüfen Sie Ihre Verbindung.",
      "login_title": "IKPro Login",
      "email_label": "E-Mail:",
      "password_label": "Passwort:",
      "login_button": "Anmelden",
      "lbl_user": "Benutzer",
      "role_superadmin": "SYSTEMADMINISTRATOR",
      "role_admin": "PERSONALWESEN (MANAGER)",
      "role_hr": "PERSONALWESEN (SPEZIALIST)",
      "role_manager": "ABTEILUNGSLEITER",
      "role_employee_short": "PERSONAL",
      "lbl_notifications": "BENACHRICHTIGUNGEN",
      "lbl_new": "NEU",
      "msg_no_new_notifs": "KEINE NEUEN BENACHRICHTIGUNGEN",
      "lbl_leave_requests": "URLAUBSANTRÄGE",
      "lbl_items": "Stück",
      "msg_leave_waiting": "Urlaubsantrag/-anträge warten auf Genehmigung.",
      "lbl_expense_requests": "SPESENANTRÄGE",
      "msg_expense_waiting": "Spesenabrechnung(en) warten auf Genehmigung.",
      "lbl_open_tickets": "OFFENE TICKETS",
      "msg_ticket_waiting": "offene Support-Ticket(s).",
      "btn_view_all_dashboard": "ALLE ANSEHEN (ZUM DASHBOARD)",
      "lbl_logged_in": "ANGEMELDET",
      "btn_secure_logout": "SICHER ABMELDEN",
      "tooltip_drag_to_move": "Zum Bewegen ziehen",
      "tooltip_edit_position": "POSITION BEARBEITEN",
      "tooltip_delete_position": "POSITION LÖSCHEN",
      "lbl_vacant_position": "VAKANTE POSITION",
      "lbl_filled_positions": "BESETZTE POSITIONEN",
      "lbl_employee_count": "MITARBEITERZAHL",
      "err_fetch_org_data": "Organigramm-Daten konnten nicht geladen werden.",
      "msg_confirm_delete_pos": "Sind Sie sicher, dass Sie diese Position löschen möchten? Untergeordnete Positionen und Personal können betroffen sein.",
      "msg_deleting_pos": "Position wird gelöscht...",
      "msg_delete_success": "Position erfolgreich gelöscht.",
      "err_delete_pos_failed": "Position konnte nicht gelöscht werden (enthält möglicherweise Personal).",
      "msg_creating_dept": "Abteilung wird erstellt...",
      "msg_dept_added": "Neue Abteilung ins System aufgenommen.",
      "err_add_dept": "Abteilung konnte nicht hinzugefügt werden.",
      "err_hierarchy_loop": "HIERARCHIE-FEHLER: Sie können eine übergeordnete Position nicht mit einer ihr untergeordneten Position verknüpfen!",
      "msg_confirm_move_pos": "Sind Sie sicher, dass Sie diese Position einem neuen Vorgesetzten zuordnen möchten?",
      "msg_updating_org": "Organisation wird aktualisiert...",
      "msg_move_success": "Position erfolgreich verschoben.",
      "err_move_failed": "Beim Verschieben der Position ist ein Fehler aufgetreten.",
      "err_select_dept": "Bitte wählen Sie eine Abteilung aus!",
      "err_self_parent": "Sie können eine Position nicht mit sich selbst verknüpfen!",
      "msg_saving_pos": "Position wird gespeichert...",
      "msg_update_pos_success": "Position aktualisiert.",
      "msg_create_pos_success": "Neue Position erstellt.",
      "lbl_drag_drop_info": "SIE KÖNNEN POSITIONEN ZIEHEN UND ABLEGEN, UM SIE ZU VERKNÜPFEN",
      "btn_create_dept": "ABTEILUNG HINZUFÜGEN",
      "btn_create_position": "POSITION HINZUFÜGEN",
      "lbl_loading_chart": "ORGANIGRAMM WIRD ERSTELLT...",
      "msg_empty_org_chart_html": "NOCH KEINE POSITIONEN IM SYSTEM.<br/>ERSTELLEN SIE ZUERST EINE ABTEILUNG, DANN DIE ERSTE POSITION.",
      "modal_title_new_dept": "NEUE ABTEILUNG HINZUFÜGEN",
      "lbl_department_name": "ABTEILUNGSNAME",
      "ph_department_name": "Z.B.: INFORMATIONSTECHNOLOGIE",
      "btn_save_dept": "ABTEILUNG SPEICHERN",
      "modal_title_edit_pos": "POSITION AKTUALISIEREN",
      "modal_title_new_pos": "NEUE POSITION DEFINIEREN",
      "lbl_position_name": "POSITION / TITEL",
      "ph_position_name": "Z.B.: FELDINGENIEUR",
      "lbl_belongs_to_dept": "GEHÖRT ZUR ABTEILUNG",
      "lbl_parent_position": "ÜBERGEORDNETE POSITION (BERICHTET AN)",
      "opt_top_management": "TOP-MANAGEMENT (KEIN VORGESETZTER)",
      "desc_parent_pos_info": "Urlaubsanträge von Mitarbeitern dieser Position gehen an die gewählte übergeordnete Position.",
      "btn_save_changes": "ÄNDERUNGEN SPEICHERN",
      "btn_save_to_system": "IM SYSTEM SPEICHERN",
      "err_select_personnel": "Bitte wählen Sie zuerst einen Mitarbeiter aus!",
      "msg_ai_success": "KI-9-Box-Analyse abgeschlossen.",
      "err_ai_failed": "KI-Analyse konnte momentan nicht erstellt werden.",
      "msg_goal_updated": "Ziel aktualisiert.",
      "msg_goal_added": "Neues Ziel zugewiesen.",
      "err_goal_saved": "Ziel konnte nicht gespeichert werden!",
      "confirm_delete_goal": "Sind Sie sicher, dass Sie dieses Ziel löschen möchten?",
      "msg_goal_deleted": "Ziel gelöscht.",
      "err_goal_deleted": "Ziel konnte nicht gelöscht werden!",
      "msg_progress_saved": "Fortschritt gespeichert.",
      "err_progress_update": "Fortschritt konnte nicht aktualisiert werden!",
      "msg_review_updated": "Bewertung aktualisiert.",
      "msg_review_saved": "Bewertung gespeichert.",
      "err_review_failed": "Fehler bei der Bewertung!",
      "confirm_delete_review": "Sind Sie sicher, dass Sie diese Bewertung löschen möchten?",
      "msg_review_deleted": "Bewertung gelöscht.",
      "err_review_deleted": "Bewertung konnte nicht gelöscht werden.",
      "tab_okr": "ZIELE (OKR)",
      "tab_360": "360°-BEWERTUNG",
      "tab_ai": "KI-TALENT-ANALYSE",
      "opt_select_personnel": "PERSONAL WÄHLEN",
      "lbl_eval_center": "BEWERTUNGSZENTRUM",
      "msg_select_personnel": "BITTE WÄHLEN SIE EIN PERSONAL, UM FORTZUFAHREN.",
      "lbl_strategic_goals": "STRATEGISCHE ZIELE",
      "btn_add_goal": "NEUES ZIEL HINZUFÜGEN",
      "msg_no_goals": "SIE HABEN NOCH KEINE ZUGEWIESENEN ZIELE.",
      "lbl_progress": "AKTUELLER FORTSCHRITT",
      "msg_ai_analyzing": "KI-DATENANALYSE LÄUFT...",
      "lbl_9box_matrix": "9-BOX POTENZIAL-/LEISTUNGSMATRIX",
      "lbl_ai_summary": "KI-MANAGER-ZUSAMMENFASSUNG",
      "lbl_dev_suggestion": "Entwicklungsvorschlag",
      "val_fast_promo": "Schnelle Beförderung / Führungstraining",
      "lbl_risk_analysis": "Risikoanalyse",
      "val_low_risk": "Niedrig (Hohes Engagement)",
      "msg_press_to_analyze": "Drücken Sie die Taste, um die Analyse zu starten.",
      "btn_run_analysis": "ANALYSE STARTEN",
      "box_STAR": "STAR",
      "box_HIGH_POTENTIAL": "HOHES POTENZIAL",
      "box_ENIGMA": "ENIGMA",
      "box_HIGH_PERFORMER": "HIGH PERFORMER",
      "box_CORE_EMPLOYEE": "KERNE-MITARBEITER",
      "box_DILEMMA": "DILEMMA",
      "box_SOLID_PERFORMER": "SOLIDER PERFORMER",
      "box_EFFECTIVE_EMPLOYEE": "EFFEKTIVER MITARBEITER",
      "box_UNDER_PERFORMER": "UNDERPERFORMER",
      "lbl_feedback_pool": "FEEDBACK-POOL",
      "btn_score": "BEWERTEN",
      "msg_no_reviews": "KEINE VERGANGENEN BEWERTUNGEN.",
      "lbl_peer_note": "Kollegen-Notiz",
      "modal_review_title": "LEISTUNGSBEWERTUNG",
      "lbl_review_period": "Bewertungszeitraum",
      "opt_q1": "2026 Q1",
      "opt_q2": "2026 Q2",
      "opt_q3": "2026 Q3",
      "opt_q4": "2026 Q4",
      "opt_custom_period": "Eigener Zeitraum...",
      "ph_custom_period": "Z.B. 2026 Jahresendbewertung",
      "lbl_rating": "Gesamtbewertung (1-5)",
      "lbl_manager_comments": "Kommentare des Managers",
      "ph_manager_comments": "Schreiben Sie hier Ihre Notizen zu den Stärken und Entwicklungsbereichen des Mitarbeiters...",
      "btn_cancel": "ABBRECHEN",
      "btn_save_score": "PUNKTE SPEICHERN",
      "modal_goal_title": "ZIELPARAMETER",
      "lbl_goal_title": "Titel des Ziels",
      "lbl_goal_desc": "Details",
      "lbl_due_date": "Fälligkeitsdatum",
      "opt_end_q1": "Ende 2026-Q1",
      "opt_end_q2": "Ende 2026-Q2",
      "opt_end_q3": "Ende 2026-Q3",
      "opt_end_q4": "Ende 2026-Q4",
      "opt_custom_date": "Eigenes Datum...",
      "btn_save": "SPEICHERN",
      "err_unauthorized_access": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen!",
      "err_fill_all_fields": "Bitte füllen Sie alle Felder aus.",
      "err_pwd_length": "Ihr Passwort muss mindestens 6 Zeichen lang sein.",
      "msg_creating_account": "Ihr Konto und Unternehmensprofil werden erstellt...",
      "msg_registration_success": "Registrierung erfolgreich! Ihre 30-Tage-Testversion hat begonnen.",
      "err_registration_failed": "Während der Registrierung ist ein Fehler aufgetreten.",
      "lbl_welcome_title_html": "WILLKOMMEN BEI<br/>KTC HR",
      "lbl_welcome_desc": "Sie stehen kurz davor, alle Ihre Personal-, Leistungs-, Anlagen- und Betriebsprozesse unter einem Dach zu verwalten.",
      "lbl_feature_1": "30 Tage kostenlose Testversion",
      "lbl_feature_2": "Unbegrenzte Mitarbeiter",
      "lbl_feature_3": "Jederzeit kündbar",
      "lbl_step_company": "Firma",
      "lbl_step_payment": "Zahlung",
      "lbl_corporate_info": "Unternehmensinformationen",
      "lbl_company_org_name": "Firmen- / Organisationsname",
      "ph_company_name": "Z.B.: Tech Solutions GmbH",
      "lbl_manager_name": "Vollständiger Name des Managers",
      "ph_manager_name": "Vollständiger Name",
      "lbl_business_email": "Geschäftliche E-Mail-Adresse",
      "ph_business_email": "admin@firma.com",
      "lbl_account_password": "Konto-Passwort",
      "ph_password": "Mindestens 6 Zeichen",
      "btn_proceed_payment": "ZUR ZAHLUNG",
      "msg_already_have_account": "Haben Sie bereits ein Konto?",
      "btn_login_link": "Anmelden",
      "lbl_payment_method": "Zahlungsmethode",
      "lbl_ssl_secure": "256-BIT SSL SICHER",
      "lbl_card_holder_display": "KARTENINHABER",
      "lbl_full_name_display": "NAME",
      "lbl_expiry_display": "ABLAUF",
      "lbl_mm_yy_display": "MM/JJ",
      "lbl_card_name": "Name auf der Karte",
      "ph_card_name": "Name des Karteninhabers",
      "lbl_card_number": "Kartennummer",
      "lbl_expiry_date": "Ablaufdatum",
      "ph_expiry_date": "MM/JJ",
      "lbl_security_code": "Sicherheitscode",
      "ph_security_code": "CVC",
      "msg_no_charge_warning": "* Ihre Kreditkarte wird während der 30-tägigen Testphase <strong class='text-indigo-600'>nicht belastet.</strong>",
      "btn_back": "ZURÜCK",
      "btn_complete_and_start": "REGISTRIERUNG ABSCHLIESSEN & STARTEN",
      "lbl_loading": "LÄDT...",
      "role_superadmin": "SYSTEMADMINISTRATOR",
      "role_admin": "PERSONALWESEN (MANAGER)",
      "role_hr": "PERSONALWESEN (SPEZIALIST)",
      "role_manager": "ABTEILUNGSLEITER",
      "role_employee_short": "PERSONAL",
      "menu_dashboard": "KOKPİT",
      "menu_employees": "PERSONALVERWALTUNG",
      "menu_org_chart": "ORGANIGRAMM",
      "menu_ats": "BEWERBERMANAGEMENT (ATS)",
      "menu_attendance": "ZEITERFASSUNG",
      "menu_operations_time": "BETRIEB / ZEITERFASSUNG",
      "menu_locations": "STANDORTE & BEREICHE",
      "menu_leaves": "URLAUBSVERWALTUNG",
      "menu_dossier": "E-AKTE ARCHIV",
      "menu_performance": "LEISTUNG (OKR)",
      "menu_training": "SCHULUNG (LMS)",
      "menu_expenses": "SPESENVERWALTUNG",
      "menu_assets": "INVENTAR & GERÄTE",
      "menu_helpdesk": "HELPDESK",
      "menu_portal": "KOKPİT",
      "menu_my_team": "MEIN TEAM (PERSONAL)",
      "menu_settings": "FIRMENEINSTELLUNGEN (NEU)",
      "operations_time_kicker": "Betrieb / Zeiterfassung",
      "operations_time_title": "Zeiterfassung und Lohnabrechnung",
      "operations_time_desc": "Feiertage, Pay-Code-Freigaben, Zeiterfassungsperioden und Exportprofile zentral verwalten.",
      "schedule_management_kicker": "Schichtplanung",
      "schedule_management_title": "Schichtpläne und Zuweisungen",
      "schedule_management_desc": "Schichtvorlagen erstellen, Abteilungen zuweisen und Mitarbeiterausnahmen verwalten.",
      "schedule_management_open": "Schichtplanung öffnen",
      "operations_time_tab_puantaj": "Zeiterfassung",
      "operations_time_tab_schedules": "Schichtplanung",
      "operations_time_tab_leave": "Urlaubseinstellungen",
      "operations_time_tab_departments": "Abteilungszuweisungen",
      "operations_time_tab_overrides": "Mitarbeiterausnahmen",
      "operations_time_tab_reports": "Lohnabrechnungsbericht",
      "operations_time_tab_settings": "Zeiterfassungseinstellungen",
      "operations_time_tabs": "Zeiterfassungsregister",
      "pay_code_title": "Freigabe von Lohncodes und Faktoren",
      "pay_code_desc": "Nicht freigegebene Faktoren werden nicht exportiert.",
      "pay_code_seed": "Standardwerte erstellen",
      "pay_code_add": "Vorschlagen",
      "pay_code_category": "Kategorie",
      "pay_code_code": "Code",
      "pay_code_name": "Beschreibung",
      "pay_code_accounting_code": "Buchhaltungscode",
      "pay_code_coefficient": "Faktor",
      "pay_code_unit": "Einheit",
      "pay_code_status_approved": "Freigegeben",
      "pay_code_status_proposed": "Freigabe ausstehend",
      "pay_code_status_rejected": "Abgelehnt",
      "pay_code_category_work": "Arbeit",
      "pay_code_category_overtime": "Überstunden",
      "pay_code_category_holiday": "Feiertag",
      "pay_code_category_leave": "Urlaub",
      "pay_code_category_absence": "Abwesenheit",
      "payroll_export_title": "Lohnabrechnung-Exportprofil",
      "payroll_export_desc": "Ohne freigegebenes Profil kann kein Buchhaltungsformat verwendet werden.",
      "payroll_export_provider": "Anbieter",
      "payroll_export_format": "Format",
      "payroll_export_delimiter": "Trennzeichen",
      "payroll_export_date_format": "Datumsformat",
      "payroll_export_propose": "Vorschlagen",
      "payroll_export_approve": "Freigeben",
      "payroll_export_status_approved": "Freigegeben",
      "payroll_export_status_proposed": "Freigabe ausstehend",
      "timesheet_title": "Zeiterfassung berechnen und exportieren",
      "timesheet_desc": "Berechnen, zur Freigabe senden, sperren und exportieren.",
      "timesheet_start": "Beginn",
      "timesheet_end": "Ende",
      "timesheet_create": "Erstellen",
      "timesheet_calculate": "Berechnen",
      "timesheet_send_approval": "Zur Freigabe senden",
      "timesheet_approve": "Freigeben",
      "timesheet_lock": "Sperren",
      "timesheet_export": "Exportieren",
      "timesheet_status": "Status",
      "timesheet_status_draft": "Entwurf",
      "timesheet_status_calculated": "Berechnet",
      "timesheet_status_pending": "Freigabe ausstehend",
      "timesheet_status_approved": "Freigegeben",
      "timesheet_status_locked": "Gesperrt",
      "timesheet_status_exported": "Exportiert",
      "timesheet_calculated": "Zeiterfassung berechnet.",
      "timesheet_sent_approval": "Zur Freigabe gesendet.",
      "timesheet_approved": "Zeiterfassung freigegeben.",
      "timesheet_locked": "Zeiterfassung gesperrt.",
      "refresh": "Aktualisieren",
      "holiday_source_system": "System",
      "holiday_source_company": "Unternehmen",
      "menu_logout": "SICHER ABMELDEN",
      "menu_audit_logs": "SYSTEMPROTOKOLLE",
      "audit_logs_title": "SYSTEMPROTOKOLLE",
      "audit_logs_subtitle": "ZENTRALE PRÜFANSICHT FÜR SUPERADMINS",
      "audit_logs_records": "EINTRÄGE",
      "audit_filter_company": "ALLE FIRMEN",
      "audit_filter_action": "ALLE AKTIONEN",
      "audit_filter_resource": "ALLE MODULE",
      "audit_filter_employee": "ALLE PERSONEN",
      "audit_filter_department": "ALLE ABTEILUNGEN",
      "audit_apply_filters": "FILTERN",
      "audit_reset_filters": "ZURÜCKSETZEN",
      "audit_col_datetime": "DATUM / UHRZEIT",
      "audit_col_company": "FIRMA",
      "audit_col_person": "PERSON",
      "audit_col_department": "ABTEILUNG",
      "audit_col_detail": "DETAIL",
      "audit_col_action": "AKTION",
      "audit_col_module": "MODUL",
      "audit_col_status": "STATUS",
      "audit_col_path": "ENDPUNKT",
      "audit_loading": "PROTOKOLLE WERDEN GELADEN...",
      "audit_empty": "KEINE EINTRÄGE FÜR DIE AUSGEWÄHLTEN FILTER GEFUNDEN",
      "err_fetch_audit_filters": "Protokollfilter konnten nicht geladen werden.",
      "err_fetch_audit_logs": "Protokolle konnten nicht geladen werden.",
      "audit_detail_view_logs": "Systemprotokolle angesehen",
      "audit_detail_clock_in": "Mit QR und Standort eingestempelt",
      "audit_detail_clock_out": "Mit QR und Standort ausgestempelt",
      "audit_detail_bulk_attendance": "Massenhafte Anwesenheitsdaten hochgeladen",
      "audit_detail_schedule_create": "Dienstplan erstellt",
      "audit_detail_schedule_update": "Dienstplan aktualisiert",
      "audit_detail_schedule_delete": "Dienstplan gelöscht",
      "audit_detail_schedule_assign_departments": "Dienstpläne an Abteilungen zugewiesen",
      "audit_detail_schedule_assign_employees": "Sonderpläne an Mitarbeiter zugewiesen",
      "audit_detail_schedule_clear_employees": "Mitarbeiter-Ausnahmen entfernt",
      "audit_detail_document_upload": "Dokument hochgeladen",
      "audit_detail_document_status": "Dokumentenstatus aktualisiert",
      "audit_detail_expense_create": "Spesenantrag erstellt",
      "audit_detail_expense_status": "Spesenstatus aktualisiert",
      "audit_detail_leave_create": "Urlaubsantrag erstellt",
      "audit_detail_leave_status": "Urlaubsstatus aktualisiert",
      "audit_detail_helpdesk_create": "Helpdesk-Ticket erstellt",
      "audit_detail_helpdesk_message": "Helpdesk-Nachricht gesendet",
      "audit_detail_helpdesk_status": "Helpdesk-Status aktualisiert",
      "audit_detail_location_create": "Standort erstellt",
      "audit_detail_location_update": "Standort aktualisiert",
      "audit_detail_location_rotate_qr": "Standort-QR erneuert",
      "audit_detail_location_poster": "QR-Poster heruntergeladen",
      "audit_detail_asset_assign": "Asset zugewiesen",
      "audit_detail_asset_return": "Asset zurückgenommen",
      "audit_detail_offer_letter": "Angebotsschreiben erstellt",
      "audit_detail_failed_suffix": "aber die Anfrage ist fehlgeschlagen",
      "demo_goal_description": "Beispielhaftes OKR-Ziel für diesen Mitarbeiter",
      "demo_manager_review": "Beispielhafte Führungskräftebewertung: Zielverfolgung und Teamkommunikation sind positiv.",
      "demo_peer_review": "Beispielhaftes Kollegenfeedback: unterstützend und verantwortungsbewusst.",
      "err_fetch_data": "Fehler beim Laden der Daten aufgetreten.",
      "draft_cancel_msg": "Liebe Kolleginnen und Kollegen,\n\nunsere Schulung mit dem Titel \"{{title}}\", die für den {{date}} geplant war, wurde abgesagt.\n\nVielen Dank für Ihr Verständnis.",
      "msg_training_scheduled": "Neue Schulung erfolgreich geplant.",
      "err_schedule_training": "Schulung konnte nicht geplant werden!",
      "err_select_min_one_emp": "Bitte wählen Sie mindestens 1 Mitarbeiter aus.",
      "msg_assigning_sending": "Personal wird zugewiesen und E-Mails werden gesendet...",
      "msg_assigned_invited": "Personal zugewiesen und Einladungen gesendet!",
      "err_assign_failed": "Zuweisungsvorgang fehlgeschlagen.",
      "msg_canceling_sending": "Stornierung und E-Mails werden gesendet...",
      "msg_training_canceled": "Schulung abgesagt und Teilnehmer benachrichtigt.",
      "err_cancel_failed": "Stornierungsvorgang fehlgeschlagen.",
      "msg_confirm_delete_training": "Sind Sie sicher, dass Sie diese Schulung vollständig aus dem System löschen möchten?",
      "msg_training_deleted": "Schulung aus dem System gelöscht.",
      "err_delete_training": "Schulung konnte nicht gelöscht werden.",
      "msg_attendance_updated": "Anwesenheitsstatus aktualisiert.",
      "err_attendance_update": "Anwesenheit konnte nicht aktualisiert werden!",
      "err_no_data_download": "Keine Daten zum Herunterladen gefunden.",
      "csv_headers": "Schulungsname,Datum,Trainer,Mitarbeitername,Abteilung,Anwesenheitsstatus\n",
      "msg_excel_downloaded": "Excel-Datei heruntergeladen.",
      "btn_schedule_training": "NEUE SCHULUNG PLANEN",
      "msg_no_trainings_scheduled": "NOCH KEINE SCHULUNGEN GEPLANT.",
      "badge_cancelled": "ABGESAGT",
      "badge_completed": "ABGESCHLOSSEN",
      "badge_approaching": "BEVORSTEHEND",
      "tooltip_delete": "Löschen",
      "lbl_no_description": "Keine Beschreibung verfügbar.",
      "lbl_instructor": "TRAINER",
      "lbl_date": "DATUM",
      "lbl_time": "UHRZEIT",
      "lbl_participants": "TEILNEHMER",
      "lbl_persons": "PERSONEN",
      "btn_assign_personnel": "PERSONAL ZUWEISEN",
      "err_no_participants_assigned": "Dieser Schulung ist niemand zugewiesen.",
      "btn_take_attendance": "ANWESENHEIT PRÜFEN",
      "btn_cancel": "ABBRECHEN",
      "modal_title_schedule_training": "NEUE SCHULUNG PLANEN",
      "lbl_training_title": "SCHULUNGSTITEL / THEMA",
      "ph_training_title": "Z.B. Fortgeschrittenes Excel-Training",
      "lbl_training_desc": "BESCHREIBUNG",
      "ph_training_desc": "Kurze Info zum Schulungsinhalt...",
      "ph_instructor": "Z.B. Max Mustermann",
      "lbl_location": "ORT / LINK",
      "ph_location": "Besprechungsraum 1 oder Zoom-Link",
      "btn_save_publish_training": "SCHULUNG SPEICHERN UND VERÖFFENTLICHEN",
      "modal_title_assign_personnel": "PERSONAL ZUR SCHULUNG ZUWEISEN",
      "msg_invitation_will_be_sent": "EINLADUNGS-E-MAIL WIRD AN AUSGEWÄHLTES PERSONAL GESENDET.",
      "btn_assign_and_invite": "{{count}} PERSONAL ZUWEISEN UND EINLADEN",
      "modal_title_attendance_report": "SCHULUNGSANWESENHEIT UND BERICHT",
      "lbl_registered_personnel_list": "LISTE DES REGISTRIERTEN PERSONALS",
      "btn_download_excel": "EXCEL HERUNTERLADEN",
      "msg_no_one_assigned": "DIESER SCHULUNG IST NIEMAND ZUGEWIESEN.",
      "btn_attended": "TEILGENOMMEN",
      "btn_not_attended": "NICHT TEILGENOMMEN",
      "modal_title_cancel_training": "SCHULUNG ABSAGEN",
      "lbl_cancellation_draft": "ENTWURF DER ABSAGEBENACHRICHTIGUNG",
      "msg_cancellation_warning": "DIE FOLGENDE ABSAGEMELDUNG WIRD AN ALLE FÜR DIESE SCHULUNG REGISTRIERTEN MITARBEITER PER E-MAIL GESENDET. SIE KÖNNEN DEN TEXT BEARBEITEN.",
      "lbl_cancel_email_content": "INHALT DER ABSAGE-E-MAIL",
      "btn_cancel_and_notify": "ABSAGEN UND ALLE BENACHRICHTIGEN",
      "title_leave_management": "Urlaubsverwaltung",
      "desc_leave_management_wip": "Urlaubsanträge und der Genehmigungsprozess werden hier angezeigt.",
      "badge_under_construction": "Im Aufbau",
      "mfa_title": "Sicherheitsüberprüfung",
      "mfa_subtitle": "Bitte geben Sie den 6-stelligen Code ein, der an Ihre E-Mail-Adresse gesendet wurde.",
      "otp_code_label": "BESTÄTIGUNGSCODE",
      "forgot_password": "Passwort vergessen",
      "lbl_system_subtitle": "Willkommen beim sicheren Personalverwaltungssystem.",
      "btn_back_to_login": "Zurück zum Login",
      "invalid_mfa_code": "Ungültiger oder abgelaufener Bestätigungscode!",
      "password_too_short": "Passwort ist zu kurz (Muss mindestens 8 Zeichen lang sein).",
      "password_too_weak": "Passwort ist zu schwach (Muss Groß-, Kleinbuchstaben und Zahlen enthalten).",
      "password_no_special_char": "Passwort muss mindestens ein Sonderzeichen enthalten (@$!%*?&).",
      "email_already_in_use": "Diese E-Mail-Adresse wird bereits verwendet.",
      "default_department_name": "Geschäftsführung",
      "default_position_title": "Gründer / Manager",
      "registration_successful": "Registrierung erfolgreich abgeschlossen.",
      "registration_error": "Während der Registrierung ist ein unerwarteter Fehler aufgetreten.",
      "invalid_credentials": "E-Mail-Adresse oder Passwort ungültig.",
      "account_suspended": "Ihr Konto wurde gesperrt. Bitte kontaktieren Sie den Administrator.",
      "mfa_code_sent": "Sicherheitscode wurde an Ihre E-Mail-Adresse gesendet.",
      "mfa_code_expired": "Sicherheitscode ist abgelaufen. Bitte melden Sie sich erneut an.",
      "reset_email_sent_if_exists": "Wenn ein Konto existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.",
      "btn_verify_code": "CODE BESTÄTIGEN",
      "btn_back": "ZURÜCK",
      "lbl_new_password": "Ihr neues Passwort",
      "btn_send_code": "Zurücksetzungscode senden",
      "btn_reset_password": "Passwort aktualisieren",
      "lbl_remembered_password": "Erinnern Sie sich an Ihr Passwort?",
      "msg_password_reset_success": "Ihr Passwort wurde erfolgreich aktualisiert! Sie können sich jetzt anmelden.",
      "err_password_match": "Passwörter stimmen nicht überein.",
      "msg_password_updated": "Ihr Passwort wurde erfolgreich aktualisiert.",
      "idle_warning_title": "Sind Sie noch da?",
      "idle_warning_desc": "Aus Sicherheitsgründen läuft Ihre Sitzung aufgrund von Inaktivität in Kürze ab.",
      "btn_stay_logged_in": "Ich bin hier, angemeldet bleiben",
      "btn_logout_now": "Jetzt abmelden",
      "idle_warning_title": "Sind Sie noch da?",
      "idle_warning_desc": "Aus Sicherheitsgründen läuft Ihre Sitzung aufgrund von Inaktivität in Kürze ab.",
      "btn_stay_logged_in": "Ich bin hier, angemeldet bleiben",
      "btn_logout_now": "Jetzt abmelden",
      "btn_clock_in": "EINSTECHEN",
      "btn_clock_out": "AUSTECHEN",
      "msg_getting_location": "Standort wird ermittelt...",
      "err_gps_not_supported": "Ihr Browser unterstützt kein GPS!",
      "err_location_denied": "Bitte erlauben Sie den Standortzugriff!",
      "msg_clock_in_success": "Erfolgreich eingestochen!",
      "msg_clock_out_success": "Erfolgreich ausgestochen!",
      "err_geofence_failed": "Standortverifizierung fehlgeschlagen!",
      "msg_exporting": "Wird exportiert...",
      "msg_export_success": "Datei erfolgreich heruntergeladen!",
      "err_export_failed": "Export fehlgeschlagen.",
      "btn_export_excel": "EXCEL",
      "btn_export_csv": "CSV",
      "btn_export_pdf": "PDF",
      "btn_send_email": "E-MAIL",
      "lbl_email_modal_title": "BERICHT SENDEN",
      "ph_enter_email": "EMPFÄNGER E-MAIL",
      "lbl_format": "FORMAT WÄHLEN",
      "btn_cancel": "ABBRECHEN",
      "btn_send": "SENDEN",
      "err_empty_email": "Bitte geben Sie eine E-Mail-Adresse ein.",
      "msg_sending_email": "E-Mail wird gesendet...",
      "msg_email_queued": "E-Mail erfolgreich in die Warteschlange gestellt!",
      "err_email_failed": "E-Mail konnte nicht gesendet werden.",
      "file_attendance": "Anwesenheit",
      "sheet_attendance": "Anwesenheitsbericht",
      "msg_employee_attendance_wip": "Mitarbeiter-Anwesenheitsbildschirm befindet sich im Aufbau...",
      "err_fetch_my_attendance": "Vergangene Datensätze konnten nicht abgerufen werden.",
      "err_no_geolocation": "Ihr Browser unterstützt keine Geolokalisierung.",
      "err_location_denied": "Standortzugriff verweigert oder nicht verfügbar. Bitte aktivieren Sie die Standortberechtigungen in Ihrem Browser.",
      "msg_getting_location": "Ihr Standort wird ermittelt, bitte warten...",
      "msg_verifying_location": "Standort wird überprüft...",
      "msg_validating_qr_location": "QR-Code und Standort werden geprüft...",
      "msg_success": "Vorgang erfolgreich!",
      "msg_attendance_completed": "Zeiterfassung erfolgreich abgeschlossen.",
      "msg_requesting_camera": "Kameraberechtigung wird angefordert...",
      "msg_scan_qr_prompt": "Halten Sie den QR-Code in die Kamera. Kamera- und Standortberechtigung sind erforderlich.",
      "msg_qr_detected": "QR-Code erkannt. Standort wird geprüft...",
      "err_action_failed": "Vorgang fehlgeschlagen.",
      "err_camera_not_supported": "Dieser Browser unterstützt keinen Kamerazugriff. Bitte verwenden Sie ein anderes Gerät oder einen anderen Browser.",
      "err_camera_qr_not_supported": "Dieser Browser unterstützt kein QR-Scannen per Kamera. Bitte verwenden Sie einen aktuellen Chrome- oder Edge-Browser.",
      "err_camera_denied": "Ohne Kameraberechtigung kann keine Zeiterfassung durchgeführt werden.",
      "err_camera_denied_persisted": "Ohne Kameraberechtigung kann keine Zeiterfassung durchgeführt werden. Bitte aktivieren Sie die Kameraberechtigung in den Browsereinstellungen und versuchen Sie es erneut.",
      "err_qr_scan_failed": "QR-Code konnte nicht gelesen werden. Bitte versuchen Sie es erneut.",
      "btn_clock_in_large": "EINSTEMPELN",
      "btn_clock_out_large": "AUSSTEMPELN",
      "lbl_gps_required": "GPS ERFORDERLICH",
      "lbl_camera_gps_required": "KAMERA + GPS ERFORDERLICH",
      "attendance_qr_modal_title_in": "MIT QR EINSTEMPELN",
      "attendance_qr_modal_title_out": "MIT QR AUSSTEMPELN",
      "attendance_qr_modal_subtitle": "Kamera- und Standortberechtigung sind erforderlich",
      "attendance_qr_security_title": "Sichere Zeiterfassung",
      "attendance_qr_security_desc": "QR-Scan und Live-Standortprüfung werden gemeinsam verwendet, bevor ein Anwesenheitseintrag erstellt wird.",
      "attendance_qr_steps_title": "Schritte",
      "attendance_qr_step_1": "Richten Sie die Kamera auf den aktuellen QR-Code am Standort.",
      "attendance_qr_step_2": "Bestätigen Sie die Standortfreigabe, wenn Ihr Browser danach fragt.",
      "attendance_qr_step_3": "Ein- oder Ausstempeln erfolgt erst, wenn QR-Code und Standort gemeinsam bestätigt sind.",
      "attendance_qr_status_error": "FEHLER",
      "attendance_qr_status_success": "ERFOLGREICH",
      "attendance_qr_status_active": "AKTIVE ERFASSUNG",
      "btn_retry_qr_scan": "ERNEUT VERSUCHEN",
      "btn_cancel_scan": "ABBRECHEN",
      "lbl_my_recent_records": "MEINE LETZTEN DATENSÄTZE (30 TAGE)",
      "nav_dashboard": "KOKPİT",
        "nav_sub_dashboard": "Allgemeine Statistiken",
        "nav_employees": "MITARBEITERVERWALTUNG",
        "nav_sub_employees": "Personal & Belegschaft",
        "nav_org_chart": "ORGANIGRAMM",
        "nav_sub_org_chart": "Hierarchische Struktur",
        "nav_ats": "BEWERBERMANAGEMENT (ATS)",
        "nav_sub_ats": "Rekrutierungsprozess",
        "nav_attendance": "ZEIT & ANWESENHEIT",
        "nav_sub_attendance": "Arbeitszeiterfassung",
        "nav_locations": "STANDORTE & BEREICHE",
        "nav_sub_locations": "Geofence-Verwaltung",
        "nav_leaves": "ABWESENHEITSVERWALTUNG",
        "nav_sub_leaves": "Genehmigungszentrum",
        "nav_dossier": "E-AKTE",
        "nav_sub_dossier": "Digitale Dokumente",
        "nav_performance": "LEISTUNG & TALENT",
        "nav_sub_performance": "OKR & 360°-Feedback",
        "nav_training": "UNTERNEHMENSAKADEMIE",
        "nav_sub_training": "Schulungsverwaltung",
        "nav_expenses": "SPESENVERWALTUNG",
        "nav_sub_expenses": "Budget & Belege",
        "nav_assets": "INVENTARVERWALTUNG",
        "nav_sub_assets": "Bestandsverfolgung",
        "nav_helpdesk": "HELPDESK (IT/HR)",
        "nav_sub_helpdesk": "Interne Anfragen",
        "nav_settings": "SYSTEM- & FIRMENEINSTELLUNGEN",
        "nav_sub_settings": "Verwaltung der Corporate Identity",
        "nav_billing": "ABONNEMENT & ABRECHNUNG",
        "nav_sub_billing": "SaaS-Paketverwaltung",
        "nav_portal": "KOKPİT",
        "nav_sub_portal": "Persönliches Dashboard",
        "nav_my_leaves": "MEINE ABWESENHEITEN",
        "nav_sub_my_leaves": "Persönlicher Urlaubsstatus",
        "nav_my_performance": "MEINE LEISTUNG",
        "nav_sub_my_performance": "Meine Ziele (OKR)",
        "nav_my_training": "MEINE TRAININGS",
        "nav_sub_my_training": "Mein Entwicklungsplan",
        "nav_my_expenses": "MEINE AUSGABEN",
        "nav_sub_my_expenses": "Spesenabrechnungen",
        "nav_my_assets": "MEIN INVENTAR",
        "nav_sub_my_assets": "Firmenausstattung",
        "nav_fallback": "COCKPIT",
        "nav_sub_fallback": "Unternehmensverwaltung",
        "lbl_city_weather": "STADT / WETTER",
        "ph_type_city": "Stadt...",
        "lbl_today": "HEUTE",
      "btn_add_schedule": "SCHICHTPLAN HINZUFÜGEN",
      "btn_assign_special_schedule": "SONDERPLAN ZUWEISEN",
      "btn_collapse_department": "Abteilung einklappen",
      "btn_coming_soon": "BALD VERFÜGBAR",
      "btn_create_schedule": "PLAN ERSTELLEN",
      "btn_expand_department": "Abteilung ausklappen",
      "btn_reset_to_department_default": "AUF ABTEILUNGSSTANDARD ZURÜCKSETZEN",
      "btn_save_department_schedules": "ABTEILUNGSZUWEISUNGEN SPEICHERN",
      "btn_saving": "WIRD GESPEICHERT...",
      "btn_update_schedule": "PLAN AKTUALISIEREN",
      "col_active_people": "AKTIVE PERSONEN",
      "col_check_in": "KOMMEN",
      "col_check_out": "GEHEN",
      "col_date": "DATUM",
      "col_default_schedule": "STANDARDPLAN",
      "col_my_schedule": "MEIN PLAN",
      "col_schedule_hours": "ZEITEN",
      "col_schedule_name": "PLANNAME",
      "col_schedule_rules": "REGELN",
      "col_schedule_type": "TYP",
      "col_schedule_usage": "NUTZUNG",
      "col_total_hours": "GESAMTSTUNDEN",
      "default_repair_done_note": "Reparatur abgeschlossen und zurück ins Lager gebucht.",
      "default_repair_note": "Wegen Störung zur Reparatur gesendet.",
      "desc_assign_after_stock": "Sie können den Vermögenswert zuerst im Lager lassen und später zuweisen.",
      "desc_department_schedule_defaults": "Legen Sie den Standard-Arbeitsplan für jede Abteilung fest.",
      "desc_employee_schedule_override": "Weisen Sie nur Ausnahme-Mitarbeitern einen Sonderplan zu.",
      "desc_work_schedules": "Erstellen Sie feste oder flexible Arbeitspläne für Ihr Unternehmen.",
      "err_department_schedules_save": "Abteilungspläne konnten nicht gespeichert werden.",
      "err_employee_schedule_assign": "Mitarbeiterplan konnte nicht zugewiesen werden.",
      "err_employee_schedule_clear": "Sonderplan des Mitarbeiters konnte nicht entfernt werden.",
      "err_fetch_department_schedules": "Abteilungspläne konnten nicht geladen werden.",
      "err_fetch_employee_overrides": "Mitarbeiter-Ausnahmen konnten nicht geladen werden.",
      "err_fetch_schedules": "Arbeitspläne konnten nicht geladen werden.",
      "err_invalid_date": "Bitte ein gültiges Datum eingeben.",
      "err_schedule_delete": "Arbeitsplan konnte nicht gelöscht werden.",
      "err_schedule_save": "Arbeitsplan konnte nicht gespeichert werden.",
      "err_select_department_schedule": "Bitte für jede Abteilung einen Plan wählen.",
      "err_select_employees": "Bitte zuerst Mitarbeiter auswählen.",
      "err_select_schedule_for_people": "Bitte einen Arbeitsplan für die ausgewählten Mitarbeiter wählen.",
      "info_assign_after_create": "Sie können die Zuweisung nach dem Erstellen des Datensatzes vornehmen.",
      "info_status_route_not_ready": "Dieser Statusablauf ist im Backend noch nicht aktiv.",
      "lbl_active_overrides": "AKTIVE AUSNAHMEN",
      "lbl_break_minutes": "PAUSE (MIN)",
      "lbl_bulk_department_logic": "Der Abteilungsstandard gilt automatisch für die meisten Mitarbeiter.",
      "lbl_core_end": "KERNENDE",
      "lbl_core_start": "KERNBEGINN",
      "lbl_crosses_midnight": "GEHT ÜBER MITTERNACHT",
      "lbl_crosses_midnight_toggle": "Schicht geht über Mitternacht",
      "lbl_department_defaults": "ABTEILUNGSSTANDARDS",
      "lbl_department_filter": "ABTEILUNGSFILTER",
      "lbl_departments_short": "Abt.",
      "lbl_early_leave_after": "SCHWELLE FÜR FRÜHES GEHEN",
      "lbl_early_out": "FRÜHER AUSSTEMPELN",
      "lbl_effective_from": "GÜLTIG AB",
      "lbl_employee_override_logic": "Weisen Sie Ausnahme-Mitarbeitern einen individuellen Sonderplan zu.",
      "lbl_employee_overrides": "MITARBEITER-AUSNAHMEN",
      "lbl_end_time": "ENDZEIT",
      "lbl_grace_in": "TOLERANZ KOMMEN",
      "lbl_grace_in_minutes": "TOLERANZ KOMMEN (MIN)",
      "lbl_grace_out": "TOLERANZ GEHEN",
      "lbl_grace_out_minutes": "TOLERANZ GEHEN (MIN)",
      "lbl_late": "VERSPÄTET",
      "lbl_late_after": "VERSPÄTUNGSSCHWELLE",
      "lbl_loading_department_schedules": "Abteilungspläne werden geladen...",
      "lbl_loading_people": "Mitarbeiter werden geladen...",
      "lbl_loading_schedules": "Arbeitspläne werden geladen...",
      "lbl_no_schedule_type": "Kein Plantyp",
      "lbl_no_target_schedule": "Kein Plan ausgewählt",
      "lbl_ot_after": "ÜBERSTUNDENSCHWELLE",
      "lbl_overtime": "ÜBERSTUNDEN",
      "lbl_overtime_after": "ÜBERSTUNDEN AB",
      "lbl_people": "Personen",
      "lbl_people_short": "Pers.",
      "lbl_position_count": "Positionen",
      "lbl_remaining_leave": "RESTURLAUB",
      "lbl_same_day": "GLEICHER TAG",
      "lbl_schedule_logic": "PLANLOGIK",
      "desc_core_hours": "Definieren Sie bei flexiblen Arbeitszeiten das Kernzeitfenster, in dem Mitarbeitende zwingend im Büro sein sollen.",
      "lbl_schedule_name": "PLANNAME",
      "lbl_schedule_type": "PLANTYP",
      "lbl_selected_people": "AUSGEWÄHLTE PERSONEN",
      "lbl_start_time": "STARTZEIT",
      "lbl_stat_late_days": "VERSPÄTETE TAGE",
      "lbl_stat_present_days": "ANWESENDE TAGE",
      "lbl_stat_total_hours": "GESAMTSTUNDEN",
      "lbl_target_schedule": "ZIELPLAN",
      "lbl_total_plans": "GESAMTPLÄNE",
      "lbl_unknown_department": "Unbekannte Abteilung",
      "lbl_unscheduled": "Nicht geplant",
      "modal_title_edit_schedule": "ARBEITSPLAN BEARBEITEN",
      "modal_title_new_schedule": "NEUER ARBEITSPLAN",
      "msg_assigning_employee_schedule": "Mitarbeiterplan wird zugewiesen...",
      "msg_billing_not_enabled": "Das Abrechnungsmodul ist derzeit nicht aktiv.",
      "msg_billing_passive_banner": "Die Abonnementseite ist bereit, aber die Zahlungsinfrastruktur ist in dieser Umgebung passiv.",
      "msg_clearing_employee_schedule": "Sonderplan des Mitarbeiters wird entfernt...",
      "msg_confirm_clear_employee_schedule": "Möchten Sie die ausgewählten Mitarbeiter wirklich auf den Abteilungsstandard zurücksetzen?",
      "msg_confirm_delete_schedule": "Möchten Sie diesen Arbeitsplan wirklich löschen?",
      "msg_creating_schedule": "Arbeitsplan wird erstellt...",
      "msg_deleting_schedule": "Arbeitsplan wird gelöscht...",
      "msg_department_schedules_saved": "Abteilungspläne gespeichert.",
      "msg_employee_schedule_assigned": "Mitarbeiterplan zugewiesen.",
      "msg_employee_schedule_cleared": "Sonderplan des Mitarbeiters entfernt.",
      "msg_expense_approved": "Spesen genehmigt.",
      "msg_expense_rejected": "Spesen abgelehnt.",
      "msg_hire_pick_org_slot": "Bitte Abteilung und Position für die Einstellung wählen.",
      "msg_no_departments": "Keine Abteilungen gefunden.",
      "msg_no_employee_overrides": "Keine aktiven Mitarbeiter-Ausnahmen.",
      "msg_no_filtered_employees": "Keine Mitarbeiter entsprechen dem Filter.",
      "msg_no_schedules": "Noch keine Arbeitspläne definiert.",
      "msg_saving_department_schedules": "Abteilungspläne werden gespeichert...",
      "msg_schedule_created": "Arbeitsplan erstellt.",
      "msg_schedule_deleted": "Arbeitsplan gelöscht.",
      "msg_schedule_updated": "Arbeitsplan aktualisiert.",
      "msg_updating_schedule": "Arbeitsplan wird aktualisiert...",
      "opt_all_departments": "Alle Abteilungen",
      "opt_fixed": "Fest",
      "opt_flex": "Flexibel",
      "opt_select_position": "Position wählen",
      "opt_select_schedule": "Arbeitsplan wählen",
      "ph_override_reason": "Grund der Ausnahme (optional)",
      "ph_search_employee": "Nach Name, E-Mail oder Telefon suchen...",
      "prompt_repair_done_note": "Notiz nach Reparatur:",
      "prompt_repair_note": "Reparaturnotiz:",
      "status_early_out": "FRÜHER AUS",
      "status_late_early": "SPÄT + FRÜH",
      "tab_attendance_records": "ANWESENHEIT",
      "tab_department_assignments": "ABTEILUNGSZUWEISUNGEN",
      "tab_employee_overrides": "MITARBEITER-AUSNAHMEN",
      "tab_work_schedules": "ARBEITSPLÄNE",
      "tbl_schedule_plan": "Plan",
      "title_department_schedule_defaults": "ABTEILUNGS-ARBEITSPLÄNE",
      "title_employee_schedule_override": "MITARBEITER-PLAN AUSNAHMEN",
      "title_work_schedules": "ARBEITSPLÄNE",
      "btn_schedule_pdf_report": "PDF-BERICHT",
      "btn_participant_report_pdf": "PDF-TEILNEHMERBERICHT",
      "lbl_created_by": "ERSTELLT VON",
      "type_maternity": "MUTTERSCHAFTSURLAUB",
      "unknown_employee": "Unbekannter Mitarbeiter",
      "unknown_user": "Unbekannter Benutzer",
      "violation_early_out": "Früher Ausstieg",
      "violation_late_early": "Spät + Früh",
      "violation_late_in": "Später Einstieg",
      "violation_missing_in": "Fehlende Anmeldung",
      "violation_missing_out": "Fehlende Abmeldung",
      "violation_none": "Keine Verletzung",
    }
  },
  ar: {
    translation: {
      "login_title": "تسجيل الدخول",
      "email_label": "البريد الإلكتروني",
      "password_label": "كلمة المرور",
      "login_button": "تسجيل الدخول",
      "select_language": "اختر اللغة",
      "login_failed_generic": "فشل تسجيل الدخول. يرجى التحقق من بياناتك.",
      "server_unreachable": "تعذر الوصول إلى الخادم. يرجى التحقق من اتصالك.",
      "condition_new": "جديد",
      "condition_working": "سليم / يعمل بحالة جيدة",
      "error_fetching_data": "فشل في جلب البيانات.",
      "assets_added_success": "تمت إضافة الأصول بنجاح.",
      "error_adding_assets": "فشل في إضافة الأصول.",
      "prompt_return_note": "ملاحظة الإرجاع / الحالة:",
      "default_return_note": "تم الإرجاع بحالة جيدة",
      "status_updated": "تم تحديث الحالة.",
      "error_occurred": "حدث خطأ.",
      "select_personnel_first": "يرجى تحديد الموظف.",
      "assignment_successful": "نجاح التعيين.",
      "assignment_error": "خطأ في التعيين.",
      "preparing_pdf": "جاري تحضير PDF...",
      "pdf_downloaded": "تم تنزيل PDF.",
      "pdf_not_found": "لم يتم العثور على PDF.",
      "status_in_stock": "في المخزن",
      "status_assigned": "مُعيَّن",
      "status_in_repair": "في الإصلاح",
      "status_archived": "مؤرشف",
      "filter_all": "الكل",
      "filter_in_stock": "في المخزن",
      "filter_assigned": "مُعيَّن",
      "filter_in_repair": "في الإصلاح",
      "btn_add_new_asset": "إضافة أصل جديد",
      "stat_total_assets": "إجمالي الأصول",
      "stat_available": "في المخزن (متاح)",
      "stat_assigned": "مُعيَّن",
      "stat_in_repair": "في الإصلاح / معطل",
      "loading": "جاري التحميل...",
      "table_category_model": "الفئة / اسم الطراز",
      "table_stock_status": "حالة المخزون",
      "table_actions": "الإجراءات",
      "lbl_total": "المجموع",
      "lbl_stock": "المخزن",
      "table_serial_plate": "الرقم التسلسلي / اللوحة",
      "table_status": "الحالة",
      "table_current_assignee": "المُعيَّن الحالي",
      "table_operations": "العمليات",
      "unknown": "غير معروف",
      "btn_assign": "تعيين",
      "btn_send_repair": "إصلاح",
      "btn_report": "تقرير",
      "btn_return": "إرجاع",
      "btn_repair_done": "تم الإصلاح",
      "modal_bulk_entry_title": "إدخال مخزون مجمّع",
      "lbl_model_name": "النموذج / اسم الأصل",
      "ph_model_name": "مثال: MACBOOK PRO M3",
      "lbl_category": "الفئة",
      "cat_electronics": "الإلكترونيات",
      "cat_vehicles": "المركبات / النقل",
      "cat_furniture": "أثاث / مكتب",
      "cat_digital": "التراخيص / رقمي",
      "cat_other": "أخرى",
      "lbl_serial_numbers": "الأرقام التسلسلية",
      "ph_serial_numbers": "عنصر واحد في كل سطر...",
      "lbl_total_detected": "الإجمالي: تم اكتشاف {count}",
      "lbl_instant_assign": "تعيين فوري",
      "opt_keep_in_stock": "الاحتفاظ في المخزن",
      "lbl_notes": "الوصف / الملاحظات",
      "btn_cancel": "إلغاء",
      "btn_save_assets": "معالجة الأصول إلى النظام",
      "modal_assign_title": "تعيين الموظفين",
      "lbl_select_personnel": "تحديد الموظف",
      "opt_select": "يرجى الاختيار",
      "lbl_delivery_condition": "حالة التسليم",
      "ph_condition": "مثال: خالي من الخدوش / جديد",
      "btn_confirm_assign": "تأكيد وتعيين",
      "stage_new": "مقدم طلب جديد",
      "stage_interview": "مقابلة",
      "stage_reference": "مرجع واختبار",
      "stage_offer": "تم إرسال العرض",
      "stage_talent_pool": "مجموعة المواهب 🏊‍♂️",
      "stage_withdrawn": "منسحب 🛑",
      "stage_rejected": "مرفوض",
      "stage_hired": "تم التوظيف 🎉",
      "error_fetch_data": "فشل في جلب البيانات",
      "msg_job_published": "تم نشر الوظيفة بنجاح.",
      "msg_job_create_error": "فشل في إنشاء الوظيفة.",
      "msg_select_open_job": "يرجى تحديد وظيفة شاغرة!",
      "msg_candidate_created": "تم إنشاء سجل المرشح.",
      "msg_candidate_create_error": "فشل في إضافة المرشح!",
      "msg_pdf_only": "يرجى تحميل ملف PDF فقط.",
      "msg_uploading_cv": "جاري تحميل السيرة الذاتية...",
      "msg_cv_uploaded": "تم تحميل السيرة الذاتية بنجاح.",
      "msg_cv_upload_error": "فشل تحميل السيرة الذاتية",
      "msg_upload_cv_first": "يجب عليك تحميل السيرة الذاتية للمرشح أولاً.",
      "msg_ai_analyzing": "يقوم Gemini AI بتحليل السيرة الذاتية...",
      "lbl_ai_evaluation": "تقييم الذكاء الاصطناعي",
      "msg_ai_analysis_done": "اكتمل تحليل الذكاء الاصطناعي!",
      "msg_ai_analysis_error": "الذكاء الاصطناعي مشغول حالياً أو حدث خطأ.",
      "msg_confirm_withdraw": "هل أنت متأكد أن المرشح {{name}} قد انسحب أو رفض العرض؟",
      "mail_reject_subject": "بخصوص طلبك لوظيفة {{job}}",
      "mail_reject_body": "عزيزي/عزيزتي {{first_name}} {{last_name}}،\n\nنشكرك على اهتمامك بشركتنا وبوظيفة {{job}}.\n\nلقد قمنا بمراجعة سيرتك الذاتية ونتائج المقابلة بعناية. للأسف، لن نتمكن من المضي قدمًا في طلبك في هذا الوقت.\n\nمؤهلاتك مثيرة للإعجاب، وسنسعد بالتواصل معك في حال توفرت فرصة مناسبة في المستقبل.\n\nنتمنى لك التوفيق في مسيرتك المهنية.\n\nمع خالص التحيات،\nقسم الموارد البشرية",
      "msg_stage_update_error": "خطأ في تحديث المرحلة.",
      "msg_saving_notes": "جاري حفظ ملاحظات التقييم...",
      "msg_saved_successfully": "تم الحفظ بنجاح.",
      "msg_save_error": "فشل في حفظ ملاحظات التقييم!",
      "msg_sending_reject_mail": "جاري إرسال بريد الرفض...",
      "msg_reject_mail_sent": "تم إرسال بريد الرفض إلى {{name}}.",
      "msg_error_occurred": "حدث خطأ.",
      "msg_creating_employee_card": "جاري إنشاء سجل الموظف...",
      "msg_hire_success": "{{name}} هو الآن موظف رسمي.",
      "msg_hire_error": "فشل إنشاء الموظف! تحقق من الحقول المطلوبة.",
      "msg_confirm_delete_candidate": "هل أنت متأكد أنك تريد حذف المرشح {{name}} نهائيًا؟",
      "msg_candidate_deleted": "تم حذف المرشح.",
      "msg_candidate_delete_error": "خطأ في حذف المرشح.",
      "msg_generating_offer_pdf": "جاري إنشاء خطاب العرض (PDF)...",
      "msg_offer_downloaded": "تم تنزيل الخطاب بنجاح.",
      "msg_offer_error": "خطأ في إنشاء خطاب العرض.",
      "opt_no_active_job": "لا توجد وظائف نشطة",
      "btn_new_job": "إعلان وظيفة جديد",
      "btn_add_candidate": "إضافة مرشح",
      "msg_empty_board": "يرجى تحديد وظيفة أو إنشاء وظيفة جديدة",
      "msg_empty_board_sub": "استخدم القائمة أعلاه لإدارة مجموعة المرشحين.",
      "tooltip_delete_candidate": "حذف المرشح",
      "tooltip_global_score": "نقاط الملاءمة العالمية (الموارد البشرية + الذكاء الاصطناعي)",
      "lbl_drag_here": "اسحب هنا",
      "lbl_click_to_offer": "انقر على المرشح لإنشاء العقد.",
      "modal_title_new_job": "إعلان وظيفة جديد",
      "lbl_select_position_from_org": "تحديد منصب شاغر من الهيكل التنظيمي",
      "opt_manual_job": "سأقوم بالإدخال يدوياً",
      "msg_auto_fill_warning": "سيتم ملء اسم المنصب والقسم تلقائياً.",
      "lbl_job_title": "المسمى الوظيفي / المنصب",
      "lbl_department": "القسم",
      "lbl_job_desc": "الوصف الوظيفي والمتطلبات",
      "btn_publish_job": "نشر الوظيفة",
      "modal_title_new_candidate": "إضافة مرشح جديد",
      "lbl_first_name": "الاسم الأول",
      "lbl_last_name": "اسم العائلة",
      "lbl_email": "البريد الإلكتروني",
      "lbl_phone": "رقم الهاتف",
      "ph_optional": "اختياري",
      "btn_save_to_system": "حفظ في النظام",
      "modal_title_hire": "إكمال التوظيف",
      "lbl_creating_emp_card": "جاري إنشاء بطاقة الموظف",
      "lbl_identity_no": "رقم الهوية / جواز السفر",
      "ph_identity": "رقم الهوية",
      "lbl_position": "المنصب / اللقب",
      "lbl_gross_salary": "الراتب الإجمالي",
      "lbl_hire_date": "تاريخ البدء",
      "btn_save_official_employee": "حفظ كموظف رسمي",
      "lbl_evaluation_center": "مركز تقييم المرشحين (بطاقة الأداء)",
      "lbl_global_score": "نقاط الملاءمة الشاملة",
      "lbl_contact_and_cv": "التواصل والسيرة الذاتية",
      "btn_view_cv": "عرض السيرة الذاتية",
      "btn_analyzing": "جاري التحليل...",
      "btn_start_ai_analysis": "بدء تحليل الذكاء الاصطناعي",
      "btn_upload_pdf": "تحميل PDF",
      "lbl_ai_analysis_title": "تحليل الذكاء الاصطناعي (AI)",
      "lbl_match_score": "نقاط التطابق",
      "lbl_no_ai_note": "لم يتم العثور على ملاحظة ذكاء اصطناعي.",
      "lbl_competency_eval": "تقييم الكفاءة (كمي)",
      "lbl_rating_comm": "التواصل والتعبير",
      "lbl_rating_tech": "المهنية / الفنية",
      "lbl_rating_culture": "التوافق الثقافي",
      "lbl_rating_motivation": "الثقة والتحفيز",
      "lbl_interview_notes": "ملاحظات المقابلة (نوعي)",
      "lbl_pros": "نقاط القوة (الإيجابيات)",
      "ph_pros": "أين تألق المرشح بشكل أكبر...",
      "lbl_cons": "المخاوف (السلبيات)",
      "ph_cons": "المخاوف أو مجالات التحسين...",
      "lbl_overall": "القرار الشامل للموارد البشرية / ملخص",
      "ph_overall": "هل توصي بهذا المرشح لمدير التوظيف؟",
      "btn_generate_contract": "إنشاء عقد",
      "btn_save_eval_form": "حفظ نموذج التقييم",
      "modal_title_reject": "رفض المرشح وإخطاره",
      "lbl_edit_mail_template": "يمكنك تعديل قالب البريد الإلكتروني أدناه",
      "lbl_to": "إلى:",
      "lbl_mail_subject": "موضوع البريد الإلكتروني",
      "lbl_mail_body": "محتوى البريد الإلكتروني",
      "btn_send_and_reject": "إرسال ورفض المرشح",
      "modal_title_offer": "إنشاء خطاب العرض",
      "lbl_preparing_pdf": "جاري تحضير وثيقة PDF الرسمية",
      "lbl_offered_salary": "الراتب الشهري المعروض",
      "ph_salary": "مثال: 45000",
      "lbl_planned_start_date": "تاريخ البدء المخطط",
      "btn_download_pdf": "تنزيل PDF",
      "nav_dashboard": "لوحة القيادة",
      "nav_sub_dashboard": "إحصائيات عامة",
      "nav_employees": "إدارة شؤون الموظفين",
      "nav_sub_employees": "طاقم العمل",
      "nav_org_chart": "الهيكل التنظيمي",
      "nav_sub_org_chart": "الهيكل الهرمي",
      "nav_ats": "نظام تتبع المتقدمين (ATS)",
      "nav_sub_ats": "عملية التوظيف",
      "nav_attendance": "الوقت والحضور",
      "nav_sub_attendance": "تتبع الدوام والورديات",
      "nav_locations": "المواقع والمناطق",
      "nav_sub_locations": "إدارة النطاق الجغرافي",
      "nav_leaves": "إدارة الإجازات",
      "nav_sub_leaves": "مركز الموافقات",
      "nav_dossier": "أرشيف الملفات الإلكترونية",
      "nav_sub_dossier": "المستندات الرقمية",
      "nav_performance": "الأداء والمواهب",
      "nav_sub_performance": "تقييم الأهداف و 360 درجة",
      "nav_training": "أكاديمية الشركة",
      "nav_sub_training": "إدارة التدريب",
      "nav_expenses": "إدارة النفقات",
      "nav_sub_expenses": "الميزانية والإيصالات",
      "nav_assets": "الأصول والمخزون",
      "nav_sub_assets": "تتبع العهد",
      "nav_helpdesk": "مكتب المساعدة (IT/HR)",
      "nav_sub_helpdesk": "الطلبات الداخلية",
      "nav_settings": "إعدادات النظام والشركة",
      "nav_sub_settings": "الهوية المؤسسية",
      "nav_billing": "الاشتراك والفوترة",
      "nav_sub_billing": "إدارة باقة SaaS",
      "menu_onboarding": "التهيئة الوظيفية وإنهاء الخدمة",
      "lifecycle_header_title": "التهيئة الوظيفية وإنهاء الخدمة",
      "lifecycle_header_subtitle": "عمليات الانضمام والمغادرة والمستندات",
      "lifecycle_role_employee": "موظف",
      "lifecycle_role_manager": "مدير",
      "lifecycle_role_hr": "الموارد البشرية",
      "lifecycle_role_admin": "مسؤول",
      "lifecycle_role_superadmin": "المسؤول الأعلى",
      "lifecycle_tab_onboarding": "التهيئة الوظيفية",
      "lifecycle_tab_offboarding": "إنهاء الخدمة",
      "lifecycle_search_onboarding": "ابحث عن موظف جديد",
      "lifecycle_search_offboarding": "ابحث في إجراءات إنهاء الخدمة",
      "lifecycle_no_matching_personnel": "لم يتم العثور على موظف مطابق لهذا العرض.",
      "lifecycle_detail_loading": "جارٍ تحميل تفاصيل الإجراء...",
      "lifecycle_select_personnel": "اختر موظفًا",
      "lifecycle_select_personnel_hint": "عند اختيار موظف من القائمة اليسرى ستظهر هنا خطوات التهيئة الوظيفية / إنهاء الخدمة.",
      "lifecycle_onboarding_process": "إجراء التهيئة الوظيفية",
      "lifecycle_offboarding_process": "إجراء إنهاء الخدمة",
      "lifecycle_progress": "التقدم",
      "lifecycle_account_active": "الحساب نشط",
      "lifecycle_account_closed_status": "الحساب مغلق",
      "lifecycle_document_count": "عدد المستندات",
      "lifecycle_open_workload": "الأعباء المفتوحة",
      "lifecycle_active_device": "الجهاز النشط",
      "lifecycle_leave_unit": "إجازة",
      "lifecycle_expense_unit": "مصروف",
      "lifecycle_device_unit": "جهاز",
      "lifecycle_checklist": "قائمة التحقق",
      "lifecycle_process_actions": "إجراءات العملية",
      "lifecycle_close_account": "إغلاق الحساب",
      "lifecycle_open_account": "فتح الحساب / إرسال كلمة المرور",
      "lifecycle_open_release_form": "فتح نموذج إنهاء الخدمة",
      "lifecycle_download_document": "تنزيل المستند",
      "btn_store_to_dossier": "الحفظ في الملف الإلكتروني",
      "lifecycle_process_note": "ملاحظة العملية",
      "lifecycle_offboarding_note": "تحقق أولًا من العهد النشطة والأعباء المفتوحة. عند إغلاق الحساب سيتم أيضًا تعطيل MFA وجلسات الأجهزة المحمولة.",
      "lifecycle_onboarding_note": "عند فتح الحساب تُرسل كلمة مرور مؤقتة. يمكنك حفظ العقد المُنشأ في الملف الإلكتروني وإضافته إلى حزمة مستندات التهيئة.",
      "lifecycle_highlights": "النقاط المفتوحة",
      "lifecycle_no_open_items": "لا توجد بنود مفتوحة في هذه العملية",
      "lifecycle_offboarding_document": "مستند إنهاء الخدمة",
      "lifecycle_release_form_title": "نموذج إنهاء الخدمة / المخالصة",
      "lifecycle_release_form_desc": "يقوم النظام بتعبئة الحقول الأساسية. يمكنك هنا إكمال النصوص القانونية الحرة وبنود التسوية ثم إنشاء ملف PDF.",
      "lifecycle_form_loading": "جارٍ تحميل النموذج...",
      "lifecycle_template_label": "قالب المستند",
      "lifecycle_template_tr_release_title": "نموذج مخالصة TR/KKTC",
      "lifecycle_template_tr_release_subtitle": "نص مخالصة وتسوية تقليدي متوافق مع تركيا / شمال قبرص",
      "lifecycle_template_generic_clearance_title": "نموذج تسوية وإخلاء طرف عام",
      "lifecycle_template_generic_clearance_subtitle": "نموذج عام للتسوية وإخلاء الطرف صالح لمختلف الدول",
      "lifecycle_template_de_exit_title": "نموذج الخروج والتسوية DE",
      "lifecycle_template_de_exit_subtitle": "ملخص خروج وتسوية نهائية مخصص لألمانيا",
      "lifecycle_template_sgk_note": "يستخدم هذا القالب حقول التسجيل المحلية.",
      "lifecycle_template_generic_note": "يُستخدم هذا القالب كنموذج إخلاء طرف عام.",
      "lifecycle_employer_name": "اسم صاحب العمل",
      "lifecycle_employer_address": "عنوان صاحب العمل",
      "lifecycle_employer_sgk": "رقم تسجيل مكان العمل",
      "lifecycle_employer_tax": "الرقم الضريبي",
      "lifecycle_employee_name": "اسم الموظف",
      "lifecycle_employee_ssn": "رقم الضمان الاجتماعي",
      "lifecycle_exit_reason_label": "سبب إنهاء الخدمة",
      "lifecycle_hire_date": "تاريخ الالتحاق",
      "lifecycle_exit_date": "تاريخ إنهاء الخدمة",
      "lifecycle_exit_date_short": "تاريخ الخروج",
      "lifecycle_release_date": "تاريخ المخالصة",
      "lifecycle_other_exit_reason_note": "شرح سبب آخر",
      "lifecycle_other_exit_reason_placeholder": "اشرح بالنص الحر",
      "lifecycle_intro_text": "نص المقدمة",
      "lifecycle_settlement_text": "نص التسوية",
      "lifecycle_no_claim_text": "نص عدم وجود مطالبات متبقية",
      "lifecycle_contact_note": "العنوان والهاتف / ملاحظة حرة",
      "lifecycle_payment_table": "جدول المدفوعات",
      "lifecycle_payment_table_hint": "يمكنك تركه فارغًا أو تعبئة الصفوف وفقًا لمراجعة الشؤون القانونية أو المحاسبة.",
      "lifecycle_payment_col_name": "المدفوعات",
      "lifecycle_payment_col_gross": "إجمالي",
      "lifecycle_payment_col_legal": "الاستقطاع القانوني",
      "lifecycle_payment_col_net": "الصافي",
      "lifecycle_payment_col_special": "استقطاع خاص",
      "lifecycle_payment_col_net_payment": "صافي الدفع",
      "lifecycle_exit_reason_select": "اختر السبب",
      "lifecycle_exit_reason_abandonment": "ترك العمل",
      "lifecycle_exit_reason_resignation": "استقالة",
      "lifecycle_exit_reason_termination": "فصل / إنهاء",
      "lifecycle_exit_reason_military": "الخدمة العسكرية",
      "lifecycle_exit_reason_retirement": "تقاعد",
      "lifecycle_exit_reason_death": "وفاة",
      "lifecycle_exit_reason_other": "أخرى",
      "lifecycle_overview_load_error": "تعذر تحميل بيانات العملية.",
      "lifecycle_preparing_document": "جارٍ تجهيز المستند...",
      "lifecycle_document_downloaded": "تم تنزيل المستند.",
      "lifecycle_document_download_error": "تعذر تنزيل المستند.",
      "lifecycle_document_storing": "جارٍ حفظ المستند في الملف الإلكتروني...",
      "lifecycle_document_stored": "تم إنشاء المستند وحفظه في الملف الإلكتروني.",
      "lifecycle_document_store_error": "تعذر حفظ المستند.",
      "lifecycle_account_opening": "جارٍ فتح حساب المستخدم...",
      "lifecycle_account_opened_with_temp": "تم فتح الحساب. كلمة المرور المؤقتة: {{password}}",
      "lifecycle_account_opened": "تم فتح الحساب.",
      "lifecycle_account_open_error": "تعذر فتح الحساب.",
      "lifecycle_account_closing": "جارٍ إغلاق الحساب...",
      "lifecycle_account_closed": "تم إغلاق الحساب وأرشفة الموظف.",
      "lifecycle_account_close_error": "تعذر إغلاق الحساب.",
      "lifecycle_release_form_open_error": "تعذر فتح نموذج إنهاء الخدمة.",
      "lifecycle_template_load_error": "تعذر تحميل القالب.",
      "lifecycle_release_pdf_preparing": "جارٍ تجهيز PDF لإنهاء الخدمة...",
      "lifecycle_release_pdf_downloaded": "تم تنزيل مستند إنهاء الخدمة.",
      "lifecycle_release_pdf_error": "تعذر تنزيل مستند إنهاء الخدمة.",
      "lifecycle_release_storing": "جارٍ حفظ مستند إنهاء الخدمة في الملف الإلكتروني...",
      "lifecycle_release_stored": "تم إنشاء مستند إنهاء الخدمة وحفظه في الملف الإلكتروني.",
      "lifecycle_release_store_error": "تعذر حفظ مستند إنهاء الخدمة.",
      "lifecycle_not_planned": "غير مخطط",
      "lifecycle_no_department": "لا يوجد قسم",
      "lifecycle_opening_progress": "تقدم التهيئة",
      "lifecycle_closure_progress": "تقدم الإنهاء",
      "lifecycle_detail_load_error": "تعذر تحميل تفاصيل العملية.",
      "lifecycle_summary_total_process": "إجمالي العمليات",
      "lifecycle_summary_total_process_hint": "الموظفون المتابعون",
      "lifecycle_summary_closed_accounts": "الحسابات المغلقة",
      "lifecycle_summary_closed_accounts_hint": "تم تعطيل الوصول",
      "lifecycle_summary_documents_ready": "المستندات جاهزة",
      "lifecycle_summary_offboarding_documents_hint": "تم إعداد مستندات الخروج",
      "lifecycle_summary_attention_needed": "يحتاج متابعة",
      "lifecycle_summary_attention_needed_hint": "توجد خطوات مفتوحة",
      "lifecycle_summary_total_employees": "إجمالي الموظفين",
      "lifecycle_summary_total_employees_hint": "عرض التهيئة",
      "lifecycle_summary_accounts_ready": "الحسابات جاهزة",
      "lifecycle_summary_accounts_ready_hint": "تم إعداد بيانات الدخول",
      "lifecycle_summary_onboarding_documents_hint": "العقد والمستندات جاهزة",
      "lifecycle_summary_attention_needed_onboarding_hint": "توجد خطوات ناقصة",
      "helpdesk_stat_open": "مفتوح",
      "helpdesk_stat_open_hint": "إجمالي الطلبات النشطة",
      "helpdesk_stat_pending": "بانتظار الرد",
      "helpdesk_stat_pending_hint": "بانتظار أول رد",
      "helpdesk_stat_in_progress_hint": "قيد المعالجة حاليًا",
      "helpdesk_total_tickets": "إجمالي الطلبات",
      "nav_portal": "لوحة القيادة",
      "nav_sub_portal": "لوحة التحكم الشخصية",
      "nav_my_leaves": "إجازاتي",
      "nav_sub_my_leaves": "حالة الإجازة الشخصية",
      "nav_my_performance": "أدائي",
      "nav_sub_my_performance": "أهدافي (OKR)",
      "nav_my_training": "أكاديمية التدريب",
      "nav_sub_my_training": "خطة التطوير",
      "nav_my_expenses": "مصروفاتي",
      "nav_sub_my_expenses": "إدخالات النفقات",
      "nav_my_assets": "العهد الخاصة بي",
      "nav_sub_my_assets": "معدات الشركة",
      "nav_fallback": "لوحة التحكم",
      "nav_sub_fallback": "إدارة الشركات",
      "error_fetch_weather": "فشل في جلب حالة الطقس",
      "lbl_city_weather": "المدينة / الطقس",
      "ph_type_city": "اكتب اسم المدينة...",
      "tooltip_change_city": "انقر لتغيير المدينة",
      "lbl_today": "اليوم",
      "msg_payment_success": "🎉 تمت عملية الدفع بنجاح! تم تحديث اشتراكك.",
      "msg_payment_failed": "حدث خطأ أثناء الدفع. يرجى المحاولة مرة أخرى.",
      "msg_redirecting_payment": "جاري التوجيه إلى صفحة الدفع الآمنة...",
      "msg_no_payment_link": "تعذر الحصول على رابط الدفع.",
      "msg_payment_init_failed": "فشل بدء عملية الدفع. يرجى المحاولة مرة أخرى.",
      "lbl_current_subscription": "اشتراكك الحالي",
      "lbl_active": "نشط",
      "lbl_renews_in_days": "يتجدد خلال {{days}} أيام",
      "lbl_saved_card": "البطاقة المحفوظة:",
      "btn_update_card": "تحديث البطاقة",
      "lbl_iyzico_secure": "آمن 100% عبر IYZICO",
      "plan_starter_title": "البداية",
      "plan_starter_desc": "للفرق الصغيرة",
      "lbl_month": "شهر",
      "feat_max_10_emp": "بحد أقصى 10 موظفين",
      "feat_standard_payroll": "كشوف رواتب قياسية (D1)",
      "feat_no_ats": "لا يوجد نظام تتبع المتقدمين (ATS)",
      "feat_no_helpdesk": "لا يوجد مكتب مساعدة",
      "btn_current_plan": "الخطة الحالية",
      "btn_downgrade": "خفض الخطة",
      "badge_most_popular": "الأكثر شيوعاً",
      "plan_pro_title": "خطة برو (Pro)",
      "plan_pro_desc": "للشركات المتنامية",
      "feat_max_50_emp": "بحد أقصى 50 موظفاً",
      "feat_all_payroll": "جميع أنواع كشوف الرواتب (D1, D3, E1)",
      "feat_ats_module": "نظام تتبع المتقدمين (ATS)",
      "feat_helpdesk": "مكتب مساعدة الموظفين",
      "plan_enterprise_title": "المؤسسات (Enterprise)",
      "plan_enterprise_desc": "للشركات الكبرى",
      "feat_unlimited_emp": "عدد غير محدود من الموظفين",
      "feat_advanced_api": "وصول متقدم لواجهة برمجة التطبيقات API",
      "feat_private_server": "تثبيت سيرفر خاص",
      "feat_vip_support": "دعم خاص VIP على مدار الساعة",
      "btn_upgrade": "ترقية الخطة",
      "err_invalid_qr": "إجراء غير صالح: يرجى مسح رمز الاستجابة السريعة (QR) الحالي في الموقع لتسجيل الدخول.",
      "msg_clock_in_success": "تم تسجيل الدخول بنجاح! نتمنى لك مناوبة جيدة.",
      "err_location_verify": "تعذر التحقق من الموقع.",
      "err_location_denied": "تم رفض إذن الموقع أو غير متوفر!",
      "err_location_timeout": "انتهاء المهلة: يرجى الخروج والمحاولة مرة أخرى.",
      "lbl_verifying_gps": "جاري التحقق من GPS...",
      "lbl_clocked_in": "تم تسجيل الدخول",
      "btn_clock_in": "تسجيل الدخول (QR و GPS)",
      "err_fetch_attendance": "فشل في جلب بيانات الحضور.",
      "err_only_excel": "يمكنك فقط تحميل ملفات Excel (.xlsx، .xls).",
      "err_select_excel": "يرجى تحديد ملف Excel.",
      "msg_processing_excel": "جاري معالجة ملف Excel...",
      "msg_excel_success": "تم استيراد بيانات Excel إلى النظام بنجاح!",
      "msg_upload_failed": "فشل التحميل.",
      "action_reject": "رفض",
      "action_approve": "الموافقة على",
      "msg_confirm_bulk": "هل أنت متأكد أنك تريد {{action}} السجلات المحددة وعددها {{count}} دفعة واحدة؟",
      "msg_applying_bulk": "جاري تطبيق الإجراء الجماعي...",
      "msg_bulk_success": "تم اكتمال الإجراء الجماعي بنجاح.",
      "status_present": "حاضر",
      "status_absent": "غائب",
      "status_late": "متأخر",
      "status_off": "إجازة / عطلة",
      "badge_manager_pending": "في انتظار المدير",
      "badge_hr_pending": "في انتظار الموارد البشرية",
      "badge_payroll_ready": "جاهز للرواتب",
      "badge_rejected": "مرفوض",
      "lbl_bulk_excel": "رفع جماعي عبر EXCEL",
      "lbl_excel_desc": "ملف .xlsx من جهاز بصمة الوجه / الإصبع.",
      "btn_select_file": "اختر الملف",
      "btn_select_excel": "اختر ملف EXCEL",
      "btn_processing": "جاري المعالجة...",
      "btn_transfer": "رفع",
      "lbl_listed_records": "السجلات المدرجة على الشاشة",
      "lbl_records": "السجلات",
      "lbl_record_selected": "سجلات محددة",
      "btn_reject_selected": "رفض",
      "btn_approve_selected": "موافقة",
      "opt_all_approvals": "جميع الموافقات",
      "lbl_loading_data": "جاري تحميل البيانات...",
      "tbl_emp_dept": "الموظف والقسم",
      "tbl_day_in_out": "اليوم وتسجيل الدخول-الخروج",
      "tbl_total_ot": "الإجمالي / العمل الإضافي",
      "tbl_daily_status": "الحالة اليومية",
      "tbl_approval_status": "حالة الموافقة",
      "lbl_no_records": "لا توجد سجلات حتى الآن.",
      "lbl_unknown": "غير معروف",
      "lbl_weekday_ot": "أيام الأسبوع",
      "lbl_weekend_ot": "نهاية الأسبوع",
      "lbl_no_ot": "لا يوجد عمل إضافي",
      "lbl_records_selected_html": "تم تحديد<br/>سجلات",
      "lbl_assigned_count": "المعيّن",
      "lbl_selected_count": "المحدد",
      "badge_already_assigned": "تم التعيين مسبقاً",
      "btn_select_all_visible": "تحديد الظاهر",
      "btn_clear_visible": "مسح الظاهر",
      "btn_manager_approve": "موافقة المدير",
      "btn_hr_approve": "موافقة الموارد البشرية (رواتب)",
      "btn_reject_cancel": "رفض (إلغاء)",
      "err_password_length": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
      "err_password_match": "كلمات المرور غير متطابقة.",
      "msg_register_success": "تم تسجيل الشركة بنجاح! يرجى تسجيل الدخول.",
      "err_generic_login": "حدث خطأ. يرجى التحقق من بياناتك.",
      "lbl_login_title": "تسجيل الدخول إلى النظام",
      "lbl_register_title": "ابدأ تجربتك المجانية لمدة 30 يومًا",
      "ph_company_name": "اسم الشركة / المؤسسة",
      "ph_first_name": "الاسم الأول",
      "ph_last_name": "اسم العائلة",
      "ph_email": "البريد الإلكتروني",
      "ph_password": "كلمة المرور",
      "ph_confirm_password": "تأكيد كلمة المرور",
      "btn_login": "تسجيل الدخول",
      "btn_register": "إنشاء حساب",
      "msg_no_account": "ليس لديك حساب بعد؟",
      "msg_has_account": "هل لديك حساب شركة بالفعل؟",
      "btn_start_trial": "ابدأ التجربة الآن",
      "btn_back_to_login": "العودة لتسجيل الدخول",
      "lbl_other": "أخرى",
      "lbl_unassigned": "غير معين",
      "err_fetch_data": "حدث خطأ أثناء تحميل البيانات.",
      "msg_updating_company_info": "جاري تحديث معلومات الشركة...",
      "msg_company_info_updated": "تم تحديث معلومات الهوية المؤسسية بنجاح!",
      "err_updating_info": "حدث خطأ أثناء التحديث.",
      "err_file_size": "لا يمكن أن يتجاوز حجم الملف 2 ميغابايت.",
      "msg_uploading_logo": "جاري رفع الشعار إلى الخادم...",
      "msg_logo_uploaded": "تم رفع الشعار وتطبيقه على النظام بنجاح!",
      "err_uploading_logo": "حدث خطأ أثناء رفع الشعار.",
      "msg_saving_routing": "جاري حفظ إعدادات التوجيه والتشغيل...",
      "msg_routing_saved": "تم قفل جميع مسارات النظام بنجاح!",
      "err_saving_routing": "تعذر حفظ الإعدادات. يرجى التحقق من اتصال الخادم.",
      "err_pwd_match": "كلمات المرور الجديدة غير متطابقة!",
      "err_pwd_length": "يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل.",
      "msg_updating_pwd": "جاري تحديث كلمة المرور الخاصة بك...",
      "msg_pwd_updated": "تم تغيير كلمة المرور الخاصة بك بنجاح!",
      "err_updating_pwd": "تعذر تحديث كلمة المرور. يرجى التحقق من كلمة المرور الحالية.",
      "lbl_loading_settings": "جاري تحميل الإعدادات...",
      "tab_company": "إعدادات الشركة",
      "tab_security": "الأمان الشخصي",
      "lbl_official_title": "الاسم الرسمي",
      "lbl_company_name": "اسم الشركة",
      "lbl_routing_settings": "إعدادات توجيه النظام",
      "desc_routing": "حدد المسؤولين الرئيسيين للوحدات.",
      "lbl_routing_policy": "منطق مسار الموافقات",
      "desc_helpdesk_policy": "مكتب المساعدة: تُحوَّل الطلبات إلى المسؤول المحدد في إعدادات الشركة.",
      "desc_leave_policy": "الإجازات: المدير أولاً، ثم الموارد البشرية / الإدارة.",
      "desc_expense_policy": "المصاريف: المدير أولاً، ثم الإدارة / المالية.",
      "desc_document_policy": "المستندات: تُرسل لاعتماد الموارد البشرية / الإدارة.",
      "lbl_helpdesk_it": "مكتب المساعدة (IT)",
      "lbl_hr_responsible": "الإجازات والمستندات (HR)",
      "lbl_admin_responsible": "الطلبات الإدارية والمصاريف",
      "lbl_payroll_officer": "مسؤول الرواتب",
      "desc_payroll_officer": "هذا الشخص يستقبل طلبات الرواتب في مكتب المساعدة ويعمل كنقطة مالية في مسار المصاريف.",
      "btn_processing": "جاري المعالجة...",
      "btn_save_routing": "قفل وحفظ الإعدادات",
      "lbl_pdf_active": "نظام الترويسة PDF نشط",
      "lbl_no_logo": "لم يتم تحديد شعار",
      "tab_company_info": "معلومات",
      "tab_company_info_span": "الشركة",
      "lbl_address": "العنوان",
      "lbl_phone": "الهاتف",
      "lbl_email": "البريد الإلكتروني",
      "lbl_website": "الموقع الإلكتروني",
      "btn_update_info": "تحديث المعلومات",
      "lbl_logo_management": "إدارة الشعار",
      "btn_select_new_file": "اختر ملفاً جديداً",
      "btn_start_upload": "بدء الرفع",
      "lbl_no_logo_uploaded": "لا يوجد شعار",
      "lbl_current_view": "العرض الحالي",
      "tab_account": "أمان",
      "tab_security_span": "الحساب",
      "lbl_update_pwd": "تحديث كلمة المرور الخاصة بك",
      "desc_update_pwd": "لأمان حسابك، يُنصح بتغيير كلمة المرور بانتظام.",
      "lbl_old_pwd": "كلمة المرور الحالية",
      "lbl_new_pwd": "كلمة المرور الجديدة",
      "lbl_confirm_pwd": "كلمة المرور الجديدة (تأكيد)",
      "btn_change_pwd": "تحديث كلمة المرور",
      "opt_none_selected": "لم يتم اختيار أحد",
      "err_login_failed_check_info": "فشل تسجيل الدخول. يرجى التحقق من بياناتك.",
      "lbl_system_subtitle": "نظام إدارة شؤون الموظفين",
      "lbl_email_address": "البريد الإلكتروني",
      "ph_email_example": "example@company.com",
      "lbl_password": "كلمة المرور",
      "btn_login_system": "تسجيل الدخول للنظام",
      "msg_no_account_yet": "ليس لديك حساب بعد؟",
      "btn_register_now": "سجل الآن",
      "notif_loading": "📢 جاري تحميل لوحة التحكم، يرجى الانتظار...",
      "err_fetch_ats": "فشل في جلب بيانات ATS:",
      "err_fetch_kudos": "فشل في جلب قائمة الشكر (Kudos):",
      "notif_pending_leaves": "{{count}} طلبات إجازة سنوية بانتظار موافقتك.",
      "notif_pending_expenses": "{{count}} مطالبات نفقات بانتظار موافقتك.",
      "notif_pending_documents": "{{count}} مستندات بانتظار موافقتك.",
      "notif_dossier_missing_required_documents": "{{count}} نواقص إلزامية في الملف بانتظار المراجعة.",
      "notif_dossier_expired_documents": "{{count}} مستندات تبدو منتهية الصلاحية.",
      "notif_dossier_expiring_documents": "{{count}} مستندات ستنتهي قريباً.",
      "notif_open_tickets": "توجد {{count}} تذاكر مفتوحة في قسم تكنولوجيا المعلومات/الدعم.",
      "notif_all_clear": "ليس لديك أي موافقات معلقة حالياً. نتمنى لك يوماً رائعاً!",
      "notif_last_announcement": "آخر إعلان: {{title}}",
      "notif_welcome": "مرحباً بك في النظام، نتمنى لك يوم عمل مثمر.",
      "err_server_unreachable": "تعذر الاتصال بالخادم. يرجى المحاولة مرة أخرى لاحقاً.",
      "lbl_dashboard_warning": "تحذير تحميل لوحة التحكم",
      "btn_view_all": "عرض الكل",
      "btn_new_job_posting": "إعلان وظيفة جديد",
      "btn_go_to_roster": "الذهاب للموظفين",
      "lbl_ats_summary": "ملخص التوظيف (ATS)",
      "lbl_active_jobs": "{{count}} وظائف نشطة",
      "lbl_loading": "جاري التحميل...",
      "msg_no_active_jobs_html": "لا توجد إعلانات وظائف<br/>نشطة في الوقت الحالي",
      "lbl_unnamed_job": "وظيفة غير مسماة",
      "lbl_candidates_waiting": "{{count}} مرشحين في الانتظار",
      "lbl_daily_roster": "حالة طاقم العمل اليومية",
      "lbl_on_site": "في موقع العمل حالياً",
      "lbl_person": "أشخاص",
      "lbl_on_leave": "في إجازة / مريض",
      "lbl_kudos_title": "التقدير والثناء (Kudos)",
      "msg_no_kudos_html": "لا يوجد شكر حتى الآن.<br/>كن أول من يرسل رسالة شكر!",
      "lbl_thanked_suffix": "تلقى شكراً من",
      "lbl_company_news": "أخبار وإعلانات الشركة",
      "msg_no_announcement_html": "لا توجد إعلانات<br/>حالية",
      "doc_id": "نسخة الهوية / الجواز",
      "doc_pre_permit": "مستندات التصريح المسبق",
      "doc_work_permit": "تصريح العمل والتقرير الطبي",
      "doc_residency": "إثبات السكن / العنوان",
      "doc_visa": "التأشيرة / تصريح الإقامة",
      "doc_contract": "عقد العمل",
      "doc_nda": "اتفاقية السرية / NDA",
      "doc_handbook_ack": "إقرار دليل الموظف",
      "doc_background_check": "فحص الخلفية",
      "doc_ohs_training": "تدريب السلامة / اللياقة الطبية",
      "doc_bank_info": "بيانات البنك / IBAN",
      "doc_tax_doc": "مستند الضريبة / TIN",
      "doc_payroll": "كشف الراتب",
      "doc_social_security_record": "سجل الضمان الاجتماعي",
      "doc_performance_review": "تقييم الأداء",
      "doc_training_record": "سجل التدريب",
      "doc_leave_record": "سجل الإجازات / الغياب",
      "doc_disciplinary": "سجل تأديبي",
      "doc_termination": "إنهاء الخدمة (إخلاء طرف)",
      "doc_exit_interview": "مقابلة الخروج",
      "doc_onboarding_checklist": "قائمة بدء العمل",
      "doc_offboarding_checklist": "قائمة إنهاء الخدمة",
      "doc_certificate": "شهادات وتدريب مهني",
      "doc_other": "مستندات أخرى",
      "lbl_employee": "الموظف",
      "lbl_first_name": "الاسم الأول",
      "lbl_last_name": "اسم العائلة",
      "err_fetch_files": "تعذر جلب ملفاتك.",
      "err_fetch_emps": "تعذر جلب الموظفين.",
      "err_fetch_docs": "تعذر جلب المستندات.",
      "err_file_size": "لا يمكن أن يتجاوز حجم الملف 10 ميغابايت.",
      "msg_uploading_doc": "جاري رفع المستند إلى الأرشيف...",
      "msg_upload_pending": "تم رفع المستند بنجاح وتم إرساله لموافقة المدير.",
      "msg_upload_success": "تمت إضافة المستند إلى الأرشيف بنجاح.",
      "msg_document_status_updated": "تم تحديث حالة المستند إلى {{status}}.",
      "err_document_status_update": "تعذر تحديث حالة المستند.",
      "err_upload_failed": "حدث خطأ أثناء تحميل المستند.",
      "action_approved": "معتمد",
      "action_rejected": "مرفوض",
      "msg_status_updated": "تم تحديث حالة المستند إلى {{status}}.",
      "err_status_update": "تعذر تحديث الحالة.",
      "err_delete_pending_only": "يمكنك فقط حذف مستنداتك المعلقة (PENDING).",
      "msg_confirm_delete_doc": "سيتم حذف هذا المستند نهائياً. هل أنت متأكد؟",
      "msg_delete_success": "تم حذف المستند من الأرشيف بنجاح.",
      "err_delete_failed": "تعذر حذف المستند.",
      "lbl_archive_selection": "اختيار الأرشيف",
      "lbl_selected_employee": "الموظف المحدد",
      "msg_no_employee_selected": "لم يتم اختيار موظف بعد",
      "btn_select_employee_archive": "اختر موظفًا",
      "btn_change_employee_archive": "تغيير الموظف",
      "msg_select_emp_focus_html": "اختر موظفًا أولاً<br/>لعرض الأرشيف الإلكتروني.",
      "ph_search_emp": "ابحث عن اسم أو قسم...",
      "msg_select_emp_html": "الرجاء اختيار موظف من اليسار<br/>لعرض الأرشيف الإلكتروني.",
      "lbl_my_dossier": "أرشيفي الإلكتروني الشخصي",
      "lbl_official_dossier": "ملف الموظف الرسمي",
      "lbl_archive_size": "حجم الأرشيف",
      "lbl_docs": "مستندات",
      "lbl_upload_new_doc": "رفع مستند جديد للنظام",
      "lbl_doc_category": "فئة المستند",
      "lbl_doc_number": "رقم المستند",
      "lbl_doc_number_short": "رقم",
      "lbl_doc_issued_by": "الجهة المصدرة",
      "lbl_doc_issue_date": "تاريخ الإصدار",
      "lbl_doc_valid_until": "صالح حتى",
      "lbl_doc_mandatory": "مستند إلزامي",
      "lbl_dossier_compliance": "ملخص توافق المستندات",
      "lbl_uploaded_documents": "المستندات المرفوعة",
      "lbl_document_detail": "تفاصيل المستند",
      "tab_uploaded_documents": "المستندات المرفوعة",
      "tab_upload_document": "رفع مستند",
      "tab_compliance": "التوافق",
      "lbl_completion_score": "نسبة الاكتمال",
      "lbl_expiring_soon": "تنتهي قريباً",
      "lbl_expired_docs": "منتهية الصلاحية",
      "lbl_missing_required": "نواقص إلزامية",
      "msg_missing_required_docs": "مستندات إلزامية ناقصة",
      "msg_all_required_docs_ready": "المستندات الإلزامية مكتملة",
      "msg_dossier_compliant": "تبدو جميع المستندات الإلزامية المطلوبة مكتملة حالياً في هذا الملف.",
      "lbl_expired_required_docs": "مستندات إلزامية منتهية الصلاحية",
      "lbl_expiring_required_docs": "مستندات إلزامية تنتهي قريباً",
      "msg_no_expired_required_docs": "لا توجد حالياً مستندات إلزامية منتهية الصلاحية.",
      "msg_no_expiring_required_docs": "لا توجد حالياً مستندات إلزامية تنتهي قريباً.",
      "lbl_country_role_rule_set": "مجموعة قواعد الدولة / الدور",
      "dossier_profile_tr": "ملف تركيا",
      "dossier_profile_kktc": "ملف شمال قبرص",
      "dossier_profile_eu": "ملف الاتحاد الأوروبي",
      "dossier_profile_mena": "ملف الشرق الأوسط وشمال أفريقيا",
      "dossier_profile_global": "ملف عالمي",
      "msg_select_doc_for_detail": "اختر مستنداً لعرض التفاصيل",
      "badge_expiring_soon": "تنتهي قريباً",
      "badge_expired": "انتهت الصلاحية",
      "lbl_missing_required_dossier_docs": "مستندات إلزامية ناقصة",
      "msg_missing_required_dossier_docs_waiting": "هناك نواقص إلزامية تحتاج متابعة.",
      "lbl_expired_dossier_docs": "مستندات منتهية الصلاحية",
      "msg_expired_dossier_docs_waiting": "توجد مستندات تحتاج إلى تجديد.",
      "lbl_expiring_dossier_docs": "مستندات تنتهي قريباً",
      "msg_expiring_dossier_docs_waiting": "توجد مستندات ستنتهي صلاحيتها قريباً.",
      "lbl_select_file_format": "اختر ملف (PDF / صورة)",
      "btn_choose_from_pc": "اختر ملفاً من الكمبيوتر",
      "btn_uploading": "جاري الرفع...",
      "btn_upload_to_archive": "رفع للأرشيف",
      "lbl_max_file_size": "الحد الأقصى لحجم الملف: 10MB",
      "msg_searching_docs": "جاري البحث عن المستندات...",
      "msg_no_docs_found": "لم يتم العثور على مستندات في ملف هذا الموظف حتى الآن.",
      "badge_pending_approval": "قيد الانتظار",
      "badge_approved_doc": "مستند معتمد",
      "badge_rejected_doc": "مرفوض",
      "tooltip_view_doc": "عرض المستند",
      "btn_approve": "اعتماد",
      "btn_reject": "رفض",
      "tooltip_delete_archive": "حذف من الأرشيف",
      "tooltip_download_doc": "تحميل المستند",
      "err_fetch_assets": "تعذر جلب العهد المخصصة لك.",
      "err_empty_issue": "الرجاء وصف المشكلة بالتفصيل.",
      "msg_sending_ticket": "جاري إرسال طلب الدعم الخاص بك إلى قسم تكنولوجيا المعلومات (IT)...",
      "lbl_issue_report": "تقرير مشكلة",
      "lbl_serial_plate": "الرقم التسلسلي/اللوحة",
      "lbl_category": "الفئة",
      "lbl_issue_details": "المشكلة",
      "msg_ticket_created": "تم إنشاء طلب الدعم بنجاح!",
      "err_ticket_create_failed": "تعذر إنشاء الطلب. يرجى التواصل مع مديرك.",
      "msg_confirm_acknowledge": "هل تؤكد أنك استلمت عهدة الشركة المسماة \"{{name}}\" فعلياً وهي كاملة وبحالة جيدة؟ (هذه العملية تعتبر بمثابة توقيع رقمي)",
      "msg_acknowledging": "جاري تأكيد الاستلام...",
      "msg_acknowledge_success": "تم تأكيد استلام العهدة بنجاح!",
      "err_acknowledge_failed": "فشل في تأكيد الاستلام.",
      "lbl_my_active_assets": "عهدي النشطة",
      "msg_no_assets_html": "ليس لديك أي عهد<br/>مخصصة من الشركة حالياً.",
      "badge_in_repair": "في الإصلاح",
      "badge_active_device": "جهاز نشط",
      "lbl_no_serial_no": "لم يتم تحديد رقم تسلسلي",
      "lbl_allocation_date": "تاريخ التخصيص",
      "msg_please_acknowledge": "إذا كنت قد استلمت الجهاز فعلياً، يرجى تأكيد الاستلام أدناه.",
      "btn_acknowledge_asset": "لقد استلمت الجهاز (تأكيد)",
      "btn_asset_in_repair": "الجهاز حالياً في الصيانة",
      "btn_report_issue": "الإبلاغ عن مشكلة / طلب دعم",
      "modal_title_issue_report": "الإبلاغ عن مشكلة وطلب الدعم",
      "msg_ticket_route_warning": "سيتم إرسال طلب الدعم هذا مباشرة إلى قسم تكنولوجيا المعلومات (IT).",
      "lbl_issue_desc": "ما هي المشكلة؟ يرجى الشرح بالتفصيل.",
      "ph_issue_example": "مثال: الشاشة مكسورة، البطارية لا تشحن، لا أستطيع تسجيل الدخول للنظام...",
      "btn_send_to_it": "إرسال الطلب إلى IT",
      "cat_food": "الطعام والوجبات",
      "cat_transport": "السفر والنقل",
      "cat_accommodation": "الإقامة",
      "cat_education": "التعليم والدورات",
      "cat_office": "اللوازم المكتبية",
      "cat_customer": "استضافة العملاء",
      "cat_other": "أخرى",
      "err_fetch_expenses": "تعذر جلب النفقات.",
      "err_missing_receipt": "يرجى تحميل صورة إيصال أو فاتورة لنفقتك!",
      "lbl_no_desc": "لم يتم تقديم وصف.",
      "msg_uploading_expense": "جاري رفع بيان النفقة إلى النظام...",
      "msg_expense_submitted": "تم إرسال نفقتك مع الإيصال للموافقة!",
      "err_submit_expense": "حدث خطأ أثناء إضافة النفقة.",
      "msg_confirm_cancel_expense": "هل أنت متأكد أنك تريد إلغاء بيان النفقة هذا؟",
      "msg_canceling_expense": "جاري إلغاء النفقة...",
      "msg_expense_canceled": "تم إلغاء النفقة بنجاح.",
      "err_cancel_failed": "فشل الإلغاء.",
      "btn_new_receipt": "إيصال / فاتورة جديدة",
      "lbl_pending_approval": "في انتظار الموافقة",
      "lbl_approved_total": "المعتمد (الإجمالي)",
      "lbl_past_declarations": "بياناتي السابقة",
      "msg_no_expenses_html": "لم تقم بإدخال<br/>أي نفقات حتى الآن.",
      "tooltip_cancel_expense": "إلغاء النفقة (حذف)",
      "btn_view_receipt": "عرض الإيصال",
      "badge_approved": "معتمد",
      "badge_rejected": "مرفوض",
      "badge_pending": "قيد الانتظار",
      "lbl_cancel_reason": "سبب الإلغاء:",
      "modal_title_new_expense": "إدخال إيصال / فاتورة جديدة",
      "lbl_approved_paid": "سيتم دفع النفقات المعتمدة",
      "msg_expense_policy": "يرجى إدخال نفقات العمل الخاصة بالشركة فقط. سيتم سداد النفقات المعتمدة.",
      "msg_limit_warning": "المبلغ المدخل يتجاوز الحد المسموح به وهو {{limit}}. قد تستغرق موافقة المدير وقتاً أطول.",
      "lbl_amount": "المبلغ",
      "lbl_amount_preview": "معاينة المبلغ",
      "lbl_currency": "العملة",
      "lbl_category": "الفئة",
      "lbl_receipt_date": "تاريخ الإيصال",
      "lbl_short_desc": "وصف قصير / التفاصيل",
      "ph_expense_desc": "مثال: نفقة عشاء لزيارة عميل في الرياض...",
      "lbl_receipt_image": "صورة الإيصال / الفاتورة أو PDF",
      "btn_open_cam_gallery": "افتح الكاميرا أو اختر من المعرض",
      "btn_submit_for_approval": "إرسال النفقة للموافقة",
      "modal_title_receipt": "إيصال النفقة",
      "lbl_receipt_pdf": "ملف الإيصال PDF",
      "lbl_receipt_img": "صورة الإيصال",
      "lbl_img_not_found": "الصورة+غير+موجودة",
      "btn_close_window": "إغلاق النافذة",
      "err_fetch_leaves": "تعذر جلب الإجازات.",
      "err_date_order": "تاريخ الانتهاء لا يمكن أن يكون قبل تاريخ البدء!",
      "msg_creating_leave_req": "جاري إنشاء طلب الإجازة الخاص بك...",
      "msg_leave_req_success": "تم إرسال طلب الإجازة الخاص بك لموافقة المدير بنجاح!",
      "err_form_invalid": "بيانات النموذج غير مكتملة أو غير صالحة!",
      "err_create_failed": "تعذر إنشاء الطلب.",
      "msg_confirm_cancel_leave": "هل أنت متأكد أنك تريد إلغاء طلب الإجازة هذا؟",
      "msg_canceling_leave": "جاري إلغاء طلب الإجازة...",
      "msg_leave_canceled": "تم إلغاء طلب الإجازة بنجاح.",
      "type_annual": "إجازة سنوية (مدفوعة الأجر)",
      "type_excuse": "إجازة عذر",
      "type_sick": "إجازة مرضية (بتقرير طبي)",
      "type_unpaid": "إجازة غير مدفوعة الأجر",
      "lbl_used_this_year": "المستخدم هذا العام (المعتمد)",
      "lbl_days": "أيام",
      "btn_request_new_leave": "طلب إجازة جديدة",
      "lbl_my_leave_movements": "سجل إجازاتي",
      "msg_no_leaves_html": "ليس لديك أي طلبات<br/>إجازة حتى الآن.",
      "tooltip_cancel_leave": "إلغاء الإجازة (حذف)",
      "lbl_note": "ملاحظة:",
      "modal_title_new_leave": "إنشاء طلب إجازة",
      "lbl_request_will_be_reviewed": "سيتم تقديم طلبك لموافقة المدير",
      "msg_leave_policy": "سيتم تقييم طلبات الإجازة السنوية من قبل الموارد البشرية ومديرك المباشر.",
      "lbl_leave_type": "نوع الإجازة",
      "lbl_start_date": "تاريخ البدء",
      "lbl_end_date": "تاريخ الانتهاء",
      "lbl_reason": "السبب / الوصف",
      "ph_leave_reason": "يمكنك كتابة وصف قصير...",
      "btn_submit_leave_req": "إرسال الطلب للموافقة",
      "lbl_default_report_title": "قائمة الموظفين وتقرير السلامة",
      "col_fullname": "الاسم الكامل",
      "col_identity": "الهوية / الجواز",
      "col_department": "القسم",
      "col_position": "المنصب",
      "col_blood_type": "فصيلة الدم",
      "col_phone": "الهاتف",
      "col_email": "البريد الإلكتروني",
      "col_hire_date": "تاريخ التوظيف",
      "col_education": "التعليم",
      "col_nationality": "الجنسية",
      "opt_male": "ذكر",
      "opt_female": "أنثى",
      "opt_unknown": "غير معروف",
      "opt_university": "جامعة",
      "err_fetch_data": "حدث خطأ أثناء جلب البيانات.",
      "lbl_unassigned_dept": "مناصب غير معينة",
      "msg_opening_dossier": "جاري فتح ملف الموظف...",
      "err_loading_emp_details": "حدث خطأ أثناء تحميل تفاصيل الموظف.",
      "prompt_exit_date": "تاريخ إنهاء الخدمة (YYYY-MM-DD):",
      "msg_confirm_archive": "هل أنت متأكد أنك تريد أرشفة الموظف {{name}}؟",
      "msg_archiving_emp": "جاري أرشفة الموظف...",
      "msg_archive_success": "تمت أرشفة الموظف وتفريغ منصبه بنجاح.",
      "err_archive_failed": "قد تكون للموظف عهد/نفقات معلقة، فشلت الأرشفة.",
      "msg_confirm_reset_pwd": "هل أنت متأكد أنك تريد إعادة تعيين كلمة المرور لـ {{name}}؟",
      "msg_resetting_pwd": "جاري إعادة تعيين كلمة المرور...",
      "msg_reset_success": "تمت إعادة تعيين كلمة المرور بنجاح. (تم إرسال بريد)",
      "err_reset_failed": "حدث خطأ أثناء إعادة تعيين كلمة المرور.",
      "msg_processing_record": "جاري معالجة سجل الموظف...",
      "msg_update_success": "تم تحديث السجل بنجاح.",
      "msg_create_success": "تمت إضافة الموظف إلى النظام بنجاح.",
      "err_save_failed": "تعذر الحفظ. يرجى التحقق من البيانات المدخلة.",
      "msg_preparing_pdf": "جاري تحضير وثيقة PDF...",
      "msg_download_success": "تم تنزيل الوثيقة.",
      "err_pdf_failed": "حدث خطأ أثناء إنشاء PDF!",
      "err_select_column": "يرجى تحديد عمود واحد على الأقل.",
      "msg_generating_report": "جاري إنشاء تقريرك المخصص...",
      "msg_report_downloaded": "تم تنزيل التقرير بنجاح.",
      "err_report_failed": "حدث خطأ أثناء إنشاء التقرير.",
      "msg_processing": "جاري المعالجة...",
      "msg_profile_updated": "تم تحديث الملف الشخصي بنجاح.",
      "msg_request_rejected": "تم رفض الطلب.",
      "err_action_failed": "تعذر تنفيذ الإجراء.",
      "lbl_key_phone": "رقم الهاتف",
      "lbl_key_address": "عنوان السكن",
      "lbl_first_name": "الاسم الأول",
      "lbl_last_name": "اسم العائلة",
      "lbl_identity_no": "رقم الهوية / الجواز",
      "lbl_gender": "الجنس",
      "lbl_mother_name": "اسم الأم",
      "lbl_father_name": "اسم الأب",
      "lbl_birth_place": "مكان الميلاد",
      "lbl_birth_date": "تاريخ الميلاد",
      "lbl_phone_no": "الهاتف المحمول",
      "lbl_address": "عنوان السكن",
      "lbl_nationality": "الجنسية / المواطنة",
      "ph_nationality": "مثال: سعودي، مصري",
      "lbl_marital_married": "الحالة الاجتماعية: متزوج",
      "lbl_spouse_name": "اسم الزوج/ة الكامل",
      "lbl_spouse_works": "هل الزوج/ة يعمل؟ (خصم ضريبي)",
      "lbl_children_count": "عدد الأطفال المعالين",
      "lbl_child_name": "الاسم الكامل للطفل {{idx}}",
      "lbl_company_branch": "الشركة / الفرع",
      "opt_select": "اختر",
      "lbl_hire_date": "تاريخ التوظيف",
      "lbl_department": "القسم",
      "opt_select_dept": "اختر القسم",
      "lbl_position": "المنصب / اللقب",
      "opt_no_position": "لم يتم تحديد منصب",
      "lbl_select_dept_first": "اختر القسم أولاً",
      "lbl_system_role": "صلاحية النظام (الدور)",
      "role_employee": "موظف عادي (معلوماته فقط)",
      "role_manager": "مدير (فريقه والموافقات)",
      "role_hr": "الموارد البشرية (جميع الموظفين)",
      "role_admin": "مسؤول النظام (صلاحية كاملة)",
      "desc_role_access": "يتم ضبط القائمة اليسرى والوصول للبيانات تلقائياً بناءً على الدور.",
      "lbl_education_level": "المستوى التعليمي",
      "edu_primary": "ابتدائي",
      "edu_middle": "متوسط",
      "edu_high": "ثانوي",
      "edu_university": "جامعة",
      "edu_master": "ماجستير",
      "lbl_gross_salary": "الراتب المتفق عليه (الإجمالي)",
      "lbl_blood_type": "فصيلة الدم",
      "opt_not_selected": "غير محدد",
      "lbl_ssn": "رقم التأمينات الاجتماعية (SSN)",
      "lbl_tax_no": "الرقم الضريبي (اختياري)",
      "lbl_emergency_contact_name": "جهة اتصال الطوارئ",
      "lbl_emergency_contact_relation": "صلة القرابة",
      "lbl_emergency_contact_phone": "هاتف الطوارئ",
      "lbl_bank_name": "اسم البنك",
      "lbl_account_holder_name": "اسم صاحب الحساب",
      "lbl_iban": "IBAN",
      "lbl_tax_id_number": "الرقم الضريبي / TIN",
      "lbl_work_auth_type": "نوع تصريح العمل",
      "lbl_work_auth_no": "رقم تصريح العمل",
      "lbl_work_auth_start": "بداية التصريح",
      "lbl_work_auth_expiry": "نهاية التصريح",
      "lbl_visa_type": "نوع التأشيرة / الإقامة",
      "lbl_visa_expiry": "تاريخ انتهاء التأشيرة",
      "lbl_nda_signed_at": "تاريخ توقيع اتفاقية السرية",
      "lbl_handbook_ack_signed_at": "تاريخ إقرار دليل الموظف",
      "lbl_background_check_status": "حالة فحص الخلفية",
      "lbl_background_check_completed_at": "تاريخ فحص الخلفية",
      "lbl_occupational_health_status": "السلامة والصحة المهنية / اللياقة",
      "lbl_occupational_health_valid_until": "الصحة المهنية صالحة حتى",
      "opt_not_started": "لم يبدأ",
      "opt_in_progress": "قيد التنفيذ",
      "opt_completed_short": "مكتمل",
      "opt_exempt": "معفى",
      "opt_fit": "لائق",
      "opt_restricted": "لائق مع قيود",
      "opt_expired": "منتهي",
      "tab_active_roster": "طاقم العمل النشط",
      "tab_archive_roster": "الأرشيف (المنهية خدماتهم)",
      "btn_approvals": "الموافقات",
      "btn_custom_report": "إنشاء تقرير مخصص",
      "btn_new_record": "سجل جديد",
      "col_head_name": "الاسم / المنصب",
      "col_head_company": "الشركة / الموقع",
      "col_head_hire": "تاريخ التوظيف",
      "col_head_exit": "تاريخ الإنهاء",
      "col_head_actions": "الإجراءات",
      "msg_no_records_tab": "لا توجد سجلات في هذا التبويب.",
      "lbl_personnel_count": "موظف",
      "lbl_unassigned_short": "غير معين",
      "tooltip_download_card": "تنزيل بطاقة المعلومات (PDF)",
      "tooltip_download_cert": "تنزيل شهادة العمل (PDF)",
      "tooltip_reset_pwd": "إعادة تعيين كلمة مرور الدخول",
      "tooltip_edit": "تعديل",
      "tooltip_terminate": "إنهاء الخدمة (أرشفة)",
      "modal_title_approvals": "طلبات تحديث الملف الشخصي",
      "msg_no_pending_requests_html": "تمت مراجعة جميع الطلبات!<br/>لا توجد إجراءات معلقة.",
      "badge_new_request": "طلب جديد",
      "btn_reject": "رفض",
      "btn_approve": "اعتماد",
      "modal_title_custom_report": "إنشاء تقرير مخصص",
      "lbl_report_title": "عنوان التقرير",
      "lbl_report_columns": "المعلومات المراد تضمينها (الأعمدة)",
      "btn_cancel": "إلغاء",
      "btn_download_pdf_report": "تنزيل تقرير PDF",
      "modal_title_edit_emp": "تحديث ملف الموظف",
      "modal_title_new_emp": "تسجيل موظف جديد",
      "step_1": "1. الهوية",
      "step_2": "2. التواصل والعائلة",
      "step_3": "3. الشركة",
      "step_4": "4. المالية والقانونية",
      "btn_back": "رجوع",
      "lbl_step": "خطوة {{step}} / 4",
      "btn_next": "التالي",
      "btn_update_record": "تحديث السجل",
      "btn_complete_record": "إكمال التسجيل",
      "err_session_expired": "قد تكون جلستك انتهت، يرجى تسجيل الدخول مرة أخرى.",
      "err_fetch_performance": "تعذر جلب بيانات الأداء.",
      "msg_progress_saved": "تم حفظ التقدم بنجاح.",
      "err_progress_update": "تعذر تحديث التقدم.",
      "lbl_loading_performance": "جاري تحميل بيانات الأداء...",
      "lbl_ai_career_assistant": "مساعد الذكاء الاصطناعي (AI) المهني",
      "msg_default_ai_summary": "بناءً على تقييماتك وأهدافك السابقة، فقد حققت زخماً رائعاً. استمر على هذا النحو!",
      "lbl_active_goals": "أهدافي النشطة (OKRS)",
      "msg_no_assigned_goals": "لم يتم تعيين أي أهداف لك بعد.",
      "lbl_progress_status": "حالة التقدم",
      "lbl_drag_to_save": "اسحب وأفلت الشريط للحفظ",
      "lbl_my_reviews": "تقييماتي",
      "msg_no_past_reviews": "لا توجد تقييمات سابقة.",
      "lbl_manager_note": "ملاحظة المدير",
      "mood_great": "رائع",
      "mood_good": "جيد",
      "mood_normal": "عادي",
      "mood_bad": "سيء",
      "mood_awful": "مريع",
      "badge_team_star": "🌟 نجم الفريق",
      "badge_fast_solver": "🚀 الحلّال السريع",
      "badge_helpful": "🦸‍♂️ متعاون جداً",
      "badge_creative": "💡 فكرة مبتكرة",
      "lbl_employee_fallback": "الموظف",
      "err_fetch_portal": "تعذر تحميل بيانات البوابة، يرجى تحديث الصفحة.",
      "msg_creating_leave": "جاري إنشاء طلب الإجازة الخاص بك...",
      "msg_leave_success": "تم إرسال طلب إجازتك لموافقة المدير بنجاح!",
      "err_leave_failed": "تعذر إنشاء الطلب.",
      "msg_no_changes": "لم تقم بإجراء أي تغييرات.",
      "msg_sending_update": "جاري إرسال طلب التحديث...",
      "msg_update_success": "تم إرسال طلب التغيير الخاص بك إلى الموارد البشرية للموافقة!",
      "err_update_failed": "تعذر إرسال الطلب. يرجى المحاولة مرة أخرى.",
      "err_pwd_match": "كلمات المرور الجديدة غير متطابقة!",
      "err_pwd_length": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
      "msg_changing_pwd": "جاري تغيير كلمة المرور...",
      "msg_pwd_changed": "تم تغيير كلمة المرور بنجاح!",
      "err_pwd_failed": "تعذر تغيير كلمة المرور.",
      "msg_mood_success": "تم مشاركة حالتك المزاجية مع الفريق بنجاح!",
      "err_mood_failed": "تعذر حفظ حالتك المزاجية.",
      "msg_sending_kudos": "جاري إرسال الشارة...",
      "msg_kudos_success": "تم إرسال شارة الشكر بنجاح!",
      "err_kudos_failed": "تعذر إرسال الشارة.",
      "lbl_loading_portal": "جاري تحميل البوابة...",
      "lbl_hello": "مرحباً، {{name}} 👋",
      "lbl_personnel": "موظف",
      "lbl_general_dept": "القسم العام",
      "btn_account_pwd": "حسابي / كلمة المرور",
      "btn_req_new_leave": "طلب إجازة جديدة",
      "lbl_used_this_year": "المستخدم هذا العام: {{days}} أيام",
      "btn_declare_expense": "تقديم مطالبة نفقات",
      "lbl_receipt_invoice": "إدخال الإيصالات والفواتير",
      "lbl_how_do_you_feel": "كيف تشعر اليوم؟",
      "lbl_share_mood": "شارك حالتك المزاجية وأرسل طاقة إيجابية لفريقك!",
      "lbl_upcoming_trainings": "دوراتي التدريبية القادمة",
      "lbl_no_trainings": "ليس لديك أي دورات تدريبية مجدولة أو قادمة.",
      "lbl_participant": "مشارك",
      "lbl_my_assets": "عهدي النشطة",
      "lbl_no_assets": "لا يوجد عهد نشطة مخصصة لك.",
      "lbl_celebrations_this_month": "نحتفل هذا الشهر!",
      "lbl_no_celebrations": "لا توجد مناسبات للاحتفال<br/>هذا الشهر.",
      "lbl_day": "يوم",
      "lbl_birthday": "يوم الميلاد",
      "lbl_anniversary": "الذكرى السنوية الـ {{years}}",
      "lbl_kudos_board": "لوحة التقدير (Kudos)",
      "tooltip_send_badge": "أرسل شارة",
      "lbl_no_kudos": "لم يقم أحد بإرسال شارة بعد.<br/>كن أول من يشكر زملاءه!",
      "modal_title_kudos": "إرسال شارة شكر",
      "lbl_to_whom": "إلى من ترسلها؟",
      "opt_select_colleague": "-- اختر زميلاً --",
      "lbl_select_badge": "اختر الشارة",
      "lbl_write_note": "اكتب ملاحظة لطيفة",
      "ph_kudos_note": "شكراً جزيلاً على مساعدتك...",
      "btn_send_kudos": "إرسال الشارة والرسالة",
      "modal_title_leave": "إنشاء طلب إجازة",
      "lbl_manager_approval": "سيتم تقديم طلبك لموافقة المدير",
      "lbl_used_leave": "الإجازة المستخدمة هذا العام",
      "lbl_days": "أيام",
      "lbl_leave_type": "نوع الإجازة",
      "opt_annual": "إجازة سنوية (مدفوعة الأجر)",
      "opt_excuse": "إجازة عذر",
      "opt_sick": "إجازة مرضية (تقرير طبي)",
      "opt_unpaid": "إجازة بدون راتب",
      "lbl_start": "البداية",
      "lbl_end": "النهاية",
      "lbl_reason": "السبب / الوصف",
      "ph_reason": "يمكنك كتابة وصف قصير...",
      "btn_cancel": "إلغاء",
      "btn_submit_approval": "إرسال للموافقة",
      "modal_title_settings": "إعدادات الحساب",
      "tab_contact": "معلومات الاتصال",
      "tab_password": "تغيير كلمة المرور",
      "lbl_update_req": "طلب تحديث",
      "desc_update_req": "يتم إرسال التغييرات التي يتم إجراؤها هنا كـ \"مسودة\" إلى الموارد البشرية. سيتم تطبيقها على ملفك الرسمي بمجرد الموافقة عليها.",
      "lbl_phone": "رقم الهاتف",
      "ph_phone": "مثال: 05XX XXX XX XX",
      "lbl_address": "عنوان السكن",
      "ph_address": "أدخل عنوانك بالكامل...",
      "lbl_old_pwd": "كلمة المرور الحالية",
      "ph_old_pwd": "كلمة المرور التي تستخدمها لتسجيل الدخول",
      "lbl_new_pwd": "كلمة المرور الجديدة",
      "ph_new_pwd": "6 أحرف على الأقل",
      "lbl_confirm_pwd": "تأكيد كلمة المرور",
      "ph_confirm_pwd": "تأكيد كلمة المرور الجديدة",
      "btn_change_pwd": "تغيير كلمة المرور",
      "err_fetch_trainings": "تعذر جلب تقويم التدريب الخاص بك.",
      "lbl_loading_trainings": "جاري تحميل تقويم التدريب...",
      "lbl_assigned_training": "التدريبات المخصصة لك:",
      "lbl_count": "عنصر",
      "msg_no_upcoming_html": "لا يوجد لديك أي تدريبات<br/>مجدولة في الفترة القادمة.",
      "badge_approaching": "قريباً",
      "lbl_date": "التاريخ",
      "lbl_time": "الوقت",
      "lbl_instructor": "المدرب",
      "lbl_location": "الموقع",
      "lbl_past_cancelled_trainings": "التدريبات السابقة والملغاة",
      "badge_cancelled_by_admin": "تم الإلغاء من قِبل الإدارة",
      "lbl_unknown_field": "حقل غير معروف",
      "err_format_invalid": "خطأ ({{field}}): التنسيق مفقود أو غير صالح!",
      "err_no_user_id": "لم يتم العثور على معرف المستخدم.",
      "msg_confirm_approve": "هل أنت متأكد أنك تريد الموافقة على بيان النفقة هذا؟",
      "msg_processing": "جاري المعالجة وإرسال البريد الإلكتروني...",
      "msg_confirm_delete_expense": "هل أنت متأكد أنك تريد حذف هذه النفقة تماماً؟",
      "msg_expense_deleted": "تم حذف سجل النفقة بنجاح.",
      "tab_pending": "قيد الانتظار",
      "tab_approved": "معتمد",
      "tab_rejected": "مرفوض",
      "btn_new_expense": "إدخال نفقة جديدة",
      "lbl_loading": "جاري تحميل النفقات...",
      "msg_no_expenses_category_html": "لا توجد بيانات نفقات في هذه الفئة.",
      "col_personnel": "الموظف",
      "col_category_date": "الفئة والتاريخ",
      "col_amount": "المبلغ",
      "col_receipt": "الإيصال / الفاتورة",
      "col_description": "الوصف / ملاحظة",
      "col_actions": "الإجراءات",
      "badge_added_to_payroll": "تمت الإضافة للرواتب",
      "lbl_no_doc": "لا يوجد مستند",
      "lbl_action_completed": "تم الإجراء",
      "tooltip_delete_req": "حذف طلبي",
      "lbl_no_action_needed": "لا يلزم أي إجراء",
      "lbl_expense_date": "تاريخ النفقة",
      "lbl_desc_details": "الوصف / التفاصيل",
      "lbl_personnel_name": "الموظف:",
      "prompt_reject_reason": "يرجى كتابة سبب الرفض (اختياري):",
      "prompt_reject_default": "صورة الإيصال غير مقروءة أو غير قياسية.",
      "err_fetch_tickets": "تعذر جلب التذاكر.",
      "err_fetch_details": "تعذر جلب تفاصيل التذكرة.",
      "msg_creating_ticket": "جاري إنشاء تذكرة الدعم...",
      "msg_ticket_created": "تم إنشاء تذكرتك بنجاح.",
      "err_create_ticket": "حدث خطأ أثناء إنشاء التذكرة.",
      "msg_sending_msg": "جاري إرسال الرسالة...",
      "lbl_file_attached": "يرجى مراجعة الملف المرفق.",
      "msg_msg_sent": "تم إرسال الرسالة!",
      "err_send_msg": "لم يتم إرسال الرسالة.",
      "msg_confirm_resolve": "هل ترغب في تحديد هذه التذكرة على أنها \"تم الحل\"؟ لا يمكن التراجع عن هذا الإجراء وسيتم إغلاق المحادثة.",
      "msg_closing_ticket": "جاري إغلاق التذكرة...",
      "msg_ticket_closed": "تم إغلاق التذكرة بنجاح.",
      "err_update_status": "تعذر تحديث الحالة.",
      "status_open": "مفتوح",
      "status_in_progress": "قيد التنفيذ",
      "status_resolved": "تم الحل",
      "cat_payroll": "مسيرات الرواتب",
      "cat_it": "دعم تقني (IT)",
      "cat_hr": "طلب موارد بشرية",
      "cat_admin": "إداري / مواد",
      "btn_create_ticket": "إنشاء تذكرة جديدة",
      "lbl_tickets": "التذاكر",
      "lbl_urgent": "عاجل",
      "msg_no_tickets_html": "لا توجد تذاكر مسجلة<br/>في النظام.",
      "lbl_ticket_no": "رقم التذكرة:",
      "btn_close_ticket": "إغلاق التذكرة",
      "msg_no_messages": "لم يتم إرسال أي رسائل حتى الآن.",
      "btn_open_attachment": "فتح الملف المرفق",
      "lbl_click_to_view": "انقر للعرض",
      "ph_type_reply": "اكتب رداً...",
      "msg_ticket_closed_comment": "هذه التذكرة مغلقة للتعليقات لأنه تم حلها.",
      "msg_select_ticket_html": "اختر تذكرة من اليسار<br/>لعرض التفاصيل والرسائل",
      "modal_title_new_ticket": "تذكرة دعم جديدة",
      "lbl_subject_summary": "ملخص الموضوع",
      "ph_subject": "مثال: أطلب مسير راتبي لشهر مارس 2024",
      "lbl_priority": "الأولوية",
      "prio_low": "منخفض",
      "prio_normal": "عادي",
      "prio_urgent": "عاجل",
      "lbl_message_details": "رسالتك / التفاصيل",
      "ph_ticket_message": "اكتب طلبك هنا...",
      "btn_submit_ticket": "إرسال الطلب إلى النظام",
      "err_fetch_requests": "حدث خطأ أثناء جلب طلبات الإجازة.",
      "prompt_reject_reason": "يرجى تحديد سبب الرفض (إلزامي):",
      "prompt_reject_default": "غير مناسب بسبب ضغط العمليات.",
      "err_reject_reason_required": "يجب تقديم سبب لرفض الإجازة.",
      "msg_confirm_approve": "هل أنت متأكد أنك تريد الموافقة على طلب الإجازة هذا؟",
      "msg_processing": "جاري المعالجة وإرسال البريد الإلكتروني...",
      "action_approved": "تمت الموافقة",
      "action_rejected": "مرفوض",
      "msg_status_updated": "الطلب {{status}}.",
      "err_action_failed": "حدث خطأ أثناء العملية.",
      "err_missing_form_data": "يرجى ملء التواريخ والسبب بالكامل.",
      "msg_creating_leave": "جاري إنشاء طلب الإجازة الخاص بك...",
      "msg_leave_req_success": "تم إنشاء طلب الإجازة وإرساله للموافقة بنجاح!",
      "err_leave_submit_failed": "معلومات ناقصة أو فشلت العملية.",
      "err_fetch_summary": "تعذر جلب ملخص الموظف.",
      "badge_pending": "في انتظار الموافقة",
      "badge_approved": "معتمد",
      "badge_rejected": "مرفوض",
      "badge_unknown": "غير معروف",
      "type_annual": "إجازة سنوية (مدفوعة)",
      "type_excuse": "إجازة عذر",
      "type_sick": "إجازة مرضية (بتقرير)",
      "type_unpaid": "إجازة بدون راتب",
      "tab_pending_approvals": "الموافقات المعلقة",
      "tab_approved_requests": "المعتمدة",
      "tab_rejected_requests": "المرفوضة",
      "btn_new_leave_req": "طلب إجازة جديد",
      "lbl_loading_requests": "جاري تحميل الطلبات...",
      "msg_no_requests_html": "لا توجد طلبات إجازة في هذه الفئة.",
      "col_personnel": "الموظف",
      "col_status": "الحالة",
      "col_leave_type": "نوع الإجازة",
      "col_date_range": "النطاق الزمني",
      "col_days": "الأيام",
      "col_description": "الوصف / ملاحظة",
      "col_actions": "الإجراءات",
      "btn_leave_summary": "ملخص الإجازات المتبقية",
      "lbl_cancel_note": "ملاحظة:",
      "lbl_action_completed": "تم الإجراء",
      "lbl_no_action_needed": "لا يلزم اتخاذ إجراء",
      "lbl_pending_authorization": "في انتظار الصلاحية",
      "btn_approve": "اعتماد",
      "btn_reject": "رفض",
      "modal_title_create_leave": "إنشاء طلب إجازة",
      "lbl_leave_type": "نوع الإجازة",
      "lbl_start": "البداية",
      "lbl_end": "النهاية",
      "lbl_calculated_days": "الأيام المحسوبة:",
      "lbl_days": "أيام",
      "lbl_reason": "السبب / الوصف",
      "ph_leave_reason": "اشرح سبب الإجازة باختصار...",
      "btn_cancel": "إلغاء",
      "btn_submit_approval": "إرسال للموافقة",
      "modal_title_leave_summary": "ملخص مستحقات الإجازة",
      "lbl_total_used_this_year": "إجمالي المستخدم هذا العام",
      "lbl_usage_breakdown": "تفصيل الاستخدام",
      "msg_no_approved_leaves": "لم يتم العثور على سجلات إجازة معتمدة حتى الآن.",
      "btn_close_window": "إغلاق النافذة",
      "err_fetch_locations": "تعذر جلب المواقع.",
      "err_geo_not_supported": "متصفحك لا يدعم تحديد الموقع الجغرافي (GPS).",
      "msg_geo_success": "تم الحصول على موقعك بنجاح.",
      "err_geo_failed": "تعذر الحصول على الموقع. يرجى التحقق من أذونات المتصفح.",
      "msg_saving_location": "جاري حفظ الموقع...",
      "msg_location_updated": "تم تحديث الموقع بنجاح.",
      "msg_location_added": "تمت إضافة موقع جديد بنجاح.",
      "msg_confirm_delete_location": "هل أنت متأكد أنك تريد حذف (أرشفة) الموقع \"{{name}}\"؟ سيؤدي هذا الإجراء إلى إبطال رمز الاستجابة السريعة (QR) الخاص به.",
      "msg_archiving_location": "جاري أرشفة الموقع...",
      "msg_location_deleted": "تم حذف الموقع بنجاح.",
      "err_delete_location": "حدث خطأ أثناء حذف الموقع.",
      "msg_confirm_rotate_qr": "تحذير: هل أنت متأكد أنك تريد إبطال رمز الاستجابة السريعة الحالي لموقع \"{{name}}\" وإنشاء رمز أمان جديد تماماً؟ (اللوحات الحالية لن تعمل بعد الآن!)",
      "msg_resetting_qr": "جاري إعادة تعيين رمز الاستجابة السريعة...",
      "msg_qr_rotated": "تم تجديد رمز الأمان. لا تنسَ تنزيل اللوحة الجديدة!",
      "err_rotate_qr": "حدث خطأ أثناء تجديد رمز الاستجابة السريعة.",
      "msg_preparing_poster": "جاري تحضير ملصق PDF...",
      "msg_poster_downloaded": "تم تنزيل PDF.",
      "err_poster_failed": "حدث خطأ أثناء إنشاء الملصق.",
      "lbl_anti_fraud_system": "نظام مكافحة الاحتيال (الأسوار الجغرافية)",
      "desc_anti_fraud_html": "لكل موقع تضيفه، يقوم النظام بإنشاء ملصق QR بحجم A4 مزود بـ <span class='bg-rose-200 text-rose-900 px-2 py-0.5 rounded-md font-black'>رمز أمان</span>. إذا حاول الموظف مسحه من مسافة بعيدة (أو عبر صور واتساب)، يتحقق النظام من GPS ويرفض الدخول.",
      "btn_add_location": "إضافة موقع / مكتب",
      "lbl_loading_locations": "جاري تحميل المواقع...",
      "msg_no_locations_html": "لا توجد مواقع/مكاتب مسجلة في النظام.",
      "tooltip_reset_qr": "إعادة تعيين رمز QR (مكافحة الاحتيال)",
      "tooltip_delete": "حذف (أرشفة)",
      "lbl_no_address": "لم يتم تحديد عنوان",
      "lbl_latitude": "دائرة العرض (LAT)",
      "lbl_longitude": "خط الطول (LNG)",
      "lbl_security_radius": "النطاق الأمني",
      "lbl_meters": "متر",
      "btn_download_poster": "تنزيل ملصق QR بحجم A4",
      "modal_title_edit_loc": "تعديل موقع / مكتب",
      "modal_title_new_loc": "إضافة موقع / مكتب جديد",
      "lbl_location_name": "اسم الموقع (مثل: المكتب الرئيسي)",
      "lbl_full_address": "العنوان الكامل",
      "ph_optional": "اختياري...",
      "lbl_gps_coordinates": "إحداثيات GPS",
      "btn_finding_location": "جاري التحديد...",
      "btn_get_my_location": "الحصول على موقعي الحالي",
      "lbl_security_radius_input": "النطاق الأمني (نصف القطر بالمتر)",
      "desc_radius_warning": "إذا خرج الموظف من هذا النطاق، فلن يعمل رمز QR ولن يتمكن من تسجيل الدخول.",
      "btn_update_location": "تحديث الموقع",
      "btn_save_location": "حفظ الموقع في النظام",
      "login_failed_generic": "فشل تسجيل الدخول. يرجى التحقق من بياناتك.",
      "server_unreachable": "يتعذر الوصول إلى الخادم. يرجى التحقق من اتصالك.",
      "login_title": "تسجيل الدخول إلى IKPro",
      "email_label": "البريد الإلكتروني:",
      "password_label": "كلمة المرور:",
      "login_button": "تسجيل الدخول",
      "lbl_user": "المستخدم",
      "role_superadmin": "مسؤول النظام",
      "role_admin": "الموارد البشرية (مدير)",
      "role_hr": "الموارد البشرية (أخصائي)",
      "role_manager": "مدير القسم",
      "role_employee_short": "موظف",
      "lbl_notifications": "الإشعارات",
      "lbl_new": "جديد",
      "msg_no_new_notifs": "لا توجد إشعارات جديدة",
      "lbl_leave_requests": "طلبات الإجازة",
      "lbl_items": "عنصر",
      "msg_leave_waiting": "طلب إجازة بانتظار موافقتك.",
      "lbl_expense_requests": "طلبات النفقات",
      "msg_expense_waiting": "نفقة بانتظار موافقتك.",
      "lbl_open_tickets": "التذاكر المفتوحة",
      "msg_ticket_waiting": "تذكرة دعم مفتوحة.",
      "btn_view_all_dashboard": "عرض الكل (الذهاب للوحة القيادة)",
      "lbl_logged_in": "تم تسجيل الدخول",
      "btn_secure_logout": "تسجيل خروج آمن",
      "tooltip_drag_to_move": "اسحب للتحريك",
      "tooltip_edit_position": "تعديل بيانات المنصب",
      "tooltip_delete_position": "حذف المنصب",
      "lbl_vacant_position": "منصب شاغر",
      "lbl_filled_positions": "مناصب مشغولة",
      "lbl_employee_count": "عدد الموظفين",
      "err_fetch_org_data": "تعذر جلب بيانات الهيكل التنظيمي.",
      "msg_confirm_delete_pos": "هل أنت متأكد أنك تريد حذف هذا المنصب؟ قد يتأثر المرؤوسون والموظفون.",
      "msg_deleting_pos": "جاري حذف المنصب...",
      "msg_delete_success": "تم حذف المنصب بنجاح.",
      "err_delete_pos_failed": "قد يحتوي المنصب على موظفين، فشل الحذف.",
      "msg_creating_dept": "جاري إنشاء القسم...",
      "msg_dept_added": "تمت إضافة القسم الجديد للنظام.",
      "err_add_dept": "تعذر إضافة القسم.",
      "err_hierarchy_loop": "خطأ في التسلسل الهرمي: لا يمكنك ربط منصب أعلى بمنصب تابع له!",
      "msg_confirm_move_pos": "هل أنت متأكد أنك تريد ربط هذا المنصب بمدير جديد؟",
      "msg_updating_org": "جاري تحديث الهيكل...",
      "msg_move_success": "تم نقل المنصب بنجاح.",
      "err_move_failed": "حدث خطأ أثناء نقل المنصب.",
      "err_select_dept": "يرجى تحديد قسم!",
      "err_self_parent": "لا يمكنك ربط المنصب بنفسه!",
      "msg_saving_pos": "جاري حفظ المنصب...",
      "msg_update_pos_success": "تم تحديث المنصب.",
      "msg_create_pos_success": "تم إنشاء منصب جديد.",
      "lbl_drag_drop_info": "يمكنك سحب وإفلات المناصب لربطها",
      "btn_create_dept": "إضافة قسم",
      "btn_create_position": "إضافة منصب",
      "lbl_loading_chart": "جاري إنشاء الهيكل...",
      "msg_empty_org_chart_html": "لا توجد مناصب في النظام حتى الآن.<br/>أنشئ قسماً أولاً، ثم أضف المنصب الأول.",
      "modal_title_new_dept": "إضافة قسم جديد",
      "lbl_department_name": "اسم القسم",
      "ph_department_name": "مثال: تكنولوجيا المعلومات",
      "btn_save_dept": "حفظ القسم",
      "modal_title_edit_pos": "تحديث المنصب",
      "modal_title_new_pos": "تعريف منصب جديد",
      "lbl_position_name": "اسم المنصب / اللقب",
      "ph_position_name": "مثال: مهندس ميداني",
      "lbl_belongs_to_dept": "تابع لقسم",
      "lbl_parent_position": "المنصب الأعلى (المدير المباشر)",
      "opt_top_management": "الإدارة العليا (غير تابع لأحد)",
      "desc_parent_pos_info": "طلبات الإجازة من الموظفين في هذا المنصب ستنتقل إلى المنصب الأعلى المحدد.",
      "btn_save_changes": "حفظ التغييرات",
      "btn_save_to_system": "الحفظ في النظام",
      "err_select_personnel": "يرجى تحديد موظف أولاً!",
      "msg_ai_success": "اكتمل تحليل AI 9-Box.",
      "err_ai_failed": "تعذر إنشاء تحليل الذكاء الاصطناعي في الوقت الحالي.",
      "msg_goal_updated": "تم تحديث الهدف.",
      "msg_goal_added": "تم تعيين هدف جديد.",
      "err_goal_saved": "تعذر حفظ الهدف!",
      "confirm_delete_goal": "هل أنت متأكد أنك تريد حذف هذا الهدف؟",
      "msg_goal_deleted": "تم حذف الهدف.",
      "err_goal_deleted": "تعذر حذف الهدف!",
      "msg_progress_saved": "تم حفظ التقدم.",
      "err_progress_update": "تعذر تحديث التقدم!",
      "msg_review_updated": "تم تحديث التقييم.",
      "msg_review_saved": "تم حفظ التقييم.",
      "err_review_failed": "خطأ في التقييم!",
      "confirm_delete_review": "هل أنت متأكد أنك تريد حذف هذا التقييم؟",
      "msg_review_deleted": "تم حذف التقييم.",
      "err_review_deleted": "تعذر حذف التقييم.",
      "tab_okr": "الأهداف (OKR)",
      "tab_360": "تقييم 360 درجة",
      "tab_ai": "تحليل المواهب AI",
      "opt_select_personnel": "اختر الموظف",
      "lbl_eval_center": "مركز التقييم",
      "msg_select_personnel": "يرجى اختيار موظف للمتابعة.",
      "lbl_strategic_goals": "الأهداف الاستراتيجية",
      "btn_add_goal": "إضافة هدف جديد",
      "msg_no_goals": "ليس لديك أهداف معينة حتى الآن.",
      "lbl_progress": "التقدم الحالي",
      "msg_ai_analyzing": "جاري تحليل البيانات بالذكاء الاصطناعي...",
      "lbl_9box_matrix": "مصفوفة 9-BOX (الأداء/الإمكانات)",
      "lbl_ai_summary": "الملخص التنفيذي AI",
      "lbl_dev_suggestion": "اقتراح التطوير",
      "val_fast_promo": "ترقية سريعة / تدريب قيادي",
      "lbl_risk_analysis": "تحليل المخاطر",
      "val_low_risk": "منخفض (تفاعل عالي)",
      "msg_press_to_analyze": "اضغط على الزر لبدء التحليل.",
      "btn_run_analysis": "تشغيل التحليل",
      "box_STAR": "نجم (STAR)",
      "box_HIGH_POTENTIAL": "إمكانات عالية",
      "box_ENIGMA": "لغز (ENIGMA)",
      "box_HIGH_PERFORMER": "أداء عالي",
      "box_CORE_EMPLOYEE": "موظف أساسي",
      "box_DILEMMA": "معضلة (DILEMMA)",
      "box_SOLID_PERFORMER": "أداء قوي",
      "box_EFFECTIVE_EMPLOYEE": "موظف فعال",
      "box_UNDER_PERFORMER": "أداء منخفض",
      "lbl_feedback_pool": "مجموعة الملاحظات",
      "btn_score": "إضافة تقييم",
      "msg_no_reviews": "لا توجد تقييمات سابقة.",
      "lbl_peer_note": "ملاحظة زميل",
      "modal_review_title": "تسجيل الأداء",
      "lbl_review_period": "فترة التقييم",
      "opt_q1": "الربع الأول 2026",
      "opt_q2": "الربع الثاني 2026",
      "opt_q3": "الربع الثالث 2026",
      "opt_q4": "الربع الرابع 2026",
      "opt_custom_period": "فترة مخصصة...",
      "ph_custom_period": "مثال: التقييم السنوي 2026",
      "lbl_rating": "التقييم العام (1-5)",
      "lbl_manager_comments": "تعليقات / ملاحظات المدير",
      "ph_manager_comments": "اكتب ملاحظاتك حول نقاط قوة الموظف ومجالات التطوير هنا...",
      "btn_cancel": "إلغاء",
      "btn_save_score": "حفظ التقييم",
      "modal_goal_title": "معلمات الهدف",
      "lbl_goal_title": "عنوان الهدف",
      "lbl_goal_desc": "التفاصيل",
      "lbl_due_date": "تاريخ الاستحقاق",
      "opt_end_q1": "نهاية الربع الأول 2026",
      "opt_end_q2": "نهاية الربع الثاني 2026",
      "opt_end_q3": "نهاية الربع الثالث 2026",
      "opt_end_q4": "نهاية الربع الرابع 2026",
      "opt_custom_date": "تاريخ مخصص...",
      "btn_save": "حفظ",
      "err_unauthorized_access": "ليس لديك صلاحية للوصول إلى هذه الصفحة!",
      "err_fill_all_fields": "يرجى ملء جميع الحقول.",
      "err_pwd_length": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
      "msg_creating_account": "جاري إنشاء حسابك وملف الشركة...",
      "msg_registration_success": "اكتمل التسجيل بنجاح! بدأت تجربتك المجانية لمدة 30 يوماً.",
      "err_registration_failed": "حدث خطأ أثناء التسجيل.",
      "lbl_welcome_title_html": "مرحباً بك في<br/>KTC HR",
      "lbl_welcome_desc": "أنت على وشك البدء في إدارة جميع عمليات الموارد البشرية، الأداء، العهد، والعمليات التشغيلية تحت سقف واحد.",
      "lbl_feature_1": "تجربة مجانية لمدة 30 يوماً",
      "lbl_feature_2": "إضافة موظفين بلا حدود",
      "lbl_feature_3": "إلغاء الاشتراك في أي وقت",
      "lbl_step_company": "الشركة",
      "lbl_step_payment": "الدفع",
      "lbl_corporate_info": "معلومات الشركة",
      "lbl_company_org_name": "اسم الشركة / المؤسسة",
      "ph_company_name": "مثال: شركة التقنية الحديثة",
      "lbl_manager_name": "الاسم الكامل للمدير",
      "ph_manager_name": "الاسم الكامل",
      "lbl_business_email": "البريد الإلكتروني للعمل",
      "ph_business_email": "admin@company.com",
      "lbl_account_password": "كلمة مرور الحساب",
      "ph_password": "6 أحرف على الأقل",
      "btn_proceed_payment": "المتابعة إلى الدفع",
      "msg_already_have_account": "هل لديك حساب بالفعل؟",
      "btn_login_link": "تسجيل الدخول",
      "lbl_payment_method": "طريقة الدفع",
      "lbl_ssl_secure": "مؤمن بـ 256-BIT SSL",
      "lbl_card_holder_display": "حامل البطاقة",
      "lbl_full_name_display": "الاسم الكامل",
      "lbl_expiry_display": "انتهاء",
      "lbl_mm_yy_display": "شهر/سنة",
      "lbl_card_name": "الاسم على البطاقة",
      "ph_card_name": "اسم حامل البطاقة",
      "lbl_card_number": "رقم البطاقة",
      "lbl_expiry_date": "تاريخ الانتهاء",
      "ph_expiry_date": "شهر/سنة",
      "lbl_security_code": "رمز الأمان",
      "ph_security_code": "CVC",
      "msg_no_charge_warning": "* <strong class='text-indigo-600'>لن يتم خصم أي رسوم</strong> من بطاقتك الائتمانية خلال فترة التجربة المجانية.",
      "btn_back": "رجوع",
      "btn_complete_and_start": "إكمال التسجيل والبدء",
      "lbl_loading": "جاري التحميل...",
      "role_superadmin": "مسؤول النظام",
      "role_admin": "الموارد البشرية (مدير)",
      "role_hr": "الموارد البشرية (أخصائي)",
      "role_manager": "مدير القسم",
      "role_employee_short": "موظف",
      "menu_dashboard": "لوحة القيادة",
      "menu_employees": "إدارة شؤون الموظفين",
      "menu_org_chart": "الهيكل التنظيمي",
      "menu_ats": "تتبع المتقدمين (ATS)",
      "menu_attendance": "الوقت والحضور",
      "menu_operations_time": "العمليات / الوقت والحضور",
      "menu_locations": "المواقع والمنشآت",
      "menu_leaves": "إدارة الإجازات",
      "menu_dossier": "أرشيف الملفات (E-Dossier)",
      "menu_performance": "الأداء (OKR)",
      "menu_training": "التدريب (LMS)",
      "menu_expenses": "إدارة النفقات",
      "menu_assets": "الأصول والمخزون",
      "menu_helpdesk": "مكتب المساعدة",
      "menu_portal": "لوحة القيادة",
      "menu_my_team": "فريقي (الموظفين)",
      "menu_settings": "إعدادات الشركة (جديد)",
      "operations_time_kicker": "العمليات / الوقت والحضور",
      "operations_time_title": "عمليات الحضور والرواتب",
      "operations_time_desc": "إدارة التقويمات والعقود والاعتمادات وفترات الحضور وملفات التصدير من شاشة واحدة.",
      "schedule_management_kicker": "تخطيط الورديات",
      "schedule_management_title": "خطط الورديات والتعيينات",
      "schedule_management_desc": "أنشئ قوالب الورديات وعيّنها للأقسام وأدر استثناءات الموظفين.",
      "schedule_management_open": "فتح تخطيط الورديات",
      "operations_time_tab_puantaj": "الحضور",
      "operations_time_tab_schedules": "تخطيط الورديات",
      "operations_time_tab_leave": "إعدادات الإجازات",
      "operations_time_tab_departments": "تعيينات الأقسام",
      "operations_time_tab_overrides": "استثناءات الموظفين",
      "operations_time_tab_reports": "تقرير الرواتب",
      "operations_time_tab_settings": "إعدادات الحضور",
      "operations_time_tabs": "علامات تبويب الحضور",
      "pay_code_title": "اعتماد رموز الأجور والمعاملات",
      "pay_code_desc": "لا يتم تصدير المعاملات غير المعتمدة.",
      "pay_code_seed": "إنشاء القيم الافتراضية",
      "pay_code_add": "اقتراح",
      "pay_code_category": "الفئة",
      "pay_code_code": "الرمز",
      "pay_code_name": "الوصف",
      "pay_code_accounting_code": "رمز المحاسبة",
      "pay_code_coefficient": "المعامل",
      "pay_code_unit": "الوحدة",
      "pay_code_status_approved": "معتمد",
      "pay_code_status_proposed": "بانتظار الاعتماد",
      "pay_code_status_rejected": "مرفوض",
      "pay_code_category_work": "عمل",
      "pay_code_category_overtime": "عمل إضافي",
      "pay_code_category_holiday": "عطلة رسمية",
      "pay_code_category_leave": "إجازة",
      "pay_code_category_absence": "غياب",
      "payroll_export_title": "ملف تصدير الرواتب",
      "payroll_export_desc": "لا يمكن استخدام تنسيق محاسبي بدون ملف معتمد.",
      "payroll_export_provider": "المزود",
      "payroll_export_format": "التنسيق",
      "payroll_export_delimiter": "الفاصل",
      "payroll_export_date_format": "تنسيق التاريخ",
      "payroll_export_propose": "اقتراح",
      "payroll_export_approve": "اعتماد",
      "payroll_export_status_approved": "معتمد",
      "payroll_export_status_proposed": "بانتظار الاعتماد",
      "timesheet_title": "حساب وتصدير الحضور",
      "timesheet_desc": "احسب، أرسل للاعتماد، اقفل ثم صدّر بيانات الرواتب.",
      "timesheet_start": "البداية",
      "timesheet_end": "النهاية",
      "timesheet_create": "إنشاء",
      "timesheet_calculate": "حساب",
      "timesheet_send_approval": "إرسال للاعتماد",
      "timesheet_approve": "اعتماد",
      "timesheet_lock": "قفل",
      "timesheet_export": "تصدير",
      "timesheet_status": "الحالة",
      "timesheet_status_draft": "مسودة",
      "timesheet_status_calculated": "تم الحساب",
      "timesheet_status_pending": "بانتظار الاعتماد",
      "timesheet_status_approved": "معتمد",
      "timesheet_status_locked": "مقفل",
      "timesheet_status_exported": "تم التصدير",
      "timesheet_calculated": "تم حساب الحضور.",
      "timesheet_sent_approval": "تم الإرسال للاعتماد.",
      "timesheet_approved": "تم اعتماد الحضور.",
      "timesheet_locked": "تم قفل الحضور.",
      "refresh": "تحديث",
      "holiday_source_system": "النظام",
      "holiday_source_company": "الشركة",
      "menu_logout": "تسجيل خروج آمن",
      "menu_audit_logs": "سجلات النظام",
      "audit_logs_title": "سجلات النظام",
      "audit_logs_subtitle": "شاشة التدقيق المركزية للمسؤول العام",
      "audit_logs_records": "سجل",
      "audit_filter_company": "كل الشركات",
      "audit_filter_action": "كل العمليات",
      "audit_filter_resource": "كل الوحدات",
      "audit_filter_employee": "كل الأشخاص",
      "audit_filter_department": "كل الأقسام",
      "audit_apply_filters": "تصفية",
      "audit_reset_filters": "إعادة ضبط",
      "audit_col_datetime": "التاريخ / الوقت",
      "audit_col_company": "الشركة",
      "audit_col_person": "الشخص",
      "audit_col_department": "القسم",
      "audit_col_detail": "تفاصيل العملية",
      "audit_col_action": "العملية",
      "audit_col_module": "الوحدة",
      "audit_col_status": "النتيجة",
      "audit_col_path": "المسار",
      "audit_loading": "جارٍ تحميل السجلات...",
      "audit_empty": "لم يتم العثور على سجلات للفلاتر المحددة",
      "err_fetch_audit_filters": "تعذر تحميل فلاتر السجلات.",
      "err_fetch_audit_logs": "تعذر تحميل سجلات النظام.",
      "audit_detail_view_logs": "عرض سجلات النظام",
      "audit_detail_clock_in": "سجل الدخول باستخدام QR والموقع",
      "audit_detail_clock_out": "سجل الخروج باستخدام QR والموقع",
      "audit_detail_bulk_attendance": "رفع بيانات حضور جماعية",
      "audit_detail_schedule_create": "أنشأ خطة دوام",
      "audit_detail_schedule_update": "حدّث خطة دوام",
      "audit_detail_schedule_delete": "حذف خطة دوام",
      "audit_detail_schedule_assign_departments": "ربط خطط الدوام بالأقسام",
      "audit_detail_schedule_assign_employees": "عيّن خطة خاصة للموظفين",
      "audit_detail_schedule_clear_employees": "أزال استثناءات الموظفين",
      "audit_detail_document_upload": "رفع مستنداً",
      "audit_detail_document_status": "حدّث حالة المستند",
      "audit_detail_expense_create": "أنشأ طلب نفقة",
      "audit_detail_expense_status": "حدّث حالة النفقة",
      "audit_detail_leave_create": "أنشأ طلب إجازة",
      "audit_detail_leave_status": "حدّث حالة الإجازة",
      "audit_detail_helpdesk_create": "أنشأ تذكرة دعم",
      "audit_detail_helpdesk_message": "أرسل رسالة دعم",
      "audit_detail_helpdesk_status": "حدّث حالة تذكرة الدعم",
      "audit_detail_location_create": "أنشأ موقعاً",
      "audit_detail_location_update": "حدّث الموقع",
      "audit_detail_location_rotate_qr": "جدّد رمز QR للموقع",
      "audit_detail_location_poster": "حمّل ملصق QR",
      "audit_detail_asset_assign": "عيّن عهدة",
      "audit_detail_asset_return": "استعاد العهدة",
      "audit_detail_offer_letter": "أنشأ خطاب عرض",
      "audit_detail_failed_suffix": "لكن الطلب انتهى بخطأ",
      "demo_goal_description": "هدف OKR تجريبي لهذا الموظف",
      "demo_manager_review": "تقييم إداري تجريبي: متابعة الأهداف والتواصل داخل الفريق إيجابيان.",
      "demo_peer_review": "ملاحظات زميل تجريبية: داعم ويتحمل المسؤولية.",
      "err_fetch_data": "حدث خطأ أثناء جلب البيانات.",
      "draft_cancel_msg": "الزملاء الأعزاء،\n\nلقد تم إلغاء تدريبنا بعنوان \"{{title}}\" المجدول بتاريخ {{date}}.\n\nشكراً لتفهمكم.",
      "msg_training_scheduled": "تمت جدولة التدريب الجديد بنجاح.",
      "err_schedule_training": "تعذر جدولة التدريب!",
      "err_select_min_one_emp": "يرجى تحديد موظف واحد على الأقل.",
      "msg_assigning_sending": "جاري تعيين الموظفين وإرسال رسائل البريد...",
      "msg_assigned_invited": "تم تعيين الموظفين وإرسال الدعوات!",
      "err_assign_failed": "فشلت عملية التعيين.",
      "msg_canceling_sending": "جاري الإلغاء وإرسال رسائل البريد...",
      "msg_training_canceled": "تم إلغاء التدريب وإخطار المشاركين.",
      "err_cancel_failed": "فشلت عملية الإلغاء.",
      "msg_confirm_delete_training": "هل أنت متأكد أنك تريد حذف هذا التدريب تماماً من النظام؟",
      "msg_training_deleted": "تم حذف التدريب من النظام.",
      "err_delete_training": "تعذر حذف التدريب.",
      "msg_attendance_updated": "تم تحديث حالة الحضور.",
      "err_attendance_update": "تعذر تحديث الحضور!",
      "err_no_data_download": "لم يتم العثور على بيانات للتنزيل.",
      "csv_headers": "اسم التدريب,التاريخ,المدرب,اسم الموظف,القسم,حالة الحضور\n",
      "msg_excel_downloaded": "تم تنزيل ملف الإكسل.",
      "btn_schedule_training": "جدولة تدريب جديد",
      "msg_no_trainings_scheduled": "لم يتم جدولة أي تدريبات حتى الآن.",
      "badge_cancelled": "تم الإلغاء",
      "badge_completed": "مكتمل",
      "badge_approaching": "قريباً",
      "tooltip_delete": "حذف",
      "lbl_no_description": "لا يوجد وصف.",
      "lbl_instructor": "المدرب",
      "lbl_date": "التاريخ",
      "lbl_time": "الوقت",
      "lbl_participants": "المشاركين",
      "lbl_persons": "شخص",
      "btn_assign_personnel": "تعيين الموظفين",
      "err_no_participants_assigned": "لم يتم تعيين أحد لهذا التدريب.",
      "btn_take_attendance": "أخذ الحضور",
      "btn_cancel": "إلغاء",
      "modal_title_schedule_training": "جدولة تدريب جديد",
      "lbl_training_title": "عنوان / موضوع التدريب",
      "ph_training_title": "مثال: تدريب متقدم في الإكسل",
      "lbl_training_desc": "الوصف",
      "ph_training_desc": "معلومات موجزة حول محتوى التدريب...",
      "ph_instructor": "مثال: أحمد يحيى",
      "lbl_location": "الموقع / الرابط",
      "ph_location": "غرفة الاجتماعات 1 أو رابط زووم",
      "btn_save_publish_training": "حفظ ونشر التدريب",
      "modal_title_assign_personnel": "تعيين الموظفين للتدريب",
      "msg_invitation_will_be_sent": "سيتم إرسال بريد دعوة للموظفين المحددين.",
      "btn_assign_and_invite": "تعيين ودعوة {{count}} موظف",
      "modal_title_attendance_report": "حضور وتقرير التدريب",
      "lbl_registered_personnel_list": "قائمة الموظفين المسجلين",
      "btn_download_excel": "تنزيل إكسل",
      "msg_no_one_assigned": "لم يتم تعيين أحد لهذا التدريب.",
      "btn_attended": "حضر",
      "btn_not_attended": "لم يحضر",
      "modal_title_cancel_training": "إلغاء التدريب",
      "lbl_cancellation_draft": "مسودة إشعار الإلغاء",
      "msg_cancellation_warning": "سيتم إرسال رسالة الإلغاء التالية عبر البريد الإلكتروني لجميع الموظفين المسجلين في هذا التدريب. يمكنك تعديل النص.",
      "lbl_cancel_email_content": "محتوى بريد الإلغاء",
      "btn_cancel_and_notify": "إلغاء وإخطار الجميع",
      "title_leave_management": "إدارة الإجازات",
      "desc_leave_management_wip": "سيتم عرض طلبات الإجازة وعملية الموافقة هنا.",
      "badge_under_construction": "قيد الإنشاء",
      "mfa_title": "التحقق الأمني",
      "mfa_subtitle": "يرجى إدخال الرمز المكون من 6 أرقام المرسل إلى بريدك الإلكتروني.",
      "otp_code_label": "رمز التحقق",
      "forgot_password": "نسيت كلمة المرور",
      "lbl_system_subtitle": "مرحباً بكم في نظام إدارة الموظفين الآمن.",
      "btn_back_to_login": "العودة لتسجيل الدخول",
      "invalid_mfa_code": "رمز التحقق غير صالح أو منتهي الصلاحية!",
      "password_too_short": "كلمة المرور قصيرة جداً (يجب أن تتكون من 8 أحرف على الأقل).",
      "password_too_weak": "كلمة المرور ضعيفة جداً (يجب أن تحتوي على أحرف كبيرة وصغيرة وأرقام).",
      "password_no_special_char": "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل (@$!%*?&).",
      "email_already_in_use": "عنوان البريد الإلكتروني هذا مستخدم بالفعل.",
      "default_department_name": "مجلس الإدارة",
      "default_position_title": "المؤسس / المدير",
      "registration_successful": "تمت عملية التسجيل بنجاح.",
      "registration_error": "حدث خطأ غير متوقع أثناء التسجيل.",
      "invalid_credentials": "البريد الإلكتروني أو كلمة المرور غير صالحة.",
      "account_suspended": "تم تعليق حسابك. يرجى الاتصال بالمسؤول.",
      "mfa_code_sent": "تم إرسال رمز الأمان إلى عنوان بريدك الإلكتروني.",
      "mfa_code_expired": "انتهت صلاحية رمز الأمان. الرجاء تسجيل الدخول مرة أخرى.",
      "reset_email_sent_if_exists": "إذا كان الحساب موجودًا، فقد تم إرسال رابط إعادة تعيين كلمة المرور.",
      "btn_verify_code": "تحقق من الرمز",
      "btn_back": "عُد",
      "lbl_new_password": "كلمة المرور الجديدة",
      "btn_send_code": "إرسال رمز إعادة التعيين",
      "btn_reset_password": "تحديث كلمة المرور",
      "lbl_remembered_password": "هل تذكرت كلمة المرور؟",
      "msg_password_reset_success": "تم تحديث كلمة المرور بنجاح! يمكنك الآن تسجيل الدخول.",
      "err_password_match": "كلمات المرور غير متطابقة.",
      "msg_password_updated": "تم تحديث كلمة المرور بنجاح.",
      "idle_warning_title": "هل أنت ما زلت هنا؟",
      "idle_warning_desc": "لدواعي أمنية، ستنتهي جلستك قريباً بسبب عدم النشاط.",
      "btn_stay_logged_in": "أنا هنا، ابقني مسجلاً للدخول",
      "btn_logout_now": "تسجيل الخروج الآن",
      "idle_warning_title": "هل ما زلت هنا؟",
      "idle_warning_desc": "لدواعي أمنية، ستنتهي جلستك قريباً بسبب عدم النشاط.",
      "btn_stay_logged_in": "أنا هنا، ابقني مسجلاً",
      "btn_logout_now": "تسجيل الخروج الآن",
      "btn_clock_in": "تسجيل الدخول",
      "btn_clock_out": "تسجيل الخروج",
      "msg_getting_location": "جاري تحديد موقعك...",
      "err_gps_not_supported": "متصفحك لا يدعم نظام تحديد المواقع!",
      "err_location_denied": "يرجى السماح بالوصول إلى الموقع!",
      "msg_clock_in_success": "تم تسجيل الدخول بنجاح!",
      "msg_clock_out_success": "تم تسجيل الخروج بنجاح!",
      "err_geofence_failed": "فشل التحقق من الموقع!",
      "msg_exporting": "جارٍ التصدير...",
      "msg_export_success": "تم تنزيل الملف بنجاح!",
      "err_export_failed": "فشل التصدير.",
      "btn_export_excel": "إكسل",
      "btn_export_csv": "CSV",
      "btn_export_pdf": "PDF",
      "btn_send_email": "بريد إلكتروني",
      "lbl_email_modal_title": "إرسال التقرير",
      "ph_enter_email": "البريد الإلكتروني للمستلم",
      "lbl_format": "تحديد التنسيق",
      "btn_cancel": "إلغاء",
      "btn_send": "إرسال",
      "err_empty_email": "الرجاء إدخال عنوان بريد إلكتروني.",
      "msg_sending_email": "جاري إرسال البريد الإلكتروني...",
      "msg_email_queued": "تم وضع البريد الإلكتروني في قائمة الانتظار بنجاح!",
      "err_email_failed": "فشل في إرسال البريد الإلكتروني.",
      "file_attendance": "الحضور",
      "sheet_attendance": "تقرير_الحضور",
      "msg_employee_attendance_wip": "شاشة حضور الموظفين قيد الإنشاء...",
      "err_fetch_my_attendance": "فشل في جلب السجلات السابقة.",
      "err_no_geolocation": "متصفحك لا يدعم تحديد الموقع الجغرافي.",
      "err_location_denied": "تم رفض الوصول إلى الموقع أو غير متاح. يرجى تمكين أذونات الموقع في متصفحك.",
      "msg_getting_location": "جاري الحصول على موقعك، يرجى الانتظار...",
      "msg_verifying_location": "جاري التحقق من الموقع...",
      "msg_validating_qr_location": "جارٍ التحقق من رمز QR والموقع...",
      "msg_success": "العملية ناجحة!",
      "msg_attendance_completed": "اكتملت عملية الحضور بنجاح.",
      "msg_requesting_camera": "بانتظار إذن الكاميرا...",
      "msg_scan_qr_prompt": "وجّه رمز QR إلى الكاميرا. إذنا الكاميرا والموقع إلزاميان.",
      "msg_qr_detected": "تم اكتشاف رمز QR. جارٍ التحقق من الموقع...",
      "err_action_failed": "فشلت العملية.",
      "err_camera_not_supported": "هذا المتصفح لا يدعم الوصول إلى الكاميرا. يرجى استخدام متصفح أو جهاز آخر.",
      "err_camera_qr_not_supported": "هذا المتصفح لا يدعم مسح QR بالكاميرا. يرجى استخدام Chrome أو Edge حديث.",
      "err_camera_denied": "لا يمكن تنفيذ الحضور بدون إذن الكاميرا.",
      "err_camera_denied_persisted": "لا يمكن تنفيذ الحضور بدون إذن الكاميرا. يرجى تفعيل إذن الكاميرا من إعدادات المتصفح ثم المحاولة مرة أخرى.",
      "err_qr_scan_failed": "تعذر قراءة رمز QR. يرجى المحاولة مرة أخرى.",
      "btn_clock_in_large": "تسجيل الدخول",
      "btn_clock_out_large": "تسجيل الخروج",
      "lbl_gps_required": "نظام تحديد المواقع مطلوب",
      "lbl_camera_gps_required": "الكاميرا + الموقع إلزاميان",
      "attendance_qr_modal_title_in": "بدء الدوام عبر QR",
      "attendance_qr_modal_title_out": "إنهاء الدوام عبر QR",
      "attendance_qr_modal_subtitle": "إذن الكاميرا والموقع إلزامي",
      "attendance_qr_security_title": "حضور آمن",
      "attendance_qr_security_desc": "يُستخدم مسح QR والتحقق المباشر من الموقع معًا قبل إنشاء سجل الحضور.",
      "attendance_qr_steps_title": "الخطوات",
      "attendance_qr_step_1": "وجّه الكاميرا إلى رمز QR الحالي في الموقع.",
      "attendance_qr_step_2": "وافق على إذن الموقع إذا طلبه المتصفح.",
      "attendance_qr_step_3": "لن يتم تسجيل الدخول أو الخروج حتى يتم التحقق من QR والموقع معًا.",
      "attendance_qr_status_error": "خطأ",
      "attendance_qr_status_success": "نجاح",
      "attendance_qr_status_active": "جارٍ المسح",
      "btn_retry_qr_scan": "أعد المحاولة",
      "btn_cancel_scan": "إلغاء",
      "lbl_my_recent_records": "سجلاتي الأخيرة (30 يومًا)",
      "nav_dashboard": "لوحة القيادة",
        "nav_sub_dashboard": "الإحصائيات العامة",
        "nav_employees": "إدارة الموظفين",
        "nav_sub_employees": "الموظفون والكوادر",
        "nav_org_chart": "الهيكل التنظيمي",
        "nav_sub_org_chart": "الهيكل الهرمي",
        "nav_ats": "تتبع المتقدمين (ATS)",
        "nav_sub_ats": "عملية التوظيف",
        "nav_attendance": "الوقت والحضور",
        "nav_sub_attendance": "تتبع الورديات والوقت",
        "nav_locations": "المواقع والأماكن",
        "nav_sub_locations": "إدارة السياج الجغرافي",
        "nav_leaves": "إدارة الإجازات",
        "nav_sub_leaves": "مركز الموافقات",
        "nav_dossier": "الملف الإلكتروني",
        "nav_sub_dossier": "السجلات الرقمية",
        "nav_performance": "الأداء والمواهب",
        "nav_sub_performance": "الأهداف والنتائج الرئيسية وتقييم 360 درجة",
        "nav_training": "أكاديمية الشركة",
        "nav_sub_training": "إدارة التدريب",
        "nav_expenses": "إدارة النفقات",
        "nav_sub_expenses": "الميزانيات والإيصالات",
        "nav_assets": "إدارة الأصول",
        "nav_sub_assets": "تتبع المخزون",
        "nav_helpdesk": "مكتب المساعدة (IT/HR)",
        "nav_sub_helpdesk": "الطلبات الداخلية",
        "nav_settings": "إعدادات النظام والشركة",
        "nav_sub_settings": "إدارة الهوية المؤسسية",
        "nav_billing": "الاشتراك والفواتير",
        "nav_sub_billing": "إدارة باقات SaaS",
        "nav_portal": "لوحة القيادة",
        "nav_sub_portal": "لوحة التحكم الشخصية",
        "nav_my_leaves": "إجازاتي",
        "nav_sub_my_leaves": "حالة الإجازات الشخصية",
        "nav_my_performance": "أدائي",
        "nav_sub_my_performance": "أهدافي",
        "nav_my_training": "أكاديمية التدريب الخاصة بي",
        "nav_sub_my_training": "خطة التطوير الخاصة بي",
        "nav_my_expenses": "نفقاتي",
        "nav_sub_my_expenses": "مطالبات المصروفات",
        "nav_my_assets": "أصولي",
        "nav_sub_my_assets": "معدات الشركة",
        "nav_fallback": "لوحة التحكم",
        "nav_sub_fallback": "إدارة الشركة",
        "lbl_city_weather": "المدينة / الطقس",
        "ph_type_city": "المدينة...",
        "lbl_today": "اليوم",
      "btn_add_schedule": "إضافة خطة دوام",
      "btn_assign_special_schedule": "تعيين خطة خاصة",
      "btn_collapse_department": "طي القسم",
      "btn_coming_soon": "قريباً",
      "btn_create_schedule": "إنشاء الخطة",
      "btn_expand_department": "توسيع القسم",
      "btn_reset_to_department_default": "إرجاع إلى افتراضي القسم",
      "btn_save_department_schedules": "حفظ تعيينات الأقسام",
      "btn_saving": "جارٍ الحفظ...",
      "btn_update_schedule": "تحديث الخطة",
      "col_active_people": "الأشخاص النشطون",
      "col_check_in": "الدخول",
      "col_check_out": "الخروج",
      "col_date": "التاريخ",
      "col_default_schedule": "الخطة الافتراضية",
      "col_my_schedule": "خطتي",
      "col_schedule_hours": "الساعات",
      "col_schedule_name": "اسم الخطة",
      "col_schedule_rules": "القواعد",
      "col_schedule_type": "النوع",
      "col_schedule_usage": "الاستخدام",
      "col_total_hours": "إجمالي الساعات",
      "default_repair_done_note": "اكتمل الإصلاح وتمت إعادة الأصل إلى المخزن.",
      "default_repair_note": "تم الإرسال إلى الصيانة بسبب عطل.",
      "desc_assign_after_stock": "يمكنك إبقاء الأصل في المخزن أولاً ثم تعيينه لاحقاً.",
      "desc_department_schedule_defaults": "حدد خطة الدوام الافتراضية لكل قسم.",
      "desc_employee_schedule_override": "خصص خطة خاصة فقط للموظفين الاستثنائيين.",
      "desc_work_schedules": "أنشئ خطط دوام ثابتة أو مرنة لشركتك.",
      "err_department_schedules_save": "تعذر حفظ تعيينات دوام الأقسام.",
      "err_employee_schedule_assign": "تعذر تعيين خطة دوام للموظف.",
      "err_employee_schedule_clear": "تعذر إزالة الخطة الخاصة للموظف.",
      "err_fetch_department_schedules": "تعذر جلب تعيينات دوام الأقسام.",
      "err_fetch_employee_overrides": "تعذر جلب استثناءات الموظفين.",
      "err_fetch_schedules": "تعذر جلب خطط الدوام.",
      "err_invalid_date": "أدخل تاريخاً صالحاً.",
      "err_schedule_delete": "تعذر حذف خطة الدوام.",
      "err_schedule_save": "تعذر حفظ خطة الدوام.",
      "err_select_department_schedule": "اختر خطة لكل قسم.",
      "err_select_employees": "اختر الموظفين أولاً.",
      "err_select_schedule_for_people": "اختر خطة دوام للموظفين المحددين.",
      "info_assign_after_create": "يمكنك تعيين الأصل بعد إنشاء السجل.",
      "info_status_route_not_ready": "هذا المسار الخاص بالحالة غير مفعل في الخلفية بعد.",
      "lbl_active_overrides": "الاستثناءات النشطة",
      "lbl_break_minutes": "الاستراحة (د)",
      "lbl_bulk_department_logic": "يتم تطبيق افتراضي القسم تلقائياً على معظم الموظفين.",
      "lbl_core_end": "نهاية الساعات الأساسية",
      "lbl_core_start": "بداية الساعات الأساسية",
      "lbl_crosses_midnight": "يتجاوز منتصف الليل",
      "lbl_crosses_midnight_toggle": "الوردية تتجاوز منتصف الليل",
      "lbl_department_defaults": "افتراضيات الأقسام",
      "lbl_department_filter": "تصفية القسم",
      "lbl_departments_short": "قسم",
      "lbl_early_leave_after": "حد الخروج المبكر",
      "lbl_early_out": "خروج مبكر",
      "lbl_effective_from": "ساري من",
      "lbl_employee_override_logic": "عيّن خطة خاصة على مستوى الموظف للموظفين الاستثنائيين.",
      "lbl_employee_overrides": "استثناءات الموظفين",
      "lbl_end_time": "وقت النهاية",
      "lbl_grace_in": "سماحية الدخول",
      "lbl_grace_in_minutes": "سماحية الدخول (د)",
      "lbl_grace_out": "سماحية الخروج",
      "lbl_grace_out_minutes": "سماحية الخروج (د)",
      "lbl_late": "متأخر",
      "lbl_late_after": "حد التأخر",
      "lbl_loading_department_schedules": "جارٍ تحميل تعيينات الأقسام...",
      "lbl_loading_people": "جارٍ تحميل الموظفين...",
      "lbl_loading_schedules": "جارٍ تحميل خطط الدوام...",
      "lbl_no_schedule_type": "لا يوجد نوع خطة",
      "lbl_no_target_schedule": "لم يتم اختيار خطة",
      "lbl_ot_after": "حد العمل الإضافي",
      "lbl_overtime": "عمل إضافي",
      "lbl_overtime_after": "بداية العمل الإضافي",
      "lbl_people": "أشخاص",
      "lbl_people_short": "أشخاص",
      "lbl_position_count": "المناصب",
      "lbl_remaining_leave": "الإجازة المتبقية",
      "lbl_same_day": "نفس اليوم",
      "lbl_schedule_logic": "منطق الدوام",
      "desc_core_hours": "حدد نطاق الساعات الأساسية التي يجب أن يكون فيها الموظف موجوداً في المكتب عند استخدام الدوام المرن.",
      "lbl_schedule_name": "اسم الخطة",
      "lbl_schedule_type": "نوع الخطة",
      "lbl_selected_people": "الأشخاص المحددون",
      "lbl_start_time": "وقت البداية",
      "lbl_stat_late_days": "أيام التأخر",
      "lbl_stat_present_days": "أيام الحضور",
      "lbl_stat_total_hours": "إجمالي الساعات",
      "lbl_target_schedule": "الخطة المستهدفة",
      "lbl_total_plans": "إجمالي الخطط",
      "lbl_unknown_department": "قسم غير معروف",
      "lbl_unscheduled": "بدون خطة",
      "modal_title_edit_schedule": "تعديل خطة الدوام",
      "modal_title_new_schedule": "خطة دوام جديدة",
      "msg_assigning_employee_schedule": "جارٍ تعيين خطة دوام للموظف...",
      "msg_billing_not_enabled": "وحدة الفوترة غير مفعلة حالياً.",
      "msg_billing_passive_banner": "شاشة الاشتراك جاهزة، لكن البنية التحتية للدفع غير مفعلة في هذه البيئة.",
      "msg_clearing_employee_schedule": "جارٍ إزالة الخطة الخاصة للموظف...",
      "msg_confirm_clear_employee_schedule": "هل أنت متأكد من إعادة الموظفين المحددين إلى افتراضي القسم؟",
      "msg_confirm_delete_schedule": "هل أنت متأكد من حذف خطة الدوام هذه؟",
      "msg_creating_schedule": "جارٍ إنشاء خطة الدوام...",
      "msg_deleting_schedule": "جارٍ حذف خطة الدوام...",
      "msg_department_schedules_saved": "تم حفظ تعيينات دوام الأقسام.",
      "msg_employee_schedule_assigned": "تم تعيين خطة دوام للموظف.",
      "msg_employee_schedule_cleared": "تمت إزالة الخطة الخاصة للموظف.",
      "msg_expense_approved": "تمت الموافقة على المصروف.",
      "msg_expense_rejected": "تم رفض المصروف.",
      "msg_hire_pick_org_slot": "اختر القسم والمنصب لإتمام التوظيف.",
      "msg_no_departments": "لم يتم العثور على أقسام.",
      "msg_no_employee_overrides": "لا توجد استثناءات نشطة للموظفين.",
      "msg_no_filtered_employees": "لا يوجد موظفون مطابقون للتصفية.",
      "msg_no_schedules": "لم يتم تعريف أي خطط دوام بعد.",
      "msg_saving_department_schedules": "جارٍ حفظ تعيينات الأقسام...",
      "msg_schedule_created": "تم إنشاء خطة الدوام.",
      "msg_schedule_deleted": "تم حذف خطة الدوام.",
      "msg_schedule_updated": "تم تحديث خطة الدوام.",
      "msg_updating_schedule": "جارٍ تحديث خطة الدوام...",
      "opt_all_departments": "كل الأقسام",
      "opt_fixed": "ثابت",
      "opt_flex": "مرن",
      "opt_select_position": "اختر المنصب",
      "opt_select_schedule": "اختر خطة الدوام",
      "ph_override_reason": "سبب الاستثناء (اختياري)",
      "ph_search_employee": "ابحث بالاسم أو البريد الإلكتروني أو الهاتف...",
      "prompt_repair_done_note": "ملاحظة بعد الإصلاح:",
      "prompt_repair_note": "ملاحظة الإرسال للصيانة:",
      "status_early_out": "خروج مبكر",
      "status_late_early": "متأخر + مبكر",
      "tab_attendance_records": "الحضور",
      "tab_department_assignments": "تعيينات الأقسام",
      "tab_employee_overrides": "استثناءات الموظفين",
      "tab_work_schedules": "خطط الدوام",
      "tbl_schedule_plan": "الخطة",
      "title_department_schedule_defaults": "خطط دوام الأقسام",
      "title_employee_schedule_override": "استثناءات دوام الموظفين",
      "title_work_schedules": "خطط الدوام",
      "btn_schedule_pdf_report": "تقرير PDF",
      "btn_participant_report_pdf": "تقرير المشاركين PDF",
      "lbl_created_by": "تم الإنشاء بواسطة",
      "type_maternity": "إجازة أمومة",
      "unknown_employee": "موظف غير معروف",
      "unknown_user": "مستخدم غير معروف",
      "violation_early_out": "خروج مبكر",
      "violation_late_early": "دخول متأخر + خروج مبكر",
      "violation_late_in": "دخول متأخر",
      "violation_missing_in": "دخول مفقود",
      "violation_missing_out": "خروج مفقود",
      "violation_none": "لا يوجد مخالفة",
    }
  }
};

const additionalTranslations = {
  tr: {
    sidebar_group_workspace: 'Çalışma Alanı',
    sidebar_group_people: 'İnsan Kaynakları',
    sidebar_group_operations: 'Operasyon',
    sidebar_group_compliance: 'Gelişim & Uyum',
    sidebar_group_requests: 'Finans & Talepler',
    sidebar_group_team: 'Ekip & Organizasyon',
    sidebar_group_workday: 'Günlük Çalışma',
    sidebar_group_growth: 'Gelişim',
    menu_knowledge_base: 'BİLGİ BANKASI & POLİTİKALAR',
    menu_purchase_requests: 'SATIN ALMA TALEPLERİ',
    menu_request_forms: 'KURUMSAL TALEP FORMLARI',
    menu_kpi_statistics: 'KPI & İSTATİSTİKLER',
    menu_surveys: 'ANKETLER VE TAVSİYE SKORU',
    menu_meal_menu: 'GÜNLÜK YEMEK MENÜSÜ',
    sidebar_group_experience: 'Çalışan Deneyimi',
    engagement_module: 'Çalışan Deneyimi',
    survey_title: 'Anketler ve Çalışan Tavsiye Skoru',
    survey_phase1_info: 'Bu alandan anket şablonlarını oluşturabilir, anketleri yayımlayabilir ve çalışan geri bildirimlerini takip edebilirsiniz.',
    survey_my_inbox: 'Anket Kutum',
    survey_no_pending: 'Bekleyen anket yok.',
    survey_anonymous: 'Anonim',
    survey_named: 'İsimli',
    survey_answer: 'Yanıtla',
    survey_completed: 'Tamamlanan',
    survey_admin_center: 'Yönetim',
    survey_templates: 'Şablonlar',
    survey_template_name: 'Şablon adı',
    survey_question_code: 'Kod',
    survey_question_text: 'Soru',
    survey_required: 'Zorunlu',
    survey_delete: 'Sil',
    survey_choices_comma: 'Seçenekler (virgül ile)',
    survey_add_question: 'Soru Ekle',
    survey_existing_templates: 'Mevcut Şablonlar',
    survey_update_template: 'Şablonu Güncelle',
    survey_create_template: 'Şablon Oluştur',
    survey_campaigns: 'Kampanyalar',
    survey_choose_template: 'Şablon seçin',
    survey_campaign_name: 'Kampanya adı',
    survey_department_filter: 'Hedef departman numaraları (virgülle ayırın)',
    survey_role_filter: 'Hedef rol kodları (virgülle ayırın)',
    survey_start_at: 'Başlangıç tarihi',
    survey_end_at: 'Bitiş tarihi',
    survey_is_anonymous: 'Anonim anket',
    survey_update_campaign: 'Kampanyayı Güncelle',
    survey_create_campaign: 'Kampanya Oluştur',
    survey_campaign_list: 'Kampanya Listesi',
    survey_edit_campaign: 'Düzenle',
    survey_launch: 'Başlat',
    survey_close: 'Kapat',
    survey_view_analytics: 'Analitik',
    survey_participation: 'Katılım',
    survey_recommendation_score: 'Çalışan Tavsiye Skoru',
    survey_scale_avg: 'Ortalama Skor',
    survey_department_breakdown: 'Departman Kırılımı',
    survey_role_breakdown: 'Rol Kırılımı',
    survey_role_admin: 'Yönetici (Admin)',
    survey_role_employee: 'Personel',
    survey_role_hr: 'İnsan Kaynakları',
    survey_role_manager: 'Departman Yöneticisi',
    survey_role_superadmin: 'Sistem Yöneticisi',
    survey_select_option: 'Seçim yapın',
    survey_submit: 'Gönder',
    survey_edit: 'Düzenle',
    survey_status_draft: 'Taslak',
    survey_status_live: 'Yayında',
    survey_status_closed: 'Kapatıldı',
    survey_status_active: 'Aktif',
    survey_category_pulse: 'Nabız Anketi',
    survey_category_enps: 'Çalışan Tavsiye Skoru',
    survey_category_exit: 'Çıkış Anketi',
    survey_category_onboarding: 'İşe Başlangıç Anketi',
    survey_category_custom: 'Özel Anket',
    survey_qtype_nps_0_10: '0-10 Tavsiye Skoru',
    survey_qtype_scale_1_5: '1-5 Değerlendirme Ölçeği',
    survey_qtype_single_choice: 'Tek Seçimli',
    survey_qtype_multi_choice: 'Çok Seçimli',
    survey_qtype_text_short: 'Kısa Metin',
    survey_qtype_text_long: 'Uzun Metin',
    survey_default_question_recommendation: 'Şirketimizi çalışılacak bir yer olarak tavsiye etme olasılığınız nedir?',
    survey_default_question_improvement: 'Neyi daha iyi yapmalıyız?',
    survey_load_failed: 'Anket verileri yüklenemedi.',
    survey_template_load_failed: 'Şablon detayı yüklenemedi.',
    survey_question_required: 'En az bir soru metni girin.',
    survey_template_create_failed: 'Şablon oluşturulamadı.',
    survey_campaign_save_failed: 'Kampanya kaydedilemedi.',
    survey_campaign_launch_failed: 'Kampanya başlatılamadı.',
    survey_campaign_close_failed: 'Kampanya kapatılamadı.',
    survey_detail_load_failed: 'Anket detayı yüklenemedi.',
    survey_submit_failed: 'Anket gönderilemedi.',
    survey_analytics_failed: 'Analitik yüklenemedi.',
    nav_knowledge_base: 'BİLGİ BANKASI & POLİTİKALAR',
    nav_sub_knowledge_base: 'Politika ve SOP okuma merkezi',
    nav_request_forms: 'KURUMSAL TALEP FORMLARI',
    nav_sub_request_forms: 'Yapılandırılmış talep ve iş akışı yönetimi',
    nav_kpi_statistics: 'KPI & İSTATİSTİKLER',
    nav_sub_kpi_statistics: 'Tarih aralığına göre metrik takibi',
    btn_add: 'EKLE',
    btn_refresh: 'YENİLE',
    btn_new_purchase_request: 'Yeni Satın Alma Talebi',
    btn_submit_purchase_request: 'Talebi Gönder',
    btn_convert_to_expense: 'Masrafa Dönüştür',
    btn_new_generic_request: 'Yeni Kurumsal Talep',
    btn_open_flow: 'Detayı Aç',
    btn_take_in_progress: 'İncelemeye Al',
    btn_complete: 'Sonuçlandır',
    btn_send_message: 'Mesaj Gönder',
    btn_add_attachment: 'Dosya Ekle',
    btn_submit_request: 'Talebi Gönder',
    btn_new_kpi_metric: 'Yeni KPI Kaydı',
    err_fetch_purchase_requests: 'Satın alma talepleri yüklenemedi.',
    err_create_purchase_request: 'Satın alma talebi oluşturulamadı.',
    err_convert_purchase_expense: 'Masraf kaydı oluşturulamadı.',
    err_fetch_generic_requests: 'Kurumsal talepler yüklenemedi.',
    err_fetch_generic_request_detail: 'Talep detayı yüklenemedi.',
    err_create_generic_request: 'Talep oluşturulamadı.',
    err_fetch_kpi_metrics: 'KPI kayıtları yüklenemedi.',
    err_create_kpi_metric: 'KPI kaydı oluşturulamadı.',
    err_delete_kpi_metric: 'KPI kaydı silinemedi.',
    generic_requests_open: 'Açık Kayıtlar',
    lbl_pending_requests: 'İşlem Bekleyen Toplam',
    lbl_approved_requests: 'Onaylanan Talepler',
    lbl_rejected_requests: 'Reddedilen Talepler',
    lbl_current_total: 'Seçili Görünüm Toplamı',
    lbl_finance_approver: 'Finans Onaycısı',
    lbl_item_name: 'Kalem / Hizmet',
    lbl_vendor: 'Tedarikçi',
    lbl_product_link: 'Ürün / Hizmet Linki',
    lbl_quantity: 'Adet',
    lbl_quantity_unit_price: 'Adet ve Birim Fiyat',
    lbl_unit_price: 'Birim Fiyat',
    lbl_justification: 'Gerekçe',
    lbl_needed_by: 'İhtiyaç Tarihi',
    lbl_converted_to_expense: 'Masrafa Dönüştürüldü',
    lbl_request_routing_engine: 'Talep İş Akışı Motoru',
    lbl_routing_logic: 'İş Akışı',
    lbl_request_type: 'Talep Türü',
    lbl_requested_by: 'Talebi Açan',
    lbl_requested_for: 'Talep Edilen Personel',
    lbl_assigned_to: 'İş Sahibi',
    lbl_request_timeline: 'İş Akışı Geçmişi',
    lbl_required: 'Zorunlu',
    lbl_route_explanation: 'İş Akışı Özeti',
    lbl_no_resolution_note: 'Henüz sonuç notu girilmedi.',
    lbl_undefined: 'Tanımsız',
    lbl_record: 'Kayıt',
    lbl_title: 'Başlık',
    lbl_description: 'Açıklama',
    lbl_system: 'Sistem',
    lbl_statistics_engine: 'İstatistik Motoru',
    lbl_kpi_pulse: 'KPI Nabzı',
    lbl_open_statistics_screen: 'İstatistik ekranını aç',
    lbl_selected_period_metrics: 'Seçili Dönem Kayıt',
    lbl_selected_period_total: 'Seçili Dönem Toplam',
    lbl_period_delta: 'Önceki Dönem Farkı',
    lbl_category_breakdown: 'Kategori Dağılımı',
    lbl_kpi_records: 'KPI Kayıtları',
    kpi_category_headcount: 'Kadro',
    kpi_category_recruitment: 'İşe Alım',
    kpi_category_payroll: 'Bordro',
    kpi_category_absence: 'Devamsızlık',
    kpi_category_training: 'Eğitim',
    kpi_category_performance: 'Performans',
    kpi_category_finance: 'Finans',
    kpi_category_other: 'Diğer',
    lbl_metric_date: 'Metrik Tarihi',
    lbl_source_type: 'Veri Kaynağı',
    lbl_target_value: 'Hedef Değer',
    lbl_actual_value: 'Gerçekleşen Değer',
    lbl_target_progress: 'Hedef İlerlemesi',
    lbl_unit: 'Birim',
    kpi_unit_count: 'Adet',
    kpi_unit_percent: '%',
    kpi_unit_currency: 'Para',
    kpi_unit_day: 'Gün',
    kpi_unit_hour: 'Saat',
    kpi_source_manual: 'Manuel',
    kpi_source_system: 'Sistem',
    lbl_search: 'Arama',
    lbl_date_range: 'Tarih Aralığı',
    lbl_status: 'Durum',
    ph_search_purchase_requests: 'Kalem, tedarikçi veya personel ara',
    modal_purchase_request: 'Satın Alma Talebi',
    ph_search_generic_requests: 'Başlık, açıklama veya personel ara',
    ph_generic_request_title: 'Talebin konusunu kısa ve net yazın',
    ph_generic_request_description: 'İhtiyacı, iş etkisini ve beklenen çıktıyı yazın',
    ph_request_reply: 'Yanıtınızı yazın',
    ph_search_kpi_metrics: 'KPI başlığı ara',
    ph_kpi_title: 'Örn. Aylık devamsızlık oranı',
    ph_kpi_note: 'Opsiyonel açıklama',
    opt_all_personnel: 'Tüm Personel',
    opt_all_request_types: 'Tüm Talep Türleri',
    opt_all_categories: 'Tüm Kategoriler',
    opt_myself: 'Kendim',
    btn_reset_filter: 'Temizle',
    btn_confirm_filter: 'Onayla',
    priority_low: 'Düşük',
    priority_normal: 'Normal',
    priority_high: 'Yüksek',
    priority_urgent: 'Acil',
    status_pending: 'Bekliyor',
    status_approved: 'Onaylandı',
    status_active: 'Aktif',
    status_completed: 'Tamamlandı',
    status_rejected: 'Reddedildi',
    msg_creating_purchase_request: 'Satın alma talebi oluşturuluyor...',
    msg_purchase_request_created: 'Satın alma talebi finans onayına gönderildi.',
    msg_confirm_purchase_approve: 'Bu satın alma talebini onaylamak istiyor musunuz?',
    prompt_purchase_reject_reason: 'Lütfen reddetme sebebini yazın:',
    prompt_purchase_reject_default: 'Bütçe / satın alma politikası nedeniyle uygun bulunmadı.',
    msg_purchase_request_approved: 'Satın alma talebi onaylandı.',
    msg_purchase_request_rejected: 'Satın alma talebi reddedildi.',
    msg_confirm_convert_purchase_expense: 'Bu talebi masraf kaydına dönüştürmek istiyor musunuz?',
    msg_converting_purchase_expense: 'Masraf kaydı oluşturuluyor...',
    msg_purchase_expense_converted: 'Talep masraf kaydına dönüştürüldü.',
    msg_no_purchase_requests: 'Bu görünümde talep bulunmuyor.',
    msg_creating_generic_request: 'Kurumsal talep oluşturuluyor...',
    msg_generic_request_created: 'Talep ilgili iş sahibinin akışına aktarıldı.',
    prompt_generic_request_reject: 'Reddetme notunu girin:',
    prompt_generic_request_reject_default: 'Talep mevcut süreç veya politika ile uyumlu bulunmadı.',
    msg_confirm_generic_request_action: 'Bu durumu uygulamak istiyor musunuz?',
    msg_generic_request_updated: 'Talep iş akışı durumu güncellendi.',
    msg_no_generic_requests: 'Bu görünümde talep bulunmuyor.',
    msg_no_request_messages: 'Henüz mesaj bulunmuyor.',
    msg_creating_kpi_metric: 'KPI kaydı oluşturuluyor...',
    msg_kpi_metric_created: 'KPI kaydı eklendi.',
    msg_confirm_delete_kpi: 'Bu KPI kaydını silmek istiyor musunuz?',
    msg_kpi_metric_deleted: 'KPI kaydı silindi.',
    msg_no_kpi_metrics: 'Seçili filtrelerde KPI kaydı bulunmuyor.',
    attendance_self_recent_tab: 'SON KAYITLAR',
    attendance_self_health_tab: 'SAĞLIK RAPORLARIM',
    attendance_self_health_summary_title: 'KENDİ SAĞLIK RAPORU GÖRÜNÜMÜ',
    attendance_self_health_summary_desc: 'Bu alanda yalnız puantaj ve bordro etkisi için gerekli asgari bilgiler gösterilir. Tanı, tıbbi değerlendirme ve iç işlem notları gösterilmez.',
    attendance_self_health_summary_correction: 'Hatalı veya eksik kayıt görürseniz Destek Masası üzerinden İK düzeltme talebi açabilirsiniz.',
    attendance_self_no_health_reports: 'KAYITLI SAĞLIK RAPORU BULUNMUYOR.',
    attendance_self_report_period: 'RAPOR DÖNEMİ',
    attendance_self_report_no: 'RAPOR NO',
    attendance_self_issue_date: 'DÜZENLENME TARİHİ',
    attendance_self_payroll_visibility: 'BORDRO ETKİSİ',
    attendance_self_full_pay: 'TAM ÜCRETLİ',
    attendance_self_deduct_pay: 'BORDRO KESİNTİSİNE DAHİL',
    attendance_self_included_in_payroll: 'PUANTAJDA AKTİF',
    attendance_self_not_included_in_payroll: 'PUANTAJA DAHİL DEĞİL',
    attendance_self_report_short: 'RAPOR',
    attendance_self_health_entry: 'SAĞLIK RAPORU KAYDI',
    attendance_self_report_reference: 'REFERANS',
    btn_open_correction_request: 'DÜZELTME TALEBİ AÇ',
    attendance_self_open_record_correction: 'BU KAYIT İÇİN DÜZELTME TALEBİ',
    generic_request_prefill_health_title: 'Puantaj Sağlık Raporu Kaydı Düzeltme Talebi',
    generic_request_prefill_health_intro: 'Kendi sağlık raporu puantaj kaydım için düzeltme talep ediyorum.',
    generic_request_prefill_health_closing: 'Lütfen kayıt doğruluğunu ve bordro etkisini kontrol edin.',
    generic_request_prefill_health_document: 'Puantaj / Sağlık Raporu Kaydı',
    generic_request_prefill_health_delivery: 'İK inceleme ve düzeltme',
    generic_request_quick_all: 'TÜM TALEPLER',
    generic_request_quick_health_corrections: 'SAĞLIK KAYDI DÜZELTMELERİ',
    notif_pending_purchase_requests: '{{count}} adet satın alma talebi işlem bekliyor.',
    notif_open_generic_requests: '{{count}} adet kurumsal talep iş akışında işlem bekliyor.',
    notif_pending_policy_acknowledgements: '{{count}} adet politika içeriği okuma veya onay bekliyor.',
    lbl_purchase_requests: 'SATIN ALMA TALEPLERİ',
    msg_purchase_requests_waiting: 'satın alma talebi işlem bekliyor.',
    lbl_generic_requests: 'KURUMSAL TALEPLER',
    msg_generic_requests_waiting: 'kurumsal talep iş akışında işlem bekliyor.',
    notif_health_record_corrections: '{{count}} adet sağlık kaydı düzeltme talebi İK incelemesi bekliyor.',
    lbl_health_record_corrections: 'SAĞLIK KAYDI DÜZELTME',
    msg_health_record_corrections_waiting: 'İK incelemesi bekleyen düzeltme talebi var.',
    lbl_pending_policy_acknowledgements: 'POLİTİKA ONAYLARI',
    msg_pending_policy_acknowledgements_waiting: 'okuma ve onay bekleyen politika içeriği var.',
    lbl_stat_sick_report_days: 'RAPORLU GÜN',
    lbl_days_short: 'Gün',
    lifecycle_manage_template: 'Şablonu Yönet',
    lifecycle_operation_checklist: 'Operasyon Kontrol Listesi',
    lifecycle_progress_summary: 'İlerleme Özeti',
    lifecycle_add_template_item: 'Yeni Şablon Maddesi',
    lifecycle_auto_action: 'Otomatik Aksiyon',
    lifecycle_auto_step: 'Otomatik',
    lifecycle_manual_step: 'Manuel madde',
    lifecycle_checklist_not_completed: 'Henüz tamamlanmadı',
    lifecycle_checklist_template_label: 'Kontrol Listesi Şablonu',
    lifecycle_checklist_update_error: 'Kontrol listesi maddesi güncellenemedi.',
    lifecycle_checklist_updated: 'Kontrol listesi maddesi güncellendi.',
    lifecycle_checklist_updating: 'Kontrol listesi maddesi güncelleniyor...',
    lifecycle_custom_checklist_empty: 'Bu süreç için henüz tekrar kullanılabilir kontrol listesi maddesi eklenmedi.',
    lifecycle_offboarding_checklist_note: 'Standart kapanış maddeleri ile şirketin tekrar kullanılabilir işten ayrılış kontrol listesi adımları birlikte ilerleme yüzdesine dahil edilir.',
    lifecycle_onboarding_checklist_note: 'Standart işe başlatma maddeleri ile şirketin tekrar kullanılabilir işe başlatma kontrol listesi adımları birlikte ilerleme yüzdesine dahil edilir.',
    lifecycle_sort_order: 'Sıra',
    lifecycle_target_role_any: 'Genel / Atamasız',
    lifecycle_target_role_short: 'Sorumlu Rol',
    lifecycle_template_create_error: 'Kontrol listesi maddesi eklenemedi.',
    lifecycle_template_created: 'Kontrol listesi şablon maddesi eklendi.',
    lifecycle_template_creating: 'Kontrol listesi maddesi ekleniyor...',
    lifecycle_template_delete_error: 'Kontrol listesi maddesi silinemedi.',
    lifecycle_template_deleted: 'Kontrol listesi şablon maddesi silindi.',
    lifecycle_template_deleting: 'Kontrol listesi maddesi siliniyor...',
    lifecycle_template_empty: 'Bu süreç için henüz kontrol listesi maddesi eklenmedi.',
    lifecycle_template_modal_offboarding: 'İşten Ayrılış Kontrol Listesi Şablonu',
    lifecycle_template_modal_onboarding: 'İşe Başlatma Kontrol Listesi Şablonu',
    lifecycle_template_no_detail: 'Açıklama girilmedi.',
    lifecycle_template_required_note: 'Bu madde ilerleme hesabına dahil edilsin',
    lbl_contact_cadro: 'CADRO DESTEK',
    title_support_center: 'Destek Mesajları',
    msg_contact_cadro_desc: 'Teknik konu, faturalama veya ürün geri bildirimi için kayıt açın. Durum güncellemelerini burada takip edebilirsiniz.',
    btn_new_support_request: 'Yeni Talep',
    btn_my_support_requests: 'Mesajlarım',
    btn_support_broadcasts: 'Duyurular',
    lbl_support_category: 'Kategori',
    lbl_support_subject: 'Konu',
    lbl_support_message: 'Mesaj',
    lbl_support_attachments: 'Dosya / Fotoğraf Ekle',
    btn_support_choose_files: 'Dosya Seç',
    btn_send_support: 'Destek Talebini Gönder',
    msg_support_failed: 'Destek talebi gönderilemedi.',
    msg_support_sent: 'Destek talebiniz gönderildi.',
    msg_support_subject_message_required: 'Konu ve mesaj alanlarını doldurun.',
    msg_support_broadcasts_failed: 'Duyurular alınamadı.',
    msg_support_broadcast_read_failed: 'Duyuru okunmuş olarak işaretlenemedi.',
    msg_support_broadcast_sent: 'Duyuru yayınlandı.',
    msg_support_broadcast_failed: 'Duyuru yayınlanamadı.',
    msg_support_messages_loading: 'Mesajlar yükleniyor...',
    msg_support_inbox_empty: 'Henüz gelen mesaj yok.',
    support_status_pending: 'Beklemede',
    support_status_in_progress: 'İşleme Alındı',
    support_status_resolved: 'Sonuçlandı',
    lbl_owner_update: 'CADRO Ekibi Güncellemesi',
    lbl_owner_approval_required: 'CADRO Ekibi Onayı Gerekli',
    lbl_subscription_cancellation: 'Abonelik İptal Talebi',
    title_subscription_cancellation_owner_review: 'İptal talebi önce CADRO ekibi onayına gider',
    msg_subscription_cancellation_owner_review: 'Bu seçenek yalnızca superadmin için açıktır. Talep önce CADRO ekibine düşer; görüşme ve onay sonrası Paddle tarafında işleme alınır.',
    btn_request_subscription_cancellation: 'Aboneliğimi İptal Et',
    msg_support_cancellation_message_required: 'İptal talebi için kısa bir açıklama yazın.',
    msg_support_cancellation_sent: 'Abonelik iptal talebiniz CADRO ekibi onayına gönderildi.',
    msg_support_cancellation_failed: 'Abonelik iptal talebi gönderilemedi.',
    msg_support_cancellation_sending: 'Gönderiliyor...',
    msg_support_cancellation_owner_queue: 'Paddle öncesi CADRO ekibi onayı bekleyen iptal talebi',
    ph_support_owner_note: 'Müşteriye görünecek kısa durum notu',
    ph_support_cancellation_owner_note: 'Görüşme notu, ikna durumu veya Paddle öncesi karar notu',
    msg_support_status_saved: 'Destek durumu kaydedildi.',
    msg_support_status_save_failed: 'Destek kaydı güncellenemedi.',
    btn_save_status: 'Durumu Kaydet',
    msg_executive_fetch_failed: 'Yönetmen koltuğu verileri alınamadı.',
    lbl_hero_desc: 'Modern şirketler için tasarlanmış yeni nesil İK, Finans ve Operasyon yönetim platformu.',
    step_identity: 'KİMLİK',
    step_contact_family: 'AİLE VE İLETİŞİM',
    step_corporate: 'KURUMSAL',
    step_finance_legal: 'FİNANS VE YASAL',
    lbl_system_metrics: 'Sistem Metrikleri',
    btn_sick_report: 'SAĞLIK RAPORU GİRİŞİ',
    lbl_report_worked_days: 'ÇALIŞILAN GÜN',
    lbl_report_approved_leaves: 'ONAYLI İZİN',
    lbl_report_sick_days: 'RAPORLU GÜN',
    lbl_report_paid_sick_days: 'TAM ÜCRETLİ RAPOR',
    lbl_report_deducted_sick_days: 'KESİNTİLİ RAPOR',
    lbl_report_late_count: 'GEÇ',
    lbl_report_early_count: 'ERKEN',
    lbl_report_overtime_hours: 'MESAİ',
    lbl_badge_cv_reviewed: 'CV İNCELENDİ',
    lbl_badge_phone_screen: 'TELEFON GÖRÜŞMESİ YAPILDI',
    lbl_badge_interview_completed: 'MÜLAKAT TAMAMLANDI',
    lbl_badge_reference_checked: 'REFERANSLAR ARANDI',
    lbl_badge_test_completed: 'TEST TAMAMLANDI',
    lbl_badge_technical_approved: 'TEKNİK ONAY ALINDI',
    lbl_badge_manager_approved: 'YÖNETİCİ ONAYI ALINDI',
    lbl_badge_offer_shared: 'TEKLİF PAYLAŞILDI',
    lbl_badge_documents_received: 'BELGELER ALINDI',
    lbl_badge_employee_record_created: 'PERSONEL KAYDI OLUŞTURULDU',
    lifecycle_item_account_closed: 'Kullanıcı hesabı kapatıldı',
    lifecycle_item_account_closed_detail: 'Hesap erişimi durdurulur, MFA ve mobil oturumlar pasifleştirilir.',
    lifecycle_item_exit_date: 'Çıkış tarihi tanımlandı',
    lifecycle_item_exit_date_missing: 'Henüz çıkış tarihi girilmedi.',
    lifecycle_item_termination_document: 'Çıkış belgesi oluşturuldu',
    lifecycle_item_assets_returned: 'Zimmetler kapatıldı',
    lifecycle_item_finance_clearance: 'Açık izin ve masraf kalmadı',
    lifecycle_item_tickets_closed: 'Açık destek talepleri kapatıldı',
    lifecycle_item_org_assignment: 'Departman ve kadro ataması yapıldı',
    lifecycle_item_account_ready: 'Kullanıcı hesabı hazır',
    lifecycle_item_account_ready_missing: 'E-posta tanımlı değil',
    lifecycle_item_password_change: 'İlk giriş şifre değişimi bekleniyor',
    lifecycle_item_password_change_active: 'Geçici şifre aktif',
    lifecycle_item_password_change_done: 'Şifre kalıcı hale gelmiş',
    lifecycle_item_contract_document: 'İş sözleşmesi oluşturuldu',
    lifecycle_item_dossier_ready: 'Özlük evrakları toplandı',
    lifecycle_item_device_login: 'İlk cihaz oturumu görüldü',
    lifecycle_detail_documents_count: '{{count}} belge',
    lifecycle_detail_active_assets_count: '{{count}} aktif zimmet',
    lifecycle_detail_open_tickets_count: '{{count}} açık talep',
    lifecycle_detail_pending_finance_count: '{{leaveCount}} izin, {{expenseCount}} masraf bekliyor',
    lifecycle_detail_dossier_count: '{{totalCount}} evrak, {{pendingCount}} bekleyen',
    lifecycle_detail_device_count: '{{count}} cihaz kaydı',
    menu_support_center: 'DESTEK MESAJLARI',
    lbl_document_action_history: 'EVRAK AKSİYON GEÇMİŞİ',
    field_system_name: 'Sistem / Uygulama',
    field_access_level: 'Erişim Seviyesi',
    field_document_name: 'Talep Edilen Belge',
    field_payload_document_name: 'Belge / Konu',
    field_delivery_method: 'Teslim Şekli',
    field_payload_delivery_method: 'Teslim / İşlem Şekli',
    field_health_correction_topic: 'Düzeltme Konusu',
    field_health_correction_expectation: 'İşlem Beklentisi',
    field_payroll_period: 'Bordro Dönemi',
    field_payroll_topic: 'Bordro Konusu',
    field_equipment_name: 'Talep Edilen Ekipman',
    field_payload_equipment_name: 'Ekipman',
    field_equipment_quantity: 'Adet',
    field_admin_topic: 'İdari Konu',
    field_other_reference: 'Referans / Kısa Etiket',
    field_payload_reference: 'Referans',
    ph_system_name: 'Örn. ERP, CRM, e-posta',
    ph_access_level: 'Örn. görüntüleme, düzenleme',
    ph_document_name: 'Örn. çalışma belgesi, maaş yazısı',
    ph_delivery_method: 'E-posta, imzalı PDF, basılı kopya',
    ph_health_correction_topic: 'Örn. sağlık raporu puantaj kaydı',
    ph_health_correction_expectation: 'Örn. İK inceleme ve bordro kontrolü',
    ph_payroll_period: 'Örn. 2026-03',
    ph_payroll_topic: 'Örn. mesai, kesinti, prim',
    ph_equipment_name: 'Örn. laptop, kulaklık, kart okuyucu',
    ph_equipment_quantity: 'Örn. 1',
    ph_admin_topic: 'Örn. ofis, lojistik, araç, tedarik',
    ph_other_reference: 'İç referans veya kısa etiket',
    settings_tab_responsibles: 'Şirket Sorumluları',
    settings_tab_responsibles_hint: 'Sistem iş akışı ayarları',
    settings_tab_company: 'Şirket Bilgileri',
    settings_tab_company_hint: 'Adres, telefon, logo',
    settings_tab_personal: 'Kişisel Ayarlar',
    settings_tab_personal_hint: 'Şifre ve güvenlik',
    settings_responsible_it: 'Helpdesk (IT)',
    settings_responsible_it_desc: 'Teknik destek, cihaz arızası ve BT operasyon talepleri varsayılan olarak bu sorumlunun iş listesine düşer.',
    settings_responsible_hr: 'İK Sorumlusu',
    settings_responsible_hr_desc: 'Özlük, evrak ve çalışan yaşam döngüsü süreçlerinde ilk operasyon sorumlusu olarak kullanılır.',
    settings_responsible_admin: 'İdari / Malzeme',
    settings_responsible_admin_desc: 'İdari işler, satın alma ön talepleri ve ofis ihtiyaçlarında varsayılan iş akışı sahibi olarak çalışır.',
    settings_responsible_payroll: 'Bordro Sorumlusu',
    settings_responsible_payroll_desc: 'Bordro, ücret, kesinti ve dönemsel maaş sorularında ilk değerlendirme sorumlusu olarak atanır.',
    settings_responsible_onboarding: 'İşe Başlatma Sorumlusu',
    settings_responsible_onboarding_desc: 'Yeni personel hesabı açılışı, ilk evrak takibi ve işe başlangıç adımlarında varsayılan iş sahibi olur.',
    settings_responsible_offboarding: 'İşten Ayrılış Sorumlusu',
    settings_responsible_offboarding_desc: 'Çıkış tarihi, hesap kapatma, iade ve kapanış belgeleri sürecinde varsayılan iş sahibi olur.',
    msg_saving_company_responsibles: 'Şirket sorumluları kaydediliyor...',
    msg_company_responsibles_saved: 'Şirket sorumluları kaydedildi.',
    err_company_responsibles_save: 'Şirket sorumluları kaydedilemedi.',
    msg_updating_password: 'Şifreniz güncelleniyor...',
    err_password_update: 'Şifre güncellenemedi.',
    msg_updating_logo: 'Logo yükleniyor...',
    msg_logo_updated: 'Logo başarıyla güncellendi.',
    err_logo_upload: 'Logo yüklenemedi.',
    msg_loading_settings: 'Ayarlar yükleniyor...',
    msg_updating_company_info: 'Şirket bilgileri güncelleniyor...',
    msg_company_info_updated: 'Şirket bilgileri güncellendi.',
    err_company_info_update: 'Şirket bilgileri güncellenemedi.',
    lbl_general_note: 'Genel Not',
    lbl_dossier_rules_engine: 'E-Özlük Kural Motoru',
    lbl_required_document_sets: 'Zorunlu belge setleri',
    lbl_expiry_alert_roles: 'Expiry Alert Rolleri',
    btn_save_routing_responsibles: 'İş Akışı Sorumlularını Kaydet',
    settings_field_visible_company_name: 'Görünen Şirket Adı',
    settings_field_legal_name: 'Yasal / Ticari Unvan',
    ph_legal_name: 'Sözleşme ve resmi belgelerde kullanılacak unvan',
    settings_field_tax_no: 'Vergi No',
    settings_field_workplace_no: 'SGK / İşyeri Sicil No',
    settings_field_active_plan: 'Aktif Paket',
    settings_field_address: 'Adres',
    settings_field_phone: 'Telefon',
    settings_field_email: 'E-Posta',
    settings_field_website: 'Web Sitesi',
    btn_update_company_info: 'Şirket Bilgilerini Güncelle',
    lbl_document_header: 'Belge Başlığı',
    lbl_brand_identity: 'Kurumsal Kimlik',
    msg_no_logo_yet: 'Henüz logo yok',
    msg_pdf_header_ready: 'PDF anteti hazır',
    msg_logo_pending: 'Logo bekleniyor',
    btn_upload_logo: 'Logoyu Yükle',
    lbl_personal_settings: 'Kişisel Ayarlar',
    lbl_account_security: 'Hesap Güvenliği',
    lbl_password_update: 'Şifre Güncelleme',
    lbl_personal_security_settings: 'Kişisel güvenlik ayarları',
    lbl_current_password: 'Mevcut Şifre',
    lbl_confirm_new_password: 'Yeni Şifre Tekrar',
    btn_update_password: 'Şifreyi Güncelle',
    lbl_kudos_sentence: '{{from}}, {{to}}\'ya teşekkür etti.',
    err_settings_load: 'Ayarlar veya personel listesi yüklenemedi.',
    msg_routing_saved: 'Yönlendirme ayarları başarıyla kaydedildi!',
    err_settings_save: 'Ayarlar kaydedilirken bir sorun oluştu.',
    page_system_settings_title_prefix: 'Sistem &',
    page_system_settings_title_highlight: 'İş Akışı Ayarları',
    page_system_settings_desc: 'Destek, izin ve operasyon taleplerinin varsayılan olarak hangi sorumlunun iş listesine düşeceğini buradan tanımlayabilirsiniz.',
    btn_save_settings: 'AYARLARI KAYDET',
    msg_waiting_settings_api: 'Ayarlar ve kadrolar API’den bekleniyor...',
    lbl_workflow_responsibles: 'İş Akışı Sorumluları',
    opt_select_employee: 'Personel Seçiniz',
    btn_forgot: 'Şifremi unuttum',
    btn_verify: 'DOĞRULA VE GİRİŞ YAP',
    btn_setup_start: 'ŞİFREMİ BELİRLE VE BAŞLA',
    btn_reset_send: 'KOD GÖNDER',
    btn_reset_save: 'YENİ ŞİFREYİ KAYDET',
    btn_force_reset_save: 'YENİ ŞİFREYİ BELİRLE',
    lbl_login: 'Giriş Yap',
    lbl_login_desc: 'CADRO hesabınıza giriş yapın',
    lbl_reset_password: 'Şifremi Unuttum',
    lbl_reset_desc: 'E-posta adresinize sıfırlama kodu göndereceğiz',
    lbl_mfa: 'Kimlik Doğrulama',
    lbl_mfa_desc: 'E-posta adresinize gelen 6 haneli kodu giriniz',
    lbl_setup_title: 'Hesabınızı Aktifleştirin',
    lbl_setup_desc: 'Ödeme onaylandı! E-postanızdaki kod ile şifrenizi belirleyin.',
    lbl_force_reset_title: 'Şifrenizi Yenileyin',
    lbl_force_reset_desc: 'İlk girişten önce yeni bir şifre belirlemeniz zorunludur.',
    lbl_membership_note: 'Henüz üye değilseniz',
    lbl_membership_note2: 'adresinden abonelik başlatabilirsiniz.',
    msg_login_success: 'Giriş başarılı!',
    msg_mfa_sent: 'Güvenlik kodunuz e-postanıza gönderildi.',
    msg_reset_code_sent: 'Kod e-postanıza gönderildi.',
    msg_password_changed: 'Şifre güncellendi!',
    msg_force_password_changed: 'Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.',
    msg_force_password_reset_sent: 'İlk giriş güvenliği için şifre yenileme kodunuz e-postanıza gönderildi.',
    msg_account_activated: 'Hesabınız aktifleştirildi!',
    err_default: 'Bir hata oluştu.',
    ph_mfa_code: '6 haneli doğrulama kodu',
    ph_setup_code: 'E-postanızdaki 6 haneli kod',
    ph_reset_code: '6 haneli sıfırlama kodu',
    ph_setup_password: 'Yeni şifrenizi belirleyin',
    btn_send_kudos_short: 'TEŞEKKÜR GÖNDER',
    lbl_kudos_counts: 'Teşekkür sayıları',
    err_leave_country_type_required: 'Lütfen önce ülke / bölge ve izin türü seçin.',
    lbl_leave_country: 'ÜLKE / BÖLGE',
    opt_select_country: 'Ülke / Bölge Seçin',
    opt_select_leave_type: 'Önce izin profili seçin',
    tab_payroll_report: 'BORDRO RAPORU',
    btn_save_sick_report: 'SAĞLIK RAPORUNU KAYDET',
    modal_title_sick_report: 'SAĞLIK RAPORU GİRİŞİ',
    msg_creating_sick_report: 'Sağlık raporu kaydediliyor...',
    msg_sick_report_created: 'Sağlık raporu kaydedildi.',
    msg_sick_report_full_pay: 'Tam ücretli rapor olarak işlendi.',
    msg_sick_report_deduct: 'Kesintili rapor olarak işlendi.',
    err_sick_report_create: 'Sağlık raporu kaydedilemedi.',
    err_select_employee_for_sick_report: 'Önce personel seçin.',
    err_fetch_attendance_report: 'Bordro raporu yüklenemedi.',
    msg_no_attendance_report_rows: 'Seçilen dönem için bordro raporu satırı bulunmadı.',
    lbl_loading_attendance_report: 'Bordro raporu yükleniyor...',
    lbl_payroll_effect: 'Bordro etkisi',
    lbl_payroll_decision_note: 'Bordro karar notu',
    lbl_report_no: 'Rapor No',
    lbl_report_people: 'Raporlanan Personel',
    lbl_issue_date: 'Düzenlenme Tarihi',
    lbl_issued_by: 'Düzenleyen Kurum',
    badge_sick_deduct: 'KESİNTİLİ RAPOR',
    badge_sick_full_pay: 'TAM ÜCRETLİ RAPOR',
    lbl_deduct_in_payroll: 'Bordroda kesintili',
    lbl_full_pay_in_payroll: 'Bordroda tam ücretli',
    status_sick_report: 'Sağlık raporu',
    ph_search_attendance: 'Personel veya departman ara',
    lbl_action_history: 'Aksiyon Geçmişi',
    msg_no_action_history: 'Henüz aksiyon geçmişi bulunmuyor.',
    msg_loading_document_history: 'Evrak aksiyon geçmişi yükleniyor...',
    msg_no_document_history: 'Henüz evrak aksiyon geçmişi yok.',
    lbl_created: 'Oluşturuldu',
    lbl_status_updated: 'Durum güncellendi',
    lbl_message_added: 'Mesaj eklendi',
    lbl_attachment_added: 'Ek dosya yüklendi',
    lbl_attachment_count: '{{count}} ek',
    doc_deleted: 'Evrak silindi',
    dossier_history_uploaded: 'Evrak yüklendi',
    dossier_history_status_updated: 'Evrak durumu güncellendi',
    dossier_history_deleted: 'Evrak arşivden silindi',
    common_not_available: 'Mevcut değil',
    tooltip_view_archive: 'Arşivi görüntüle',
    opt_support_technical: 'Teknik Sorun',
    opt_support_billing: 'Faturalama',
    opt_support_feature: 'Özellik Talebi',
    opt_support_other: 'Diğer',
    ph_support_subject: 'Kısa bir konu yazın',
    ph_support_message: 'Mesajınızı yazın',
    btn_mark_as_read: 'Okundu işaretle',
    lbl_broadcast_read: 'Okundu',
    lbl_broadcast_unread: 'Okunmadı',
    msg_loading_support_requests: 'Destek talepleri yükleniyor...',
    msg_no_support_requests: 'Destek talebi bulunmuyor.',
    msg_loading_support_broadcasts: 'Duyurular yükleniyor...',
    msg_no_support_broadcasts: 'Duyuru bulunmuyor.',
    lbl_system_user: 'Sistem',
    msg_support_failed: 'Destek kayıtları alınamadı.',
    msg_support_broadcasts_failed: 'Duyurular alınamadı.',
    msg_support_broadcast_read_failed: 'Duyuru okunmuş olarak işaretlenemedi.',
    msg_support_subject_message_required: 'Konu ve mesaj alanlarını doldurun.',
    msg_support_sent: 'Destek talebiniz gönderildi.',
    msg_support_cancellation_message_required: 'İptal talebi için kısa bir açıklama yazın.',
    msg_support_cancellation_sent: 'Abonelik iptal talebiniz CADRO ekibi onayına gönderildi.',
    msg_support_cancellation_failed: 'Abonelik iptal talebi gönderilemedi.',
    msg_support_cancellation_sending: 'Gönderiliyor...',
    support_status_pending: 'Beklemede',
    support_status_in_progress: 'İşleme Alındı',
    support_status_resolved: 'Sonuçlandı',
    title_support_center: 'Destek Mesajları',
    msg_contact_cadro_desc: 'Teknik konu, faturalama veya ürün geri bildirimi için kayıt açın. Durum güncellemelerini burada takip edebilirsiniz.',
    btn_new_support_request: 'Yeni Talep',
    btn_my_support_requests: 'Mesajlarım',
    btn_support_broadcasts: 'Duyurular',
    lbl_subscription_cancellation: 'Abonelik İptal Talebi',
    title_subscription_cancellation_owner_review: 'İptal talebi önce CADRO ekibi onayına gider',
    msg_subscription_cancellation_owner_review: 'Bu seçenek yalnızca superadmin için açıktır. Talep önce CADRO ekibine düşer; görüşme ve onay sonrası Paddle tarafında işleme alınır.',
    btn_request_subscription_cancellation: 'Aboneliğimi İptal Et',
    lbl_support_category: 'Kategori',
    lbl_support_subject: 'Konu',
    lbl_support_message: 'Mesaj',
    lbl_support_attachments: 'Dosya / Fotoğraf Ekle',
    btn_support_choose_files: 'Dosya Seç',
    btn_send_support: 'Destek Talebini Gönder',
    lbl_owner_approval_required: 'CADRO Ekibi Onayı Gerekli',
    lbl_owner_update: 'CADRO Ekibi Güncellemesi',
    lbl_kpi_group_workforce: 'İşgücü',
    lbl_kpi_group_absence: 'Devamsızlık & İzin',
    lbl_kpi_group_operations: 'Operasyon',
    lbl_kpi_group_compliance: 'Uyum',
    lbl_system_active_employees: 'Aktif Personel',
    lbl_system_turnover_rate: 'Dönem Devir Oranı',
    lbl_system_leave_today: 'Bugün İzinli',
    lbl_system_absent_today: 'Bugün Devamsız',
    lbl_system_absence_rate_today: 'Bugün Devamsızlık Oranı',
    lbl_system_leave_coverage_rate_today: 'Bugün İzin Oranı',
    lbl_system_leave_usage_rate: 'Dönem İzin Kullanımı',
    lbl_system_open_queue: 'Açık İş Kuyruğu',
    lbl_system_pending_policy_ack: 'Bekleyen Politika Onayı',
    lbl_system_expiring_documents: '30 Günde Bitecek Evrak',
    msg_no_kpi_categories: 'Seçili filtrelerde kategori verisi bulunmuyor.',
    btn_clear: 'Temizle',
    msg_saving: 'Kaydediliyor...',
    msg_sending: 'Gönderiliyor...',
    msg_leave_cancel_not_available: 'İzin talebi iptali şu anda personel portalında aktif değil. İptal için yöneticiniz veya İK ile iletişime geçin.',
    opt_full_pay_sick: 'TAM ÜCRET ÖDE',
    opt_deduct_sick: 'KESİNTİYE DAHİL ET',
    file_attendance: 'Puantaj',
    col_name: 'AD SOYAD',
    desc_bulk_action: 'Seçilen kayıtları toplu olarak yönetmek için kullanın.',
    action_approve: 'onaylamak',
    action_reject: 'reddetmek',
    opt_all_schedule_types: 'TÜM PLAN TİPLERİ',
    opt_all_schedules: 'TÜM PLANLAR',
    opt_all_statuses: 'TÜM DURUMLAR',
    ph_select_employee: 'Personel seçin',
    err_schedule_report_pdf: 'Mesai planı PDF raporu oluşturulamadı.',
    msg_schedule_report_pdf: 'Mesai planı PDF raporu hazırlanıyor...',
    msg_schedule_report_pdf_ready: 'Mesai planı raporu hazır.',
    err_schedule_members_report_pdf: 'Plan personel raporu oluşturulamadı.',
    msg_schedule_members_report_pdf: '"{{name}}" için personel raporu hazırlanıyor...',
    msg_schedule_members_report_pdf_ready: 'Plan personel raporu hazır.',
    doc_id: 'KİMLİK / PASAPORT FOTOKOPİSİ',
    doc_pre_permit: 'ÖN İZİN EVRAKLARI (KKTC)',
    doc_work_permit: 'ÇALIŞMA İZNİ & SAĞLIK RAPORU',
    doc_residency: 'İKAMET / ADRES TEYİT BELGESİ',
    doc_visa: 'VİZE / OTURUM İZNİ',
    doc_contract: 'İŞ SÖZLEŞMESİ (HİZMET AKDİ)',
    doc_nda: 'GİZLİLİK / NDA',
    doc_handbook_ack: 'EL KİTABI ONAYI',
    doc_background_check: 'ARKA PLAN KONTROLÜ',
    doc_ohs_training: 'İSG EĞİTİM / SAĞLIK UYGUNLUK',
    doc_bank_info: 'BANKA / IBAN BİLGİSİ',
    doc_tax_doc: 'VERGİ / TIN BELGESİ',
    doc_payroll: 'MAAŞ BORDROSU',
    doc_social_security_record: 'SOSYAL GÜVENLİK KAYDI',
    doc_performance_review: 'PERFORMANS DEĞERLENDİRME',
    doc_training_record: 'EĞİTİM KAYDI',
    doc_leave_record: 'İZİN / DEVAMSIZLIK BELGESİ',
    doc_disciplinary: 'DİSİPLİN KAYDI',
    doc_termination: 'İŞTEN AYRILMA (FESİH / İBRANAME)',
    doc_exit_interview: 'ÇIKIŞ GÖRÜŞMESİ',
    doc_onboarding_checklist: 'ONBOARDING CHECKLIST',
    doc_offboarding_checklist: 'OFFBOARDING CHECKLIST',
    doc_certificate: 'SERTİFİKA & MESLEKİ EĞİTİM',
    doc_other: 'DİĞER EVRAKLAR',
    tab_uploaded_documents: 'YÜKLENMİŞ EVRAKLAR',
    tab_upload_document: 'EVRAK YÜKLE',
    tab_compliance: 'UYUM ÖZETİ',
    action_approved: 'Onaylandı',
    action_rejected: 'Reddedildi',
    badge_approved_doc: 'ONAYLI EVRAK',
    btn_approve: 'ONAYLA',
    btn_reject: 'REDDET',
    btn_select_employee_archive: 'PERSONEL SEÇ',
    btn_change_employee_archive: 'PERSONEL DEĞİŞTİR',
    btn_choose_from_pc: 'BİLGİSAYARDAN DOSYA SEÇİN',
    btn_upload_to_archive: 'ARŞİVE YÜKLE',
    btn_uploading: 'YÜKLENİYOR...',
    err_delete_failed: 'Evrak silinemedi.',
    err_delete_pending_only: 'Personel yalnızca bekleyen evrakları silebilir.',
    err_document_status_update: 'Evrak durumu güncellenemedi.',
    err_fetch_docs: 'Evraklar yüklenemedi.',
    err_fetch_emps: 'Personel listesi yüklenemedi.',
    err_fetch_files: 'Dosyalar yüklenemedi.',
    err_file_size: 'Dosya boyutu sınırı aşıldı.',
    err_upload_failed: 'Evrak yüklenemedi.',
    lbl_archive_selection: 'ARŞİV SEÇİMİ',
    lbl_completion_score: 'TAMAMLILIK SKORU',
    lbl_country_role_rule_set: 'ÜLKE / ROL KURAL SETİ',
    lbl_doc_category: 'EVRAK KATEGORİSİ',
    lbl_doc_issue_date: 'DÜZENLENME TARİHİ',
    lbl_doc_issued_by: 'VEREN KURUM',
    lbl_doc_mandatory: 'ZORUNLU EVRAK',
    lbl_doc_number: 'BELGE NO',
    lbl_doc_number_short: 'NO',
    lbl_doc_valid_until: 'GEÇERLİLİK TARİHİ',
    lbl_document_detail: 'EVRAK DETAYI',
    lbl_dossier_compliance: 'EVRAK UYUM ÖZETİ',
    lbl_expired_docs: 'SÜRESİ DOLAN',
    lbl_expired_required_docs: 'SÜRESİ DOLAN ZORUNLU EVRAKLAR',
    lbl_expiring_required_docs: 'YAKINDA BİTECEK ZORUNLU EVRAKLAR',
    lbl_expiring_soon: 'YAKINDA SONA ERECEK',
    lbl_items: 'adet',
    lbl_max_file_size: 'Maksimum Dosya Boyutu: 10MB',
    lbl_missing_required: 'EKSİK ZORUNLU',
    lbl_my_dossier: 'KİŞİSEL E-ÖZLÜK ARŞİVİM',
    lbl_select_file_format: 'DOSYA SEÇİN (PDF / RESİM)',
    lbl_upload_new_doc: 'SİSTEME YENİ EVRAK YÜKLE',
    msg_all_required_docs_ready: 'ZORUNLU EVRAKLAR TAMAM',
    msg_confirm_delete_doc: 'Bu evrak kalıcı olarak silinecek. Emin misiniz?',
    msg_delete_success: 'Evrak başarıyla arşivden silindi.',
    msg_document_status_updated: 'Evrak durumu {{status}} olarak güncellendi.',
    msg_dossier_compliant: 'Bu arşivde tanımlı zorunlu evraklar şu an eksiksiz görünüyor.',
    msg_missing_required_docs: 'EKSİK ZORUNLU EVRAKLAR',
    msg_no_docs_found: 'Bu personelin dosyasında henüz evrak bulunmuyor.',
    msg_no_employee_selected: 'Henüz personel seçilmedi',
    msg_no_expired_required_docs: 'Zorunlu belgelerde süresi dolmuş kayıt görünmüyor.',
    msg_no_expiring_required_docs: 'Yakında bitecek zorunlu evrak görünmüyor.',
    msg_searching_docs: 'Evraklar aranıyor...',
    msg_select_doc_for_detail: 'DETAYI GÖRMEK İÇİN BİR EVRAK SEÇİN',
    msg_select_emp_focus_html: 'E-ÖZLÜK DOSYASINI GÖRMEK İÇİN<br/>ÖNCE BİR PERSONEL SEÇİNİZ.',
    msg_upload_pending: 'Evrak onay bekliyor.',
    msg_upload_success: 'Evrak başarıyla arşive eklendi.',
    msg_uploading_doc: 'Evrak yükleniyor...',
    ph_search_emp: 'İsim veya departman ara...',
    tooltip_delete_archive: 'Arşivden Sil',
    tooltip_view_doc: 'Evrakı Görüntüle',
    badge_pending_approval: 'ONAY BEKLİYOR',
    badge_rejected_doc: 'REDDEDİLDİ',
    badge_expiring_soon: 'YAKINDA BİTİYOR',
    badge_expired: 'SÜRESİ DOLDU',
    lbl_employee: 'PERSONEL',
    lbl_first_name: 'ADI',
    lbl_last_name: 'SOYADI',
    lbl_pending_documents: 'BEKLEYEN EVRAKLAR',
    lbl_support_broadcasts: 'DESTEK MESAJLARI',
    msg_document_waiting: 'evrak onayınızı bekliyor.',
    msg_support_broadcast_waiting: 'okunmamış duyuru sizi bekliyor.',
    role_owner: 'PLATFORM SAHİBİ',
    btn_contact_cadro: 'CADRO DESTEK',
    menu_executive_console: 'YÖNETMEN KOLTUĞU',
    menu_executive_companies: 'ŞİRKETLER',
    menu_executive_revenue: 'GELİR & PAKETLER',
    menu_executive_risks: 'RİSKLER & UYARILAR',
    menu_executive_messages: 'MESAJLAR',
    menu_account_security: 'HESAP GÜVENLİĞİ',
    dossier_profile_global_title: 'Global',
    dossier_profile_global_desc: 'Varsayılan şirket profili için temel zorunlu belge seti.',
    dossier_profile_tr_title: 'TR',
    dossier_profile_tr_desc: 'Türkiye profili için zorunlu belge seti.',
    dossier_profile_kktc_title: 'KKTC',
    dossier_profile_kktc_desc: 'KKTC profili için zorunlu belge seti.',
    dossier_profile_eu_title: 'EU',
    dossier_profile_eu_desc: 'Avrupa profili için zorunlu belge seti.',
    dossier_profile_mena_title: 'MENA',
    dossier_profile_mena_desc: 'MENA profili için zorunlu belge seti.',
    dossier_profile_leadership_title: 'Leadership',
    dossier_profile_leadership_desc: 'Yönetici, HR, Admin ve Superadmin için ek zorunlu belge seti.',
    lbl_security_tip: 'Öneri',
    desc_security_tip: 'Yönetici hesabında güçlü bir parola kullanın ve düzenli aralıklarla değiştirin. Mobil MFA akışınız zaten aktif durumdadır.',

    // 🕐 PUANTAJ YENİ MODÜL — RBAC odaklı çeviriler
    attendance_kpi_present: 'Devam Günü',
    attendance_kpi_late: 'Geç Kalma',
    attendance_kpi_hours: 'Toplam Saat',
    attendance_kpi_sick: 'Sağlık Raporu',
    attendance_kpi_checked_in: 'Bugün Giriş',
    attendance_kpi_late_count: 'Geç Kalan',
    attendance_kpi_absent: 'Eksik/Gelmeyen',
    attendance_kpi_pending: 'Onay Bekleyen',
    attendance_kpi_total_hours: 'Toplam Saat',
    attendance_view_weekly: 'Haftalık',
    attendance_view_monthly: 'Aylık',
    attendance_legend_present: 'Giriş',
    attendance_legend_late: 'Geç',
    attendance_legend_absent: 'Yok',
    attendance_legend_sick: 'Rapor',
    attendance_legend_holiday: 'Tatil',
    attendance_filter_date: 'Tarih',
    attendance_filter_from: 'Başlangıç',
    attendance_filter_to: 'Bitiş',
    attendance_filter_personnel: 'Personel',
    attendance_filter_search: 'Ad Soyad Ara',
    attendance_filter_search_placeholder: 'İsim veya soyisim...',
    attendance_filter_department: 'Departman',
    attendance_filter_all_departments: 'Tüm Departmanlar',
    attendance_filter_status: 'Durum',
    attendance_filter_all_status: 'Tüm Durumlar',
    attendance_filter_approval: 'Onay',
    attendance_filter_all_approval: 'Tüm Onaylar',
    attendance_export: 'Dışa Aktar',
    attendance_export_success: 'Dışa aktarım tamamlandı.',
    attendance_no_records: 'Henüz puantaj kaydı bulunamadı.',
    attendance_selected: 'kayıt seçildi',
    attendance_bulk_approve: 'Toplu Onayla',
    attendance_bulk_reject: 'Toplu Reddet',
    attendance_bulk_approved: 'Seçilen kayıtlar onaylandı.',
    attendance_col_employee: 'Personel',
    attendance_col_date: 'Tarih',
    attendance_col_in: 'Giriş',
    attendance_col_out: 'Çıkış',
    attendance_col_duration: 'Süre',
    attendance_col_status: 'Durum',
    attendance_col_approval: 'Onay',
    attendance_col_actions: 'İşlem',
    schedule_kicker: 'Mesai Planı Yönetimi',
    schedule_title: 'Mesai Planı Şablonları',
    schedule_add: 'Yeni Şablon',
    schedule_empty: 'Henüz mesai planı şablonu yok.',
    schedule_name: 'Plan Adı',
    schedule_type: 'Tip',
    schedule_break: 'Mola (dk)',
    schedule_start: 'Başlangıç',
    schedule_end: 'Bitiş',
    schedule_grace_in: 'Giriş Tolerans (dk)',
    schedule_overtime: 'Fazla Mesai Sonrası (dk)',
    schedule_active: 'Aktif',
    schedule_updated: 'Mesai planı güncellendi.',
    schedule_created: 'Mesai planı oluşturuldu.',
    schedule_deleted: 'Mesai planı silindi.',
    schedule_delete_confirm: 'Bu mesai planını silmek istediğinize emin misiniz?',
    schedule_edit: 'Mesai Planını Düzenle',
    schedule_new: 'Yeni Mesai Planı',
    dept_assign_kicker: 'Departman Atamaları',
    dept_assign_title: 'Departman Bazlı Mesai Planı',
    dept_assign_desc: 'Her departman için varsayılan mesai planını seçin.',
    dept_assign_employees: 'personel',
    dept_assign_none: 'Atanmamış',
    dept_assign_empty: 'Departman bulunamadı.',
    override_kicker: 'Personel İstisnası',
    override_title: 'Personel Bazlı Mesai İstisnası',
    override_desc: 'Belirli personellere departman mesai planından farklı bir plan ata.',
    override_search: 'Personel ara...',
    override_all_departments: 'Tüm Departmanlar',
    override_empty: 'Personel bulunamadı.',
    override_badge: 'İSTİSNA',
    override_selected: 'personel seçildi',
    override_select_schedule: 'Mesai planı seçin...',
    override_reason: 'Sebep (opsiyonel)',
    override_assign_btn: 'Ata',
    override_clear_btn: 'İstisnaları Kaldır',
    override_assigned: 'Personel istisnaları atandı.',
    override_cleared: 'İstisnalar kaldırıldı.',
    override_select_both: 'Personel ve mesai planı seçin.',
    override_clear_confirm: 'Seçili personelin istisnalarını kaldırmak istediğinize emin misiniz?',
    payroll_kicker: 'Bordro Özeti',
    payroll_title: 'Bordroya Esas Puantaj Özeti',
    payroll_generate: 'Oluştur',
    payroll_click_generate: 'Bordro özetini görmek için "Oluştur" butonuna tıklayın.',
    payroll_col_employee: 'Personel',
    payroll_col_normal: 'Normal',
    payroll_col_overtime: 'Fazla Mesai',
    payroll_col_absent: 'Eksik',
    payroll_col_total: 'Toplam',
    payroll_total: 'GENEL TOPLAM',
  },
  en: {
    sidebar_group_workspace: 'Workspace',
    sidebar_group_people: 'People Operations',
    sidebar_group_operations: 'Operations',
    sidebar_group_compliance: 'Growth & Compliance',
    sidebar_group_requests: 'Finance & Requests',
    sidebar_group_team: 'Team & Organization',
    sidebar_group_workday: 'Workday',
    sidebar_group_growth: 'Growth',
    menu_knowledge_base: 'KNOWLEDGE BASE & POLICIES',
    menu_purchase_requests: 'PURCHASE REQUESTS',
    menu_request_forms: 'CORPORATE REQUEST FORMS',
    menu_kpi_statistics: 'KPI & STATISTICS',
    menu_surveys: 'SURVEYS & RECOMMENDATION SCORE',
    sidebar_group_experience: 'Employee Experience',
    engagement_module: 'Employee Experience',
    survey_title: 'Surveys and Employee Recommendation Score',
    survey_phase1_info: 'From this area you can create survey templates, publish campaigns, and follow employee feedback.',
    survey_my_inbox: 'My Survey Inbox',
    survey_no_pending: 'No pending surveys.',
    survey_anonymous: 'Anonymous',
    survey_named: 'Named',
    survey_answer: 'Answer',
    survey_completed: 'Completed',
    survey_admin_center: 'Management',
    survey_templates: 'Templates',
    survey_template_name: 'Template name',
    survey_question_code: 'Code',
    survey_question_text: 'Question',
    survey_required: 'Required',
    survey_delete: 'Delete',
    survey_choices_comma: 'Choices (comma separated)',
    survey_add_question: 'Add Question',
    survey_existing_templates: 'Existing Templates',
    survey_update_template: 'Update Template',
    survey_create_template: 'Create Template',
    survey_campaigns: 'Campaigns',
    survey_choose_template: 'Choose template',
    survey_campaign_name: 'Campaign name',
    survey_department_filter: 'Target department IDs (comma separated)',
    survey_role_filter: 'Target role codes (comma separated)',
    survey_start_at: 'Start date',
    survey_end_at: 'End date',
    survey_is_anonymous: 'Anonymous survey',
    survey_update_campaign: 'Update Campaign',
    survey_create_campaign: 'Create Campaign',
    survey_campaign_list: 'Campaign List',
    survey_edit_campaign: 'Edit',
    survey_launch: 'Launch',
    survey_close: 'Close',
    survey_view_analytics: 'Analytics',
    survey_participation: 'Participation',
    survey_recommendation_score: 'Employee Recommendation Score',
    survey_scale_avg: 'Average Score',
    survey_department_breakdown: 'Department Breakdown',
    survey_role_breakdown: 'Role Breakdown',
    survey_role_admin: 'Admin',
    survey_role_employee: 'Employee',
    survey_role_hr: 'HR',
    survey_role_manager: 'Manager',
    survey_role_superadmin: 'Super Admin',
    survey_select_option: 'Select an option',
    survey_submit: 'Submit',
    survey_edit: 'Edit',
    survey_status_draft: 'Draft',
    survey_status_live: 'Live',
    survey_status_closed: 'Closed',
    survey_status_active: 'Active',
    survey_category_pulse: 'Pulse Survey',
    survey_category_enps: 'Employee Recommendation Score',
    survey_category_exit: 'Exit Survey',
    survey_category_onboarding: 'Onboarding Survey',
    survey_category_custom: 'Custom Survey',
    survey_qtype_nps_0_10: '0-10 Recommendation Score',
    survey_qtype_scale_1_5: '1-5 Rating Scale',
    survey_qtype_single_choice: 'Single Choice',
    survey_qtype_multi_choice: 'Multiple Choice',
    survey_qtype_text_short: 'Short Text',
    survey_qtype_text_long: 'Long Text',
    survey_default_question_recommendation: 'How likely are you to recommend our company as a place to work?',
    survey_default_question_improvement: 'What should we improve?',
    survey_load_failed: 'Survey data could not be loaded.',
    survey_template_load_failed: 'Template detail could not be loaded.',
    survey_question_required: 'Please enter at least one question.',
    survey_template_create_failed: 'Template could not be saved.',
    survey_campaign_save_failed: 'Campaign could not be saved.',
    survey_campaign_launch_failed: 'Campaign could not be launched.',
    survey_campaign_close_failed: 'Campaign could not be closed.',
    survey_detail_load_failed: 'Survey detail could not be loaded.',
    survey_submit_failed: 'Survey could not be submitted.',
    survey_analytics_failed: 'Analytics could not be loaded.',
    nav_knowledge_base: 'KNOWLEDGE BASE & POLICIES',
    nav_sub_knowledge_base: 'Policy and SOP reading center',
    nav_request_forms: 'CORPORATE REQUEST FORMS',
    nav_sub_request_forms: 'Structured request and workflow management',
    nav_kpi_statistics: 'KPI & STATISTICS',
    nav_sub_kpi_statistics: 'Metric tracking by date range',
    btn_add: 'ADD',
    btn_refresh: 'REFRESH',
    btn_new_purchase_request: 'New Purchase Request',
    btn_submit_purchase_request: 'Submit Request',
    btn_convert_to_expense: 'Convert to Expense',
    btn_new_generic_request: 'New Corporate Request',
    btn_open_flow: 'Open Details',
    btn_take_in_progress: 'Move to Review',
    btn_complete: 'Close Out',
    btn_send_message: 'Send Message',
    btn_add_attachment: 'Add Attachment',
    btn_submit_request: 'Submit Request',
    btn_new_kpi_metric: 'New KPI Metric',
    err_fetch_purchase_requests: 'Purchase requests could not be loaded.',
    err_create_purchase_request: 'Purchase request could not be created.',
    err_convert_purchase_expense: 'Expense record could not be created.',
    err_fetch_generic_requests: 'Corporate requests could not be loaded.',
    err_fetch_generic_request_detail: 'Request detail could not be loaded.',
    err_create_generic_request: 'Request could not be created.',
    err_fetch_kpi_metrics: 'KPI records could not be loaded.',
    err_create_kpi_metric: 'KPI record could not be created.',
    err_delete_kpi_metric: 'KPI record could not be deleted.',
    generic_requests_open: 'Open Records',
    lbl_pending_requests: 'Total Awaiting Action',
    lbl_approved_requests: 'Approved Requests',
    lbl_rejected_requests: 'Rejected Requests',
    lbl_current_total: 'Current View Total',
    lbl_finance_approver: 'Finance Approver',
    lbl_item_name: 'Item / Service',
    lbl_vendor: 'Vendor',
    lbl_product_link: 'Product / Service Link',
    lbl_quantity: 'Quantity',
    lbl_quantity_unit_price: 'Quantity and Unit Price',
    lbl_unit_price: 'Unit Price',
    lbl_justification: 'Justification',
    lbl_needed_by: 'Needed By',
    lbl_converted_to_expense: 'Converted to Expense',
    lbl_request_routing_engine: 'Request Workflow Engine',
    lbl_routing_logic: 'Workflow',
    lbl_request_type: 'Request Type',
    lbl_requested_by: 'Requested By',
    lbl_requested_for: 'Requested For',
    lbl_assigned_to: 'Workflow Owner',
    lbl_request_timeline: 'Workflow Timeline',
    lbl_required: 'Required',
    lbl_route_explanation: 'Workflow Summary',
    lbl_no_resolution_note: 'No outcome note entered yet.',
    lbl_undefined: 'Undefined',
    lbl_record: 'Record',
    lbl_title: 'Title',
    lbl_description: 'Description',
    lbl_system: 'System',
    lbl_statistics_engine: 'Statistics Engine',
    lbl_kpi_pulse: 'KPI Pulse',
    lbl_open_statistics_screen: 'Open statistics screen',
    lbl_selected_period_metrics: 'Selected Period Records',
    lbl_selected_period_total: 'Selected Period Total',
    lbl_period_delta: 'Previous Period Delta',
    lbl_category_breakdown: 'Category Breakdown',
    lbl_kpi_records: 'KPI Records',
    kpi_category_headcount: 'Headcount',
    kpi_category_recruitment: 'Recruitment',
    kpi_category_payroll: 'Payroll',
    kpi_category_absence: 'Absence',
    kpi_category_training: 'Training',
    kpi_category_performance: 'Performance',
    kpi_category_finance: 'Finance',
    kpi_category_other: 'Other',
    lbl_metric_date: 'Metric Date',
    lbl_source_type: 'Source Type',
    lbl_target_value: 'Target Value',
    lbl_actual_value: 'Actual Value',
    lbl_target_progress: 'Target Progress',
    lbl_unit: 'Unit',
    kpi_unit_count: 'Count',
    kpi_unit_percent: '%',
    kpi_unit_currency: 'Currency',
    kpi_unit_day: 'Day',
    kpi_unit_hour: 'Hour',
    kpi_source_manual: 'Manual',
    kpi_source_system: 'System',
    lbl_search: 'Search',
    lbl_date_range: 'Date Range',
    lbl_status: 'Status',
    ph_search_purchase_requests: 'Search item, vendor or employee',
    modal_purchase_request: 'Purchase Request',
    ph_search_generic_requests: 'Search title, description or employee',
    ph_generic_request_title: 'Write the request topic clearly',
    ph_generic_request_description: 'Explain the need, business impact and expected outcome',
    ph_request_reply: 'Write your reply',
    ph_search_kpi_metrics: 'Search KPI title',
    ph_kpi_title: 'E.g. monthly absence rate',
    ph_kpi_note: 'Optional note',
    opt_all_personnel: 'All Personnel',
    opt_all_request_types: 'All Request Types',
    opt_all_categories: 'All Categories',
    opt_myself: 'Myself',
    btn_reset_filter: 'Clear',
    btn_confirm_filter: 'Apply',
    priority_low: 'Low',
    priority_normal: 'Normal',
    priority_high: 'High',
    priority_urgent: 'Urgent',
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_active: 'Active',
    status_completed: 'Completed',
    status_rejected: 'Rejected',
    msg_creating_purchase_request: 'Creating purchase request...',
    msg_purchase_request_created: 'Purchase request sent for finance approval.',
    msg_confirm_purchase_approve: 'Do you want to approve this purchase request?',
    prompt_purchase_reject_reason: 'Please enter the rejection reason:',
    prompt_purchase_reject_default: 'Not approved due to budget / purchasing policy.',
    msg_purchase_request_approved: 'Purchase request approved.',
    msg_purchase_request_rejected: 'Purchase request rejected.',
    msg_confirm_convert_purchase_expense: 'Do you want to convert this request into an expense record?',
    msg_converting_purchase_expense: 'Creating expense record...',
    msg_purchase_expense_converted: 'Request converted into an expense record.',
    msg_no_purchase_requests: 'No requests in this view.',
    msg_creating_generic_request: 'Creating corporate request...',
    msg_generic_request_created: 'The request was added to the relevant workflow owner queue.',
    prompt_generic_request_reject: 'Enter rejection note:',
    prompt_generic_request_reject_default: 'The request was not found compatible with the current process or policy.',
    msg_confirm_generic_request_action: 'Do you want to apply this status?',
    msg_generic_request_updated: 'The workflow status was updated.',
    msg_no_generic_requests: 'No requests in this view.',
    msg_no_request_messages: 'No messages yet.',
    msg_creating_kpi_metric: 'Creating KPI record...',
    msg_kpi_metric_created: 'KPI record created.',
    msg_confirm_delete_kpi: 'Do you want to delete this KPI record?',
    msg_kpi_metric_deleted: 'KPI record deleted.',
    msg_no_kpi_metrics: 'No KPI records found for selected filters.',
    attendance_self_recent_tab: 'RECENT RECORDS',
    attendance_self_health_tab: 'MY SICK REPORTS',
    attendance_self_health_summary_title: 'MY HEALTH REPORT VIEW',
    attendance_self_health_summary_desc: 'This area only shows the minimum information needed for attendance and payroll impact. Diagnosis, medical assessment, and internal processing notes are not shown.',
    attendance_self_health_summary_correction: 'If you notice an incorrect or missing record, you can open an HR correction request through Corporate Request Forms.',
    attendance_self_no_health_reports: 'NO REGISTERED SICK REPORTS FOUND.',
    attendance_self_report_period: 'REPORT PERIOD',
    attendance_self_report_no: 'REPORT NO',
    attendance_self_issue_date: 'ISSUE DATE',
    attendance_self_payroll_visibility: 'PAYROLL IMPACT',
    attendance_self_full_pay: 'FULL PAY',
    attendance_self_deduct_pay: 'INCLUDED IN PAYROLL DEDUCTION',
    attendance_self_included_in_payroll: 'ACTIVE IN ATTENDANCE',
    attendance_self_not_included_in_payroll: 'NOT INCLUDED IN ATTENDANCE',
    attendance_self_report_short: 'REPORT',
    attendance_self_health_entry: 'SICK REPORT ENTRY',
    attendance_self_report_reference: 'REFERENCE',
    btn_open_correction_request: 'OPEN CORRECTION REQUEST',
    attendance_self_open_record_correction: 'OPEN CORRECTION FOR THIS RECORD',
    generic_request_prefill_health_title: 'Attendance Sick Report Correction Request',
    generic_request_prefill_health_intro: 'I am requesting a correction for my own sick report attendance record.',
    generic_request_prefill_health_closing: 'Please review the record accuracy and payroll impact.',
    generic_request_prefill_health_document: 'Attendance / Sick Report Record',
    generic_request_prefill_health_delivery: 'HR review and correction',
    generic_request_quick_all: 'ALL REQUESTS',
    generic_request_quick_health_corrections: 'HEALTH RECORD CORRECTIONS',
    notif_pending_purchase_requests: '{{count}} purchase requests are awaiting action.',
    notif_open_generic_requests: '{{count}} corporate requests are awaiting action.',
    notif_pending_policy_acknowledgements: '{{count}} policy items are awaiting reading or acknowledgment.',
    lbl_purchase_requests: 'PURCHASE REQUESTS',
    msg_purchase_requests_waiting: 'purchase requests are awaiting action.',
    lbl_generic_requests: 'CORPORATE REQUESTS',
    msg_generic_requests_waiting: 'corporate requests are awaiting action.',
    notif_health_record_corrections: '{{count}} health record correction requests are awaiting HR review.',
    lbl_health_record_corrections: 'HEALTH RECORD CORRECTIONS',
    msg_health_record_corrections_waiting: 'There are correction requests waiting for HR review.',
    lbl_pending_policy_acknowledgements: 'POLICY ACKNOWLEDGEMENTS',
    msg_pending_policy_acknowledgements_waiting: 'There are policy items awaiting reading or acknowledgment.',
    lbl_stat_sick_report_days: 'SICK DAYS',
    lbl_days_short: 'Days',
    lifecycle_manage_template: 'Manage Template',
    lifecycle_operation_checklist: 'Operational Checklist',
    lifecycle_progress_summary: 'Progress Summary',
    lifecycle_add_template_item: 'New Template Item',
    lifecycle_auto_action: 'Automatic Action',
    lifecycle_auto_step: 'Automatic',
    lifecycle_manual_step: 'Manual item',
    lifecycle_checklist_not_completed: 'Not completed yet',
    lifecycle_checklist_template_label: 'Checklist Template',
    lifecycle_checklist_update_error: 'Checklist item could not be updated.',
    lifecycle_checklist_updated: 'Checklist item updated.',
    lifecycle_checklist_updating: 'Updating checklist item...',
    lifecycle_custom_checklist_empty: 'No reusable checklist items have been added for this process yet.',
    lifecycle_offboarding_checklist_note: 'Standard exit items and the company reusable offboarding checklist steps are included together in the progress percentage.',
    lifecycle_onboarding_checklist_note: 'Standard onboarding items and the company reusable onboarding checklist steps are included together in the progress percentage.',
    lifecycle_sort_order: 'Order',
    lifecycle_target_role_any: 'General / Unassigned',
    lifecycle_target_role_short: 'Responsible Role',
    lifecycle_template_create_error: 'Checklist item could not be added.',
    lifecycle_template_created: 'Checklist template item added.',
    lifecycle_template_creating: 'Adding checklist item...',
    lifecycle_template_delete_error: 'Checklist item could not be deleted.',
    lifecycle_template_deleted: 'Checklist template item deleted.',
    lifecycle_template_deleting: 'Deleting checklist item...',
    lifecycle_template_empty: 'No checklist items have been added for this process yet.',
    lifecycle_template_modal_offboarding: 'Offboarding Checklist Template',
    lifecycle_template_modal_onboarding: 'Onboarding Checklist Template',
    lifecycle_template_no_detail: 'No description entered.',
    lifecycle_template_required_note: 'Include this item in progress calculation',
    lbl_contact_cadro: 'CADRO SUPPORT',
    title_support_center: 'Support Messages',
    msg_contact_cadro_desc: 'Open a record for technical issues, billing, or product feedback. Track status updates here.',
    btn_new_support_request: 'New Request',
    btn_my_support_requests: 'My Messages',
    btn_support_broadcasts: 'Announcements',
    lbl_support_category: 'Category',
    lbl_support_subject: 'Subject',
    lbl_support_message: 'Message',
    lbl_support_attachments: 'Add File / Image',
    btn_support_choose_files: 'Choose Files',
    btn_send_support: 'Send Support Request',
    msg_support_failed: 'Support request could not be sent.',
    msg_support_sent: 'Your support request has been sent.',
    msg_support_subject_message_required: 'Please fill in the subject and message fields.',
    msg_support_broadcasts_failed: 'Announcements could not be loaded.',
    msg_support_broadcast_read_failed: 'Announcement could not be marked as read.',
    msg_support_broadcast_sent: 'Announcement published.',
    msg_support_broadcast_failed: 'Announcement could not be published.',
    msg_support_messages_loading: 'Loading messages...',
    msg_support_inbox_empty: 'No incoming messages yet.',
    support_status_pending: 'Pending',
    support_status_in_progress: 'In Progress',
    support_status_resolved: 'Resolved',
    lbl_owner_update: 'CADRO Team Update',
    lbl_owner_approval_required: 'CADRO Team Approval Required',
    lbl_subscription_cancellation: 'Subscription Cancellation Request',
    title_subscription_cancellation_owner_review: 'Cancellation requests first go to the CADRO team',
    msg_subscription_cancellation_owner_review: 'This option is only available to superadmins. The request first reaches the CADRO team; after review and discussion it is processed in Paddle.',
    btn_request_subscription_cancellation: 'Cancel My Subscription',
    msg_support_cancellation_message_required: 'Please add a short explanation for the cancellation request.',
    msg_support_cancellation_sent: 'Your cancellation request has been sent to the CADRO team for approval.',
    msg_support_cancellation_failed: 'Subscription cancellation request could not be sent.',
    msg_support_cancellation_sending: 'Sending...',
    msg_support_cancellation_owner_queue: 'Cancellation request waiting for CADRO team approval before Paddle action',
    ph_support_owner_note: 'Short status note visible to the customer',
    ph_support_cancellation_owner_note: 'Call note, retention note, or decision note before Paddle action',
    msg_support_status_saved: 'Support status saved.',
    msg_support_status_save_failed: 'Support record could not be updated.',
    btn_save_status: 'Save Status',
    msg_executive_fetch_failed: 'Executive console data could not be loaded.',
    lbl_hero_desc: 'The next-generation HR, Finance, and Operations management platform designed for modern companies.',
    step_identity: 'IDENTITY',
    step_contact_family: 'FAMILY & CONTACT',
    step_corporate: 'CORPORATE',
    step_finance_legal: 'FINANCE & LEGAL',
    lbl_system_metrics: 'System Metrics',
    btn_sick_report: 'SICK REPORT ENTRY',
    lbl_report_worked_days: 'WORKED DAYS',
    lbl_report_approved_leaves: 'APPROVED LEAVE',
    lbl_report_sick_days: 'SICK DAYS',
    lbl_report_paid_sick_days: 'FULLY PAID SICK REPORT',
    lbl_report_deducted_sick_days: 'DEDUCTED SICK REPORT',
    lbl_report_late_count: 'LATE',
    lbl_report_early_count: 'EARLY',
    lbl_report_overtime_hours: 'OVERTIME',
    lbl_badge_cv_reviewed: 'CV REVIEWED',
    lbl_badge_phone_screen: 'PHONE SCREEN COMPLETED',
    lbl_badge_interview_completed: 'INTERVIEW COMPLETED',
    lbl_badge_reference_checked: 'REFERENCES CHECKED',
    lbl_badge_test_completed: 'TEST COMPLETED',
    lbl_badge_technical_approved: 'TECHNICAL APPROVAL RECEIVED',
    lbl_badge_manager_approved: 'MANAGER APPROVED',
    lbl_badge_offer_shared: 'OFFER SHARED',
    lbl_badge_documents_received: 'DOCUMENTS RECEIVED',
    lbl_badge_employee_record_created: 'EMPLOYEE RECORD CREATED',
    lifecycle_item_account_closed: 'User account closed',
    lifecycle_item_account_closed_detail: 'Account access is blocked, and MFA and mobile sessions are disabled.',
    lifecycle_item_exit_date: 'Exit date defined',
    lifecycle_item_exit_date_missing: 'No exit date has been entered yet.',
    lifecycle_item_termination_document: 'Exit document created',
    lifecycle_item_assets_returned: 'Assets closed out',
    lifecycle_item_finance_clearance: 'No open leave or expense remains',
    lifecycle_item_tickets_closed: 'Open support tickets closed',
    lifecycle_item_org_assignment: 'Department and role assignment completed',
    lifecycle_item_account_ready: 'User account ready',
    lifecycle_item_account_ready_missing: 'No email address defined',
    lifecycle_item_password_change: 'First-login password change pending',
    lifecycle_item_password_change_active: 'Temporary password is active',
    lifecycle_item_password_change_done: 'Password has been made permanent',
    lifecycle_item_contract_document: 'Employment contract created',
    lifecycle_item_dossier_ready: 'Employee dossier documents collected',
    lifecycle_item_device_login: 'First device session detected',
    lifecycle_detail_documents_count: '{{count}} document',
    lifecycle_detail_active_assets_count: '{{count}} active asset',
    lifecycle_detail_open_tickets_count: '{{count}} open ticket',
    lifecycle_detail_pending_finance_count: '{{leaveCount}} leaves, {{expenseCount}} expenses pending',
    lifecycle_detail_dossier_count: '{{totalCount}} documents, {{pendingCount}} pending',
    lifecycle_detail_device_count: '{{count}} device records',
    menu_support_center: 'SUPPORT MESSAGES',
    lbl_document_action_history: 'DOCUMENT ACTION HISTORY',
    field_system_name: 'System / Application',
    field_access_level: 'Access Level',
    field_document_name: 'Requested Document',
    field_payload_document_name: 'Document / Subject',
    field_delivery_method: 'Delivery Method',
    field_payload_delivery_method: 'Delivery / Processing Method',
    field_health_correction_topic: 'Correction Topic',
    field_health_correction_expectation: 'Expected Action',
    field_payroll_period: 'Payroll Period',
    field_payroll_topic: 'Payroll Topic',
    field_equipment_name: 'Requested Equipment',
    field_payload_equipment_name: 'Equipment',
    field_equipment_quantity: 'Quantity',
    field_admin_topic: 'Administrative Topic',
    field_other_reference: 'Reference / Short Label',
    field_payload_reference: 'Reference',
    ph_system_name: 'Example: ERP, CRM, email',
    ph_access_level: 'Example: view, edit',
    ph_document_name: 'Example: employment certificate, salary letter',
    ph_delivery_method: 'Email, signed PDF, printed copy',
    ph_health_correction_topic: 'Example: sick report attendance record',
    ph_health_correction_expectation: 'Example: HR review and payroll control',
    ph_payroll_period: 'Example: 2026-03',
    ph_payroll_topic: 'Example: overtime, deduction, bonus',
    ph_equipment_name: 'Example: laptop, headset, card reader',
    ph_equipment_quantity: 'Example: 1',
    ph_admin_topic: 'Example: office, logistics, vehicle, supply',
    ph_other_reference: 'Internal reference or short tag',
    settings_tab_responsibles: 'Company Responsibilities',
    settings_tab_responsibles_hint: 'System workflow settings',
    settings_tab_company: 'Company Information',
    settings_tab_company_hint: 'Address, phone, logo',
    settings_tab_personal: 'Personal Settings',
    settings_tab_personal_hint: 'Password and security',
    settings_responsible_it: 'Helpdesk (IT)',
    settings_responsible_it_desc: 'Technical support, device incidents, and IT operations requests are assigned to this owner by default.',
    settings_responsible_hr: 'HR Owner',
    settings_responsible_hr_desc: 'Used as the primary operations owner for personnel files, documents, and employee lifecycle processes.',
    settings_responsible_admin: 'Administrative / Supplies',
    settings_responsible_admin_desc: 'Acts as the default workflow owner for administrative requests, purchase pre-requests, and office needs.',
    settings_responsible_payroll: 'Payroll Owner',
    settings_responsible_payroll_desc: 'Assigned as the first reviewer for payroll, compensation, deductions, and periodic salary questions.',
    settings_responsible_onboarding: 'Onboarding Owner',
    settings_responsible_onboarding_desc: 'Becomes the default owner for new employee account creation, initial document tracking, and onboarding steps.',
    settings_responsible_offboarding: 'Offboarding Owner',
    settings_responsible_offboarding_desc: 'Becomes the default owner for exit date, account closure, returns, and offboarding documents.',
    msg_saving_company_responsibles: 'Saving company responsibilities...',
    msg_company_responsibles_saved: 'Company responsibilities saved.',
    err_company_responsibles_save: 'Company responsibilities could not be saved.',
    msg_updating_password: 'Updating your password...',
    err_password_update: 'Password could not be updated.',
    msg_updating_logo: 'Uploading logo...',
    msg_logo_updated: 'Logo updated successfully.',
    err_logo_upload: 'Logo could not be uploaded.',
    msg_loading_settings: 'Loading settings...',
    msg_updating_company_info: 'Updating company information...',
    msg_company_info_updated: 'Company information updated.',
    err_company_info_update: 'Company information could not be updated.',
    lbl_general_note: 'General Note',
    lbl_dossier_rules_engine: 'E-Dossier Rules Engine',
    lbl_required_document_sets: 'Required document sets',
    lbl_expiry_alert_roles: 'Expiry alert roles',
    btn_save_routing_responsibles: 'Save Workflow Owners',
    settings_field_visible_company_name: 'Displayed Company Name',
    settings_field_legal_name: 'Legal / Trade Name',
    ph_legal_name: 'Name to use on contracts and official documents',
    settings_field_tax_no: 'Tax Number',
    settings_field_workplace_no: 'Social Security / Workplace Registration No',
    settings_field_active_plan: 'Active Plan',
    settings_field_address: 'Address',
    settings_field_phone: 'Phone',
    settings_field_email: 'Email',
    settings_field_website: 'Website',
    btn_update_company_info: 'Update Company Information',
    lbl_document_header: 'Document Header',
    lbl_brand_identity: 'Brand Identity',
    msg_no_logo_yet: 'No logo yet',
    msg_pdf_header_ready: 'PDF letterhead ready',
    msg_logo_pending: 'Logo pending',
    btn_upload_logo: 'Upload Logo',
    lbl_personal_settings: 'Personal Settings',
    lbl_account_security: 'Account Security',
    lbl_password_update: 'Update Password',
    lbl_personal_security_settings: 'Personal security settings',
    lbl_current_password: 'Current Password',
    lbl_confirm_new_password: 'Confirm New Password',
    btn_update_password: 'Update Password',
    lbl_kudos_sentence: '{{from}} thanked {{to}}.',
    err_settings_load: 'Settings or employee list could not be loaded.',
    msg_routing_saved: 'Routing settings saved successfully!',
    err_settings_save: 'A problem occurred while saving the settings.',
    page_system_settings_title_prefix: 'System &',
    page_system_settings_title_highlight: 'Workflow Settings',
    page_system_settings_desc: 'You can define here which owner should receive support, leave, and operations requests by default.',
    btn_save_settings: 'SAVE SETTINGS',
    msg_waiting_settings_api: 'Waiting for settings and staff from the API...',
    lbl_workflow_responsibles: 'Workflow Owners',
    opt_select_employee: 'Select Employee',
    btn_forgot: 'Forgot password',
    btn_verify: 'VERIFY AND SIGN IN',
    btn_setup_start: 'SET MY PASSWORD AND START',
    btn_reset_send: 'SEND CODE',
    btn_reset_save: 'SAVE NEW PASSWORD',
    btn_force_reset_save: 'SET NEW PASSWORD',
    lbl_login: 'Sign In',
    lbl_login_desc: 'Sign in to your CADRO account',
    lbl_reset_password: 'Forgot Password',
    lbl_reset_desc: 'We will send a reset code to your email address',
    lbl_mfa: 'Verification',
    lbl_mfa_desc: 'Enter the 6-digit code sent to your email',
    lbl_setup_title: 'Activate Your Account',
    lbl_setup_desc: 'Payment confirmed. Set your password using the code sent to your email.',
    lbl_force_reset_title: 'Renew Your Password',
    lbl_force_reset_desc: 'You must set a new password before your first sign-in.',
    lbl_membership_note: 'If you are not a member yet,',
    lbl_membership_note2: 'you can start a subscription from',
    msg_login_success: 'Signed in successfully.',
    msg_mfa_sent: 'Your security code has been sent to your email.',
    msg_reset_code_sent: 'The code has been sent to your email.',
    msg_password_changed: 'Password updated.',
    msg_force_password_changed: 'Your password has been updated. You can sign in with your new password.',
    msg_force_password_reset_sent: 'A password reset code has been sent to your email for first-login security.',
    msg_account_activated: 'Your account has been activated.',
    err_default: 'Something went wrong.',
    ph_mfa_code: '6-digit verification code',
    ph_setup_code: '6-digit code from your email',
    ph_reset_code: '6-digit reset code',
    ph_setup_password: 'Set your new password',
    btn_send_kudos_short: 'SEND KUDOS',
    lbl_kudos_counts: 'Kudos counts',
    err_leave_country_type_required: 'Please select the country / region and leave type first.',
    lbl_leave_country: 'COUNTRY / REGION',
    opt_select_country: 'Select Country / Region',
    opt_select_leave_type: 'Select a leave profile first',
    tab_payroll_report: 'PAYROLL REPORT',
    btn_save_sick_report: 'SAVE SICK REPORT',
    modal_title_sick_report: 'SICK REPORT ENTRY',
    msg_creating_sick_report: 'Saving sick report...',
    msg_sick_report_created: 'Sick report saved.',
    msg_sick_report_full_pay: 'Recorded as fully paid leave.',
    msg_sick_report_deduct: 'Recorded as deductible leave.',
    err_sick_report_create: 'Sick report could not be saved.',
    err_select_employee_for_sick_report: 'Please select an employee first.',
    err_fetch_attendance_report: 'Payroll report could not be loaded.',
    msg_no_attendance_report_rows: 'No payroll report rows were found for the selected period.',
    lbl_loading_attendance_report: 'Loading payroll report...',
    lbl_payroll_effect: 'Payroll effect',
    lbl_payroll_decision_note: 'Payroll decision note',
    lbl_report_no: 'Report No',
    lbl_report_people: 'Reported Employees',
    lbl_issue_date: 'Issue Date',
    lbl_issued_by: 'Issued By',
    badge_sick_deduct: 'DEDUCTIBLE REPORT',
    badge_sick_full_pay: 'FULL PAY REPORT',
    lbl_deduct_in_payroll: 'Deductible in payroll',
    lbl_full_pay_in_payroll: 'Fully paid in payroll',
    status_sick_report: 'Sick report',
    ph_search_attendance: 'Search employee or department',
    lbl_action_history: 'Action History',
    msg_no_action_history: 'No action history yet.',
    msg_loading_document_history: 'Loading document action history...',
    msg_no_document_history: 'No document action history yet.',
    lbl_created: 'Created',
    lbl_status_updated: 'Status updated',
    lbl_message_added: 'Message added',
    lbl_attachment_added: 'Attachment added',
    lbl_attachment_count: '{{count}} attachments',
    doc_deleted: 'Document deleted',
    dossier_history_uploaded: 'Document uploaded',
    dossier_history_status_updated: 'Document status updated',
    dossier_history_deleted: 'Document removed from archive',
    common_not_available: 'Not available',
    tooltip_view_archive: 'View archive',
    opt_support_technical: 'Technical Issue',
    opt_support_billing: 'Billing',
    opt_support_feature: 'Feature Request',
    opt_support_other: 'Other',
    ph_support_subject: 'Write a short subject',
    ph_support_message: 'Write your message',
    btn_mark_as_read: 'Mark as read',
    lbl_broadcast_read: 'Read',
    lbl_broadcast_unread: 'Unread',
    msg_loading_support_requests: 'Loading support requests...',
    msg_no_support_requests: 'No support requests found.',
    msg_loading_support_broadcasts: 'Loading announcements...',
    msg_no_support_broadcasts: 'No announcements found.',
    lbl_system_user: 'System',
    msg_support_failed: 'Support records could not be loaded.',
    msg_support_broadcasts_failed: 'Announcements could not be loaded.',
    msg_support_broadcast_read_failed: 'Announcement could not be marked as read.',
    msg_support_subject_message_required: 'Please fill in the subject and message fields.',
    msg_support_sent: 'Your support request has been sent.',
    msg_support_cancellation_message_required: 'Please write a short reason for the cancellation request.',
    msg_support_cancellation_sent: 'Your subscription cancellation request has been sent for CADRO team approval.',
    msg_support_cancellation_failed: 'Subscription cancellation request could not be sent.',
    msg_support_cancellation_sending: 'Sending...',
    support_status_pending: 'Pending',
    support_status_in_progress: 'In Progress',
    support_status_resolved: 'Resolved',
    title_support_center: 'Support Messages',
    msg_contact_cadro_desc: 'Open a record for technical issues, billing, or product feedback. You can track status updates here.',
    btn_new_support_request: 'New Request',
    btn_my_support_requests: 'My Messages',
    btn_support_broadcasts: 'Announcements',
    lbl_subscription_cancellation: 'Subscription Cancellation Request',
    title_subscription_cancellation_owner_review: 'The cancellation request goes to the CADRO team first',
    msg_subscription_cancellation_owner_review: 'This option is only available to superadmins. The request first goes to the CADRO team; after discussion and approval it is processed on the Paddle side.',
    btn_request_subscription_cancellation: 'Cancel My Subscription',
    lbl_support_category: 'Category',
    lbl_support_subject: 'Subject',
    lbl_support_message: 'Message',
    lbl_support_attachments: 'Add File / Photo',
    btn_support_choose_files: 'Choose File',
    btn_send_support: 'Send Support Request',
    lbl_owner_approval_required: 'CADRO Team Approval Required',
    lbl_owner_update: 'CADRO Team Update',
    lbl_kpi_group_workforce: 'Workforce',
    lbl_kpi_group_absence: 'Absence & Leave',
    lbl_kpi_group_operations: 'Operations',
    lbl_kpi_group_compliance: 'Compliance',
    lbl_system_active_employees: 'Active Employees',
    lbl_system_turnover_rate: 'Turnover Rate',
    lbl_system_leave_today: 'On Leave Today',
    lbl_system_absent_today: 'Absent Today',
    lbl_system_absence_rate_today: 'Absence Rate Today',
    lbl_system_leave_coverage_rate_today: 'Leave Coverage Rate Today',
    lbl_system_leave_usage_rate: 'Leave Usage Rate',
    lbl_system_open_queue: 'Open Work Queue',
    lbl_system_pending_policy_ack: 'Pending Policy Acknowledgements',
    lbl_system_expiring_documents: 'Documents Expiring in 30 Days',
    msg_no_kpi_categories: 'No category data found for the selected filters.',
    btn_clear: 'Clear',
    msg_saving: 'Saving...',
    msg_sending: 'Sending...',
    msg_leave_cancel_not_available: 'Leave cancellation is not currently available in the employee portal. Please contact your manager or HR for cancellation.',
    opt_full_pay_sick: 'PAY FULL SALARY',
    opt_deduct_sick: 'INCLUDE IN DEDUCTION',
    file_attendance: 'Attendance',
    col_name: 'FULL NAME',
    desc_bulk_action: 'Use this to manage the selected records in bulk.',
    action_approve: 'approve',
    action_reject: 'reject',
    opt_all_schedule_types: 'ALL SCHEDULE TYPES',
    opt_all_schedules: 'ALL SCHEDULES',
    opt_all_statuses: 'ALL STATUSES',
    ph_select_employee: 'Select employee',
    err_schedule_report_pdf: 'Work schedule PDF report could not be generated.',
    msg_schedule_report_pdf: 'Preparing work schedule PDF report...',
    msg_schedule_report_pdf_ready: 'Work schedule report is ready.',
    err_schedule_members_report_pdf: 'Schedule member report could not be generated.',
    msg_schedule_members_report_pdf: 'Preparing member report for "{{name}}"...',
    msg_schedule_members_report_pdf_ready: 'Schedule member report is ready.',
    doc_id: 'ID / PASSPORT COPY',
    doc_pre_permit: 'PRE-PERMIT DOCUMENTS (TRNC)',
    doc_work_permit: 'WORK PERMIT & MEDICAL REPORT',
    doc_residency: 'RESIDENCY / ADDRESS VERIFICATION',
    doc_visa: 'VISA / RESIDENCE PERMIT',
    doc_contract: 'EMPLOYMENT CONTRACT',
    doc_nda: 'CONFIDENTIALITY / NDA',
    doc_handbook_ack: 'HANDBOOK ACKNOWLEDGEMENT',
    doc_background_check: 'BACKGROUND CHECK',
    doc_ohs_training: 'OHS TRAINING / MEDICAL FITNESS',
    doc_bank_info: 'BANK / IBAN DETAILS',
    doc_tax_doc: 'TAX / TIN DOCUMENT',
    doc_payroll: 'PAYROLL SLIP',
    doc_social_security_record: 'SOCIAL SECURITY RECORD',
    doc_performance_review: 'PERFORMANCE REVIEW',
    doc_training_record: 'TRAINING RECORD',
    doc_leave_record: 'LEAVE / ABSENCE RECORD',
    doc_disciplinary: 'DISCIPLINARY RECORD',
    doc_termination: 'TERMINATION / RELEASE DOCUMENTS',
    doc_exit_interview: 'EXIT INTERVIEW',
    doc_onboarding_checklist: 'ONBOARDING CHECKLIST',
    doc_offboarding_checklist: 'OFFBOARDING CHECKLIST',
    doc_certificate: 'CERTIFICATE & PROFESSIONAL TRAINING',
    doc_other: 'OTHER DOCUMENTS',
    tab_uploaded_documents: 'UPLOADED DOCUMENTS',
    tab_upload_document: 'UPLOAD DOCUMENT',
    tab_compliance: 'COMPLIANCE SUMMARY',
    action_approved: 'Approved',
    action_rejected: 'Rejected',
    badge_approved_doc: 'APPROVED DOCUMENT',
    btn_approve: 'APPROVE',
    btn_reject: 'REJECT',
    btn_select_employee_archive: 'SELECT EMPLOYEE',
    btn_change_employee_archive: 'CHANGE EMPLOYEE',
    btn_choose_from_pc: 'CHOOSE FILE FROM COMPUTER',
    btn_upload_to_archive: 'UPLOAD TO ARCHIVE',
    btn_uploading: 'UPLOADING...',
    err_delete_failed: 'Document could not be deleted.',
    err_delete_pending_only: 'Employees can only delete pending documents.',
    err_document_status_update: 'Document status could not be updated.',
    err_fetch_docs: 'Documents could not be loaded.',
    err_fetch_emps: 'Employee list could not be loaded.',
    err_fetch_files: 'Files could not be loaded.',
    err_file_size: 'File size limit exceeded.',
    err_upload_failed: 'Document could not be uploaded.',
    lbl_archive_selection: 'ARCHIVE SELECTION',
    lbl_completion_score: 'COMPLETION SCORE',
    lbl_country_role_rule_set: 'COUNTRY / ROLE RULE SET',
    lbl_doc_category: 'DOCUMENT CATEGORY',
    lbl_doc_issue_date: 'ISSUE DATE',
    lbl_doc_issued_by: 'ISSUED BY',
    lbl_doc_mandatory: 'REQUIRED DOCUMENT',
    lbl_doc_number: 'DOCUMENT NO',
    lbl_doc_number_short: 'NO',
    lbl_doc_valid_until: 'VALID UNTIL',
    lbl_document_detail: 'DOCUMENT DETAIL',
    lbl_dossier_compliance: 'DOCUMENT COMPLIANCE SUMMARY',
    lbl_expired_docs: 'EXPIRED',
    lbl_expired_required_docs: 'EXPIRED REQUIRED DOCUMENTS',
    lbl_expiring_required_docs: 'REQUIRED DOCUMENTS EXPIRING SOON',
    lbl_expiring_soon: 'EXPIRING SOON',
    lbl_items: 'items',
    lbl_max_file_size: 'Maximum File Size: 10MB',
    lbl_missing_required: 'MISSING REQUIRED',
    lbl_my_dossier: 'MY PERSONAL E-DOSSIER',
    lbl_select_file_format: 'SELECT FILE (PDF / IMAGE)',
    lbl_upload_new_doc: 'UPLOAD NEW DOCUMENT TO SYSTEM',
    msg_all_required_docs_ready: 'REQUIRED DOCUMENTS COMPLETE',
    msg_confirm_delete_doc: 'This document will be permanently deleted. Are you sure?',
    msg_delete_success: 'Document removed from archive successfully.',
    msg_document_status_updated: 'Document status updated to {{status}}.',
    msg_dossier_compliant: 'All required documents currently appear complete in this dossier.',
    msg_missing_required_docs: 'MISSING REQUIRED DOCUMENTS',
    msg_no_docs_found: 'No documents found in this employee file yet.',
    msg_no_employee_selected: 'No employee selected yet',
    msg_no_expired_required_docs: 'No expired required documents are visible.',
    msg_no_expiring_required_docs: 'No required documents are expiring soon.',
    msg_searching_docs: 'Searching documents...',
    msg_select_doc_for_detail: 'SELECT A DOCUMENT TO SEE THE DETAIL',
    msg_select_emp_focus_html: 'SELECT AN EMPLOYEE FIRST<br/>TO VIEW THE E-DOSSIER.',
    msg_upload_pending: 'Document is awaiting approval.',
    msg_upload_success: 'Document added to archive successfully.',
    msg_uploading_doc: 'Uploading document...',
    ph_search_emp: 'Search by name or department...',
    tooltip_delete_archive: 'Delete from Archive',
    tooltip_view_doc: 'View Document',
    badge_pending_approval: 'PENDING APPROVAL',
    badge_rejected_doc: 'REJECTED',
    badge_expiring_soon: 'EXPIRING SOON',
    badge_expired: 'EXPIRED',
    lbl_employee: 'EMPLOYEE',
    lbl_first_name: 'FIRST NAME',
    lbl_last_name: 'LAST NAME',
    lbl_pending_documents: 'PENDING DOCUMENTS',
    lbl_support_broadcasts: 'SUPPORT MESSAGES',
    msg_document_waiting: 'documents are awaiting your approval.',
    msg_support_broadcast_waiting: 'unread announcement(s) are waiting for you.',
    role_owner: 'PLATFORM OWNER',
    btn_contact_cadro: 'CADRO SUPPORT',
    menu_executive_console: 'EXECUTIVE CONSOLE',
    menu_executive_companies: 'COMPANIES',
    menu_executive_revenue: 'REVENUE & PLANS',
    menu_executive_risks: 'RISKS & ALERTS',
    menu_executive_messages: 'MESSAGES',
    menu_account_security: 'ACCOUNT SECURITY',
    dossier_profile_global_title: 'Global',
    dossier_profile_global_desc: 'Core required document set for the default company profile.',
    dossier_profile_tr_title: 'TR',
    dossier_profile_tr_desc: 'Required document set for the Türkiye profile.',
    dossier_profile_kktc_title: 'TRNC',
    dossier_profile_kktc_desc: 'Required document set for the TRNC profile.',
    dossier_profile_eu_title: 'EU',
    dossier_profile_eu_desc: 'Required document set for the Europe profile.',
    dossier_profile_mena_title: 'MENA',
    dossier_profile_mena_desc: 'Required document set for the MENA profile.',
    dossier_profile_leadership_title: 'Leadership',
    dossier_profile_leadership_desc: 'Additional required document set for managers, HR, admins, and superadmins.',
    lbl_security_tip: 'Tip',
    desc_security_tip: 'Use a strong password for the admin account and rotate it regularly. Your mobile MFA flow is already active.',

    // 🕐 NEW ATTENDANCE MODULE — RBAC-focused translations
    attendance_kpi_present: 'Days Present',
    attendance_kpi_late: 'Late Arrivals',
    attendance_kpi_hours: 'Total Hours',
    attendance_kpi_sick: 'Sick Reports',
    attendance_kpi_checked_in: 'Checked In Today',
    attendance_kpi_late_count: 'Late',
    attendance_kpi_absent: 'Absent',
    attendance_kpi_pending: 'Pending Approval',
    attendance_kpi_total_hours: 'Total Hours',
    attendance_view_weekly: 'Weekly',
    attendance_view_monthly: 'Monthly',
    attendance_legend_present: 'Present',
    attendance_legend_late: 'Late',
    attendance_legend_absent: 'Absent',
    attendance_legend_sick: 'Sick',
    attendance_legend_holiday: 'Holiday',
    attendance_filter_date: 'Date',
    attendance_filter_from: 'From',
    attendance_filter_to: 'To',
    attendance_filter_personnel: 'Personnel',
    attendance_filter_search: 'Search Name',
    attendance_filter_search_placeholder: 'First or last name...',
    attendance_filter_department: 'Department',
    attendance_filter_all_departments: 'All Departments',
    attendance_filter_status: 'Status',
    attendance_filter_all_status: 'All Statuses',
    attendance_filter_approval: 'Approval',
    attendance_filter_all_approval: 'All Approvals',
    attendance_export: 'Export',
    attendance_export_success: 'Export completed.',
    attendance_no_records: 'No attendance records found.',
    attendance_selected: 'records selected',
    attendance_bulk_approve: 'Bulk Approve',
    attendance_bulk_reject: 'Bulk Reject',
    attendance_bulk_approved: 'Selected records approved.',
    attendance_col_employee: 'Employee',
    attendance_col_date: 'Date',
    attendance_col_in: 'In',
    attendance_col_out: 'Out',
    attendance_col_duration: 'Duration',
    attendance_col_status: 'Status',
    attendance_col_approval: 'Approval',
    attendance_col_actions: 'Actions',
    schedule_kicker: 'Schedule Management',
    schedule_title: 'Work Schedule Templates',
    schedule_add: 'New Template',
    schedule_empty: 'No schedule templates yet.',
    schedule_name: 'Schedule Name',
    schedule_type: 'Type',
    schedule_break: 'Break (min)',
    schedule_start: 'Start',
    schedule_end: 'End',
    schedule_grace_in: 'Grace In (min)',
    schedule_overtime: 'Overtime After (min)',
    schedule_active: 'Active',
    schedule_updated: 'Schedule updated.',
    schedule_created: 'Schedule created.',
    schedule_deleted: 'Schedule deleted.',
    schedule_delete_confirm: 'Are you sure you want to delete this schedule?',
    schedule_edit: 'Edit Schedule',
    schedule_new: 'New Schedule',
    dept_assign_kicker: 'Department Assignments',
    dept_assign_title: 'Department-Based Schedule',
    dept_assign_desc: 'Select the default schedule for each department.',
    dept_assign_employees: 'employees',
    dept_assign_none: 'Unassigned',
    dept_assign_empty: 'No departments found.',
    override_kicker: 'Employee Override',
    override_title: 'Employee-Based Schedule Override',
    override_desc: 'Assign a different schedule to specific employees.',
    override_search: 'Search employee...',
    override_all_departments: 'All Departments',
    override_empty: 'No employees found.',
    override_badge: 'OVERRIDE',
    override_selected: 'employees selected',
    override_select_schedule: 'Select schedule...',
    override_reason: 'Reason (optional)',
    override_assign_btn: 'Assign',
    override_clear_btn: 'Clear Overrides',
    override_assigned: 'Employee overrides assigned.',
    override_cleared: 'Overrides cleared.',
    override_select_both: 'Select both employee and schedule.',
    override_clear_confirm: 'Are you sure you want to clear the selected overrides?',
    payroll_kicker: 'Payroll Summary',
    payroll_title: 'Payroll Attendance Summary',
    payroll_generate: 'Generate',
    payroll_click_generate: 'Click "Generate" to view the payroll summary.',
    payroll_col_employee: 'Employee',
    payroll_col_normal: 'Normal',
    payroll_col_overtime: 'Overtime',
    payroll_col_absent: 'Absent',
    payroll_col_total: 'Total',
    payroll_total: 'GRAND TOTAL',
  },
  de: {
    sidebar_group_workspace: 'Arbeitsbereich',
    sidebar_group_people: 'People Operations',
    sidebar_group_operations: 'Betrieb',
    sidebar_group_compliance: 'Entwicklung & Compliance',
    sidebar_group_requests: 'Finanzen & Anfragen',
    sidebar_group_team: 'Team & Organisation',
    sidebar_group_workday: 'Arbeitstag',
    sidebar_group_growth: 'Entwicklung',
    menu_knowledge_base: 'WISSENSBASIS & RICHTLINIEN',
    menu_purchase_requests: 'BESCHAFFUNGSANTRÄGE',
    menu_request_forms: 'UNTERNEHMENSFORMULARE',
    menu_kpi_statistics: 'KPI & STATISTIKEN',
    menu_surveys: 'UMFRAGEN & EMPFEHLUNGSWERT',
    sidebar_group_experience: 'Mitarbeitererlebnis',
    engagement_module: 'Mitarbeitererlebnis',
    survey_title: 'Umfragen und Mitarbeiter-Empfehlungswert',
    survey_phase1_info: 'Hier können Sie Umfragevorlagen erstellen, Kampagnen veröffentlichen und Mitarbeiterfeedback verfolgen.',
    survey_my_inbox: 'Mein Umfrage-Postfach',
    survey_no_pending: 'Keine ausstehenden Umfragen.',
    survey_anonymous: 'Anonym',
    survey_named: 'Namentlich',
    survey_answer: 'Antworten',
    survey_completed: 'Abgeschlossen',
    survey_admin_center: 'Verwaltung',
    survey_templates: 'Vorlagen',
    survey_template_name: 'Vorlagenname',
    survey_question_code: 'Code',
    survey_question_text: 'Frage',
    survey_required: 'Pflichtfeld',
    survey_delete: 'Löschen',
    survey_choices_comma: 'Optionen (durch Komma getrennt)',
    survey_add_question: 'Frage hinzufügen',
    survey_existing_templates: 'Vorhandene Vorlagen',
    survey_update_template: 'Vorlage aktualisieren',
    survey_create_template: 'Vorlage erstellen',
    survey_campaigns: 'Kampagnen',
    survey_choose_template: 'Vorlage auswählen',
    survey_campaign_name: 'Kampagnenname',
    survey_department_filter: 'Ziel-Abteilungsnummern (kommagetrennt)',
    survey_role_filter: 'Ziel-Rollencodes (kommagetrennt)',
    survey_start_at: 'Startdatum',
    survey_end_at: 'Enddatum',
    survey_is_anonymous: 'Anonyme Umfrage',
    survey_update_campaign: 'Kampagne aktualisieren',
    survey_create_campaign: 'Kampagne erstellen',
    survey_campaign_list: 'Kampagnenliste',
    survey_edit_campaign: 'Bearbeiten',
    survey_launch: 'Starten',
    survey_close: 'Schließen',
    survey_view_analytics: 'Analyse',
    survey_participation: 'Teilnahme',
    survey_recommendation_score: 'Mitarbeiter-Empfehlungswert',
    survey_scale_avg: 'Durchschnittswert',
    survey_department_breakdown: 'Abteilungsaufschlüsselung',
    survey_role_breakdown: 'Rollenaufschlüsselung',
    survey_role_admin: 'Admin',
    survey_role_employee: 'Mitarbeiter',
    survey_role_hr: 'Personalwesen',
    survey_role_manager: 'Manager',
    survey_role_superadmin: 'Systemadministrator',
    survey_select_option: 'Option auswählen',
    survey_submit: 'Senden',
    survey_edit: 'Bearbeiten',
    survey_status_draft: 'Entwurf',
    survey_status_live: 'Live',
    survey_status_closed: 'Geschlossen',
    survey_status_active: 'Aktiv',
    survey_category_pulse: 'Puls-Umfrage',
    survey_category_enps: 'Mitarbeiter-Empfehlungswert',
    survey_category_exit: 'Exit-Umfrage',
    survey_category_onboarding: 'Onboarding-Umfrage',
    survey_category_custom: 'Benutzerdefinierte Umfrage',
    survey_qtype_nps_0_10: '0-10 Empfehlungswert',
    survey_qtype_scale_1_5: '1-5 Bewertungsskala',
    survey_qtype_single_choice: 'Einzelauswahl',
    survey_qtype_multi_choice: 'Mehrfachauswahl',
    survey_qtype_text_short: 'Kurzer Text',
    survey_qtype_text_long: 'Langer Text',
    survey_default_question_recommendation: 'Wie wahrscheinlich ist es, dass Sie unser Unternehmen als Arbeitsplatz weiterempfehlen?',
    survey_default_question_improvement: 'Was sollten wir verbessern?',
    survey_load_failed: 'Umfragedaten konnten nicht geladen werden.',
    survey_template_load_failed: 'Vorlagendetails konnten nicht geladen werden.',
    survey_question_required: 'Bitte geben Sie mindestens eine Frage ein.',
    survey_template_create_failed: 'Vorlage konnte nicht gespeichert werden.',
    survey_campaign_save_failed: 'Kampagne konnte nicht gespeichert werden.',
    survey_campaign_launch_failed: 'Kampagne konnte nicht gestartet werden.',
    survey_campaign_close_failed: 'Kampagne konnte nicht geschlossen werden.',
    survey_detail_load_failed: 'Umfragedetails konnten nicht geladen werden.',
    survey_submit_failed: 'Umfrage konnte nicht gesendet werden.',
    survey_analytics_failed: 'Analysedaten konnten nicht geladen werden.',
    nav_knowledge_base: 'WISSENSBASIS & RICHTLINIEN',
    nav_sub_knowledge_base: 'Zentrum für Richtlinien und SOPs',
    nav_request_forms: 'UNTERNEHMENSFORMULARE',
    nav_sub_request_forms: 'Strukturierte Anfragen und Workflow-Management',
    nav_kpi_statistics: 'KPI & STATISTIKEN',
    nav_sub_kpi_statistics: 'Metrikverfolgung nach Zeitraum',
    btn_add: 'HINZUFÜGEN',
    btn_refresh: 'AKTUALISIEREN',
    btn_new_purchase_request: 'Neuer Beschaffungsantrag',
    btn_submit_purchase_request: 'Antrag senden',
    btn_convert_to_expense: 'In Ausgabe umwandeln',
    btn_new_generic_request: 'Neue Unternehmensanfrage',
    btn_open_flow: 'Ablauf öffnen',
    btn_take_in_progress: 'In Bearbeitung nehmen',
    btn_complete: 'Abschließen',
    btn_send_message: 'Nachricht senden',
    btn_add_attachment: 'Datei anhängen',
    btn_submit_request: 'Anfrage senden',
    btn_new_kpi_metric: 'Neuer KPI-Eintrag',
    err_fetch_purchase_requests: 'Beschaffungsanträge konnten nicht geladen werden.',
    err_create_purchase_request: 'Beschaffungsantrag konnte nicht erstellt werden.',
    err_convert_purchase_expense: 'Ausgabenbuchung konnte nicht erstellt werden.',
    err_fetch_generic_requests: 'Unternehmensanfragen konnten nicht geladen werden.',
    err_fetch_generic_request_detail: 'Anfragedetail konnte nicht geladen werden.',
    err_create_generic_request: 'Anfrage konnte nicht erstellt werden.',
    err_fetch_kpi_metrics: 'KPI-Daten konnten nicht geladen werden.',
    err_create_kpi_metric: 'KPI-Eintrag konnte nicht erstellt werden.',
    err_delete_kpi_metric: 'KPI-Eintrag konnte nicht gelöscht werden.',
    generic_requests_open: 'Offene Anfragen',
    lbl_pending_requests: 'Offene Anträge',
    lbl_approved_requests: 'Genehmigte Anträge',
    lbl_rejected_requests: 'Abgelehnte Anträge',
    lbl_current_total: 'Gesamtsumme der Ansicht',
    lbl_finance_approver: 'Finanzfreigabe',
    lbl_item_name: 'Artikel / Leistung',
    lbl_vendor: 'Lieferant',
    lbl_product_link: 'Produkt- / Leistungslink',
    lbl_quantity: 'Menge',
    lbl_quantity_unit_price: 'Menge und Stückpreis',
    lbl_unit_price: 'Stückpreis',
    lbl_justification: 'Begründung',
    lbl_needed_by: 'Benötigt bis',
    lbl_converted_to_expense: 'In Ausgabe umgewandelt',
    lbl_request_routing_engine: 'Anfragen-Workflow-Engine',
    lbl_routing_logic: 'Workflow',
    lbl_request_type: 'Anfragetyp',
    lbl_requested_by: 'Angelegt von',
    lbl_requested_for: 'Angefordert für',
    lbl_assigned_to: 'Zugewiesen an',
    lbl_request_timeline: 'Anfrageverlauf',
    lbl_required: 'Erforderlich',
    lbl_route_explanation: 'Workflow-Zusammenfassung',
    lbl_no_resolution_note: 'Keine Lösungsnotiz eingetragen.',
    lbl_undefined: 'Nicht definiert',
    lbl_record: 'Eintrag',
    lbl_title: 'Titel',
    lbl_description: 'Beschreibung',
    lbl_system: 'System',
    lbl_statistics_engine: 'Statistik-Engine',
    lbl_kpi_pulse: 'KPI-Puls',
    lbl_open_statistics_screen: 'Statistik öffnen',
    lbl_selected_period_metrics: 'Einträge im Zeitraum',
    lbl_selected_period_total: 'Summe im Zeitraum',
    lbl_period_delta: 'Differenz zum Vorzeitraum',
    lbl_category_breakdown: 'Kategorienübersicht',
    lbl_kpi_records: 'KPI-Einträge',
    kpi_category_headcount: 'Personalstand',
    kpi_category_recruitment: 'Recruiting',
    kpi_category_payroll: 'Lohnabrechnung',
    kpi_category_absence: 'Abwesenheit',
    kpi_category_training: 'Schulung',
    kpi_category_performance: 'Leistung',
    kpi_category_finance: 'Finanzen',
    kpi_category_other: 'Sonstiges',
    lbl_metric_date: 'Messdatum',
    lbl_source_type: 'Datenquelle',
    lbl_target_value: 'Zielwert',
    lbl_actual_value: 'Ist-Wert',
    lbl_target_progress: 'Zielfortschritt',
    lbl_unit: 'Einheit',
    kpi_unit_count: 'Anzahl',
    kpi_unit_percent: '%',
    kpi_unit_currency: 'Währung',
    kpi_unit_day: 'Tag',
    kpi_unit_hour: 'Stunde',
    kpi_source_manual: 'Manuell',
    kpi_source_system: 'System',
    lbl_search: 'Suche',
    lbl_date_range: 'Zeitraum',
    lbl_status: 'Status',
    ph_search_purchase_requests: 'Artikel, Lieferant oder Mitarbeiter suchen',
    modal_purchase_request: 'Beschaffungsantrag',
    ph_search_generic_requests: 'Titel, Beschreibung oder Mitarbeiter suchen',
    ph_generic_request_title: 'Thema der Anfrage klar formulieren',
    ph_generic_request_description: 'Bedarf, Geschäftsauswirkung und erwartetes Ergebnis beschreiben',
    ph_request_reply: 'Antwort eingeben',
    ph_search_kpi_metrics: 'KPI-Titel suchen',
    ph_kpi_title: 'Z. B. monatliche Abwesenheitsquote',
    ph_kpi_note: 'Optionale Notiz',
    opt_all_personnel: 'Alle Mitarbeiter',
    opt_all_request_types: 'Alle Anfragetypen',
    opt_all_categories: 'Alle Kategorien',
    opt_myself: 'Ich selbst',
    btn_reset_filter: 'Leeren',
    btn_confirm_filter: 'Anwenden',
    priority_low: 'Niedrig',
    priority_normal: 'Normal',
    priority_high: 'Hoch',
    priority_urgent: 'Dringend',
    status_active: 'Aktiv',
    status_completed: 'Abgeschlossen',
    status_pending: 'Ausstehend',
    status_approved: 'Genehmigt',
    status_rejected: 'Abgelehnt',
    msg_creating_purchase_request: 'Beschaffungsantrag wird erstellt...',
    msg_purchase_request_created: 'Beschaffungsantrag an die Finanzfreigabe gesendet.',
    msg_confirm_purchase_approve: 'Möchten Sie diesen Beschaffungsantrag genehmigen?',
    prompt_purchase_reject_reason: 'Bitte Ablehnungsgrund eingeben:',
    prompt_purchase_reject_default: 'Aufgrund von Budget / Einkaufsrichtlinie nicht genehmigt.',
    msg_purchase_request_approved: 'Beschaffungsantrag genehmigt.',
    msg_purchase_request_rejected: 'Beschaffungsantrag abgelehnt.',
    msg_confirm_convert_purchase_expense: 'Möchten Sie diesen Antrag in eine Ausgabe umwandeln?',
    msg_converting_purchase_expense: 'Ausgabenbuchung wird erstellt...',
    msg_purchase_expense_converted: 'Antrag wurde in eine Ausgabe umgewandelt.',
    msg_no_purchase_requests: 'In dieser Ansicht gibt es keine Anträge.',
    msg_creating_generic_request: 'Unternehmensanfrage wird erstellt...',
    msg_generic_request_created: 'Anfrage wurde an die zuständige Person weitergeleitet.',
    prompt_generic_request_reject: 'Ablehnungsnotiz eingeben:',
    prompt_generic_request_reject_default: 'Die Anfrage entspricht nicht dem aktuellen Prozess oder der Richtlinie.',
    msg_confirm_generic_request_action: 'Möchten Sie diesen Status anwenden?',
    msg_generic_request_updated: 'Anfragestatus aktualisiert.',
    msg_no_generic_requests: 'In dieser Ansicht gibt es keine Anfragen.',
    msg_no_request_messages: 'Noch keine Nachrichten vorhanden.',
    msg_creating_kpi_metric: 'KPI-Eintrag wird erstellt...',
    msg_kpi_metric_created: 'KPI-Eintrag erstellt.',
    msg_confirm_delete_kpi: 'Möchten Sie diesen KPI-Eintrag löschen?',
    msg_kpi_metric_deleted: 'KPI-Eintrag gelöscht.',
    msg_no_kpi_metrics: 'Für die ausgewählten Filter wurden keine KPI-Einträge gefunden.',
    attendance_self_recent_tab: 'LETZTE EINTRÄGE',
    attendance_self_health_tab: 'MEINE KRANKMELDUNGEN',
    attendance_self_health_summary_title: 'MEINE KRANKMELDUNGSANSICHT',
    attendance_self_health_summary_desc: 'Hier werden nur die Mindestinformationen angezeigt, die für Zeiterfassung und Lohnwirkung erforderlich sind. Diagnose, medizinische Bewertung und interne Verarbeitungsnotizen werden nicht angezeigt.',
    attendance_self_health_summary_correction: 'Wenn Sie einen fehlerhaften oder fehlenden Eintrag sehen, können Sie über die Unternehmensanfragen eine HR-Korrekturanfrage stellen.',
    attendance_self_no_health_reports: 'KEINE KRANKMELDUNGEN REGISTRIERT.',
    attendance_self_report_period: 'MELDEZEITRAUM',
    attendance_self_report_no: 'MELDE-NR.',
    attendance_self_issue_date: 'AUSSTELLUNGSDATUM',
    attendance_self_payroll_visibility: 'LOHNWIRKUNG',
    attendance_self_full_pay: 'VOLL BEZAHLT',
    attendance_self_deduct_pay: 'LOHNABZUG AKTIV',
    attendance_self_included_in_payroll: 'IN DER ZEITERFASSUNG AKTIV',
    attendance_self_not_included_in_payroll: 'NICHT IN DER ZEITERFASSUNG',
    attendance_self_report_short: 'MELDUNG',
    attendance_self_health_entry: 'KRANKMELDUNGS-EINTRAG',
    attendance_self_report_reference: 'REFERENZ',
    btn_open_correction_request: 'KORREKTURANFRAGE ÖFFNEN',
    attendance_self_open_record_correction: 'KORREKTUR FÜR DIESEN EINTRAG ÖFFNEN',
    generic_request_prefill_health_title: 'Korrekturanfrage zur Krankmeldungs-Zeiterfassung',
    generic_request_prefill_health_intro: 'Ich beantrage eine Korrektur meines eigenen Krankmeldungs-Eintrags in der Zeiterfassung.',
    generic_request_prefill_health_closing: 'Bitte prüfen Sie die Richtigkeit des Eintrags und die Lohnwirkung.',
    generic_request_prefill_health_document: 'Zeiterfassung / Krankmeldungs-Eintrag',
    generic_request_prefill_health_delivery: 'HR-Prüfung und Korrektur',
    generic_request_quick_all: 'ALLE ANFRAGEN',
    generic_request_quick_health_corrections: 'KORREKTUREN VON GESUNDHEITSDATEN',
    notif_pending_purchase_requests: '{{count}} Beschaffungsanträge warten auf Bearbeitung.',
    notif_open_generic_requests: '{{count}} Unternehmensanfragen warten auf Bearbeitung.',
    notif_pending_policy_acknowledgements: '{{count}} Richtlinieninhalte warten auf Lesen oder Bestätigung.',
    lbl_purchase_requests: 'BESCHAFFUNGSANTRÄGE',
    msg_purchase_requests_waiting: 'Beschaffungsanträge warten auf Bearbeitung.',
    lbl_generic_requests: 'UNTERNEHMENSANFRAGEN',
    msg_generic_requests_waiting: 'Unternehmensanfragen warten auf Bearbeitung.',
    notif_health_record_corrections: '{{count}} Korrekturanfragen zu Gesundheitsdaten warten auf die HR-Prüfung.',
    lbl_health_record_corrections: 'GESUNDHEITSDATEN-KORREKTUR',
    msg_health_record_corrections_waiting: 'Es liegen Korrekturanfragen zur HR-Prüfung vor.',
    lbl_pending_policy_acknowledgements: 'RICHTLINIEN-BESTÄTIGUNGEN',
    msg_pending_policy_acknowledgements_waiting: 'Es gibt Richtlinieninhalte, die gelesen oder bestätigt werden müssen.',
    lbl_stat_sick_report_days: 'KRANKHEITSTAGE',
    lbl_days_short: 'Tage',
    lifecycle_manage_template: 'Vorlage verwalten',
    lifecycle_operation_checklist: 'Operative Checkliste',
    lifecycle_progress_summary: 'Fortschrittsübersicht',
    lifecycle_add_template_item: 'Neuer Vorlagenpunkt',
    lifecycle_auto_action: 'Automatische Aktion',
    lifecycle_auto_step: 'Automatisch',
    lifecycle_manual_step: 'Manueller Punkt',
    lifecycle_checklist_not_completed: 'Noch nicht abgeschlossen',
    lifecycle_checklist_template_label: 'Checklisten-Vorlage',
    lifecycle_checklist_update_error: 'Checklistenpunkt konnte nicht aktualisiert werden.',
    lifecycle_checklist_updated: 'Checklistenpunkt aktualisiert.',
    lifecycle_checklist_updating: 'Checklistenpunkt wird aktualisiert...',
    lifecycle_custom_checklist_empty: 'Für diesen Prozess wurden noch keine wiederverwendbaren Checklistenpunkte hinzugefügt.',
    lifecycle_offboarding_checklist_note: 'Standard-Austrittspunkte und die wiederverwendbaren Offboarding-Schritte des Unternehmens fließen gemeinsam in den Fortschritt ein.',
    lifecycle_onboarding_checklist_note: 'Standard-Onboarding-Punkte und die wiederverwendbaren Onboarding-Schritte des Unternehmens fließen gemeinsam in den Fortschritt ein.',
    lifecycle_sort_order: 'Reihenfolge',
    lifecycle_target_role_any: 'Allgemein / Nicht zugewiesen',
    lifecycle_target_role_short: 'Verantwortliche Rolle',
    lifecycle_template_create_error: 'Checklistenpunkt konnte nicht hinzugefügt werden.',
    lifecycle_template_created: 'Checklisten-Vorlagenpunkt hinzugefügt.',
    lifecycle_template_creating: 'Checklistenpunkt wird hinzugefügt...',
    lifecycle_template_delete_error: 'Checklistenpunkt konnte nicht gelöscht werden.',
    lifecycle_template_deleted: 'Checklisten-Vorlagenpunkt gelöscht.',
    lifecycle_template_deleting: 'Checklistenpunkt wird gelöscht...',
    lifecycle_template_empty: 'Für diesen Prozess wurden noch keine Checklistenpunkte hinzugefügt.',
    lifecycle_template_modal_offboarding: 'Offboarding-Checklisten-Vorlage',
    lifecycle_template_modal_onboarding: 'Onboarding-Checklisten-Vorlage',
    lifecycle_template_no_detail: 'Keine Beschreibung eingegeben.',
    lifecycle_template_required_note: 'Diesen Punkt in die Fortschrittsberechnung einbeziehen',
    lbl_contact_cadro: 'CADRO SUPPORT',
    title_support_center: 'Support-Nachrichten',
    msg_contact_cadro_desc: 'Erstellen Sie einen Eintrag für technische Themen, Abrechnung oder Produktfeedback. Statusänderungen verfolgen Sie hier.',
    btn_new_support_request: 'Neue Anfrage',
    btn_my_support_requests: 'Meine Nachrichten',
    btn_support_broadcasts: 'Ankündigungen',
    lbl_support_category: 'Kategorie',
    lbl_support_subject: 'Betreff',
    lbl_support_message: 'Nachricht',
    lbl_support_attachments: 'Datei / Bild hinzufügen',
    btn_support_choose_files: 'Dateien auswählen',
    btn_send_support: 'Support-Anfrage senden',
    msg_support_failed: 'Support-Anfrage konnte nicht gesendet werden.',
    msg_support_sent: 'Ihre Support-Anfrage wurde gesendet.',
    msg_support_subject_message_required: 'Bitte Betreff und Nachricht ausfüllen.',
    msg_support_broadcasts_failed: 'Ankündigungen konnten nicht geladen werden.',
    msg_support_broadcast_read_failed: 'Ankündigung konnte nicht als gelesen markiert werden.',
    msg_support_broadcast_sent: 'Ankündigung veröffentlicht.',
    msg_support_broadcast_failed: 'Ankündigung konnte nicht veröffentlicht werden.',
    msg_support_messages_loading: 'Nachrichten werden geladen...',
    msg_support_inbox_empty: 'Noch keine eingehenden Nachrichten.',
    support_status_pending: 'Ausstehend',
    support_status_in_progress: 'In Bearbeitung',
    support_status_resolved: 'Abgeschlossen',
    lbl_owner_update: 'Update vom CADRO-Team',
    lbl_owner_approval_required: 'Freigabe durch das CADRO-Team erforderlich',
    lbl_subscription_cancellation: 'Abonnement-Kündigungsanfrage',
    title_subscription_cancellation_owner_review: 'Kündigungsanfragen gehen zuerst an das CADRO-Team',
    msg_subscription_cancellation_owner_review: 'Diese Option ist nur für Superadmins verfügbar. Die Anfrage geht zuerst an das CADRO-Team; nach Prüfung und Gespräch wird sie in Paddle bearbeitet.',
    btn_request_subscription_cancellation: 'Mein Abo kündigen',
    msg_support_cancellation_message_required: 'Bitte eine kurze Begründung für die Kündigungsanfrage angeben.',
    msg_support_cancellation_sent: 'Ihre Kündigungsanfrage wurde zur Freigabe an das CADRO-Team gesendet.',
    msg_support_cancellation_failed: 'Die Kündigungsanfrage konnte nicht gesendet werden.',
    msg_support_cancellation_sending: 'Wird gesendet...',
    msg_support_cancellation_owner_queue: 'Kündigungsanfrage wartet vor der Paddle-Aktion auf Freigabe durch das CADRO-Team',
    ph_support_owner_note: 'Kurze Statusnotiz für den Kunden',
    ph_support_cancellation_owner_note: 'Gesprächsnotiz, Retention-Notiz oder Entscheidungsnotiz vor der Paddle-Aktion',
    msg_support_status_saved: 'Support-Status gespeichert.',
    msg_support_status_save_failed: 'Support-Eintrag konnte nicht aktualisiert werden.',
    btn_save_status: 'Status speichern',
    msg_executive_fetch_failed: 'Daten der Leitkonsole konnten nicht geladen werden.',
    lbl_hero_desc: 'Die neue HR-, Finanz- und Betriebsplattform für moderne Unternehmen.',
    step_identity: 'IDENTITÄT',
    step_contact_family: 'FAMILIE & KONTAKT',
    step_corporate: 'UNTERNEHMEN',
    step_finance_legal: 'FINANZEN & RECHT',
    lbl_system_metrics: 'Systemmetriken',
    btn_sick_report: 'KRANKMELDUNG ERFASSEN',
    lbl_report_worked_days: 'GEARBEITETE TAGE',
    lbl_report_approved_leaves: 'GENEHMIGTER URLAUB',
    lbl_report_sick_days: 'KRANKHEITSTAGE',
    lbl_report_paid_sick_days: 'VOLL BEZAHLTER KRANKENBERICHT',
    lbl_report_deducted_sick_days: 'ABGEZOGENER KRANKENBERICHT',
    lbl_report_late_count: 'VERSPÄTET',
    lbl_report_early_count: 'FRÜH',
    lbl_report_overtime_hours: 'ÜBERSTUNDEN',
    lbl_badge_cv_reviewed: 'CV GEPRÜFT',
    lbl_badge_phone_screen: 'TELEFONINTERVIEW ERLEDIGT',
    lbl_badge_interview_completed: 'INTERVIEW ABGESCHLOSSEN',
    lbl_badge_reference_checked: 'REFERENZEN GEPRÜFT',
    lbl_badge_test_completed: 'TEST ABGESCHLOSSEN',
    lbl_badge_technical_approved: 'TECHNISCHE FREIGABE ERTEILT',
    lbl_badge_manager_approved: 'FREIGABE DURCH LEITUNG',
    lbl_badge_offer_shared: 'ANGEBOT GETEILT',
    lbl_badge_documents_received: 'DOKUMENTE ERHALTEN',
    lbl_badge_employee_record_created: 'MITARBEITERDATENSATZ ERSTELLT',
    lifecycle_item_account_closed: 'Benutzerkonto geschlossen',
    lifecycle_item_account_closed_detail: 'Der Kontozugang wird beendet, MFA und mobile Sitzungen werden deaktiviert.',
    lifecycle_item_exit_date: 'Austrittsdatum definiert',
    lifecycle_item_exit_date_missing: 'Es wurde noch kein Austrittsdatum eingetragen.',
    lifecycle_item_termination_document: 'Austrittsdokument erstellt',
    lifecycle_item_assets_returned: 'Assets abgeschlossen',
    lifecycle_item_finance_clearance: 'Keine offenen Urlaube oder Ausgaben',
    lifecycle_item_tickets_closed: 'Offene Support-Tickets geschlossen',
    lifecycle_item_org_assignment: 'Abteilungs- und Rollen-Zuordnung abgeschlossen',
    lifecycle_item_account_ready: 'Benutzerkonto bereit',
    lifecycle_item_account_ready_missing: 'Keine E-Mail-Adresse hinterlegt',
    lifecycle_item_password_change: 'Passwortwechsel beim ersten Login ausstehend',
    lifecycle_item_password_change_active: 'Temporäres Passwort ist aktiv',
    lifecycle_item_password_change_done: 'Passwort wurde dauerhaft gesetzt',
    lifecycle_item_contract_document: 'Arbeitsvertrag erstellt',
    lifecycle_item_dossier_ready: 'Personalaktenunterlagen gesammelt',
    lifecycle_item_device_login: 'Erste Gerätesitzung erkannt',
    lifecycle_detail_documents_count: '{{count}} Dokument',
    lifecycle_detail_active_assets_count: '{{count}} aktive Assets',
    lifecycle_detail_open_tickets_count: '{{count}} offene Tickets',
    lifecycle_detail_pending_finance_count: '{{leaveCount}} Urlaube, {{expenseCount}} Ausgaben offen',
    lifecycle_detail_dossier_count: '{{totalCount}} Unterlagen, {{pendingCount}} ausstehend',
    lifecycle_detail_device_count: '{{count}} Geräteeinträge',
    menu_support_center: 'SUPPORT-NACHRICHTEN',
    lbl_document_action_history: 'DOKUMENTENAKTIONSVERLAUF',
    field_system_name: 'System / Anwendung',
    field_access_level: 'Zugriffsebene',
    field_document_name: 'Angefordertes Dokument',
    field_payload_document_name: 'Dokument / Betreff',
    field_delivery_method: 'Liefermethode',
    field_payload_delivery_method: 'Liefer- / Bearbeitungsmethode',
    field_health_correction_topic: 'Korrekturthema',
    field_health_correction_expectation: 'Erwartete Bearbeitung',
    field_payroll_period: 'Abrechnungszeitraum',
    field_payroll_topic: 'Abrechnungsthema',
    field_equipment_name: 'Angefordertes Equipment',
    field_payload_equipment_name: 'Equipment',
    field_equipment_quantity: 'Menge',
    field_admin_topic: 'Verwaltungsthema',
    field_other_reference: 'Referenz / Kurzlabel',
    field_payload_reference: 'Referenz',
    ph_system_name: 'Z. B. ERP, CRM, E-Mail',
    ph_access_level: 'Z. B. ansehen, bearbeiten',
    ph_document_name: 'Z. B. Arbeitsbescheinigung, Gehaltsnachweis',
    ph_delivery_method: 'E-Mail, signiertes PDF, Ausdruck',
    ph_health_correction_topic: 'Z. B. Zeiterfassung des Krankmeldungsdatensatzes',
    ph_health_correction_expectation: 'Z. B. HR-Prüfung und Lohnabrechnungskontrolle',
    ph_payroll_period: 'Z. B. 2026-03',
    ph_payroll_topic: 'Z. B. Überstunden, Abzug, Bonus',
    ph_equipment_name: 'Z. B. Laptop, Headset, Kartenleser',
    ph_equipment_quantity: 'Z. B. 1',
    ph_admin_topic: 'Z. B. Büro, Logistik, Fahrzeug, Beschaffung',
    ph_other_reference: 'Interne Referenz oder Kurzlabel',
    settings_tab_responsibles: 'Verantwortliche',
    settings_tab_responsibles_hint: 'Workflow-Einstellungen',
    settings_tab_company: 'Unternehmensdaten',
    settings_tab_company_hint: 'Adresse, Telefon, Logo',
    settings_tab_personal: 'Persönliche Einstellungen',
    settings_tab_personal_hint: 'Passwort und Sicherheit',
    settings_responsible_it: 'Helpdesk (IT)',
    settings_responsible_it_desc: 'Technischer Support, Geräteausfälle und IT-Betriebsanfragen landen standardmäßig in der Aufgabenliste dieser Person.',
    settings_responsible_hr: 'HR-Verantwortliche:r',
    settings_responsible_hr_desc: 'Wird als erste operative Ansprechperson für Personalakten, Dokumente und Employee-Lifecycle-Prozesse verwendet.',
    settings_responsible_admin: 'Verwaltung / Material',
    settings_responsible_admin_desc: 'Ist standardmäßig für Verwaltungsanfragen, Voranfragen im Einkauf und Bürobedarfe verantwortlich.',
    settings_responsible_payroll: 'Lohnabrechnungsverantwortliche:r',
    settings_responsible_payroll_desc: 'Wird als erste prüfende Instanz für Abrechnung, Vergütung, Abzüge und periodische Gehaltsfragen eingesetzt.',
    settings_responsible_onboarding: 'Onboarding-Verantwortliche:r',
    settings_responsible_onboarding_desc: 'Ist standardmäßig zuständig für neue Mitarbeiterkonten, erste Dokumente und Onboarding-Schritte.',
    settings_responsible_offboarding: 'Offboarding-Verantwortliche:r',
    settings_responsible_offboarding_desc: 'Ist standardmäßig zuständig für Austrittsdatum, Kontoschließung, Rückgaben und Abschlussdokumente.',
    msg_saving_company_responsibles: 'Unternehmensverantwortliche werden gespeichert...',
    msg_company_responsibles_saved: 'Unternehmensverantwortliche gespeichert.',
    err_company_responsibles_save: 'Unternehmensverantwortliche konnten nicht gespeichert werden.',
    msg_updating_password: 'Passwort wird aktualisiert...',
    err_password_update: 'Passwort konnte nicht aktualisiert werden.',
    msg_updating_logo: 'Logo wird hochgeladen...',
    msg_logo_updated: 'Logo erfolgreich aktualisiert.',
    err_logo_upload: 'Logo konnte nicht hochgeladen werden.',
    msg_loading_settings: 'Einstellungen werden geladen...',
    msg_updating_company_info: 'Unternehmensdaten werden aktualisiert...',
    msg_company_info_updated: 'Unternehmensdaten wurden aktualisiert.',
    err_company_info_update: 'Unternehmensdaten konnten nicht aktualisiert werden.',
    lbl_general_note: 'Allgemeine Notiz',
    lbl_dossier_rules_engine: 'E-Dossier-Regelwerk',
    lbl_required_document_sets: 'Erforderliche Dokumentensätze',
    lbl_expiry_alert_roles: 'Rollen für Ablaufwarnungen',
    btn_save_routing_responsibles: 'Workflow-Verantwortliche speichern',
    settings_field_visible_company_name: 'Angezeigter Firmenname',
    settings_field_legal_name: 'Rechtlicher / Handelsname',
    ph_legal_name: 'Name für Verträge und offizielle Dokumente',
    settings_field_tax_no: 'Steuernummer',
    settings_field_workplace_no: 'Sozialversicherung / Betriebsnummer',
    settings_field_active_plan: 'Aktiver Tarif',
    settings_field_address: 'Adresse',
    settings_field_phone: 'Telefon',
    settings_field_email: 'E-Mail',
    settings_field_website: 'Website',
    btn_update_company_info: 'Unternehmensdaten aktualisieren',
    lbl_document_header: 'Dokumentkopf',
    lbl_brand_identity: 'Corporate Identity',
    msg_no_logo_yet: 'Noch kein Logo',
    msg_pdf_header_ready: 'PDF-Briefkopf bereit',
    msg_logo_pending: 'Logo ausstehend',
    btn_upload_logo: 'Logo hochladen',
    lbl_personal_settings: 'Persönliche Einstellungen',
    lbl_account_security: 'Kontosicherheit',
    lbl_password_update: 'Passwort aktualisieren',
    lbl_personal_security_settings: 'Persönliche Sicherheitseinstellungen',
    lbl_current_password: 'Aktuelles Passwort',
    lbl_confirm_new_password: 'Neues Passwort wiederholen',
    btn_update_password: 'Passwort aktualisieren',
    lbl_kudos_sentence: '{{from}} hat sich bei {{to}} bedankt.',
    err_settings_load: 'Einstellungen oder Mitarbeiterliste konnten nicht geladen werden.',
    msg_routing_saved: 'Routing-Einstellungen erfolgreich gespeichert!',
    err_settings_save: 'Beim Speichern der Einstellungen ist ein Problem aufgetreten.',
    page_system_settings_title_prefix: 'System &',
    page_system_settings_title_highlight: 'Workflow-Einstellungen',
    page_system_settings_desc: 'Hier legen Sie fest, an welche verantwortliche Person Support-, Urlaubs- und Betriebsanfragen standardmäßig weitergeleitet werden.',
    btn_save_settings: 'EINSTELLUNGEN SPEICHERN',
    msg_waiting_settings_api: 'Einstellungen und Personal werden von der API geladen...',
    lbl_workflow_responsibles: 'Workflow-Verantwortliche',
    opt_select_employee: 'Mitarbeiter auswählen',
    btn_forgot: 'Passwort vergessen',
    btn_verify: 'PRÜFEN UND ANMELDEN',
    btn_setup_start: 'PASSWORT FESTLEGEN UND STARTEN',
    btn_reset_send: 'CODE SENDEN',
    btn_reset_save: 'NEUES PASSWORT SPEICHERN',
    btn_force_reset_save: 'NEUES PASSWORT FESTLEGEN',
    lbl_login: 'Anmelden',
    lbl_login_desc: 'Melden Sie sich in Ihrem CADRO-Konto an',
    lbl_reset_password: 'Passwort vergessen',
    lbl_reset_desc: 'Wir senden einen Reset-Code an Ihre E-Mail-Adresse',
    lbl_mfa: 'Verifizierung',
    lbl_mfa_desc: 'Geben Sie den 6-stelligen Code aus Ihrer E-Mail ein',
    lbl_setup_title: 'Konto aktivieren',
    lbl_setup_desc: 'Zahlung bestätigt. Legen Sie Ihr Passwort mit dem Code aus Ihrer E-Mail fest.',
    lbl_force_reset_title: 'Passwort erneuern',
    lbl_force_reset_desc: 'Vor der ersten Anmeldung müssen Sie ein neues Passwort festlegen.',
    lbl_membership_note: 'Wenn Sie noch kein Mitglied sind,',
    lbl_membership_note2: 'können Sie ein Abonnement starten unter',
    msg_login_success: 'Anmeldung erfolgreich.',
    msg_mfa_sent: 'Ihr Sicherheitscode wurde an Ihre E-Mail gesendet.',
    msg_reset_code_sent: 'Der Code wurde an Ihre E-Mail gesendet.',
    msg_password_changed: 'Passwort aktualisiert.',
    msg_force_password_changed: 'Ihr Passwort wurde aktualisiert. Sie können sich jetzt mit dem neuen Passwort anmelden.',
    msg_force_password_reset_sent: 'Ein Passwort-Reset-Code wurde zur Erstanmeldesicherheit an Ihre E-Mail gesendet.',
    msg_account_activated: 'Ihr Konto wurde aktiviert.',
    err_default: 'Ein Fehler ist aufgetreten.',
    ph_mfa_code: '6-stelliger Verifizierungscode',
    ph_setup_code: '6-stelliger Code aus Ihrer E-Mail',
    ph_reset_code: '6-stelliger Reset-Code',
    ph_setup_password: 'Neues Passwort festlegen',
    btn_send_kudos_short: 'LOB SENDEN',
    lbl_kudos_counts: 'Lob-Zähler',
    err_leave_country_type_required: 'Bitte wählen Sie zuerst Land / Region und Urlaubstyp aus.',
    lbl_leave_country: 'LAND / REGION',
    opt_select_country: 'Land / Region auswählen',
    opt_select_leave_type: 'Wählen Sie zuerst ein Urlaubsprofil',
    tab_payroll_report: 'LOHNABRECHNUNGSBERICHT',
    btn_save_sick_report: 'KRANKMELDUNG SPEICHERN',
    modal_title_sick_report: 'KRANKMELDUNG ERFASSEN',
    msg_creating_sick_report: 'Krankmeldung wird gespeichert...',
    msg_sick_report_created: 'Krankmeldung gespeichert.',
    msg_sick_report_full_pay: 'Als voll vergütete Abwesenheit erfasst.',
    msg_sick_report_deduct: 'Als abzugsfähige Abwesenheit erfasst.',
    err_sick_report_create: 'Krankmeldung konnte nicht gespeichert werden.',
    err_select_employee_for_sick_report: 'Bitte wählen Sie zuerst einen Mitarbeiter aus.',
    err_fetch_attendance_report: 'Lohnabrechnungsbericht konnte nicht geladen werden.',
    msg_no_attendance_report_rows: 'Für den ausgewählten Zeitraum wurden keine Berichtszeilen gefunden.',
    lbl_loading_attendance_report: 'Lohnabrechnungsbericht wird geladen...',
    lbl_payroll_effect: 'Auswirkung auf die Lohnabrechnung',
    lbl_payroll_decision_note: 'Notiz zur Lohnentscheidung',
    lbl_report_no: 'Berichtsnummer',
    lbl_report_people: 'Gemeldete Mitarbeiter',
    lbl_issue_date: 'Ausstellungsdatum',
    lbl_issued_by: 'Ausgestellt von',
    badge_sick_deduct: 'ABZUGSBERICHT',
    badge_sick_full_pay: 'VOLLE BEZAHLUNG',
    lbl_deduct_in_payroll: 'Abzugsfähig in der Abrechnung',
    lbl_full_pay_in_payroll: 'Voll bezahlt in der Abrechnung',
    status_sick_report: 'Krankmeldung',
    ph_search_attendance: 'Mitarbeiter oder Abteilung suchen',
    lbl_action_history: 'Aktionsverlauf',
    msg_no_action_history: 'Noch kein Aktionsverlauf vorhanden.',
    msg_loading_document_history: 'Dokumentenverlauf wird geladen...',
    msg_no_document_history: 'Noch kein Dokumentenverlauf vorhanden.',
    lbl_created: 'Erstellt',
    lbl_status_updated: 'Status aktualisiert',
    lbl_message_added: 'Nachricht hinzugefügt',
    lbl_attachment_added: 'Anhang hinzugefügt',
    lbl_attachment_count: '{{count}} Anhänge',
    doc_deleted: 'Dokument gelöscht',
    dossier_history_uploaded: 'Dokument hochgeladen',
    dossier_history_status_updated: 'Dokumentenstatus aktualisiert',
    dossier_history_deleted: 'Dokument aus dem Archiv entfernt',
    common_not_available: 'Nicht verfügbar',
    tooltip_view_archive: 'Archiv anzeigen',
    opt_support_technical: 'Technisches Problem',
    opt_support_billing: 'Abrechnung',
    opt_support_feature: 'Funktionswunsch',
    opt_support_other: 'Sonstiges',
    ph_support_subject: 'Kurzen Betreff eingeben',
    ph_support_message: 'Ihre Nachricht eingeben',
    btn_mark_as_read: 'Als gelesen markieren',
    lbl_broadcast_read: 'Gelesen',
    lbl_broadcast_unread: 'Ungelesen',
    msg_loading_support_requests: 'Supportanfragen werden geladen...',
    msg_no_support_requests: 'Keine Supportanfragen gefunden.',
    msg_loading_support_broadcasts: 'Ankündigungen werden geladen...',
    msg_no_support_broadcasts: 'Keine Ankündigungen gefunden.',
    lbl_system_user: 'System',
    msg_support_failed: 'Supporteinträge konnten nicht geladen werden.',
    msg_support_broadcasts_failed: 'Ankündigungen konnten nicht geladen werden.',
    msg_support_broadcast_read_failed: 'Die Ankündigung konnte nicht als gelesen markiert werden.',
    msg_support_subject_message_required: 'Bitte füllen Sie Betreff und Nachricht aus.',
    msg_support_sent: 'Ihre Supportanfrage wurde gesendet.',
    msg_support_cancellation_message_required: 'Bitte geben Sie einen kurzen Grund für die Kündigungsanfrage an.',
    msg_support_cancellation_sent: 'Ihre Kündigungsanfrage wurde zur Freigabe an das CADRO-Team gesendet.',
    msg_support_cancellation_failed: 'Die Kündigungsanfrage konnte nicht gesendet werden.',
    msg_support_cancellation_sending: 'Wird gesendet...',
    support_status_pending: 'Ausstehend',
    support_status_in_progress: 'In Bearbeitung',
    support_status_resolved: 'Gelöst',
    title_support_center: 'Support-Nachrichten',
    msg_contact_cadro_desc: 'Erstellen Sie ein Ticket für technische Themen, Abrechnung oder Produktfeedback. Status-Updates können Sie hier verfolgen.',
    btn_new_support_request: 'Neue Anfrage',
    btn_my_support_requests: 'Meine Nachrichten',
    btn_support_broadcasts: 'Ankündigungen',
    lbl_subscription_cancellation: 'Kündigungsanfrage',
    title_subscription_cancellation_owner_review: 'Die Kündigungsanfrage geht zuerst an das CADRO-Team',
    msg_subscription_cancellation_owner_review: 'Diese Option ist nur für Superadmins verfügbar. Die Anfrage geht zuerst an das CADRO-Team; nach Abstimmung und Freigabe wird sie bei Paddle verarbeitet.',
    btn_request_subscription_cancellation: 'Mein Abonnement kündigen',
    lbl_support_category: 'Kategorie',
    lbl_support_subject: 'Betreff',
    lbl_support_message: 'Nachricht',
    lbl_support_attachments: 'Datei / Foto hinzufügen',
    btn_support_choose_files: 'Datei wählen',
    btn_send_support: 'Supportanfrage senden',
    lbl_owner_approval_required: 'Freigabe durch CADRO-Team erforderlich',
    lbl_owner_update: 'Update vom CADRO-Team',
    lbl_kpi_group_workforce: 'Belegschaft',
    lbl_kpi_group_absence: 'Abwesenheit & Urlaub',
    lbl_kpi_group_operations: 'Betrieb',
    lbl_kpi_group_compliance: 'Compliance',
    lbl_system_active_employees: 'Aktive Mitarbeiter',
    lbl_system_turnover_rate: 'Fluktuationsrate',
    lbl_system_leave_today: 'Heute im Urlaub',
    lbl_system_absent_today: 'Heute abwesend',
    lbl_system_absence_rate_today: 'Heutige Abwesenheitsquote',
    lbl_system_leave_coverage_rate_today: 'Heutige Urlaubsquote',
    lbl_system_leave_usage_rate: 'Urlaubsnutzungsrate',
    lbl_system_open_queue: 'Offene Arbeitswarteschlange',
    lbl_system_pending_policy_ack: 'Ausstehende Richtlinienbestätigungen',
    lbl_system_expiring_documents: 'In 30 Tagen ablaufende Dokumente',
    msg_no_kpi_categories: 'Für die ausgewählten Filter wurden keine Kategoriedaten gefunden.',
    btn_clear: 'Zurücksetzen',
    msg_saving: 'Wird gespeichert...',
    msg_sending: 'Wird gesendet...',
    msg_leave_cancel_not_available: 'Die Stornierung von Urlaubsanträgen ist derzeit im Mitarbeiterportal nicht verfügbar. Bitte wenden Sie sich an Ihre Führungskraft oder HR.',
    opt_full_pay_sick: 'VOLLEN LOHN ZAHLEN',
    opt_deduct_sick: 'IN ABZUG AUFNEHMEN',
    file_attendance: 'Anwesenheit',
    col_name: 'NAME',
    desc_bulk_action: 'Verwenden Sie dies, um die ausgewählten Datensätze gesammelt zu bearbeiten.',
    action_approve: 'genehmigen',
    action_reject: 'ablehnen',
    opt_all_schedule_types: 'ALLE PLANTYPEN',
    opt_all_schedules: 'ALLE PLÄNE',
    opt_all_statuses: 'ALLE STATUS',
    ph_select_employee: 'Mitarbeiter auswählen',
    err_schedule_report_pdf: 'Der PDF-Bericht für Arbeitspläne konnte nicht erstellt werden.',
    msg_schedule_report_pdf: 'PDF-Bericht für Arbeitspläne wird vorbereitet...',
    msg_schedule_report_pdf_ready: 'Der Arbeitsplanbericht ist fertig.',
    err_schedule_members_report_pdf: 'Der Mitarbeiterbericht des Plans konnte nicht erstellt werden.',
    msg_schedule_members_report_pdf: 'Mitarbeiterbericht für "{{name}}" wird vorbereitet...',
    msg_schedule_members_report_pdf_ready: 'Der Mitarbeiterbericht des Plans ist fertig.',
    doc_id: 'AUSWEIS / PASSPORTKOPIE',
    doc_pre_permit: 'VORABGENEHMIGUNGSUNTERLAGEN (TRNZ)',
    doc_work_permit: 'ARBEITSERLAUBNIS & GESUNDHEITSBERICHT',
    doc_residency: 'WOHNSITZ / ADRESSNACHWEIS',
    doc_visa: 'VISUM / AUFENTHALTSERLAUBNIS',
    doc_contract: 'ARBEITSVERTRAG',
    doc_nda: 'VERTRAULICHKEIT / NDA',
    doc_handbook_ack: 'HANDBUCHBESTÄTIGUNG',
    doc_background_check: 'HINTERGRUNDPRÜFUNG',
    doc_ohs_training: 'ARBEITSSICHERHEIT / GESUNDHEITSEIGNUNG',
    doc_bank_info: 'BANK / IBAN-ANGABEN',
    doc_tax_doc: 'STEUER / TIN-DOKUMENT',
    doc_payroll: 'LOHNABRECHNUNG',
    doc_social_security_record: 'SOZIALVERSICHERUNGSNACHWEIS',
    doc_performance_review: 'LEISTUNGSBEURTEILUNG',
    doc_training_record: 'SCHULUNGSNACHWEIS',
    doc_leave_record: 'URLAUBS- / ABWESENHEITSNACHWEIS',
    doc_disciplinary: 'DISZIPLINARAKTE',
    doc_termination: 'AUSSTELLUNG / FREISTELLUNGSDOKUMENTE',
    doc_exit_interview: 'AUSTRETTSGESPRÄCH',
    doc_onboarding_checklist: 'ONBOARDING-CHECKLISTE',
    doc_offboarding_checklist: 'OFFBOARDING-CHECKLISTE',
    doc_certificate: 'ZERTIFIKAT & BERUFLICHE SCHULUNG',
    doc_other: 'SONSTIGE DOKUMENTE',
    tab_uploaded_documents: 'HOCHGELADENE DOKUMENTE',
    tab_upload_document: 'DOKUMENT HOCHLADEN',
    tab_compliance: 'COMPLIANCE-ÜBERSICHT',
    action_approved: 'Genehmigt',
    action_rejected: 'Abgelehnt',
    badge_approved_doc: 'GENEHMIGTES DOKUMENT',
    btn_approve: 'GENEHMIGEN',
    btn_reject: 'ABLEHNEN',
    btn_select_employee_archive: 'MITARBEITER WÄHLEN',
    btn_change_employee_archive: 'MITARBEITER WECHSELN',
    btn_choose_from_pc: 'DATEI VOM COMPUTER WÄHLEN',
    btn_upload_to_archive: 'INS ARCHIV HOCHLADEN',
    btn_uploading: 'WIRD HOCHGELADEN...',
    err_delete_failed: 'Dokument konnte nicht gelöscht werden.',
    err_delete_pending_only: 'Mitarbeiter dürfen nur ausstehende Dokumente löschen.',
    err_document_status_update: 'Dokumentenstatus konnte nicht aktualisiert werden.',
    err_fetch_docs: 'Dokumente konnten nicht geladen werden.',
    err_fetch_emps: 'Mitarbeiterliste konnte nicht geladen werden.',
    err_fetch_files: 'Dateien konnten nicht geladen werden.',
    err_file_size: 'Dateigrößenlimit überschritten.',
    err_upload_failed: 'Dokument konnte nicht hochgeladen werden.',
    lbl_archive_selection: 'ARCHIVAUSWAHL',
    lbl_completion_score: 'VOLLSTÄNDIGKEITSSCORE',
    lbl_country_role_rule_set: 'LAND / ROLLEN-REGELSET',
    lbl_doc_category: 'DOKUMENTENKATEGORIE',
    lbl_doc_issue_date: 'AUSSTELLUNGSDATUM',
    lbl_doc_issued_by: 'AUSGESTELLT VON',
    lbl_doc_mandatory: 'PFLICHTDOKUMENT',
    lbl_doc_number: 'DOKUMENTNUMMER',
    lbl_doc_number_short: 'NR',
    lbl_doc_valid_until: 'GÜLTIG BIS',
    lbl_document_detail: 'DOKUMENTDETAIL',
    lbl_dossier_compliance: 'DOKUMENTEN-COMPLIANCE',
    lbl_expired_docs: 'ABGELAUFEN',
    lbl_expired_required_docs: 'ABGELAUFENE PFLICHTDOKUMENTE',
    lbl_expiring_required_docs: 'BALD ABLAUFENDE PFLICHTDOKUMENTE',
    lbl_expiring_soon: 'LÄUFT BALD AB',
    lbl_items: 'Einträge',
    lbl_max_file_size: 'Maximale Dateigröße: 10MB',
    lbl_missing_required: 'FEHLENDE PFLICHTEN',
    lbl_my_dossier: 'MEINE PERSÖNLICHE E-AKTE',
    lbl_select_file_format: 'DATEI WÄHLEN (PDF / BILD)',
    lbl_upload_new_doc: 'NEUES DOKUMENT INS SYSTEM HOCHLADEN',
    msg_all_required_docs_ready: 'PFLICHTDOKUMENTE VOLLSTÄNDIG',
    msg_confirm_delete_doc: 'Dieses Dokument wird dauerhaft gelöscht. Sind Sie sicher?',
    msg_delete_success: 'Dokument erfolgreich aus dem Archiv entfernt.',
    msg_document_status_updated: 'Dokumentenstatus wurde auf {{status}} aktualisiert.',
    msg_dossier_compliant: 'Alle erforderlichen Dokumente in dieser Akte scheinen aktuell vollständig zu sein.',
    msg_missing_required_docs: 'FEHLENDE PFLICHTDOKUMENTE',
    msg_no_docs_found: 'In dieser Mitarbeiterakte wurden noch keine Dokumente gefunden.',
    msg_no_employee_selected: 'Noch kein Mitarbeiter ausgewählt',
    msg_no_expired_required_docs: 'Keine abgelaufenen Pflichtdokumente sichtbar.',
    msg_no_expiring_required_docs: 'Keine Pflichtdokumente laufen bald ab.',
    msg_searching_docs: 'Dokumente werden gesucht...',
    msg_select_doc_for_detail: 'WÄHLEN SIE EIN DOKUMENT, UM DIE DETAILS ZU SEHEN',
    msg_select_emp_focus_html: 'WÄHLEN SIE ZUERST EINEN MITARBEITER,<br/>UM DIE E-AKTE ZU SEHEN.',
    msg_upload_pending: 'Dokument wartet auf Freigabe.',
    msg_upload_success: 'Dokument wurde erfolgreich dem Archiv hinzugefügt.',
    msg_uploading_doc: 'Dokument wird hochgeladen...',
    ph_search_emp: 'Nach Name oder Abteilung suchen...',
    tooltip_delete_archive: 'Aus dem Archiv löschen',
    tooltip_view_doc: 'Dokument ansehen',
    badge_pending_approval: 'AUSSTEHENDE GENEHMIGUNG',
    badge_rejected_doc: 'ABGELEHNT',
    badge_expiring_soon: 'LÄUFT BALD AB',
    badge_expired: 'ABGELAUFEN',
    lbl_employee: 'MITARBEITER',
    lbl_first_name: 'VORNAME',
    lbl_last_name: 'NACHNAME',
    lbl_pending_documents: 'AUSSTEHENDE DOKUMENTE',
    lbl_support_broadcasts: 'SUPPORT-NACHRICHTEN',
    msg_document_waiting: 'Dokumente warten auf Ihre Freigabe.',
    msg_support_broadcast_waiting: 'ungelesene Ankündigungen warten auf Sie.',
    role_owner: 'PLATTFORMEIGENTÜMER',
    btn_contact_cadro: 'CADRO SUPPORT',
    menu_executive_console: 'EXECUTIVE KONSOLE',
    menu_executive_companies: 'UNTERNEHMEN',
    menu_executive_revenue: 'UMSATZ & TARIFE',
    menu_executive_risks: 'RISIKEN & WARNUNGEN',
    menu_executive_messages: 'NACHRICHTEN',
    menu_account_security: 'KONTOSICHERHEIT',
    dossier_profile_global_title: 'Global',
    dossier_profile_global_desc: 'Grundlegender Pflichtdokumentensatz für das Standard-Unternehmensprofil.',
    dossier_profile_tr_title: 'TR',
    dossier_profile_tr_desc: 'Erforderlicher Dokumentensatz für das Türkei-Profil.',
    dossier_profile_kktc_title: 'TRNZ',
    dossier_profile_kktc_desc: 'Erforderlicher Dokumentensatz für das Nordzypern-Profil.',
    dossier_profile_eu_title: 'EU',
    dossier_profile_eu_desc: 'Erforderlicher Dokumentensatz für das Europa-Profil.',
    dossier_profile_mena_title: 'MENA',
    dossier_profile_mena_desc: 'Erforderlicher Dokumentensatz für das MENA-Profil.',
    dossier_profile_leadership_title: 'Leitung',
    dossier_profile_leadership_desc: 'Zusätzlicher Pflichtdokumentensatz für Führungskräfte, HR, Admins und Superadmins.',
    lbl_security_tip: 'Hinweis',
    desc_security_tip: 'Verwenden Sie für das Administratorkonto ein starkes Passwort und ändern Sie es regelmäßig. Ihr mobiler MFA-Ablauf ist bereits aktiv.',

    // 🕐 NEUES ZEITERFASSUNGSMODUL — RBAC-basierte Übersetzungen
    attendance_kpi_present: 'Anwesend',
    attendance_kpi_late: 'Verspätungen',
    attendance_kpi_hours: 'Gesamtstunden',
    attendance_kpi_sick: 'Krankmeldungen',
    attendance_kpi_checked_in: 'Heute eingecheckt',
    attendance_kpi_late_count: 'Verspätet',
    attendance_kpi_absent: 'Abwesend',
    attendance_kpi_pending: 'Ausstehende Freigaben',
    attendance_kpi_total_hours: 'Gesamtstunden',
    attendance_view_weekly: 'Wöchentlich',
    attendance_view_monthly: 'Monatlich',
    attendance_legend_present: 'Anwesend',
    attendance_legend_late: 'Verspätet',
    attendance_legend_absent: 'Abwesend',
    attendance_legend_sick: 'Krank',
    attendance_legend_holiday: 'Urlaub',
    attendance_filter_date: 'Datum',
    attendance_filter_from: 'Von',
    attendance_filter_to: 'Bis',
    attendance_filter_personnel: 'Mitarbeiter',
    attendance_filter_search: 'Name suchen',
    attendance_filter_search_placeholder: 'Vor- oder Nachname...',
    attendance_filter_department: 'Abteilung',
    attendance_filter_all_departments: 'Alle Abteilungen',
    attendance_filter_status: 'Status',
    attendance_filter_all_status: 'Alle Status',
    attendance_filter_approval: 'Freigabe',
    attendance_filter_all_approval: 'Alle Freigaben',
    attendance_export: 'Exportieren',
    attendance_export_success: 'Export abgeschlossen.',
    attendance_no_records: 'Keine Zeiterfassungseinträge gefunden.',
    attendance_selected: 'Einträge ausgewählt',
    attendance_bulk_approve: 'Sammel-Freigabe',
    attendance_bulk_reject: 'Sammel-Ablehnung',
    attendance_bulk_approved: 'Ausgewählte Einträge freigegeben.',
    attendance_col_employee: 'Mitarbeiter',
    attendance_col_date: 'Datum',
    attendance_col_in: 'Kommen',
    attendance_col_out: 'Gehen',
    attendance_col_duration: 'Dauer',
    attendance_col_status: 'Status',
    attendance_col_approval: 'Freigabe',
    attendance_col_actions: 'Aktionen',
    schedule_kicker: 'Planverwaltung',
    schedule_title: 'Arbeitszeitmodelle',
    schedule_add: 'Neues Modell',
    schedule_empty: 'Noch keine Arbeitszeitmodelle.',
    schedule_name: 'Modellname',
    schedule_type: 'Typ',
    schedule_break: 'Pause (Min.)',
    schedule_start: 'Beginn',
    schedule_end: 'Ende',
    schedule_grace_in: 'Toleranz Beginn (Min.)',
    schedule_overtime: 'Überstunden nach (Min.)',
    schedule_active: 'Aktiv',
    schedule_updated: 'Arbeitszeitmodell aktualisiert.',
    schedule_created: 'Arbeitszeitmodell erstellt.',
    schedule_deleted: 'Arbeitszeitmodell gelöscht.',
    schedule_delete_confirm: 'Möchten Sie dieses Arbeitszeitmodell wirklich löschen?',
    schedule_edit: 'Modell bearbeiten',
    schedule_new: 'Neues Modell',
    dept_assign_kicker: 'Abteilungs-Zuordnungen',
    dept_assign_title: 'Abteilungs-Arbeitszeiten',
    dept_assign_desc: 'Wählen Sie das Standard-Arbeitszeitmodell für jede Abteilung.',
    dept_assign_employees: 'Mitarbeiter',
    dept_assign_none: 'Nicht zugewiesen',
    dept_assign_empty: 'Keine Abteilungen gefunden.',
    override_kicker: 'Mitarbeiter-Ausnahme',
    override_title: 'Individuelle Arbeitszeit',
    override_desc: 'Weisen Sie bestimmten Mitarbeitern ein abweichendes Arbeitszeitmodell zu.',
    override_search: 'Mitarbeiter suchen...',
    override_all_departments: 'Alle Abteilungen',
    override_empty: 'Keine Mitarbeiter gefunden.',
    override_badge: 'AUSNAHME',
    override_selected: 'Mitarbeiter ausgewählt',
    override_select_schedule: 'Modell auswählen...',
    override_reason: 'Grund (optional)',
    override_assign_btn: 'Zuweisen',
    override_clear_btn: 'Ausnahmen aufheben',
    override_assigned: 'Mitarbeiter-Ausnahmen zugewiesen.',
    override_cleared: 'Ausnahmen aufgehoben.',
    override_select_both: 'Mitarbeiter und Arbeitszeitmodell auswählen.',
    override_clear_confirm: 'Möchten Sie die Ausnahmen der ausgewählten Mitarbeiter wirklich aufheben?',
    payroll_kicker: 'Lohnabrechnungsübersicht',
    payroll_title: 'Zeiterfassungsübersicht für Lohnabrechnung',
    payroll_generate: 'Erzeugen',
    payroll_click_generate: 'Klicken Sie "Erzeugen" für die Lohnabrechnungsübersicht.',
    payroll_col_employee: 'Mitarbeiter',
    payroll_col_normal: 'Normal',
    payroll_col_overtime: 'Überstunden',
    payroll_col_absent: 'Fehlend',
    payroll_col_total: 'Gesamt',
    payroll_total: 'GESAMT',
  },
  ar: {
    sidebar_group_workspace: 'مساحة العمل',
    sidebar_group_people: 'عمليات الموارد البشرية',
    sidebar_group_operations: 'العمليات',
    sidebar_group_compliance: 'التطوير والامتثال',
    sidebar_group_requests: 'المالية والطلبات',
    sidebar_group_team: 'الفريق والتنظيم',
    sidebar_group_workday: 'يوم العمل',
    sidebar_group_growth: 'التطوير',
    menu_knowledge_base: 'قاعدة المعرفة والسياسات',
    menu_purchase_requests: 'طلبات الشراء',
    menu_request_forms: 'نماذج الطلبات المؤسسية',
    menu_kpi_statistics: 'مؤشرات الأداء والإحصاءات',
    menu_surveys: 'الاستبيانات ومؤشر التوصية',
    sidebar_group_experience: 'تجربة الموظف',
    engagement_module: 'تجربة الموظف',
    survey_title: 'الاستبيانات ومؤشر توصية الموظف',
    survey_phase1_info: 'من هنا يمكنك إنشاء قوالب الاستبيان ونشر الحملات ومتابعة ملاحظات الموظفين.',
    survey_my_inbox: 'صندوق الاستبيانات الخاص بي',
    survey_no_pending: 'لا توجد استبيانات معلّقة.',
    survey_anonymous: 'مجهول',
    survey_named: 'بالاسم',
    survey_answer: 'إجابة',
    survey_completed: 'المكتمل',
    survey_admin_center: 'الإدارة',
    survey_templates: 'القوالب',
    survey_template_name: 'اسم القالب',
    survey_question_code: 'الرمز',
    survey_question_text: 'السؤال',
    survey_required: 'إلزامي',
    survey_delete: 'حذف',
    survey_choices_comma: 'الخيارات (مفصولة بفواصل)',
    survey_add_question: 'إضافة سؤال',
    survey_existing_templates: 'القوالب الحالية',
    survey_update_template: 'تحديث القالب',
    survey_create_template: 'إنشاء قالب',
    survey_campaigns: 'الحملات',
    survey_choose_template: 'اختر قالبًا',
    survey_campaign_name: 'اسم الحملة',
    survey_department_filter: 'أرقام الأقسام المستهدفة (مفصولة بفواصل)',
    survey_role_filter: 'رموز الأدوار المستهدفة (مفصولة بفواصل)',
    survey_start_at: 'تاريخ البدء',
    survey_end_at: 'تاريخ الانتهاء',
    survey_is_anonymous: 'استبيان مجهول',
    survey_update_campaign: 'تحديث الحملة',
    survey_create_campaign: 'إنشاء حملة',
    survey_campaign_list: 'قائمة الحملات',
    survey_edit_campaign: 'تعديل',
    survey_launch: 'إطلاق',
    survey_close: 'إغلاق',
    survey_view_analytics: 'التحليلات',
    survey_participation: 'المشاركة',
    survey_recommendation_score: 'مؤشر توصية الموظف',
    survey_scale_avg: 'متوسط التقييم',
    survey_department_breakdown: 'تفصيل الأقسام',
    survey_role_breakdown: 'تفصيل الأدوار',
    survey_role_admin: 'مشرف',
    survey_role_employee: 'موظف',
    survey_role_hr: 'الموارد البشرية',
    survey_role_manager: 'مدير',
    survey_role_superadmin: 'مشرف النظام',
    survey_select_option: 'اختر خيارًا',
    survey_submit: 'إرسال',
    survey_edit: 'تعديل',
    survey_status_draft: 'مسودة',
    survey_status_live: 'مباشر',
    survey_status_closed: 'مغلق',
    survey_status_active: 'نشط',
    survey_category_pulse: 'استبيان نبضي',
    survey_category_enps: 'مؤشر توصية الموظف',
    survey_category_exit: 'استبيان الخروج',
    survey_category_onboarding: 'استبيان التهيئة',
    survey_category_custom: 'استبيان مخصص',
    survey_qtype_nps_0_10: 'درجة توصية 0-10',
    survey_qtype_scale_1_5: 'مقياس تقييم 1-5',
    survey_qtype_single_choice: 'اختيار واحد',
    survey_qtype_multi_choice: 'اختيار متعدد',
    survey_qtype_text_short: 'نص قصير',
    survey_qtype_text_long: 'نص طويل',
    survey_default_question_recommendation: 'ما مدى احتمالية أن توصي بشركتنا كمكان للعمل؟',
    survey_default_question_improvement: 'ما الذي يجب أن نحسّنه؟',
    survey_load_failed: 'تعذر تحميل بيانات الاستبيان.',
    survey_template_load_failed: 'تعذر تحميل تفاصيل القالب.',
    survey_question_required: 'يرجى إدخال سؤال واحد على الأقل.',
    survey_template_create_failed: 'تعذر حفظ القالب.',
    survey_campaign_save_failed: 'تعذر حفظ الحملة.',
    survey_campaign_launch_failed: 'تعذر إطلاق الحملة.',
    survey_campaign_close_failed: 'تعذر إغلاق الحملة.',
    survey_detail_load_failed: 'تعذر تحميل تفاصيل الاستبيان.',
    survey_submit_failed: 'تعذر إرسال الاستبيان.',
    survey_analytics_failed: 'تعذر تحميل التحليلات.',
    nav_knowledge_base: 'قاعدة المعرفة والسياسات',
    nav_sub_knowledge_base: 'مركز قراءة السياسات وإجراءات العمل',
    nav_request_forms: 'نماذج الطلبات المؤسسية',
    nav_sub_request_forms: 'إدارة الطلبات المنظمة وسير العمل',
    nav_kpi_statistics: 'مؤشرات الأداء والإحصاءات',
    nav_sub_kpi_statistics: 'متابعة المؤشرات حسب النطاق الزمني',
    btn_add: 'إضافة',
    btn_refresh: 'تحديث',
    btn_new_purchase_request: 'طلب شراء جديد',
    btn_submit_purchase_request: 'إرسال الطلب',
    btn_convert_to_expense: 'تحويل إلى مصروف',
    btn_new_generic_request: 'طلب مؤسسي جديد',
    btn_open_flow: 'فتح المسار',
    btn_take_in_progress: 'تحويل إلى قيد التنفيذ',
    btn_complete: 'إكمال',
    btn_send_message: 'إرسال رسالة',
    btn_add_attachment: 'إضافة ملف',
    btn_submit_request: 'إرسال الطلب',
    btn_new_kpi_metric: 'تسجيل KPI جديد',
    err_fetch_purchase_requests: 'تعذر تحميل طلبات الشراء.',
    err_create_purchase_request: 'تعذر إنشاء طلب الشراء.',
    err_convert_purchase_expense: 'تعذر إنشاء سجل المصروف.',
    err_fetch_generic_requests: 'تعذر تحميل الطلبات المؤسسية.',
    err_fetch_generic_request_detail: 'تعذر تحميل تفاصيل الطلب.',
    err_create_generic_request: 'تعذر إنشاء الطلب.',
    err_fetch_kpi_metrics: 'تعذر تحميل سجلات KPI.',
    err_create_kpi_metric: 'تعذر إنشاء سجل KPI.',
    err_delete_kpi_metric: 'تعذر حذف سجل KPI.',
    lbl_contact_cadro: 'دعم CADRO',
    title_support_center: 'رسائل الدعم',
    msg_contact_cadro_desc: 'افتح طلبًا للمشكلات التقنية أو الفوترة أو ملاحظات المنتج، وتابع تحديثات الحالة من هنا.',
    btn_new_support_request: 'طلب جديد',
    btn_my_support_requests: 'رسائلي',
    btn_support_broadcasts: 'الإعلانات',
    lbl_support_category: 'الفئة',
    lbl_support_subject: 'الموضوع',
    lbl_support_message: 'الرسالة',
    lbl_support_attachments: 'إضافة ملف / صورة',
    btn_support_choose_files: 'اختر ملفات',
    btn_send_support: 'إرسال طلب الدعم',
    msg_support_failed: 'تعذر إرسال طلب الدعم.',
    msg_support_sent: 'تم إرسال طلب الدعم.',
    msg_support_subject_message_required: 'يرجى تعبئة حقلي الموضوع والرسالة.',
    msg_support_broadcasts_failed: 'تعذر تحميل الإعلانات.',
    msg_support_broadcast_read_failed: 'تعذر تعليم الإعلان كمقروء.',
    msg_support_broadcast_sent: 'تم نشر الإعلان.',
    msg_support_broadcast_failed: 'تعذر نشر الإعلان.',
    msg_support_messages_loading: 'جارٍ تحميل الرسائل...',
    msg_support_inbox_empty: 'لا توجد رسائل واردة بعد.',
    support_status_pending: 'قيد الانتظار',
    support_status_in_progress: 'قيد المعالجة',
    support_status_resolved: 'تمت المعالجة',
    lbl_owner_update: 'تحديث من فريق CADRO',
    lbl_owner_approval_required: 'مطلوب اعتماد فريق CADRO',
    lbl_subscription_cancellation: 'طلب إلغاء الاشتراك',
    title_subscription_cancellation_owner_review: 'طلبات الإلغاء تذهب أولًا إلى فريق CADRO',
    msg_subscription_cancellation_owner_review: 'هذا الخيار متاح فقط للمشرف الأعلى. يصل الطلب أولًا إلى فريق CADRO، وبعد المراجعة والتواصل يتم تنفيذه عبر Paddle.',
    btn_request_subscription_cancellation: 'إلغاء اشتراكي',
    msg_support_cancellation_message_required: 'يرجى كتابة شرح مختصر لطلب الإلغاء.',
    msg_support_cancellation_sent: 'تم إرسال طلب إلغاء الاشتراك إلى فريق CADRO للمراجعة.',
    msg_support_cancellation_failed: 'تعذر إرسال طلب إلغاء الاشتراك.',
    msg_support_cancellation_sending: 'جارٍ الإرسال...',
    msg_support_cancellation_owner_queue: 'طلب إلغاء ينتظر موافقة فريق CADRO قبل تنفيذ الإجراء عبر Paddle',
    ph_support_owner_note: 'ملاحظة حالة قصيرة تظهر للعميل',
    ph_support_cancellation_owner_note: 'ملاحظة المكالمة أو الاحتفاظ أو القرار قبل تنفيذ الإجراء عبر Paddle',
    msg_support_status_saved: 'تم حفظ حالة الدعم.',
    msg_support_status_save_failed: 'تعذر تحديث سجل الدعم.',
    btn_save_status: 'حفظ الحالة',
    msg_executive_fetch_failed: 'تعذر تحميل بيانات لوحة الإدارة.',
    generic_requests_open: 'الطلبات المفتوحة',
    lbl_pending_requests: 'الطلبات المعلقة',
    lbl_approved_requests: 'الطلبات المعتمدة',
    lbl_rejected_requests: 'الطلبات المرفوضة',
    lbl_current_total: 'إجمالي العرض الحالي',
    lbl_finance_approver: 'موافق المالية',
    lbl_item_name: 'العنصر / الخدمة',
    lbl_vendor: 'المورد',
    lbl_product_link: 'رابط المنتج / الخدمة',
    lbl_quantity: 'الكمية',
    lbl_quantity_unit_price: 'الكمية وسعر الوحدة',
    lbl_unit_price: 'سعر الوحدة',
    lbl_justification: 'المبرر',
    lbl_needed_by: 'مطلوب بحلول',
    lbl_converted_to_expense: 'تم تحويله إلى مصروف',
    lbl_request_routing_engine: 'محرك سير عمل الطلبات',
    lbl_routing_logic: 'سير العمل',
    lbl_request_type: 'نوع الطلب',
    lbl_requested_by: 'مقدم الطلب',
    lbl_requested_for: 'الطلب لصالح',
    lbl_assigned_to: 'مُسند إلى',
    lbl_request_timeline: 'سير الطلب',
    lbl_required: 'إلزامي',
    lbl_route_explanation: 'ملخص سير العمل',
    lbl_no_resolution_note: 'لا توجد ملاحظة معالجة.',
    lbl_undefined: 'غير معرّف',
    lbl_record: 'سجل',
    lbl_title: 'العنوان',
    lbl_description: 'الوصف',
    lbl_system: 'النظام',
    lbl_statistics_engine: 'محرك الإحصاءات',
    lbl_kpi_pulse: 'نبض KPI',
    lbl_open_statistics_screen: 'فتح شاشة الإحصاءات',
    lbl_selected_period_metrics: 'سجلات الفترة المحددة',
    lbl_selected_period_total: 'إجمالي الفترة المحددة',
    lbl_period_delta: 'فرق الفترة السابقة',
    lbl_category_breakdown: 'توزيع الفئات',
    lbl_kpi_records: 'سجلات KPI',
    kpi_category_headcount: 'الكوادر',
    kpi_category_recruitment: 'التوظيف',
    kpi_category_payroll: 'الرواتب',
    kpi_category_absence: 'الغياب',
    kpi_category_training: 'التدريب',
    kpi_category_performance: 'الأداء',
    kpi_category_finance: 'المالية',
    kpi_category_other: 'أخرى',
    lbl_metric_date: 'تاريخ المؤشر',
    lbl_source_type: 'مصدر البيانات',
    lbl_target_value: 'القيمة المستهدفة',
    lbl_actual_value: 'القيمة الفعلية',
    lbl_target_progress: 'التقدم نحو الهدف',
    lbl_unit: 'الوحدة',
    kpi_unit_count: 'عدد',
    kpi_unit_percent: '%',
    kpi_unit_currency: 'عملة',
    kpi_unit_day: 'يوم',
    kpi_unit_hour: 'ساعة',
    kpi_source_manual: 'يدوي',
    kpi_source_system: 'النظام',
    lbl_search: 'بحث',
    lbl_date_range: 'النطاق الزمني',
    lbl_status: 'الحالة',
    ph_search_purchase_requests: 'ابحث بالعنصر أو المورد أو الموظف',
    modal_purchase_request: 'طلب شراء',
    ph_search_generic_requests: 'ابحث بالعنوان أو الوصف أو الموظف',
    ph_generic_request_title: 'اكتب موضوع الطلب بشكل واضح',
    ph_generic_request_description: 'اشرح الحاجة وأثرها على العمل والنتيجة المتوقعة',
    ph_request_reply: 'اكتب ردك',
    ph_search_kpi_metrics: 'ابحث بعنوان KPI',
    ph_kpi_title: 'مثال: معدل الغياب الشهري',
    ph_kpi_note: 'ملاحظة اختيارية',
    opt_all_personnel: 'كل الموظفين',
    opt_all_request_types: 'كل أنواع الطلبات',
    opt_all_categories: 'كل الفئات',
    opt_myself: 'نفسي',
    btn_reset_filter: 'مسح',
    btn_confirm_filter: 'تطبيق',
    priority_low: 'منخفض',
    priority_normal: 'عادي',
    priority_high: 'مرتفع',
    priority_urgent: 'عاجل',
    status_active: 'نشط',
    status_completed: 'مكتمل',
    status_pending: 'قيد الانتظار',
    status_approved: 'تمت الموافقة',
    status_rejected: 'مرفوض',
    msg_creating_purchase_request: 'جارٍ إنشاء طلب الشراء...',
    msg_purchase_request_created: 'تم إرسال طلب الشراء إلى موافقة المالية.',
    msg_confirm_purchase_approve: 'هل تريد الموافقة على طلب الشراء هذا؟',
    prompt_purchase_reject_reason: 'يرجى كتابة سبب الرفض:',
    prompt_purchase_reject_default: 'غير مناسب بسبب الميزانية / سياسة الشراء.',
    msg_purchase_request_approved: 'تمت الموافقة على طلب الشراء.',
    msg_purchase_request_rejected: 'تم رفض طلب الشراء.',
    msg_confirm_convert_purchase_expense: 'هل تريد تحويل هذا الطلب إلى سجل مصروف؟',
    msg_converting_purchase_expense: 'جارٍ إنشاء سجل المصروف...',
    msg_purchase_expense_converted: 'تم تحويل الطلب إلى سجل مصروف.',
    msg_no_purchase_requests: 'لا توجد طلبات في هذا العرض.',
    msg_creating_generic_request: 'جارٍ إنشاء الطلب المؤسسي...',
    msg_generic_request_created: 'تم توجيه الطلب إلى المسؤول المختص.',
    prompt_generic_request_reject: 'أدخل ملاحظة الرفض:',
    prompt_generic_request_reject_default: 'لم يُعتبر الطلب متوافقاً مع العملية أو السياسة الحالية.',
    msg_confirm_generic_request_action: 'هل تريد تطبيق هذه الحالة؟',
    msg_generic_request_updated: 'تم تحديث حالة الطلب.',
    msg_no_generic_requests: 'لا توجد طلبات في هذا العرض.',
    msg_no_request_messages: 'لا توجد رسائل بعد.',
    msg_creating_kpi_metric: 'جارٍ إنشاء سجل KPI...',
    msg_kpi_metric_created: 'تم إنشاء سجل KPI.',
    msg_confirm_delete_kpi: 'هل تريد حذف سجل KPI هذا؟',
    msg_kpi_metric_deleted: 'تم حذف سجل KPI.',
    msg_no_kpi_metrics: 'لا توجد سجلات KPI للفلاتر المحددة.',
    attendance_self_recent_tab: 'السجلات الأخيرة',
    attendance_self_health_tab: 'تقارير المرض الخاصة بي',
    attendance_self_health_summary_title: 'عرض تقريري الصحي',
    attendance_self_health_summary_desc: 'يتم عرض الحد الأدنى فقط من المعلومات اللازمة للدوام وأثر الرواتب. لا يتم عرض التشخيص أو التقييم الطبي أو ملاحظات المعالجة الداخلية.',
    attendance_self_health_summary_correction: 'إذا لاحظت سجلاً خاطئاً أو ناقصاً، يمكنك فتح طلب تصحيح للموارد البشرية عبر نماذج الطلبات المؤسسية.',
    attendance_self_no_health_reports: 'لا توجد تقارير مرضية مسجلة.',
    attendance_self_report_period: 'فترة التقرير',
    attendance_self_report_no: 'رقم التقرير',
    attendance_self_issue_date: 'تاريخ الإصدار',
    attendance_self_payroll_visibility: 'أثر الرواتب',
    attendance_self_full_pay: 'راتب كامل',
    attendance_self_deduct_pay: 'مشمول في خصم الرواتب',
    attendance_self_included_in_payroll: 'نشط في الدوام',
    attendance_self_not_included_in_payroll: 'غير مشمول في الدوام',
    attendance_self_report_short: 'تقرير',
    attendance_self_health_entry: 'قيد تقرير مرضي',
    attendance_self_report_reference: 'مرجع',
    btn_open_correction_request: 'فتح طلب تصحيح',
    attendance_self_open_record_correction: 'فتح تصحيح لهذا السجل',
    generic_request_prefill_health_title: 'طلب تصحيح سجل التقرير المرضي في الدوام',
    generic_request_prefill_health_intro: 'أطلب تصحيح سجل دوامي المرتبط بتقريري المرضي.',
    generic_request_prefill_health_closing: 'يرجى مراجعة صحة السجل وأثره على الرواتب.',
    generic_request_prefill_health_document: 'سجل الدوام / التقرير المرضي',
    generic_request_prefill_health_delivery: 'مراجعة وتصحيح من الموارد البشرية',
    generic_request_quick_all: 'كل الطلبات',
    generic_request_quick_health_corrections: 'تصحيحات السجل الصحي',
    notif_pending_purchase_requests: 'هناك {{count}} من طلبات الشراء بانتظار المعالجة.',
    notif_open_generic_requests: 'هناك {{count}} من الطلبات المؤسسية بانتظار المعالجة.',
    notif_pending_policy_acknowledgements: 'هناك {{count}} من عناصر السياسات بانتظار القراءة أو الإقرار.',
    lbl_purchase_requests: 'طلبات الشراء',
    msg_purchase_requests_waiting: 'طلبات الشراء بانتظار المعالجة.',
    lbl_generic_requests: 'الطلبات المؤسسية',
    msg_generic_requests_waiting: 'الطلبات المؤسسية بانتظار المعالجة.',
    notif_health_record_corrections: 'هناك {{count}} من طلبات تصحيح السجل الصحي بانتظار مراجعة الموارد البشرية.',
    lbl_health_record_corrections: 'تصحيح السجل الصحي',
    msg_health_record_corrections_waiting: 'توجد طلبات تصحيح بانتظار مراجعة الموارد البشرية.',
    lbl_pending_policy_acknowledgements: 'إقرارات السياسات',
    msg_pending_policy_acknowledgements_waiting: 'توجد عناصر سياسة بانتظار القراءة أو الإقرار.',
    lbl_stat_sick_report_days: 'أيام مرضية',
    lbl_days_short: 'يوم',
    lifecycle_manage_template: 'إدارة القالب',
    lifecycle_operation_checklist: 'قائمة التحقق التشغيلية',
    lifecycle_progress_summary: 'ملخص التقدم',
    lifecycle_add_template_item: 'عنصر قالب جديد',
    lifecycle_auto_action: 'إجراء تلقائي',
    lifecycle_auto_step: 'تلقائي',
    lifecycle_manual_step: 'عنصر يدوي',
    lifecycle_checklist_not_completed: 'لم يكتمل بعد',
    lifecycle_checklist_template_label: 'قالب قائمة التحقق',
    lifecycle_checklist_update_error: 'تعذر تحديث عنصر قائمة التحقق.',
    lifecycle_checklist_updated: 'تم تحديث عنصر قائمة التحقق.',
    lifecycle_checklist_updating: 'جارٍ تحديث عنصر قائمة التحقق...',
    lifecycle_custom_checklist_empty: 'لم تتم إضافة عناصر قائمة تحقق قابلة لإعادة الاستخدام لهذه العملية بعد.',
    lifecycle_offboarding_checklist_note: 'يتم احتساب عناصر الإنهاء القياسية وخطوات قائمة إنهاء الخدمة القابلة لإعادة الاستخدام ضمن نسبة التقدم.',
    lifecycle_onboarding_checklist_note: 'يتم احتساب عناصر بدء العمل القياسية وخطوات قائمة بدء العمل القابلة لإعادة الاستخدام ضمن نسبة التقدم.',
    lifecycle_sort_order: 'الترتيب',
    lifecycle_target_role_any: 'عام / غير مخصص',
    lifecycle_target_role_short: 'الدور المسؤول',
    lifecycle_template_create_error: 'تعذر إضافة عنصر قائمة التحقق.',
    lifecycle_template_created: 'تمت إضافة عنصر قالب قائمة التحقق.',
    lifecycle_template_creating: 'جارٍ إضافة عنصر قائمة التحقق...',
    lifecycle_template_delete_error: 'تعذر حذف عنصر قائمة التحقق.',
    lifecycle_template_deleted: 'تم حذف عنصر قالب قائمة التحقق.',
    lifecycle_template_deleting: 'جارٍ حذف عنصر قائمة التحقق...',
    lifecycle_template_empty: 'لم تتم إضافة أي عناصر قائمة تحقق لهذه العملية بعد.',
    lifecycle_template_modal_offboarding: 'قالب قائمة إنهاء الخدمة',
    lifecycle_template_modal_onboarding: 'قالب قائمة بدء العمل',
    lifecycle_template_no_detail: 'لم يتم إدخال وصف.',
    lifecycle_template_required_note: 'احتساب هذا العنصر ضمن التقدم',
    lbl_hero_desc: 'منصة الجيل الجديد لإدارة الموارد البشرية والمالية والعمليات والمصممة للشركات الحديثة.',
    step_identity: 'الهوية',
    step_contact_family: 'العائلة والتواصل',
    step_corporate: 'المؤسسي',
    step_finance_legal: 'المالية والقانون',
    lbl_system_metrics: 'مؤشرات النظام',
    btn_sick_report: 'إدخال التقرير المرضي',
    lbl_report_worked_days: 'أيام العمل',
    lbl_report_approved_leaves: 'الإجازات المعتمدة',
    lbl_report_sick_days: 'أيام المرض',
    lbl_report_paid_sick_days: 'تقرير مرضي مدفوع بالكامل',
    lbl_report_deducted_sick_days: 'تقرير مرضي مع خصم',
    lbl_report_late_count: 'متأخر',
    lbl_report_early_count: 'مبكر',
    lbl_report_overtime_hours: 'إضافي',
    lbl_badge_cv_reviewed: 'تمت مراجعة السيرة الذاتية',
    lbl_badge_phone_screen: 'تمت المقابلة الهاتفية',
    lbl_badge_interview_completed: 'اكتملت المقابلة',
    lbl_badge_reference_checked: 'تم التحقق من المراجع',
    lbl_badge_test_completed: 'اكتمل الاختبار',
    lbl_badge_technical_approved: 'تمت الموافقة الفنية',
    lbl_badge_manager_approved: 'تمت موافقة المدير',
    lbl_badge_offer_shared: 'تم إرسال العرض',
    lbl_badge_documents_received: 'تم استلام المستندات',
    lbl_badge_employee_record_created: 'تم إنشاء سجل الموظف',
    lifecycle_item_account_closed: 'تم إغلاق حساب المستخدم',
    lifecycle_item_account_closed_detail: 'يتم إيقاف الوصول إلى الحساب وتعطيل MFA والجلسات على الأجهزة المحمولة.',
    lifecycle_item_exit_date: 'تم تحديد تاريخ الخروج',
    lifecycle_item_exit_date_missing: 'لم يتم إدخال تاريخ خروج بعد.',
    lifecycle_item_termination_document: 'تم إنشاء مستند الخروج',
    lifecycle_item_assets_returned: 'تم إغلاق العهد',
    lifecycle_item_finance_clearance: 'لا توجد إجازات أو مصروفات مفتوحة',
    lifecycle_item_tickets_closed: 'تم إغلاق طلبات الدعم المفتوحة',
    lifecycle_item_org_assignment: 'تم تعيين القسم والدور',
    lifecycle_item_account_ready: 'حساب المستخدم جاهز',
    lifecycle_item_account_ready_missing: 'لم يتم تعريف بريد إلكتروني',
    lifecycle_item_password_change: 'تغيير كلمة المرور عند أول دخول بانتظار التنفيذ',
    lifecycle_item_password_change_active: 'كلمة المرور المؤقتة فعالة',
    lifecycle_item_password_change_done: 'أصبحت كلمة المرور دائمة',
    lifecycle_item_contract_document: 'تم إنشاء عقد العمل',
    lifecycle_item_dossier_ready: 'تم جمع وثائق الملف الوظيفي',
    lifecycle_item_device_login: 'تم رصد أول جلسة جهاز',
    lifecycle_detail_documents_count: '{{count}} مستند',
    lifecycle_detail_active_assets_count: '{{count}} عهدة نشطة',
    lifecycle_detail_open_tickets_count: '{{count}} طلب دعم مفتوح',
    lifecycle_detail_pending_finance_count: '{{leaveCount}} إجازات و{{expenseCount}} مصروفات بانتظار المعالجة',
    lifecycle_detail_dossier_count: '{{totalCount}} وثائق، {{pendingCount}} بانتظار الإجراء',
    lifecycle_detail_device_count: '{{count}} سجلات أجهزة',
    menu_support_center: 'رسائل الدعم',
    lbl_document_action_history: 'سجل إجراءات المستند',
    field_system_name: 'النظام / التطبيق',
    field_access_level: 'مستوى الوصول',
    field_document_name: 'المستند المطلوب',
    field_payload_document_name: 'المستند / الموضوع',
    field_delivery_method: 'طريقة التسليم',
    field_payload_delivery_method: 'طريقة التسليم / المعالجة',
    field_health_correction_topic: 'موضوع التصحيح',
    field_health_correction_expectation: 'الإجراء المتوقع',
    field_payroll_period: 'فترة الرواتب',
    field_payroll_topic: 'موضوع الرواتب',
    field_equipment_name: 'المعدة المطلوبة',
    field_payload_equipment_name: 'المعدة',
    field_equipment_quantity: 'الكمية',
    field_admin_topic: 'موضوع إداري',
    field_other_reference: 'مرجع / وسم قصير',
    field_payload_reference: 'مرجع',
    ph_system_name: 'مثال: ERP أو CRM أو البريد الإلكتروني',
    ph_access_level: 'مثال: عرض، تعديل',
    ph_document_name: 'مثال: شهادة عمل أو خطاب راتب',
    ph_delivery_method: 'بريد إلكتروني أو PDF موقّع أو نسخة مطبوعة',
    ph_health_correction_topic: 'مثال: سجل حضور التقرير الطبي',
    ph_health_correction_expectation: 'مثال: مراجعة الموارد البشرية والتحقق من الرواتب',
    ph_payroll_period: 'مثال: 2026-03',
    ph_payroll_topic: 'مثال: عمل إضافي أو خصم أو مكافأة',
    ph_equipment_name: 'مثال: لابتوب أو سماعة أو قارئ بطاقات',
    ph_equipment_quantity: 'مثال: 1',
    ph_admin_topic: 'مثال: مكتب أو لوجستيات أو مركبة أو توريد',
    ph_other_reference: 'مرجع داخلي أو وسم قصير',
    settings_tab_responsibles: 'مسؤولو الشركة',
    settings_tab_responsibles_hint: 'إعدادات سير العمل',
    settings_tab_company: 'معلومات الشركة',
    settings_tab_company_hint: 'العنوان والهاتف والشعار',
    settings_tab_personal: 'الإعدادات الشخصية',
    settings_tab_personal_hint: 'كلمة المرور والأمان',
    settings_responsible_it: 'الدعم الفني (IT)',
    settings_responsible_it_desc: 'يتم توجيه طلبات الدعم الفني وأعطال الأجهزة وعمليات تقنية المعلومات إلى قائمة عمل هذا المسؤول بشكل افتراضي.',
    settings_responsible_hr: 'مسؤول الموارد البشرية',
    settings_responsible_hr_desc: 'يُستخدم كمسؤول تشغيلي أول لملفات الموظفين والمستندات ودورة حياة الموظف.',
    settings_responsible_admin: 'الإداري / المستلزمات',
    settings_responsible_admin_desc: 'يعمل كصاحب سير العمل الافتراضي للطلبات الإدارية والطلبات التمهيدية للشراء واحتياجات المكتب.',
    settings_responsible_payroll: 'مسؤول الرواتب',
    settings_responsible_payroll_desc: 'يُعيّن كأول جهة مراجعة للرواتب والأجور والخصومات والاستفسارات الدورية المتعلقة بالراتب.',
    settings_responsible_onboarding: 'مسؤول التهيئة الوظيفية',
    settings_responsible_onboarding_desc: 'يصبح المسؤول الافتراضي عن إنشاء حساب الموظف الجديد ومتابعة الوثائق الأولى وخطوات بدء العمل.',
    settings_responsible_offboarding: 'مسؤول إنهاء الخدمة',
    settings_responsible_offboarding_desc: 'يصبح المسؤول الافتراضي عن تاريخ الخروج وإغلاق الحساب والاسترجاع ووثائق الإنهاء.',
    msg_saving_company_responsibles: 'جارٍ حفظ مسؤولي الشركة...',
    msg_company_responsibles_saved: 'تم حفظ مسؤولي الشركة.',
    err_company_responsibles_save: 'تعذر حفظ مسؤولي الشركة.',
    msg_updating_password: 'جارٍ تحديث كلمة المرور...',
    err_password_update: 'تعذر تحديث كلمة المرور.',
    msg_updating_logo: 'جارٍ رفع الشعار...',
    msg_logo_updated: 'تم تحديث الشعار بنجاح.',
    err_logo_upload: 'تعذر رفع الشعار.',
    msg_loading_settings: 'جارٍ تحميل الإعدادات...',
    msg_updating_company_info: 'جارٍ تحديث معلومات الشركة...',
    msg_company_info_updated: 'تم تحديث معلومات الشركة.',
    err_company_info_update: 'تعذر تحديث معلومات الشركة.',
    lbl_general_note: 'ملاحظة عامة',
    lbl_dossier_rules_engine: 'محرك قواعد الملف الوظيفي',
    lbl_required_document_sets: 'مجموعات المستندات الإلزامية',
    lbl_expiry_alert_roles: 'أدوار تنبيه انتهاء الصلاحية',
    btn_save_routing_responsibles: 'حفظ مسؤولي سير العمل',
    settings_field_visible_company_name: 'اسم الشركة الظاهر',
    settings_field_legal_name: 'الاسم القانوني / التجاري',
    ph_legal_name: 'الاسم المستخدم في العقود والمستندات الرسمية',
    settings_field_tax_no: 'الرقم الضريبي',
    settings_field_workplace_no: 'الضمان الاجتماعي / رقم تسجيل مكان العمل',
    settings_field_active_plan: 'الباقة النشطة',
    settings_field_address: 'العنوان',
    settings_field_phone: 'الهاتف',
    settings_field_email: 'البريد الإلكتروني',
    settings_field_website: 'الموقع الإلكتروني',
    btn_update_company_info: 'تحديث معلومات الشركة',
    lbl_document_header: 'عنوان المستند',
    lbl_brand_identity: 'الهوية المؤسسية',
    msg_no_logo_yet: 'لا يوجد شعار بعد',
    msg_pdf_header_ready: 'ترويسة PDF جاهزة',
    msg_logo_pending: 'بانتظار الشعار',
    btn_upload_logo: 'رفع الشعار',
    lbl_personal_settings: 'الإعدادات الشخصية',
    lbl_account_security: 'أمان الحساب',
    lbl_password_update: 'تحديث كلمة المرور',
    lbl_personal_security_settings: 'إعدادات الأمان الشخصية',
    lbl_current_password: 'كلمة المرور الحالية',
    lbl_confirm_new_password: 'تأكيد كلمة المرور الجديدة',
    btn_update_password: 'تحديث كلمة المرور',
    lbl_kudos_sentence: '{{from}} شكر {{to}}.',
    err_settings_load: 'تعذر تحميل الإعدادات أو قائمة الموظفين.',
    msg_routing_saved: 'تم حفظ إعدادات التوجيه بنجاح!',
    err_settings_save: 'حدثت مشكلة أثناء حفظ الإعدادات.',
    page_system_settings_title_prefix: 'النظام و',
    page_system_settings_title_highlight: 'إعدادات سير العمل',
    page_system_settings_desc: 'يمكنك هنا تحديد المسؤول الذي ستصل إليه طلبات الدعم والإجازات والعمليات بشكل افتراضي.',
    btn_save_settings: 'حفظ الإعدادات',
    msg_waiting_settings_api: 'جارٍ انتظار الإعدادات والموظفين من واجهة API...',
    lbl_workflow_responsibles: 'مسؤولو سير العمل',
    opt_select_employee: 'اختر موظفاً',
    btn_forgot: 'نسيت كلمة المرور',
    btn_verify: 'تحقق وسجّل الدخول',
    btn_setup_start: 'حدد كلمة المرور وابدأ',
    btn_reset_send: 'إرسال الرمز',
    btn_reset_save: 'حفظ كلمة المرور الجديدة',
    btn_force_reset_save: 'تحديد كلمة مرور جديدة',
    lbl_login: 'تسجيل الدخول',
    lbl_login_desc: 'سجّل الدخول إلى حساب CADRO الخاص بك',
    lbl_reset_password: 'نسيت كلمة المرور',
    lbl_reset_desc: 'سنرسل رمز إعادة التعيين إلى بريدك الإلكتروني',
    lbl_mfa: 'التحقق',
    lbl_mfa_desc: 'أدخل الرمز المكون من 6 أرقام الذي وصل إلى بريدك الإلكتروني',
    lbl_setup_title: 'تفعيل الحساب',
    lbl_setup_desc: 'تم تأكيد الدفع. حدّد كلمة المرور باستخدام الرمز المرسل إلى بريدك الإلكتروني.',
    lbl_force_reset_title: 'تجديد كلمة المرور',
    lbl_force_reset_desc: 'يجب عليك تحديد كلمة مرور جديدة قبل أول تسجيل دخول.',
    lbl_membership_note: 'إذا لم تكن مشتركاً بعد،',
    lbl_membership_note2: 'يمكنك بدء الاشتراك من',
    msg_login_success: 'تم تسجيل الدخول بنجاح.',
    msg_mfa_sent: 'تم إرسال رمز الأمان إلى بريدك الإلكتروني.',
    msg_reset_code_sent: 'تم إرسال الرمز إلى بريدك الإلكتروني.',
    msg_password_changed: 'تم تحديث كلمة المرور.',
    msg_force_password_changed: 'تم تحديث كلمة المرور. يمكنك تسجيل الدخول بكلمة المرور الجديدة.',
    msg_force_password_reset_sent: 'تم إرسال رمز إعادة تعيين كلمة المرور إلى بريدك الإلكتروني لأمان أول تسجيل دخول.',
    msg_account_activated: 'تم تفعيل حسابك.',
    err_default: 'حدث خطأ ما.',
    ph_mfa_code: 'رمز تحقق من 6 أرقام',
    ph_setup_code: 'رمز من 6 أرقام من بريدك الإلكتروني',
    ph_reset_code: 'رمز إعادة تعيين من 6 أرقام',
    ph_setup_password: 'حدد كلمة المرور الجديدة',
    btn_send_kudos_short: 'أرسل شكراً',
    lbl_kudos_counts: 'إحصاءات الشكر',
    err_leave_country_type_required: 'يرجى اختيار البلد / المنطقة ونوع الإجازة أولاً.',
    lbl_leave_country: 'البلد / المنطقة',
    opt_select_country: 'اختر البلد / المنطقة',
    opt_select_leave_type: 'اختر ملف إجازة أولاً',
    tab_payroll_report: 'تقرير الرواتب',
    btn_save_sick_report: 'حفظ التقرير الطبي',
    modal_title_sick_report: 'إدخال التقرير الطبي',
    msg_creating_sick_report: 'جارٍ حفظ التقرير الطبي...',
    msg_sick_report_created: 'تم حفظ التقرير الطبي.',
    msg_sick_report_full_pay: 'تمت معالجته كإجازة مدفوعة بالكامل.',
    msg_sick_report_deduct: 'تمت معالجته كإجازة قابلة للخصم.',
    err_sick_report_create: 'تعذر حفظ التقرير الطبي.',
    err_select_employee_for_sick_report: 'يرجى اختيار موظف أولاً.',
    err_fetch_attendance_report: 'تعذر تحميل تقرير الرواتب.',
    msg_no_attendance_report_rows: 'لم يتم العثور على صفوف تقرير للمدة المحددة.',
    lbl_loading_attendance_report: 'جارٍ تحميل تقرير الرواتب...',
    lbl_payroll_effect: 'أثر الرواتب',
    lbl_payroll_decision_note: 'ملاحظة قرار الرواتب',
    lbl_report_no: 'رقم التقرير',
    lbl_report_people: 'الموظفون المشمولون',
    lbl_issue_date: 'تاريخ الإصدار',
    lbl_issued_by: 'الجهة المصدرة',
    badge_sick_deduct: 'تقرير مع خصم',
    badge_sick_full_pay: 'تقرير بأجر كامل',
    lbl_deduct_in_payroll: 'مع خصم في الرواتب',
    lbl_full_pay_in_payroll: 'مدفوع بالكامل في الرواتب',
    status_sick_report: 'تقرير طبي',
    ph_search_attendance: 'ابحث عن موظف أو قسم',
    lbl_action_history: 'سجل الإجراءات',
    msg_no_action_history: 'لا يوجد سجل إجراءات بعد.',
    msg_loading_document_history: 'جارٍ تحميل سجل المستندات...',
    msg_no_document_history: 'لا يوجد سجل مستندات بعد.',
    lbl_created: 'تم الإنشاء',
    lbl_status_updated: 'تم تحديث الحالة',
    lbl_message_added: 'تمت إضافة رسالة',
    lbl_attachment_added: 'تمت إضافة مرفق',
    lbl_attachment_count: '{{count}} مرفقات',
    doc_deleted: 'تم حذف المستند',
    dossier_history_uploaded: 'تم رفع المستند',
    dossier_history_status_updated: 'تم تحديث حالة المستند',
    dossier_history_deleted: 'تمت إزالة المستند من الأرشيف',
    common_not_available: 'غير متاح',
    tooltip_view_archive: 'عرض الأرشيف',
    opt_support_technical: 'مشكلة تقنية',
    opt_support_billing: 'الفوترة',
    opt_support_feature: 'طلب ميزة',
    opt_support_other: 'أخرى',
    ph_support_subject: 'اكتب موضوعاً مختصراً',
    ph_support_message: 'اكتب رسالتك',
    btn_mark_as_read: 'تحديد كمقروء',
    lbl_broadcast_read: 'مقروء',
    lbl_broadcast_unread: 'غير مقروء',
    msg_loading_support_requests: 'جارٍ تحميل طلبات الدعم...',
    msg_no_support_requests: 'لا توجد طلبات دعم.',
    msg_loading_support_broadcasts: 'جارٍ تحميل الإعلانات...',
    msg_no_support_broadcasts: 'لا توجد إعلانات.',
    lbl_system_user: 'النظام',
    msg_support_failed: 'تعذر تحميل سجلات الدعم.',
    msg_support_broadcasts_failed: 'تعذر تحميل الإعلانات.',
    msg_support_broadcast_read_failed: 'تعذر تعليم الإعلان كمقروء.',
    msg_support_subject_message_required: 'يرجى تعبئة حقلي الموضوع والرسالة.',
    msg_support_sent: 'تم إرسال طلب الدعم الخاص بك.',
    msg_support_cancellation_message_required: 'يرجى كتابة سبب مختصر لطلب الإلغاء.',
    msg_support_cancellation_sent: 'تم إرسال طلب إلغاء الاشتراك الخاص بك لموافقة فريق CADRO.',
    msg_support_cancellation_failed: 'تعذر إرسال طلب إلغاء الاشتراك.',
    msg_support_cancellation_sending: 'جارٍ الإرسال...',
    support_status_pending: 'قيد الانتظار',
    support_status_in_progress: 'قيد المعالجة',
    support_status_resolved: 'تم الحل',
    title_support_center: 'رسائل الدعم',
    msg_contact_cadro_desc: 'افتح طلباً للمشكلات التقنية أو الفوترة أو ملاحظات المنتج. يمكنك متابعة تحديثات الحالة هنا.',
    btn_new_support_request: 'طلب جديد',
    btn_my_support_requests: 'رسائلي',
    btn_support_broadcasts: 'الإعلانات',
    lbl_subscription_cancellation: 'طلب إلغاء الاشتراك',
    title_subscription_cancellation_owner_review: 'يذهب طلب الإلغاء أولاً إلى فريق CADRO',
    msg_subscription_cancellation_owner_review: 'هذا الخيار متاح فقط للمشرفين العامين. يذهب الطلب أولاً إلى فريق CADRO؛ وبعد المناقشة والموافقة تتم معالجته في Paddle.',
    btn_request_subscription_cancellation: 'إلغاء اشتراكي',
    lbl_support_category: 'الفئة',
    lbl_support_subject: 'الموضوع',
    lbl_support_message: 'الرسالة',
    lbl_support_attachments: 'إضافة ملف / صورة',
    btn_support_choose_files: 'اختر ملفاً',
    btn_send_support: 'إرسال طلب الدعم',
    lbl_owner_approval_required: 'موافقة فريق CADRO مطلوبة',
    lbl_owner_update: 'تحديث من فريق CADRO',
    lbl_kpi_group_workforce: 'القوى العاملة',
    lbl_kpi_group_absence: 'الغياب والإجازات',
    lbl_kpi_group_operations: 'العمليات',
    lbl_kpi_group_compliance: 'الامتثال',
    lbl_system_active_employees: 'الموظفون النشطون',
    lbl_system_turnover_rate: 'معدل الدوران',
    lbl_system_leave_today: 'في إجازة اليوم',
    lbl_system_absent_today: 'غائبون اليوم',
    lbl_system_absence_rate_today: 'معدل الغياب اليوم',
    lbl_system_leave_coverage_rate_today: 'معدل تغطية الإجازات اليوم',
    lbl_system_leave_usage_rate: 'معدل استخدام الإجازات',
    lbl_system_open_queue: 'قائمة العمل المفتوحة',
    lbl_system_pending_policy_ack: 'إقرارات السياسات المعلقة',
    lbl_system_expiring_documents: 'مستندات تنتهي خلال 30 يوماً',
    msg_no_kpi_categories: 'لا توجد بيانات فئات للفلاتر المحددة.',
    btn_clear: 'مسح',
    msg_saving: 'جارٍ الحفظ...',
    msg_sending: 'جارٍ الإرسال...',
    msg_leave_cancel_not_available: 'إلغاء طلب الإجازة غير متاح حالياً في بوابة الموظف. يرجى التواصل مع مديرك أو الموارد البشرية للإلغاء.',
    opt_full_pay_sick: 'ادفع الأجر كاملاً',
    opt_deduct_sick: 'ضمّنه إلى الخصم',
    file_attendance: 'الحضور',
    col_name: 'الاسم الكامل',
    desc_bulk_action: 'استخدم هذا لإدارة السجلات المحددة بشكل جماعي.',
    action_approve: 'الموافقة على',
    action_reject: 'رفض',
    opt_all_schedule_types: 'كل أنواع الخطط',
    opt_all_schedules: 'كل الخطط',
    opt_all_statuses: 'كل الحالات',
    ph_select_employee: 'اختر موظفاً',
    err_schedule_report_pdf: 'تعذر إنشاء تقرير PDF لخطة الدوام.',
    msg_schedule_report_pdf: 'جارٍ إعداد تقرير PDF لخطة الدوام...',
    msg_schedule_report_pdf_ready: 'أصبح تقرير خطة الدوام جاهزاً.',
    err_schedule_members_report_pdf: 'تعذر إنشاء تقرير أعضاء الخطة.',
    msg_schedule_members_report_pdf: 'جارٍ إعداد تقرير الأعضاء لـ "{{name}}"...',
    msg_schedule_members_report_pdf_ready: 'أصبح تقرير أعضاء الخطة جاهزاً.',
    doc_id: 'نسخة الهوية / جواز السفر',
    doc_pre_permit: 'مستندات الإذن المسبق (شمال قبرص)',
    doc_work_permit: 'تصريح العمل والتقرير الطبي',
    doc_residency: 'إثبات السكن / العنوان',
    doc_visa: 'التأشيرة / تصريح الإقامة',
    doc_contract: 'عقد العمل',
    doc_nda: 'السرية / اتفاقية عدم الإفشاء',
    doc_handbook_ack: 'إقرار دليل الموظف',
    doc_background_check: 'التحقق من الخلفية',
    doc_ohs_training: 'السلامة المهنية / اللياقة الطبية',
    doc_bank_info: 'بيانات البنك / الآيبان',
    doc_tax_doc: 'مستند الضرائب / TIN',
    doc_payroll: 'قسيمة الراتب',
    doc_social_security_record: 'سجل الضمان الاجتماعي',
    doc_performance_review: 'تقييم الأداء',
    doc_training_record: 'سجل التدريب',
    doc_leave_record: 'سجل الإجازة / الغياب',
    doc_disciplinary: 'سجل تأديبي',
    doc_termination: 'مستندات إنهاء الخدمة / المخالصة',
    doc_exit_interview: 'مقابلة الخروج',
    doc_onboarding_checklist: 'قائمة تحقق التهيئة',
    doc_offboarding_checklist: 'قائمة تحقق إنهاء الخدمة',
    doc_certificate: 'شهادة وتدريب مهني',
    doc_other: 'مستندات أخرى',
    tab_uploaded_documents: 'المستندات المرفوعة',
    tab_upload_document: 'رفع مستند',
    tab_compliance: 'ملخص الامتثال',
    action_approved: 'تمت الموافقة',
    action_rejected: 'مرفوض',
    badge_approved_doc: 'مستند معتمد',
    btn_approve: 'موافقة',
    btn_reject: 'رفض',
    btn_select_employee_archive: 'اختر موظفاً',
    btn_change_employee_archive: 'تغيير الموظف',
    btn_choose_from_pc: 'اختر ملفاً من الكمبيوتر',
    btn_upload_to_archive: 'رفع إلى الأرشيف',
    btn_uploading: 'جارٍ الرفع...',
    err_delete_failed: 'تعذر حذف المستند.',
    err_delete_pending_only: 'يمكن للموظف حذف المستندات المعلقة فقط.',
    err_document_status_update: 'تعذر تحديث حالة المستند.',
    err_fetch_docs: 'تعذر تحميل المستندات.',
    err_fetch_emps: 'تعذر تحميل قائمة الموظفين.',
    err_fetch_files: 'تعذر تحميل الملفات.',
    err_file_size: 'تم تجاوز حد حجم الملف.',
    err_upload_failed: 'تعذر رفع المستند.',
    lbl_archive_selection: 'اختيار الأرشيف',
    lbl_completion_score: 'درجة الاكتمال',
    lbl_country_role_rule_set: 'مجموعة قواعد الدولة / الدور',
    lbl_doc_category: 'فئة المستند',
    lbl_doc_issue_date: 'تاريخ الإصدار',
    lbl_doc_issued_by: 'الجهة المصدرة',
    lbl_doc_mandatory: 'مستند إلزامي',
    lbl_doc_number: 'رقم المستند',
    lbl_doc_number_short: 'رقم',
    lbl_doc_valid_until: 'صالح حتى',
    lbl_document_detail: 'تفاصيل المستند',
    lbl_dossier_compliance: 'ملخص توافق المستندات',
    lbl_expired_docs: 'منتهية الصلاحية',
    lbl_expired_required_docs: 'المستندات الإلزامية المنتهية',
    lbl_expiring_required_docs: 'المستندات الإلزامية التي تنتهي قريباً',
    lbl_expiring_soon: 'تنتهي قريباً',
    lbl_items: 'عناصر',
    lbl_max_file_size: 'الحد الأقصى لحجم الملف: 10MB',
    lbl_missing_required: 'ناقص إلزامي',
    lbl_my_dossier: 'أرشيفي الإلكتروني الشخصي',
    lbl_select_file_format: 'اختر ملفاً (PDF / صورة)',
    lbl_upload_new_doc: 'رفع مستند جديد إلى النظام',
    msg_all_required_docs_ready: 'المستندات الإلزامية مكتملة',
    msg_confirm_delete_doc: 'سيتم حذف هذا المستند نهائياً. هل أنت متأكد؟',
    msg_delete_success: 'تمت إزالة المستند من الأرشيف بنجاح.',
    msg_document_status_updated: 'تم تحديث حالة المستند إلى {{status}}.',
    msg_dossier_compliant: 'تبدو جميع المستندات الإلزامية في هذا الملف مكتملة حالياً.',
    msg_missing_required_docs: 'مستندات إلزامية ناقصة',
    msg_no_docs_found: 'لم يتم العثور على مستندات في ملف هذا الموظف حتى الآن.',
    msg_no_employee_selected: 'لم يتم اختيار موظف بعد',
    msg_no_expired_required_docs: 'لا توجد مستندات إلزامية منتهية الصلاحية حالياً.',
    msg_no_expiring_required_docs: 'لا توجد مستندات إلزامية تنتهي قريباً.',
    msg_searching_docs: 'جارٍ البحث عن المستندات...',
    msg_select_doc_for_detail: 'اختر مستنداً لعرض التفاصيل',
    msg_select_emp_focus_html: 'اختر موظفاً أولاً<br/>لعرض الأرشيف الإلكتروني.',
    msg_upload_pending: 'المستند بانتظار الموافقة.',
    msg_upload_success: 'تمت إضافة المستند إلى الأرشيف بنجاح.',
    msg_uploading_doc: 'جارٍ رفع المستند...',
    ph_search_emp: 'ابحث بالاسم أو القسم...',
    tooltip_delete_archive: 'حذف من الأرشيف',
    tooltip_view_doc: 'عرض المستند',
    badge_pending_approval: 'قيد الانتظار',
    badge_rejected_doc: 'مرفوض',
    badge_expiring_soon: 'تنتهي قريباً',
    badge_expired: 'منتهية الصلاحية',
    lbl_employee: 'الموظف',
    lbl_first_name: 'الاسم',
    lbl_last_name: 'اسم العائلة',
    lbl_pending_documents: 'المستندات المعلقة',
    lbl_support_broadcasts: 'رسائل الدعم',
    msg_document_waiting: 'مستندات بانتظار موافقتك.',
    msg_support_broadcast_waiting: 'هناك إعلانات غير مقروءة بانتظارك.',
    role_owner: 'مالك المنصة',
    btn_contact_cadro: 'دعم CADRO',
    menu_executive_console: 'لوحة الإدارة التنفيذية',
    menu_executive_companies: 'الشركات',
    menu_executive_revenue: 'الإيرادات والباقات',
    menu_executive_risks: 'المخاطر والتنبيهات',
    menu_executive_messages: 'الرسائل',
    menu_account_security: 'أمان الحساب',
    dossier_profile_global_title: 'Global',
    dossier_profile_global_desc: 'مجموعة المستندات الأساسية الإلزامية لملف الشركة الافتراضي.',
    dossier_profile_tr_title: 'TR',
    dossier_profile_tr_desc: 'مجموعة المستندات الإلزامية لملف تركيا.',
    dossier_profile_kktc_title: 'KKTC',
    dossier_profile_kktc_desc: 'مجموعة المستندات الإلزامية لملف قبرص الشمالية.',
    dossier_profile_eu_title: 'EU',
    dossier_profile_eu_desc: 'مجموعة المستندات الإلزامية لملف أوروبا.',
    dossier_profile_mena_title: 'MENA',
    dossier_profile_mena_desc: 'مجموعة المستندات الإلزامية لملف الشرق الأوسط وشمال أفريقيا.',
    dossier_profile_leadership_title: 'Leadership',
    dossier_profile_leadership_desc: 'مجموعة مستندات إلزامية إضافية للمديرين والموارد البشرية والمشرفين والمديرين العامين.',
    lbl_security_tip: 'نصيحة',
    desc_security_tip: 'استخدم كلمة مرور قوية لحساب المدير وقم بتغييرها بانتظام. مسار التحقق المتعدد على الجوال مفعل بالفعل.',

    // =============================================
    // 🕐 PUANTAJ YENİ MODÜL — RBAC odaklı çeviriler
    // =============================================
    // KPI Dashboard
    attendance_kpi_present: 'أيام الحضور',
    attendance_kpi_late: 'التأخير',
    attendance_kpi_hours: 'إجمالي الساعات',
    attendance_kpi_sick: 'تقرير صحي',
    attendance_kpi_checked_in: 'تسجيل اليوم',
    attendance_kpi_late_count: 'متأخرون',
    attendance_kpi_absent: 'غياب',
    attendance_kpi_pending: 'بانتظار الموافقة',
    attendance_kpi_total_hours: 'إجمالي الساعات',

    // Takvim
    attendance_view_weekly: 'أسبوعي',
    attendance_view_monthly: 'شهري',
    attendance_legend_present: 'حاضر',
    attendance_legend_late: 'متأخر',
    attendance_legend_absent: 'غائب',
    attendance_legend_sick: 'مرض',
    attendance_legend_holiday: 'عطلة',

    // Filtreler
    attendance_filter_date: 'التاريخ',
    attendance_filter_from: 'من',
    attendance_filter_to: 'إلى',
    attendance_filter_personnel: 'الموظف',
    attendance_filter_search: 'بحث بالاسم',
    attendance_filter_search_placeholder: 'الاسم أو اللقب...',
    attendance_filter_department: 'القسم',
    attendance_filter_all_departments: 'جميع الأقسام',
    attendance_filter_status: 'الحالة',
    attendance_filter_all_status: 'جميع الحالات',
    attendance_filter_approval: 'الموافقة',
    attendance_filter_all_approval: 'جميع الموافقات',
    attendance_export: 'تصدير',
    attendance_export_success: 'تم التصدير بنجاح.',

    // Tablo
    attendance_no_records: 'لا توجد سجلات حتى الآن.',
    attendance_selected: 'سجل محدد',
    attendance_bulk_approve: 'موافقة جماعية',
    attendance_bulk_reject: 'رفض جماعي',
    attendance_bulk_approved: 'تمت الموافقة على السجلات المحددة.',
    attendance_col_employee: 'الموظف',
    attendance_col_date: 'التاريخ',
    attendance_col_in: 'دخول',
    attendance_col_out: 'خروج',
    attendance_col_duration: 'المدة',
    attendance_col_status: 'الحالة',
    attendance_col_approval: 'الموافقة',
    attendance_col_actions: 'إجراء',

    // Mesai Planı
    schedule_kicker: 'إدارة خطة الدوام',
    schedule_title: 'قوالب خطة الدوام',
    schedule_add: 'قالب جديد',
    schedule_empty: 'لا توجد قوالب بعد.',
    schedule_name: 'اسم الخطة',
    schedule_type: 'النوع',
    schedule_break: 'استراحة (دقيقة)',
    schedule_start: 'البداية',
    schedule_end: 'النهاية',
    schedule_grace_in: 'تسامح الدخول (دقيقة)',
    schedule_overtime: 'بعد العمل الإضافي (دقيقة)',
    schedule_active: 'نشط',
    schedule_updated: 'تم تحديث خطة الدوام.',
    schedule_created: 'تم إنشاء خطة الدوام.',
    schedule_deleted: 'تم حذف خطة الدوام.',
    schedule_delete_confirm: 'هل تريد بالتأكيد حذف خطة الدوام',
    schedule_edit: 'تعديل خطة الدوام',
    schedule_new: 'خطة دوام جديدة',

    // Departman
    dept_assign_kicker: 'تعيينات الأقسام',
    dept_assign_title: 'خطة الدوام حسب القسم',
    dept_assign_desc: 'اختر خطة الدوام الافتراضية لكل قسم.',
    dept_assign_employees: 'موظف',
    dept_assign_none: 'غير معين',
    dept_assign_empty: 'لم يتم العثور على أقسام.',

    // İstisna
    override_kicker: 'استثناء الموظف',
    override_title: 'استثناء الدوام حسب الموظف',
    override_desc: 'تعيين خطة دوام مختلفة لموظفين محددين.',
    override_search: 'البحث عن موظف...',
    override_all_departments: 'جميع الأقسام',
    override_empty: 'لم يتم العثور على موظفين.',
    override_badge: 'استثناء',
    override_selected: 'موظف محدد',
    override_select_schedule: 'اختر خطة الدوام...',
    override_reason: 'السبب (اختياري)',
    override_assign_btn: 'تعيين',
    override_clear_btn: 'إزالة الاستثناءات',
    override_assigned: 'تم تعيين استثناءات الموظفين.',
    override_cleared: 'تمت إزالة الاستثناءات.',
    override_select_both: 'اختر الموظف وخطة الدوام.',
    override_clear_confirm: 'هل تريد بالتأكيد إزالة استثناءات الموظفين المحددين؟',

    // Bordro
    payroll_kicker: 'ملخص الرواتب',
    payroll_title: 'ملخص الدوام للرواتب',
    payroll_generate: 'إنشاء',
    payroll_click_generate: 'انقر على زر "إنشاء" لعرض ملخص الرواتب.',
    payroll_col_employee: 'الموظف',
    payroll_col_normal: 'عادي',
    payroll_col_overtime: 'إضافي',
    payroll_col_absent: 'غياب',
    payroll_col_total: 'الإجمالي',
    payroll_total: 'المجموع الكلي',
  },
};

Object.entries(additionalTranslations).forEach(([lang, translation]) => {
  if (resources[lang]?.translation) {
    Object.assign(resources[lang].translation, translation);
  }
});

i18n
  .use(LanguageDetector) // Tarayıcı dilini veya önceki seçimi hatırlar
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr', // Varsayılan dil
    interpolation: {
      escapeValue: false // React zaten XSS koruması sağladığı için false yapıyoruz
    }
  });

export default i18n;
